// @generated by scripts/generate-views.ts — do not edit manually
// @ts-nocheck
// biome-ignore-all lint/style/useNamingConvention: Generated from external GraphQL schema naming conventions

import { parseView } from '#core/lib/cognite/view.ts';
import { InstanceIdType } from '#core/schema/defs.ts';

import { DataModel } from '#data-models.ts';

import {
  AlarmDefinitionSchema,
  AllocatedInjectionStringAgentSchema,
  AllocatedPropertiesStringSchema,
  AllocatedRatesDailyStringAgentSchema,
  AllocatedRatesVfmStringAgentSchema,
  AllocationFactorsFieldAgentSchema,
  AllocationOutputStringSchema,
  AsphalteneCurveSchema,
  AssetSchema,
  ChokeCurveInfoSchema,
  CompanySchema,
  DailyRollupFieldAgentSchema,
  DailyRollupOutputAssetSchema,
  DailyRollupOutputCompanySchema,
  DailyRollupOutputFieldSchema,
  DailyRollupOutputLocationSchema,
  DailyRollupOutputReservoirSchema,
  DailyRollupOutputWellSchema,
  DataDrivenRatesStringAgentSchema,
  DataMappingSchema,
  EntityAgentSchema,
  EntitySchema,
  EspAlarmsAgentSchema,
  EspCableSchema,
  EspCalculationsStringAgentSchema,
  EspCurveDataStringAgentSchema,
  EspLimitsStringAgentSchema,
  EspMeasurementsStringAgentSchema,
  EspMotorSchema,
  EspPumpDetailsSchema,
  EspPumpSchema,
  EstimatedRatesStringAgentSchema,
  EventsStringSchema,
  FieldFormationSchema,
  FieldInputsSchema,
  FieldOutputsSchema,
  FieldSchema,
  FlatHierarchyAgentSchema,
  FlatHierarchySchema,
  FlowAssuranceAlarmsAgentSchema,
  FlowlineOutputsNetworkAgentSchema,
  FluidCompositionSchema,
  FormationVolumeFactorSchema,
  GasLiftAlarmsAgentSchema,
  GasLiftCalculationsStringAgentSchema,
  GasLiftLimitsStringAgentSchema,
  GasLiftMeasurementsStringAgentSchema,
  GlValveDataSchema,
  InactiveStringAgentSchema,
  InactiveStringSchema,
  InjectionAlarmsAgentSchema,
  InjectionAllocationFactorSchema,
  InjectionPerformanceStringAgentSchema,
  InjPressGuidelineStringAgentSchema,
  InjPressGuidelineStringSchema,
  LiftTypeParameterStringSchema,
  LocationInputsSchema,
  LocationSchema,
  ManifoldInputsSchema,
  MapGridMappingSchema,
  MeasuredInjectionStringAgentSchema,
  MeasuredRatesWellTestStringAgentSchema,
  ModelManagementAlarmsAgentSchema,
  ModelMatchedRatesStringAgentSchema,
  MpfmInputsSchema,
  MpfmOutputsSchema,
  MpfmSchema,
  MpfmWellTestOutputsSchema,
  NetworkInputsSchema,
  NetworkModelSchema,
  NetworkOutputsFieldSchema,
  NetworkOutputsStringSchema,
  NetworkRatesStringAgentSchema,
  NetworkRiskAgentSchema,
  NetworkRiskOptimizationScenariosAgentSchema,
  NetworkRiskOptimizationScenariosSchema,
  NetworkSchema,
  OpportunityAgentSchema,
  OptimizedRatesNetworkStringAgentSchema,
  OptimizedRatesSrmStringAgentSchema,
  PriorityRatesStringAgentSchema,
  ProdplanStringReservoirSectorSchema,
  ProdplanStringSchema,
  ProducerGuidelinesStringAgentSchema,
  ProductionAllocationAlarmsAgentSchema,
  ProsperModelAgentSchema,
  ProsperModelEventLogSchema,
  ProsperModelMetricsSchema,
  ProsperModelSchema,
  PseudoPressureTableSchema,
  PtsOutputsStringAgentSchema,
  PtsOutputsStringSchema,
  PtsReferenceConditionsSchema,
  PvtAnalysisStringAgentSchema,
  PvtAnalysisStringSchema,
  RateDiagnosticsStringAgentSchema,
  ReservoirGuidelineSchema,
  ReservoirInputsAgentSchema,
  ReservoirInputsSchema,
  ReservoirOutputsAgentSchema,
  ReservoirOutputsSchema,
  ReservoirProdplanSchema,
  ReservoirSchema,
  SaturationPressureMappingSchema,
  SectorHierarchyAgentSchema,
  SectorHierarchySchema,
  SectorOutputsSchema,
  SectorProdplanSchema,
  SectorSchema,
  SeparatorInputsSchema,
  ShgProducerGuidelineSchema,
  SPressSettingsSchema,
  SrmOutputSchema,
  SrmOutputsAllEntitiesSchema,
  SrmOutputsStringSchema,
  SrmSettingsSchema,
  StringAssetSchema,
  StringFluidCompositionAgentSchema,
  StringFluidCompositionSchema,
  StringFunctionSchema,
  StringInputsStaticSchema,
  StringReservoirInputsSchema,
  SurveillanceAlarmsAgentSchema,
  TicketRegistryAgentSchema,
  ValueTrackingAgentSchema,
  WaterAnalysisSchema,
  WellBehaviourAlarmsAgentSchema,
  WellChokeMappingSchema,
  WellInputsStaticSchema,
  WellInputsStringSchema,
  WellMovementAgentSchema,
  WellOutputsStringSchema,
  WellSchema,
  WellStatusStringAgentSchema,
  WellTestAnalysisAgentSchema,
  WellTestGaugeStringSchema,
  WellTestInputsStringSchema,
  WellTestModelParametersAgentSchema,
  WellTestOutputsStringSchema,
  WellTestRawSchema,
  WellTestReservoirAnalysisAgentSchema,
  Wf3OutputsStringSchema,
  Wf05FieldOutputsSchema,
  Wf05StringOutputsSchema,
  Wf05StringReservoirOutputsSchema,
  WfAlarmsAgentSchema,
  WfAlarmsSchema,
  WfFieldAlarmsSchema,
  WfReservoirAlarmsSchema,
  WfSectorAlarmsSchema,
  WfStringAlarmsSchema,
  WfWellAlarmsSchema,
} from '#schema/generated/validation.ts';

export const AlarmDefinitionView = parseView({
  view: { externalId: 'AlarmDefinition' },
  model: AlarmDefinitionSchema.extend({
    ...InstanceIdType.shape,
    alarmName: AlarmDefinitionSchema.shape.alarmName?.describe(
      'Unique name of the alarm configuration in iPSO, used as the primary label when referencing the alarm in dashboards, rules, and integration mappings.',
    ),
    alarmMessage: AlarmDefinitionSchema.shape.alarmMessage?.describe(
      'Message text presented to end users when the alarm is triggered, typically appearing in alarm lists, dashboards, and ticketing systems.',
    ),
    alarmMsgParameter: AlarmDefinitionSchema.shape.alarmMsgParameter?.describe(
      'Optional dynamic parameter or placeholder value (for example the breached limit or tag name) that can be injected into the alarm message at runtime.',
    ),
    alarmCategory: AlarmDefinitionSchema.shape.alarmCategory?.describe(
      'High-level category grouping similar alarms (for example production, network, or equipment alarms), used to filter, analyze, and report alarms consistently across dashboards and workflows.',
    ),
    alarmDescription: AlarmDefinitionSchema.shape.alarmDescription?.describe(
      'Free-text engineering description explaining the intent, trigger logic, and operational meaning of the alarm, used by operators and engineers to understand why it exists.',
    ),
    workflowCode: AlarmDefinitionSchema.shape.workflowCode?.describe(
      'Internal code or identifier referencing the workflow template associated with this alarm in the workflow engine.',
    ),
    workflowName: AlarmDefinitionSchema.shape.workflowName?.describe(
      'Human-readable name of the workflow that is executed when this alarm is triggered and enters the ticketing or workflow system.',
    ),
    alarmPriority: AlarmDefinitionSchema.shape.alarmPriority?.describe(
      'Operational priority assigned to the alarm, typically used to drive sorting, notification urgency, and required response times for operations teams.',
    ),
    alarmCriticality: AlarmDefinitionSchema.shape.alarmCriticality?.describe(
      'Business and operational criticality of the alarm (for example low, medium, high), capturing the potential impact on production, integrity, and HSE and driving escalation rules.',
    ),
    isAlarmTicket: AlarmDefinitionSchema.shape.isAlarmTicket?.describe(
      'Boolean flag indicating whether this alarm should automatically create a ticket or workflow action when it is triggered and persists.',
    ),
    alarmCounterToTicket: AlarmDefinitionSchema.shape.alarmCounterToTicket?.describe(
      'Number of alarm occurrences or counter threshold that must be reached before a ticket or workflow is automatically created, used to avoid noise and focus on persistent issues.',
    ),
    alarmDataSource: AlarmDefinitionSchema.shape.alarmDataSource?.describe(
      'Primary data source or system that generates the alarm signal, such as a SCADA tag, historian time series, or calculated KPI within the iPSO solution.',
    ),
    alarmType: AlarmDefinitionSchema.shape.alarmType?.describe(
      'Type of alarm, for example limit breach, model mismatch, data quality issue, or equipment state, describing how the alarm is triggered and interpreted.',
    ),
    ticketAsset: AlarmDefinitionSchema.shape.ticketAsset?.describe(
      'Default asset (for example well, network segment, facility, or equipment) that tickets generated from this alarm should be attached to for context and ownership.',
    ),
    ticketDept: AlarmDefinitionSchema.shape.ticketDept?.describe(
      'Owning department responsible for resolving tickets created from this alarm, used for reporting and accountability.',
    ),
    ticketAssignedTo: AlarmDefinitionSchema.shape.ticketAssignedTo?.describe(
      'Default individual, role, or placeholder to which tickets from this alarm should initially be assigned, used to streamline triage.',
    ),
    ticketAssignedGroup: AlarmDefinitionSchema.shape.ticketAssignedGroup?.describe(
      'Default support group or team that tickets generated by this alarm should be routed to, such as production engineers, flow assurance, or maintenance.',
    ),
    ticketRecommedation: AlarmDefinitionSchema.shape.ticketRecommedation?.describe(
      'Standard recommendation text capturing suggested troubleshooting steps or remedial actions that should be included in tickets generated from this alarm.',
    ),
    subCategory: AlarmDefinitionSchema.shape.subCategory?.describe(
      'Additional subcategory used to further organize alarms within the main category, often aligned with specific equipment types, subsystems, or operational areas.',
    ),
    subWorkflowName: AlarmDefinitionSchema.shape.subWorkflowName?.describe(
      'Name of the sub-workflow or child process configuration that is executed when this alarm triggers and enters the workflow engine.',
    ),
    alarmUnifiedCode: AlarmDefinitionSchema.shape.alarmUnifiedCode?.describe(
      'Standardized code or identifier used to uniquely reference this alarm across systems and integrations, enabling consistent reporting and analytics.',
    ),
    alarmTypeCategory: AlarmDefinitionSchema.shape.alarmTypeCategory?.describe(
      'Higher-level grouping of alarm types, used to organize alarms into major families (for example flow assurance, production loss, data quality) for analysis and reporting.',
    ),
    alarmTypeSubCategory: AlarmDefinitionSchema.shape.alarmTypeSubCategory?.describe(
      'More granular subcategory within the alarm type family, enabling detailed root-cause tagging and more targeted reporting.',
    ),
  })?.describe(
    'Configuration of production and surveillance alarms in the iPSO solution. This view defines how alarms are grouped, prioritized, sourced, and mapped into workflows and tickets used for monitoring and optimization.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const AllocatedInjectionStringAgentView = parseView({
  view: { externalId: 'AllocatedInjection_String_Agent' },
  model: AllocatedInjectionStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: AllocatedInjectionStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    dayGasInjGasInjVolume: AllocatedInjectionStringAgentSchema.shape.dayGasInjGasInjVolume?.describe(
      'Daily allocated gas injection volume (MSCF/d)',
    ),
    dayGasInjActiveHours: AllocatedInjectionStringAgentSchema.shape.dayGasInjActiveHours?.describe(
      'Number of hours (0-24) the string was actively injecting gas during the day.',
    ),
    dayWaterInjWaterInjVolume: AllocatedInjectionStringAgentSchema.shape.dayWaterInjWaterInjVolume?.describe(
      'Daily allocated water injection volume (stb/d)',
    ),
    dayWaterInjActiveHours: AllocatedInjectionStringAgentSchema.shape.dayWaterInjActiveHours?.describe(
      'Number of hours (0-24) the string was actively injecting water during the day.',
    ),
    monthGasInjGasInjVolume: AllocatedInjectionStringAgentSchema.shape.monthGasInjGasInjVolume?.describe(
      'Monthly allocated gas injection volume (MSCF)',
    ),
    monthGasInjActiveDays: AllocatedInjectionStringAgentSchema.shape.monthGasInjActiveDays?.describe(
      'Number of days (0-31) the string was actively injecting gas during the month.',
    ),
    monthWaterInjWaterInjVolume: AllocatedInjectionStringAgentSchema.shape.monthWaterInjWaterInjVolume?.describe(
      'Monthly allocated water injection volume (stb)',
    ),
    monthWaterInjActiveDays: AllocatedInjectionStringAgentSchema.shape.monthWaterInjActiveDays?.describe(
      'Number of days (0-31) the string was actively injecting water during the month.',
    ),
  })?.describe(
    'Allocated injection volumes per well string for water and gas (WF15).\n\nDaily and monthly allocated gas and water injection, active hours/days per type.\nUse for injection performance, reporting, and trend analysis. For measured rates see MeasuredInjection_String_Agent.\n\nUse for: Water or Gas Injection Monitoring (WF15), Production Allocation (WF5).',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const AllocatedPropertiesStringView = parseView({
  view: { externalId: 'AllocatedProperties_String' },
  model: AllocatedPropertiesStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: AllocatedPropertiesStringSchema.shape.entityName?.describe('Reference to the String_asset entity'),
    dayAllocProdStringFunction: AllocatedPropertiesStringSchema.shape.dayAllocProdStringFunction?.describe(
      "Functional role of the string for allocation purposes (e.g., 'PRODUCER', 'INJECTOR',\n'DISPOSAL', 'OBSERVATION')",
    ),
    dayAllocProdFlowDirection: AllocatedPropertiesStringSchema.shape.dayAllocProdFlowDirection?.describe(
      "Flow direction indicator for daily production allocation: 'PRODUCTION' for fluids\nflowing from reservoir to surface, 'INJECTION' for fluids going into the reservoir,\nor 'CIRCULATION' for through-tubing operations.",
    ),
    dayAllocProdProdMethod: AllocatedPropertiesStringSchema.shape.dayAllocProdProdMethod?.describe(
      "Artificial lift method in use for daily production (e.g., 'NATURAL_FLOW', 'ESP',\n'GAS_LIFT', 'ROD_PUMP', 'JET_PUMP')",
    ),
    dayAllocProdProdMode: AllocatedPropertiesStringSchema.shape.dayAllocProdProdMode?.describe(
      "Operating mode during production (e.g., 'NORMAL', 'CLEANUP', 'TEST', 'RAMP_UP',\n'CONSTRAINED')",
    ),
    dayAllocProdAllocatedWater: AllocatedPropertiesStringSchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily allocated water production volume (stb/d or m³/d)',
    ),
    dayAllocProdAllocatedGas: AllocatedPropertiesStringSchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily allocated gas production volume (MSCF/d or km³/d)',
    ),
    dayAllocProdActiveHours: AllocatedPropertiesStringSchema.shape.dayAllocProdActiveHours?.describe(
      'Number of hours (0-24) the string was actively producing during the day',
    ),
    dayGasInjStringFunction: AllocatedPropertiesStringSchema.shape.dayGasInjStringFunction?.describe(
      "Functional role of the string for gas injection allocation (e.g., 'GAS_INJECTOR',\n'WAG_INJECTOR', 'DISPOSAL')",
    ),
    dayGasInjFlowDirection: AllocatedPropertiesStringSchema.shape.dayGasInjFlowDirection?.describe(
      "Flow direction for gas injection: typically 'INJECTION' indicating gas flowing\nfrom surface into the reservoir",
    ),
    dayGasInjProdMode: AllocatedPropertiesStringSchema.shape.dayGasInjProdMode?.describe(
      "Operating mode for gas injection (e.g., 'NORMAL', 'TEST', 'STIMULATION').\nAffects how injection volumes are categorized for reservoir management.",
    ),
    dayGasInjMaterialType: AllocatedPropertiesStringSchema.shape.dayGasInjMaterialType?.describe(
      "Type of gas being injected (e.g., 'HYDROCARBON_GAS', 'CO2', 'NITROGEN', 'FLUE_GAS').\nImportant for EOR tracking, emissions accounting, and PVT calculations.",
    ),
    dayGasInjGasInjVolume: AllocatedPropertiesStringSchema.shape.dayGasInjGasInjVolume?.describe(
      'Daily allocated gas injection volume (MSCF/d or km³/d)',
    ),
    dayGasInjActiveHours: AllocatedPropertiesStringSchema.shape.dayGasInjActiveHours?.describe(
      'Number of hours (0-24) the string was actively injecting gas during the day.\nUsed to calculate injection efficiency and availability metrics.',
    ),
    dayWaterInjStringFunction: AllocatedPropertiesStringSchema.shape.dayWaterInjStringFunction?.describe(
      "Functional role of the string for water injection allocation (e.g., 'WATER_INJECTOR',\n'DISPOSAL', 'WAG_INJECTOR')",
    ),
    dayWaterInjFlowDirection: AllocatedPropertiesStringSchema.shape.dayWaterInjFlowDirection?.describe(
      "Flow direction for water injection: typically 'INJECTION' indicating water flowing\nfrom surface into the reservoir",
    ),
    dayWaterInjProdMode: AllocatedPropertiesStringSchema.shape.dayWaterInjProdMode?.describe(
      "Operating mode for water injection (e.g., 'NORMAL', 'TEST', 'STIMULATION').\nAffects how injection volumes are categorized for reservoir management.",
    ),
    dayWaterInjMaterialType: AllocatedPropertiesStringSchema.shape.dayWaterInjMaterialType?.describe(
      "Type of water being injected (e.g., 'SEAWATER', 'PRODUCED_WATER', 'FRESH_WATER',\n'TREATED_WATER')",
    ),
    dayWaterInjWaterInjVolume: AllocatedPropertiesStringSchema.shape.dayWaterInjWaterInjVolume?.describe(
      'Daily allocated water injection volume (stb/d or m³/d)',
    ),
    dayWaterInjActiveHours: AllocatedPropertiesStringSchema.shape.dayWaterInjActiveHours?.describe(
      'Number of hours (0-24) the string was actively injecting water during the day.\nUsed to calculate injection efficiency and well availability metrics.',
    ),
    monthAllocProdAllocatedWater: AllocatedPropertiesStringSchema.shape.monthAllocProdAllocatedWater?.describe(
      'Monthly allocated water production volume (stb or m³)',
    ),
    monthAllocProdAllocatedGas: AllocatedPropertiesStringSchema.shape.monthAllocProdAllocatedGas?.describe(
      'Monthly allocated gas production volume (MSCF or km³)',
    ),
    monthAllocProdActiveDays: AllocatedPropertiesStringSchema.shape.monthAllocProdActiveDays?.describe(
      'Number of days (0-31) the string was actively producing during the month.\nUsed to calculate monthly onstream efficiency and average daily rates.',
    ),
    monthAllocProdAllocatedOil: AllocatedPropertiesStringSchema.shape.monthAllocProdAllocatedOil?.describe(
      'Monthly allocated oil production volume (stb or m³)',
    ),
    monthAllocProdFlowDirection: AllocatedPropertiesStringSchema.shape.monthAllocProdFlowDirection?.describe(
      "Predominant flow direction for the month: 'PRODUCTION' or 'INJECTION'.\nUsed for monthly reporting categorization.",
    ),
    monthAllocProdStringFunction: AllocatedPropertiesStringSchema.shape.monthAllocProdStringFunction?.describe(
      "Predominant functional role of the string during the month (e.g., 'PRODUCER',\n'INJECTOR')",
    ),
    monthAllocProdProdMethod: AllocatedPropertiesStringSchema.shape.monthAllocProdProdMethod?.describe(
      "Predominant artificial lift method during the month (e.g., 'NATURAL_FLOW', 'ESP',\n'GAS_LIFT')",
    ),
    monthGasInjMaterialType: AllocatedPropertiesStringSchema.shape.monthGasInjMaterialType?.describe(
      "Predominant type of gas injected during the month (e.g., 'HYDROCARBON_GAS', 'CO2').",
    ),
    monthGasInjFlowDirection: AllocatedPropertiesStringSchema.shape.monthGasInjFlowDirection?.describe(
      "Predominant flow direction for monthly gas injection: typically 'INJECTION'.",
    ),
    monthGasInjActiveDays: AllocatedPropertiesStringSchema.shape.monthGasInjActiveDays?.describe(
      'Number of days (0-31) the string was actively injecting gas during the month.\nUsed to calculate monthly injection efficiency.',
    ),
    monthGasInjGasInjVolume: AllocatedPropertiesStringSchema.shape.monthGasInjGasInjVolume?.describe(
      'Monthly allocated gas injection volume (MSCF or km³)',
    ),
    monthGasInjStringFunction: AllocatedPropertiesStringSchema.shape.monthGasInjStringFunction?.describe(
      "Functional role of the string for monthly gas injection (e.g., 'GAS_INJECTOR',\n'WAG_INJECTOR')",
    ),
    monthGasInjProdMode: AllocatedPropertiesStringSchema.shape.monthGasInjProdMode?.describe(
      "Predominant operating mode for monthly gas injection (e.g., 'NORMAL', 'TEST').",
    ),
    monthWaterInjStringFunction: AllocatedPropertiesStringSchema.shape.monthWaterInjStringFunction?.describe(
      "Functional role of the string for monthly water injection (e.g., 'WATER_INJECTOR',\n'DISPOSAL')",
    ),
    monthWaterInjFlowDirection: AllocatedPropertiesStringSchema.shape.monthWaterInjFlowDirection?.describe(
      "Predominant flow direction for monthly water injection: typically 'INJECTION'.",
    ),
    monthWaterInjProdMode: AllocatedPropertiesStringSchema.shape.monthWaterInjProdMode?.describe(
      "Predominant operating mode for monthly water injection (e.g., 'NORMAL', 'TEST').",
    ),
    monthWaterInjMaterialType: AllocatedPropertiesStringSchema.shape.monthWaterInjMaterialType?.describe(
      "Predominant type of water injected during the month (e.g., 'SEAWATER', 'PRODUCED_WATER').",
    ),
    monthWaterInjWaterInjVolume: AllocatedPropertiesStringSchema.shape.monthWaterInjWaterInjVolume?.describe(
      'Monthly allocated water injection volume (stb or m³)',
    ),
    monthWaterInjActiveDays: AllocatedPropertiesStringSchema.shape.monthWaterInjActiveDays?.describe(
      'Number of days (0-31) the string was actively injecting water during the month.\nUsed to calculate monthly injection availability.',
    ),
    dayGPAllocVolProdMethod: AllocatedPropertiesStringSchema.shape.dayGPAllocVolProdMethod?.describe(
      "Production method applicable to gas plant allocation (e.g., 'NATURAL_FLOW',\n'GAS_LIFT')",
    ),
    dayGPAllocVolStringFunction: AllocatedPropertiesStringSchema.shape.dayGPAllocVolStringFunction?.describe(
      "Functional role of the string for gas plant volume allocation (e.g., 'PRODUCER',\n'GAS_PRODUCER')",
    ),
    dayGPAllocVolAllocatedGas: AllocatedPropertiesStringSchema.shape.dayGPAllocVolAllocatedGas?.describe(
      'Daily gas volume allocated using gas plant (GP) metering and allocation factors.\nMay differ from dayAllocProdAllocatedGas if multiple allocation methods exist.\nUsed for gas plant feed tracking and sales gas accounting.',
    ),
    dayGPAllocVolFlowDirection: AllocatedPropertiesStringSchema.shape.dayGPAllocVolFlowDirection?.describe(
      'Flow direction for gas plant allocation',
    ),
    dayGPAllocVolActiveHours: AllocatedPropertiesStringSchema.shape.dayGPAllocVolActiveHours?.describe(
      'Number of hours (0-24) contributing to gas plant allocation for this string.\nMay differ from production active hours if gas plant was down.',
    ),
    dayGPAllocVolProdMode: AllocatedPropertiesStringSchema.shape.dayGPAllocVolProdMode?.describe(
      "Operating mode for gas plant allocation (e.g., 'NORMAL', 'TEST').\nAffects whether volumes count toward plant feed targets.",
    ),
    monthGPAllocVolProdMethod: AllocatedPropertiesStringSchema.shape.monthGPAllocVolProdMethod?.describe(
      "Production method for monthly gas plant allocation (e.g., 'NATURAL_FLOW', 'GAS_LIFT').",
    ),
    monthGPAllocVolStringFunction: AllocatedPropertiesStringSchema.shape.monthGPAllocVolStringFunction?.describe(
      "Functional role for monthly gas plant allocation (e.g., 'PRODUCER', 'GAS_PRODUCER').",
    ),
    monthGPAllocVolAllocatedGas: AllocatedPropertiesStringSchema.shape.monthGPAllocVolAllocatedGas?.describe(
      'Monthly gas volume allocated using gas plant metering (MSCF or km³)',
    ),
    monthGPAllocVolFlowDirection: AllocatedPropertiesStringSchema.shape.monthGPAllocVolFlowDirection?.describe(
      "Predominant flow direction for monthly gas plant allocation: typically 'PRODUCTION'.",
    ),
    monthGPAllocVolActiveHours: AllocatedPropertiesStringSchema.shape.monthGPAllocVolActiveHours?.describe(
      'Total hours contributing to gas plant allocation for the month.\nMay be less than total production hours if plant had downtime.',
    ),
    monthGPAllocVolProdMode: AllocatedPropertiesStringSchema.shape.monthGPAllocVolProdMode?.describe(
      "Operating mode for monthly gas plant allocation (e.g., 'NORMAL', 'TEST').",
    ),
    dayAllocProdAllocatedOil: AllocatedPropertiesStringSchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily allocated oil production volume (stb/d or m³/d)',
    ),
  })?.describe(
    'ALLOCATED PRODUCTION AND INJECTION DATA for well strings. Contains daily and monthly\nvolumes that have been allocated from metered totals down to individual completions.\n\nKEY CONCEPTS:\n- "Allocated" means volumes have been distributed from facility meters to strings\n  based on well tests, prorated rates, or other allocation methods\n- Daily (dayAllocProd*) vs Monthly (monthAllocProd*) aggregations available\n- Production (AllocProd) vs Injection (GasInj, WaterInj) categories\n\nCOMMON QUERIES:\n- Daily allocated oil for a string: dayAllocProdAllocatedOil\n- Monthly gas injection volume: monthGasInjGasInjVolume\n- Check if string is producing or injecting: dayAllocProdFlowDirection',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const AllocatedRatesDailyStringAgentView = parseView({
  view: { externalId: 'AllocatedRates_Daily_String_Agent' },
  model: AllocatedRatesDailyStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: AllocatedRatesDailyStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    dayAllocProdAllocatedOil: AllocatedRatesDailyStringAgentSchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily allocated oil production volume (stb/d)',
    ),
    dayAllocProdAllocatedGas: AllocatedRatesDailyStringAgentSchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily allocated gas production volume (MSCF/d)',
    ),
    dayAllocProdAllocatedWater: AllocatedRatesDailyStringAgentSchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily allocated water production volume (stb/d)',
    ),
    dayAllocProdActiveHours: AllocatedRatesDailyStringAgentSchema.shape.dayAllocProdActiveHours?.describe(
      'Number of hours (0-24) the string was actively producing during the day.\nUsed to calculate onstream efficiency.',
    ),
    monthAllocProdAllocatedOil: AllocatedRatesDailyStringAgentSchema.shape.monthAllocProdAllocatedOil?.describe(
      'Monthly allocated oil production volume (stb)',
    ),
    monthAllocProdAllocatedGas: AllocatedRatesDailyStringAgentSchema.shape.monthAllocProdAllocatedGas?.describe(
      'Monthly allocated gas production volume (MSCF)',
    ),
    monthAllocProdAllocatedWater: AllocatedRatesDailyStringAgentSchema.shape.monthAllocProdAllocatedWater?.describe(
      'Monthly allocated water production volume (stb)',
    ),
    monthAllocProdActiveDays: AllocatedRatesDailyStringAgentSchema.shape.monthAllocProdActiveDays?.describe(
      'Number of days (0-31) the string was actively producing during the month.\nUsed to calculate monthly onstream efficiency.',
    ),
  })?.describe(
    'Daily and monthly allocated production volumes per well string (WF5).\n\nAllocated oil, gas, water; active hours and days per string from reconciled\nmetered volumes. Use for production performance, uptime, and forecasting. For raw/unallocated data see other views.\n\nUse for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).\n\n@name Allocated Rates - Daily/Monthly (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const AllocatedRatesVfmStringAgentView = parseView({
  view: { externalId: 'AllocatedRates_VFM_String_Agent' },
  model: AllocatedRatesVfmStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: AllocatedRatesVfmStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    preferredVFMAverageOilRate: AllocatedRatesVfmStringAgentSchema.shape.preferredVFMAverageOilRate?.describe(
      'Preferred VFM method average oil rate (stb/d, TS).',
    ),
    preferredVFMAverageAssociatedGasRate:
      AllocatedRatesVfmStringAgentSchema.shape.preferredVFMAverageAssociatedGasRate?.describe(
        'Preferred VFM method average associated gas rate (MSCF/d, TS).',
      ),
    preferredVFMAverageNonAssociatedGasRate:
      AllocatedRatesVfmStringAgentSchema.shape.preferredVFMAverageNonAssociatedGasRate?.describe(
        'Preferred VFM method average non-associated gas rate (MSCF/d, TS).',
      ),
    preferredVFMAverageWaterRate: AllocatedRatesVfmStringAgentSchema.shape.preferredVFMAverageWaterRate?.describe(
      'Preferred VFM method average water rate (stb/d, TS).',
    ),
    preferredVFMEstimatedWellOilVolume:
      AllocatedRatesVfmStringAgentSchema.shape.preferredVFMEstimatedWellOilVolume?.describe(
        'Estimated well oil volume from preferred VFM method (stb, TS).',
      ),
    preferredVFMEstimatedWellWaterVolume:
      AllocatedRatesVfmStringAgentSchema.shape.preferredVFMEstimatedWellWaterVolume?.describe(
        'Estimated well water volume from preferred VFM method (stb, TS).',
      ),
    preferredVFMDataSourceFlag: AllocatedRatesVfmStringAgentSchema.shape.preferredVFMDataSourceFlag?.describe(
      'Which VFM method was selected as preferred.',
    ),
    weightedAverageVFMOilRate: AllocatedRatesVfmStringAgentSchema.shape.weightedAverageVFMOilRate?.describe(
      'Weighted average oil rate across all VFM methods (stb/d, TS).',
    ),
    weightedAverageVFMAssociatedGasRate:
      AllocatedRatesVfmStringAgentSchema.shape.weightedAverageVFMAssociatedGasRate?.describe(
        'Weighted average associated gas rate across VFM methods (MSCF/d, TS).',
      ),
    weightedAverageVFMNonAssociatedGasRate:
      AllocatedRatesVfmStringAgentSchema.shape.weightedAverageVFMNonAssociatedGasRate?.describe(
        'Weighted average non-associated gas rate (MSCF/d, TS).',
      ),
    weightedAverageVFMWaterRate: AllocatedRatesVfmStringAgentSchema.shape.weightedAverageVFMWaterRate?.describe(
      'Weighted average water rate across VFM methods (stb/d, TS).',
    ),
    weightedAverageVFMEstimatedWellOilVolume:
      AllocatedRatesVfmStringAgentSchema.shape.weightedAverageVFMEstimatedWellOilVolume?.describe(
        'Estimated oil volume from weighted average method (stb, TS).',
      ),
    weightedAverageDataSourceFlag: AllocatedRatesVfmStringAgentSchema.shape.weightedAverageDataSourceFlag?.describe(
      'Data source flag for weighted average method.',
    ),
    vfmSystemAnalysisAverageOilRate: AllocatedRatesVfmStringAgentSchema.shape.vfmSystemAnalysisAverageOilRate?.describe(
      'System analysis average oil rate (stb/d, TS).',
    ),
    vfmIPRAverageOilRate: AllocatedRatesVfmStringAgentSchema.shape.vfmIPRAverageOilRate?.describe(
      'IPR analysis average oil rate (stb/d, TS).',
    ),
    vfmVLPAverageOilRate: AllocatedRatesVfmStringAgentSchema.shape.vfmVLPAverageOilRate?.describe(
      'VLP analysis average oil rate (stb/d, TS).',
    ),
    vfmChokeAverageOilRate: AllocatedRatesVfmStringAgentSchema.shape.vfmChokeAverageOilRate?.describe(
      'Choke analysis average oil rate (stb/d, TS).',
    ),
    vfmESPAverageOilRate: AllocatedRatesVfmStringAgentSchema.shape.vfmESPAverageOilRate?.describe(
      'ESP analysis average oil rate (stb/d, TS).',
    ),
    vfmDataDrivenAverageOilRate: AllocatedRatesVfmStringAgentSchema.shape.vfmDataDrivenAverageOilRate?.describe(
      'Data-driven model average oil rate (stb/d, TS).',
    ),
    vfmPreferredMethodOilAllocationRate:
      AllocatedRatesVfmStringAgentSchema.shape.vfmPreferredMethodOilAllocationRate?.describe(
        'Allocated oil rate from preferred VFM method (stb/d, TS).',
      ),
    vfmPreferredMethodAssociatedGasAllocationRate:
      AllocatedRatesVfmStringAgentSchema.shape.vfmPreferredMethodAssociatedGasAllocationRate?.describe(
        'Allocated AG rate from preferred VFM method (MSCF/d, TS).',
      ),
    vfmPreferredMethodNonAssociatedGasAllocationRate:
      AllocatedRatesVfmStringAgentSchema.shape.vfmPreferredMethodNonAssociatedGasAllocationRate?.describe(
        'Allocated NAG rate from preferred VFM method (MSCF/d, TS).',
      ),
    vfmPreferredMethodWaterAllocationRate:
      AllocatedRatesVfmStringAgentSchema.shape.vfmPreferredMethodWaterAllocationRate?.describe(
        'Allocated water rate from preferred VFM method (stb/d, TS).',
      ),
    vfmWeightedAverageMethodOilAllocationRate:
      AllocatedRatesVfmStringAgentSchema.shape.vfmWeightedAverageMethodOilAllocationRate?.describe(
        'Allocated oil rate from weighted average method (stb/d, TS).',
      ),
    vfmWeightedAverageAssociatedGasAllocationRate:
      AllocatedRatesVfmStringAgentSchema.shape.vfmWeightedAverageAssociatedGasAllocationRate?.describe(
        'Allocated AG rate from weighted average method (MSCF/d, TS).',
      ),
    vfmWeightedAverageNonAssociatedGasAllocationRate:
      AllocatedRatesVfmStringAgentSchema.shape.vfmWeightedAverageNonAssociatedGasAllocationRate?.describe(
        'Allocated NAG rate from weighted average method (MSCF/d, TS).',
      ),
    vfmWeightedAverageWaterAllocationRate:
      AllocatedRatesVfmStringAgentSchema.shape.vfmWeightedAverageWaterAllocationRate?.describe(
        'Allocated water rate from weighted average method (stb/d, TS).',
      ),
    averageWaterInjectionRate: AllocatedRatesVfmStringAgentSchema.shape.averageWaterInjectionRate?.describe(
      'Average water injection rate (stb/d, TS).',
    ),
    averageGasInjectionRate: AllocatedRatesVfmStringAgentSchema.shape.averageGasInjectionRate?.describe(
      'Average gas injection rate (MSCF/d, TS).',
    ),
    oilProductionAllocationStatus: AllocatedRatesVfmStringAgentSchema.shape.oilProductionAllocationStatus?.describe(
      'Oil allocation workflow status.',
    ),
    wellUptime: AllocatedRatesVfmStringAgentSchema.shape.wellUptime?.describe(
      'Well uptime hours in allocation period (hrs, TS).',
    ),
  })?.describe(
    'VFM-based allocation rates per well string from WF05 (WF5).\n\nPreferred and weighted-average VFM rates, per-method average oil rates. Use for\ncomparison of allocated rates across methods and preferred vs weighted average. Excludes raw production data.\n\nUse for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).\n\n@name Allocated Rates - VFM Reconciliation (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const AllocationFactorsFieldAgentView = parseView({
  view: { externalId: 'AllocationFactors_Field_Agent' },
  model: AllocationFactorsFieldAgentSchema.extend({
    ...InstanceIdType.shape,
    field: AllocationFactorsFieldAgentSchema.shape.field?.describe('Reference to field'),
    preferredVFMOilAllocationFactor: AllocationFactorsFieldAgentSchema.shape.preferredVFMOilAllocationFactor?.describe(
      'Oil production allocation factor for this field (fraction, TS)',
    ),
    preferredVFMAssociatedGasAllocationFactor:
      AllocationFactorsFieldAgentSchema.shape.preferredVFMAssociatedGasAllocationFactor?.describe(
        'Associated gas production allocation factor for this field (fraction, TS)',
      ),
    preferredVFMNonAssociatedGasAllocationFactor:
      AllocationFactorsFieldAgentSchema.shape.preferredVFMNonAssociatedGasAllocationFactor?.describe(
        'Non-associated gas production allocation factor for this field (fraction, TS)',
      ),
    preferredVFMWaterAllocationFactor:
      AllocationFactorsFieldAgentSchema.shape.preferredVFMWaterAllocationFactor?.describe(
        'Water production allocation factor for this field (fraction, TS)',
      ),
    gasInjectionAllocationFactor: AllocationFactorsFieldAgentSchema.shape.gasInjectionAllocationFactor?.describe(
      'Gas injection allocation factor for this field (fraction, TS).\nUse for "Show injection gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.',
    ),
    waterInjectionAllocationFactor: AllocationFactorsFieldAgentSchema.shape.waterInjectionAllocationFactor?.describe(
      'Water injection allocation factor for this field (fraction, TS).\nUse for "Show injection water Allocation Factor trend" over Day/Week/Month/Quarter/Year.',
    ),
    weightedAverageVFMOilAllocationFactor:
      AllocationFactorsFieldAgentSchema.shape.weightedAverageVFMOilAllocationFactor?.describe(
        'Weighted average VFM oil production allocation factor for this field (fraction, TS).',
      ),
    weightedAverageVFMAssociatedGasAllocationFactor:
      AllocationFactorsFieldAgentSchema.shape.weightedAverageVFMAssociatedGasAllocationFactor?.describe(
        'Weighted average VFM associated gas allocation factor for this field (fraction, TS).',
      ),
    weightedAverageVFMNonAssociatedGasAllocationFactor:
      AllocationFactorsFieldAgentSchema.shape.weightedAverageVFMNonAssociatedGasAllocationFactor?.describe(
        'Weighted average VFM non-associated gas allocation factor for this field (fraction, TS).',
      ),
    weightedAverageVFMWaterAllocationFactor:
      AllocationFactorsFieldAgentSchema.shape.weightedAverageVFMWaterAllocationFactor?.describe(
        'Weighted average VFM water allocation factor for this field (fraction, TS).',
      ),
  })?.describe(
    'Field-level allocation factor time series (WF5).\n\nVFM-based allocation factors for oil, assoc/non-assoc gas, water production, and gas/water injection at field level. Use for allocation factor trends by period and field/reservoir/sector. Use with FlatHierarchy_Agent or DailyRollupField_Agent for context.\n\nUse for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).\n\n@name Allocation Factors - Field (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const AllocationOutputStringView = parseView({
  view: { externalId: 'AllocationOutput_String' },
  model: AllocationOutputStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: AllocationOutputStringSchema.shape.entityName?.describe('Reference to the String_asset entity'),
    allocatedOilRate: AllocationOutputStringSchema.shape.allocatedOilRate?.describe(
      "Real-time allocated oil production rate (stb/d) from the allocation engine.\nThis is the string's instantaneous share of total metered oil, calculated\nfrom current well test factors and prorated measurements",
    ),
    allocatedWaterRate: AllocationOutputStringSchema.shape.allocatedWaterRate?.describe(
      'Real-time allocated water production rate (stb/d) from the allocation engine.\nUsed for real-time water cut monitoring and water handling capacity tracking.',
    ),
    allocatedGasRate: AllocationOutputStringSchema.shape.allocatedGasRate?.describe(
      'Real-time allocated gas production rate (MSCF/d) from the allocation engine.\nIncludes both solution gas and free gas',
    ),
    allocProdActiveHours: AllocationOutputStringSchema.shape.allocProdActiveHours?.describe(
      'Cumulative production active hours within the current allocation period.\nRunning count of hours the string has been producing, used to calculate\nperiod-to-date volumes and onstream efficiency.',
    ),
    allocInjActiveHours: AllocationOutputStringSchema.shape.allocInjActiveHours?.describe(
      'Cumulative injection active hours within the current allocation period.\nRunning count of hours the string has been injecting, used to calculate\nperiod-to-date injection volumes and availability metrics.',
    ),
    allocatedWaterInjRate: AllocationOutputStringSchema.shape.allocatedWaterInjRate?.describe(
      "Real-time allocated water injection rate (stb/d) from the allocation engine.\nThe string's instantaneous share of total metered water injection, used for\nreal-time voidage monitoring and injection surveillance.",
    ),
    allocatedGasInjRate: AllocationOutputStringSchema.shape.allocatedGasInjRate?.describe(
      "Real-time allocated gas injection rate (MSCF/d) from the allocation engine.\nThe string's instantaneous share of total metered gas injection, used for\nreal-time injection surveillance and EOR monitoring.",
    ),
  })?.describe(
    'REAL-TIME ALLOCATION ENGINE OUTPUTS for well strings. Contains instantaneous\nallocated rates from the production allocation system, updated more frequently\nthan the daily/monthly volumes in AllocatedProperties_String.\n\nKEY DIFFERENCES FROM AllocatedProperties_String:\n- This view has REAL-TIME allocated rates (updated continuously or hourly)\n- AllocatedProperties has DAILY/MONTHLY aggregated volumes (end-of-day/month)\n\nUSE CASES:\n- Real-time surveillance dashboards\n- Intra-day rate monitoring\n- Allocation engine troubleshooting\n- Comparing instantaneous vs daily allocated volumes',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const AsphalteneCurveView = parseView({
  view: { externalId: 'Asphaltene_Curve' },
  model: AsphalteneCurveSchema.extend({
    ...InstanceIdType.shape,
    date: AsphalteneCurveSchema.shape.date?.describe("Timestamp 'date' associated with this 'Asphaltene_Curve' row."),
    asphTable: AsphalteneCurveSchema.shape.asphTable?.describe(
      "Text attribute 'asphTable' for this 'Asphaltene_Curve' row.",
    ),
    asphP: AsphalteneCurveSchema.shape.asphP?.describe(
      "Numeric value 'asphP' (floating point) for this 'Asphaltene_Curve' row.",
    ),
    asphT: AsphalteneCurveSchema.shape.asphT?.describe(
      "Numeric value 'asphT' (floating point) for this 'Asphaltene_Curve' row.",
    ),
    sequence: AsphalteneCurveSchema.shape.sequence?.describe(
      "Numeric value 'sequence' (integer) for this 'Asphaltene_Curve' row.",
    ),
  })?.describe("View 'Asphaltene_Curve' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const AssetView = parseView({
  view: { externalId: 'Asset' },
  model: AssetSchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ChokeCurveInfoView = parseView({
  view: { externalId: 'Choke_Curve_Info' },
  model: ChokeCurveInfoSchema.extend({
    ...InstanceIdType.shape,
    chokeType: ChokeCurveInfoSchema.shape.chokeType?.describe(
      'Choke Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    chokeOpening: ChokeCurveInfoSchema.shape.chokeOpening?.describe(
      'Numeric value storing choke opening for this entity, used in calculations, reporting, or model configuration.',
    ),
    chokeBeanSize: ChokeCurveInfoSchema.shape.chokeBeanSize?.describe(
      'Numeric value storing choke bean size for this entity, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'Choke performance curve information capturing the relationship between choke opening, pressure drop, and flow rate used to model constraints and optimize choke settings.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const CompanyView = parseView({
  view: { externalId: 'Company' },
  model: CompanySchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const DailyRollupFieldAgentView = parseView({
  view: { externalId: 'DailyRollupField_Agent' },
  model: DailyRollupFieldAgentSchema.extend({
    ...InstanceIdType.shape,
    fieldEntity: DailyRollupFieldAgentSchema.shape.fieldEntity?.describe('Reference to field'),
    dayAllocProdAllocatedOil: DailyRollupFieldAgentSchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily allocated oil production volume (Sm3)',
    ),
    dayAllocProdAllocatedGas: DailyRollupFieldAgentSchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily allocated gas production volume (Sm3)',
    ),
    dayAllocProdAllocatedWater: DailyRollupFieldAgentSchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily allocated water production volume (Sm3)',
    ),
    dayAllocProdAllocatedOilRate: DailyRollupFieldAgentSchema.shape.dayAllocProdAllocatedOilRate?.describe(
      'Daily allocated oil production rate (Sm3/d or bbl/d).',
    ),
    dayAllocProdAllocatedGasRate: DailyRollupFieldAgentSchema.shape.dayAllocProdAllocatedGasRate?.describe(
      'Daily allocated gas production rate (Sm3/d).',
    ),
    dayAllocProdAllocatedWaterRate: DailyRollupFieldAgentSchema.shape.dayAllocProdAllocatedWaterRate?.describe(
      'Daily allocated water production rate (Sm3/d).',
    ),
    potentialOilProduction: DailyRollupFieldAgentSchema.shape.potentialOilProduction?.describe(
      'Unconstrained oil production potential',
    ),
    targetOilproduction: DailyRollupFieldAgentSchema.shape.targetOilproduction?.describe(
      'Target oil production from planning',
    ),
    potentialGasProduction: DailyRollupFieldAgentSchema.shape.potentialGasProduction?.describe(
      'Unconstrained gas production potential',
    ),
    targetGasProduction: DailyRollupFieldAgentSchema.shape.targetGasProduction?.describe(
      'Target gas production from planning',
    ),
    potentialWaterProduction: DailyRollupFieldAgentSchema.shape.potentialWaterProduction?.describe(
      'Unconstrained water production potential',
    ),
    targetWaterProduction: DailyRollupFieldAgentSchema.shape.targetWaterProduction?.describe(
      'Target water production from planning',
    ),
    dayAllocInjGasInjection: DailyRollupFieldAgentSchema.shape.dayAllocInjGasInjection?.describe(
      'Daily allocated gas injection volume (Sm3)',
    ),
    dayAllocInjWaterInjection: DailyRollupFieldAgentSchema.shape.dayAllocInjWaterInjection?.describe(
      'Daily allocated water injection volume (Sm3)',
    ),
    dayAllocInjGasInjectionRate: DailyRollupFieldAgentSchema.shape.dayAllocInjGasInjectionRate?.describe(
      'Daily allocated gas injection rate (Sm3/d).',
    ),
    dayAllocInjWaterInjectionRate: DailyRollupFieldAgentSchema.shape.dayAllocInjWaterInjectionRate?.describe(
      'Daily allocated water injection rate (Sm3/d).',
    ),
    potentialGasInjection: DailyRollupFieldAgentSchema.shape.potentialGasInjection?.describe(
      'Unconstrained gas injection potential',
    ),
    targetGasInjection: DailyRollupFieldAgentSchema.shape.targetGasInjection?.describe(
      'Target gas injection from planning',
    ),
    potentialWaterInjection: DailyRollupFieldAgentSchema.shape.potentialWaterInjection?.describe(
      'Unconstrained water injection potential',
    ),
    targetWaterInjection: DailyRollupFieldAgentSchema.shape.targetWaterInjection?.describe(
      'Target water injection from planning',
    ),
  })?.describe(
    'Daily field-level production and injection rollups for surveillance and target\ncomparison.\n\nContains daily aggregated data on production and injection volumes for oil,\ngas, and water at the field level, derived from operational reports and\nallocation systems. It answers analytical questions regarding field\nperformance, such as actual versus target production rates and injection\nmonitoring for various fluids. The view excludes detailed well-level data. Use\ncases: performance surveillance, operational planning, and identifying\ndiscrepancies between expected and actual production metrics.',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const DailyRollupOutputAssetView = parseView({
  view: { externalId: 'DailyRollupOutput_Asset' },
  model: DailyRollupOutputAssetSchema.extend({
    ...InstanceIdType.shape,
    entityName: DailyRollupOutputAssetSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    dayAllocProdAllocatedOil: DailyRollupOutputAssetSchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily final allocated oil production volume allocated to this asset, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedWater: DailyRollupOutputAssetSchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily final allocated water production volume allocated to this asset, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedGas: DailyRollupOutputAssetSchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily final allocated gas production volume allocated to this asset, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedOilRate: DailyRollupOutputAssetSchema.shape.dayAllocProdAllocatedOilRate?.describe(
      'Daily final allocated oil production rate for this asset, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedWaterRate: DailyRollupOutputAssetSchema.shape.dayAllocProdAllocatedWaterRate?.describe(
      'Daily final allocated water production rate for this asset, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedGasRate: DailyRollupOutputAssetSchema.shape.dayAllocProdAllocatedGasRate?.describe(
      'Daily final allocated gas production rate for this asset, derived by the allocation engine from tests, meters, and network constraints',
    ),
    potentialOilProduction: DailyRollupOutputAssetSchema.shape.potentialOilProduction?.describe(
      'Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetOilproduction: DailyRollupOutputAssetSchema.shape.targetOilproduction?.describe(
      'Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasProduction: DailyRollupOutputAssetSchema.shape.potentialGasProduction?.describe(
      'Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasProduction: DailyRollupOutputAssetSchema.shape.targetGasProduction?.describe(
      'Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterProduction: DailyRollupOutputAssetSchema.shape.potentialWaterProduction?.describe(
      'Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterProduction: DailyRollupOutputAssetSchema.shape.targetWaterProduction?.describe(
      'Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterInjection: DailyRollupOutputAssetSchema.shape.potentialWaterInjection?.describe(
      'Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterInjection: DailyRollupOutputAssetSchema.shape.targetWaterInjection?.describe(
      'Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasInjection: DailyRollupOutputAssetSchema.shape.potentialGasInjection?.describe(
      'Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasInjection: DailyRollupOutputAssetSchema.shape.targetGasInjection?.describe(
      'Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    dayAllocInjGasInjectionRate: DailyRollupOutputAssetSchema.shape.dayAllocInjGasInjectionRate?.describe(
      'Daily final allocated gas injection rate for this asset, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjWaterInjectionRate: DailyRollupOutputAssetSchema.shape.dayAllocInjWaterInjectionRate?.describe(
      'Daily final allocated water injection rate for this asset, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjGasInjection: DailyRollupOutputAssetSchema.shape.dayAllocInjGasInjection?.describe(
      'Daily final allocated gas injection volume allocated to this asset, after distributing measured totals down to the appropriate level',
    ),
    dayAllocInjWaterInjection: DailyRollupOutputAssetSchema.shape.dayAllocInjWaterInjection?.describe(
      'Daily final allocated water injection volume allocated to this asset, after distributing measured totals down to the appropriate level',
    ),
  })?.describe(
    'Daily roll-up of allocated, target, and potential production and injection metrics at an asset level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const DailyRollupOutputCompanyView = parseView({
  view: { externalId: 'DailyRollupOutput_Company' },
  model: DailyRollupOutputCompanySchema.extend({
    ...InstanceIdType.shape,
    entityName: DailyRollupOutputCompanySchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    dayAllocProdAllocatedOil: DailyRollupOutputCompanySchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily final allocated oil production volume allocated to this company portfolio, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedWater: DailyRollupOutputCompanySchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily final allocated water production volume allocated to this company portfolio, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedGas: DailyRollupOutputCompanySchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily final allocated gas production volume allocated to this company portfolio, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedOilRate: DailyRollupOutputCompanySchema.shape.dayAllocProdAllocatedOilRate?.describe(
      'Daily final allocated oil production rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedWaterRate: DailyRollupOutputCompanySchema.shape.dayAllocProdAllocatedWaterRate?.describe(
      'Daily final allocated water production rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedGasRate: DailyRollupOutputCompanySchema.shape.dayAllocProdAllocatedGasRate?.describe(
      'Daily final allocated gas production rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints',
    ),
    potentialOilProduction: DailyRollupOutputCompanySchema.shape.potentialOilProduction?.describe(
      'Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetOilproduction: DailyRollupOutputCompanySchema.shape.targetOilproduction?.describe(
      'Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasProduction: DailyRollupOutputCompanySchema.shape.potentialGasProduction?.describe(
      'Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasProduction: DailyRollupOutputCompanySchema.shape.targetGasProduction?.describe(
      'Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterProduction: DailyRollupOutputCompanySchema.shape.potentialWaterProduction?.describe(
      'Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterProduction: DailyRollupOutputCompanySchema.shape.targetWaterProduction?.describe(
      'Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterInjection: DailyRollupOutputCompanySchema.shape.potentialWaterInjection?.describe(
      'Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterInjection: DailyRollupOutputCompanySchema.shape.targetWaterInjection?.describe(
      'Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasInjection: DailyRollupOutputCompanySchema.shape.potentialGasInjection?.describe(
      'Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasInjection: DailyRollupOutputCompanySchema.shape.targetGasInjection?.describe(
      'Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    dayAllocInjGasInjectionRate: DailyRollupOutputCompanySchema.shape.dayAllocInjGasInjectionRate?.describe(
      'Daily final allocated gas injection rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjWaterInjectionRate: DailyRollupOutputCompanySchema.shape.dayAllocInjWaterInjectionRate?.describe(
      'Daily final allocated water injection rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjGasInjection: DailyRollupOutputCompanySchema.shape.dayAllocInjGasInjection?.describe(
      'Daily final allocated gas injection volume allocated to this company portfolio, after distributing measured totals down to the appropriate level',
    ),
    dayAllocInjWaterInjection: DailyRollupOutputCompanySchema.shape.dayAllocInjWaterInjection?.describe(
      'Daily final allocated water injection volume allocated to this company portfolio, after distributing measured totals down to the appropriate level',
    ),
  })?.describe(
    'Daily roll-up of allocated, target, and potential production and injection metrics at a company portfolio level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const DailyRollupOutputFieldView = parseView({
  view: { externalId: 'DailyRollupOutput_Field' },
  model: DailyRollupOutputFieldSchema.extend({
    ...InstanceIdType.shape,
    entityName: DailyRollupOutputFieldSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    dayAllocProdAllocatedOil: DailyRollupOutputFieldSchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily final allocated oil production volume allocated to this field, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedWater: DailyRollupOutputFieldSchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily final allocated water production volume allocated to this field, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedGas: DailyRollupOutputFieldSchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily final allocated gas production volume allocated to this field, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedOilRate: DailyRollupOutputFieldSchema.shape.dayAllocProdAllocatedOilRate?.describe(
      'Daily final allocated oil production rate for this field, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedWaterRate: DailyRollupOutputFieldSchema.shape.dayAllocProdAllocatedWaterRate?.describe(
      'Daily final allocated water production rate for this field, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedGasRate: DailyRollupOutputFieldSchema.shape.dayAllocProdAllocatedGasRate?.describe(
      'Daily final allocated gas production rate for this field, derived by the allocation engine from tests, meters, and network constraints',
    ),
    potentialOilProduction: DailyRollupOutputFieldSchema.shape.potentialOilProduction?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetOilproduction: DailyRollupOutputFieldSchema.shape.targetOilproduction?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasProduction: DailyRollupOutputFieldSchema.shape.potentialGasProduction?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasProduction: DailyRollupOutputFieldSchema.shape.targetGasProduction?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterProduction: DailyRollupOutputFieldSchema.shape.potentialWaterProduction?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterProduction: DailyRollupOutputFieldSchema.shape.targetWaterProduction?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterInjection: DailyRollupOutputFieldSchema.shape.potentialWaterInjection?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterInjection: DailyRollupOutputFieldSchema.shape.targetWaterInjection?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasInjection: DailyRollupOutputFieldSchema.shape.potentialGasInjection?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasInjection: DailyRollupOutputFieldSchema.shape.targetGasInjection?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    dayAllocInjGasInjectionRate: DailyRollupOutputFieldSchema.shape.dayAllocInjGasInjectionRate?.describe(
      'Daily final allocated gas injection rate for this field, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjWaterInjectionRate: DailyRollupOutputFieldSchema.shape.dayAllocInjWaterInjectionRate?.describe(
      'Daily final allocated water injection rate for this field, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjGasInjection: DailyRollupOutputFieldSchema.shape.dayAllocInjGasInjection?.describe(
      'Daily final allocated gas injection volume allocated to this field, after distributing measured totals down to the appropriate level',
    ),
    dayAllocInjWaterInjection: DailyRollupOutputFieldSchema.shape.dayAllocInjWaterInjection?.describe(
      'Daily final allocated water injection volume allocated to this field, after distributing measured totals down to the appropriate level',
    ),
  })?.describe(
    'Daily roll-up of allocated, target, and potential production and injection metrics at a field level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const DailyRollupOutputLocationView = parseView({
  view: { externalId: 'DailyRollupOutput_Location' },
  model: DailyRollupOutputLocationSchema.extend({
    ...InstanceIdType.shape,
    entityName: DailyRollupOutputLocationSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    dayAllocProdAllocatedOil: DailyRollupOutputLocationSchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily final allocated oil production volume allocated to this surface location, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedWater: DailyRollupOutputLocationSchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily final allocated water production volume allocated to this surface location, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedGas: DailyRollupOutputLocationSchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily final allocated gas production volume allocated to this surface location, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedOilRate: DailyRollupOutputLocationSchema.shape.dayAllocProdAllocatedOilRate?.describe(
      'Daily final allocated oil production rate for this surface location, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedWaterRate: DailyRollupOutputLocationSchema.shape.dayAllocProdAllocatedWaterRate?.describe(
      'Daily final allocated water production rate for this surface location, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedGasRate: DailyRollupOutputLocationSchema.shape.dayAllocProdAllocatedGasRate?.describe(
      'Daily final allocated gas production rate for this surface location, derived by the allocation engine from tests, meters, and network constraints',
    ),
    potentialOilProduction: DailyRollupOutputLocationSchema.shape.potentialOilProduction?.describe(
      'Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetOilproduction: DailyRollupOutputLocationSchema.shape.targetOilproduction?.describe(
      'Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasProduction: DailyRollupOutputLocationSchema.shape.potentialGasProduction?.describe(
      'Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasProduction: DailyRollupOutputLocationSchema.shape.targetGasProduction?.describe(
      'Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterProduction: DailyRollupOutputLocationSchema.shape.potentialWaterProduction?.describe(
      'Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterProduction: DailyRollupOutputLocationSchema.shape.targetWaterProduction?.describe(
      'Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterInjection: DailyRollupOutputLocationSchema.shape.potentialWaterInjection?.describe(
      'Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterInjection: DailyRollupOutputLocationSchema.shape.targetWaterInjection?.describe(
      'Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasInjection: DailyRollupOutputLocationSchema.shape.potentialGasInjection?.describe(
      'Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasInjection: DailyRollupOutputLocationSchema.shape.targetGasInjection?.describe(
      'Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    dayAllocInjGasInjectionRate: DailyRollupOutputLocationSchema.shape.dayAllocInjGasInjectionRate?.describe(
      'Daily final allocated gas injection rate for this surface location, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjWaterInjectionRate: DailyRollupOutputLocationSchema.shape.dayAllocInjWaterInjectionRate?.describe(
      'Daily final allocated water injection rate for this surface location, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjGasInjection: DailyRollupOutputLocationSchema.shape.dayAllocInjGasInjection?.describe(
      'Daily final allocated gas injection volume allocated to this surface location, after distributing measured totals down to the appropriate level',
    ),
    dayAllocInjWaterInjection: DailyRollupOutputLocationSchema.shape.dayAllocInjWaterInjection?.describe(
      'Daily final allocated water injection volume allocated to this surface location, after distributing measured totals down to the appropriate level',
    ),
  })?.describe(
    'Daily roll-up of allocated, target, and potential production and injection metrics at a surface location level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const DailyRollupOutputReservoirView = parseView({
  view: { externalId: 'DailyRollupOutput_Reservoir' },
  model: DailyRollupOutputReservoirSchema.extend({
    ...InstanceIdType.shape,
    entityName: DailyRollupOutputReservoirSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    dayAllocProdAllocatedOil: DailyRollupOutputReservoirSchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily final allocated oil production volume allocated to this reservoir, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedWater: DailyRollupOutputReservoirSchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily final allocated water production volume allocated to this reservoir, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedGas: DailyRollupOutputReservoirSchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily final allocated gas production volume allocated to this reservoir, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedOilRate: DailyRollupOutputReservoirSchema.shape.dayAllocProdAllocatedOilRate?.describe(
      'Daily final allocated oil production rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedWaterRate: DailyRollupOutputReservoirSchema.shape.dayAllocProdAllocatedWaterRate?.describe(
      'Daily final allocated water production rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedGasRate: DailyRollupOutputReservoirSchema.shape.dayAllocProdAllocatedGasRate?.describe(
      'Daily final allocated gas production rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints',
    ),
    potentialOilProduction: DailyRollupOutputReservoirSchema.shape.potentialOilProduction?.describe(
      'Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetOilproduction: DailyRollupOutputReservoirSchema.shape.targetOilproduction?.describe(
      'Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasProduction: DailyRollupOutputReservoirSchema.shape.potentialGasProduction?.describe(
      'Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasProduction: DailyRollupOutputReservoirSchema.shape.targetGasProduction?.describe(
      'Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterProduction: DailyRollupOutputReservoirSchema.shape.potentialWaterProduction?.describe(
      'Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterProduction: DailyRollupOutputReservoirSchema.shape.targetWaterProduction?.describe(
      'Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterInjection: DailyRollupOutputReservoirSchema.shape.potentialWaterInjection?.describe(
      'Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterInjection: DailyRollupOutputReservoirSchema.shape.targetWaterInjection?.describe(
      'Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasInjection: DailyRollupOutputReservoirSchema.shape.potentialGasInjection?.describe(
      'Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasInjection: DailyRollupOutputReservoirSchema.shape.targetGasInjection?.describe(
      'Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    dayAllocInjGasInjectionRate: DailyRollupOutputReservoirSchema.shape.dayAllocInjGasInjectionRate?.describe(
      'Daily final allocated gas injection rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjWaterInjectionRate: DailyRollupOutputReservoirSchema.shape.dayAllocInjWaterInjectionRate?.describe(
      'Daily final allocated water injection rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjGasInjection: DailyRollupOutputReservoirSchema.shape.dayAllocInjGasInjection?.describe(
      'Daily final allocated gas injection volume allocated to this reservoir, after distributing measured totals down to the appropriate level',
    ),
    dayAllocInjWaterInjection: DailyRollupOutputReservoirSchema.shape.dayAllocInjWaterInjection?.describe(
      'Daily final allocated water injection volume allocated to this reservoir, after distributing measured totals down to the appropriate level',
    ),
  })?.describe(
    'Daily roll-up of allocated, target, and potential production and injection metrics at a reservoir level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const DailyRollupOutputWellView = parseView({
  view: { externalId: 'DailyRollupOutput_Well' },
  model: DailyRollupOutputWellSchema.extend({
    ...InstanceIdType.shape,
    entityName: DailyRollupOutputWellSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    dayAllocProdAllocatedOil: DailyRollupOutputWellSchema.shape.dayAllocProdAllocatedOil?.describe(
      'Daily final allocated oil production volume allocated to this well, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedWater: DailyRollupOutputWellSchema.shape.dayAllocProdAllocatedWater?.describe(
      'Daily final allocated water production volume allocated to this well, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedGas: DailyRollupOutputWellSchema.shape.dayAllocProdAllocatedGas?.describe(
      'Daily final allocated gas production volume allocated to this well, after distributing measured totals down to the appropriate level',
    ),
    dayAllocProdAllocatedOilRate: DailyRollupOutputWellSchema.shape.dayAllocProdAllocatedOilRate?.describe(
      'Daily final allocated oil production rate for this well, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedWaterRate: DailyRollupOutputWellSchema.shape.dayAllocProdAllocatedWaterRate?.describe(
      'Daily final allocated water production rate for this well, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocProdAllocatedGasRate: DailyRollupOutputWellSchema.shape.dayAllocProdAllocatedGasRate?.describe(
      'Daily final allocated gas production rate for this well, derived by the allocation engine from tests, meters, and network constraints',
    ),
    potentialOilProduction: DailyRollupOutputWellSchema.shape.potentialOilProduction?.describe(
      'Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetOilproduction: DailyRollupOutputWellSchema.shape.targetOilproduction?.describe(
      'Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasProduction: DailyRollupOutputWellSchema.shape.potentialGasProduction?.describe(
      'Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasProduction: DailyRollupOutputWellSchema.shape.targetGasProduction?.describe(
      'Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterProduction: DailyRollupOutputWellSchema.shape.potentialWaterProduction?.describe(
      'Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterProduction: DailyRollupOutputWellSchema.shape.targetWaterProduction?.describe(
      'Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialWaterInjection: DailyRollupOutputWellSchema.shape.potentialWaterInjection?.describe(
      'Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetWaterInjection: DailyRollupOutputWellSchema.shape.targetWaterInjection?.describe(
      'Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    potentialGasInjection: DailyRollupOutputWellSchema.shape.potentialGasInjection?.describe(
      'Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    targetGasInjection: DailyRollupOutputWellSchema.shape.targetGasInjection?.describe(
      'Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    dayAllocInjGasInjectionRate: DailyRollupOutputWellSchema.shape.dayAllocInjGasInjectionRate?.describe(
      'Daily final allocated gas injection rate for this well, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjWaterInjectionRate: DailyRollupOutputWellSchema.shape.dayAllocInjWaterInjectionRate?.describe(
      'Daily final allocated water injection rate for this well, derived by the allocation engine from tests, meters, and network constraints',
    ),
    dayAllocInjGasInjection: DailyRollupOutputWellSchema.shape.dayAllocInjGasInjection?.describe(
      'Daily final allocated gas injection volume allocated to this well, after distributing measured totals down to the appropriate level',
    ),
    dayAllocInjWaterInjection: DailyRollupOutputWellSchema.shape.dayAllocInjWaterInjection?.describe(
      'Daily final allocated water injection volume allocated to this well, after distributing measured totals down to the appropriate level',
    ),
  })?.describe(
    'Daily roll-up of allocated, target, and potential production and injection metrics at a well level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const DataDrivenRatesStringAgentView = parseView({
  view: { externalId: 'DataDrivenRates_String_Agent' },
  model: DataDrivenRatesStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: DataDrivenRatesStringAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'Data-driven and ML rate estimates with injection compliance per well string (WF10).\n\nProperties from WellOutputs_Ext_1_String. ML-derived oil, gas, water, liquid\nrates and injector compliance. Use when querying ML outputs or injector compliance. For physics-based and priority rates use EstimatedRates_String_Agent.\n\nUse for: Real-Time Well Rate and Pressure Estimation (WF10).\n\n@name Data-Driven Rates - String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const DataMappingView = parseView({
  view: { externalId: 'Data_Mapping' },
  model: DataMappingSchema.extend({
    ...InstanceIdType.shape,
    stringName: DataMappingSchema.shape.stringName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    date: DataMappingSchema.shape.date?.describe(
      'Attribute capturing date for this entity in the production optimization context.',
    ),
    reservoirPressureString: DataMappingSchema.shape.reservoirPressureString?.describe(
      'Numeric value storing reservoir pressure string for this entity, used in calculations, reporting, or model configuration.',
    ),
    fieldName: DataMappingSchema.shape.fieldName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    reservoirName: DataMappingSchema.shape.reservoirName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    lat: DataMappingSchema.shape.lat?.describe(
      'Numeric value storing lat for this entity, used in calculations, reporting, or model configuration.',
    ),
    long: DataMappingSchema.shape.long?.describe(
      'Numeric value storing long for this entity, used in calculations, reporting, or model configuration.',
    ),
    x: DataMappingSchema.shape.x?.describe(
      'Numeric value storing x for this entity, used in calculations, reporting, or model configuration.',
    ),
    y: DataMappingSchema.shape.y?.describe(
      'Numeric value storing y for this entity, used in calculations, reporting, or model configuration.',
    ),
    reservoirPressureRMSError: DataMappingSchema.shape.reservoirPressureRMSError?.describe(
      'Numeric value storing reservoir pressure rmserror for this entity, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'Data Mapping view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const EntityAgentView = parseView({
  view: { externalId: 'Entity_Agent' },
  model: EntityAgentSchema.extend({
    ...InstanceIdType.shape,
    name: EntityAgentSchema.shape.name?.describe('Display name of the entity.'),
    entityType: EntityAgentSchema.shape.entityType?.describe('Type of entity'),
    startDateTime: EntityAgentSchema.shape.startDateTime?.describe('Timestamp at which the entity became active.'),
    endDateTime: EntityAgentSchema.shape.endDateTime?.describe('Timestamp at which the entity was deactivated.'),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Base entity registry â€” companies, assets, fields, reservoirs, sectors,\nlocations, wells, and strings â€” scoped to in-scope instance spaces.\n\nSingle catalogue of every logical entity in the iPSO model with its display\nname, type, and effective date range. Underpins the hierarchy and per-entity\nviews; sourced from the central entity repository. Excludes operational or\nmeasurement data.\n\n@name Entity (Agent Scoped)',
    ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EntityView = parseView({
  view: { externalId: 'Entity' },
  model: EntitySchema.extend({
    ...InstanceIdType.shape,
    name: EntitySchema.shape.name?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    startDateTime: EntitySchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this entity in the production optimization context.',
    ),
    endDateTime: EntitySchema.shape.endDateTime?.describe(
      'Attribute capturing end date time for this entity in the production optimization context.',
    ),
    entityType: EntitySchema.shape.entityType?.describe(
      'Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      "Base view for all logical entities in the iPSO solution (company, asset, field, reservoir, location, well, string, etc.). Other views like 'Well', 'Field', 'Reservoir' and 'String_asset' filter this view by 'entityType' and should be preferred for traversal and querying rather than using 'Entity' directly.",
    ),
  dataModel: DataModel.IpsoSolution,
});

export const EspAlarmsAgentView = parseView({
  view: { externalId: 'ESPAlarms_Agent' },
  model: EspAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    entityName: EspAlarmsAgentSchema.shape.entityName?.describe(
      'Display name of the entity (well, string) with the alarm.',
    ),
    entityExternalId: EspAlarmsAgentSchema.shape.entityExternalId?.describe(
      'External ID of the entity for joining to other views.',
    ),
    entityType: EspAlarmsAgentSchema.shape.entityType?.describe('Type of entity (string, well, field).'),
    startDateTime: EspAlarmsAgentSchema.shape.startDateTime?.describe('When the alarm was triggered.'),
    endDateTime: EspAlarmsAgentSchema.shape.endDateTime?.describe('When the alarm was cleared'),
    alarmCode: EspAlarmsAgentSchema.shape.alarmCode?.describe('Reference to AlarmDefinition node.'),
    alarmCodeExternalId: EspAlarmsAgentSchema.shape.alarmCodeExternalId?.describe(
      'Alarm code identifier (WF12-001, WF12-002, etc.).',
    ),
    alarmPriority: EspAlarmsAgentSchema.shape.alarmPriority?.describe('Alarm priority level'),
    alarmCriticality: EspAlarmsAgentSchema.shape.alarmCriticality?.describe('Alarm criticality level'),
    alarmCategory: EspAlarmsAgentSchema.shape.alarmCategory?.describe('Alarm category (ESP).'),
    alarmName: EspAlarmsAgentSchema.shape.alarmName?.describe('Human-readable alarm name from AlarmDefinition.'),
    customWorkflowAlarmMessage: EspAlarmsAgentSchema.shape.customWorkflowAlarmMessage?.describe(
      'Detailed alarm message with specific conditions that triggered it.',
    ),
    alarmFlags: EspAlarmsAgentSchema.shape.alarmFlags?.describe('Alarm validity flag'),
    ticketId: EspAlarmsAgentSchema.shape.ticketId?.describe('Associated troubleshooting ticket ID if one was created.'),
    alarmCounter: EspAlarmsAgentSchema.shape.alarmCounter?.describe('Count of how many times this alarm has occurred.'),
    workflowCode: EspAlarmsAgentSchema.shape.workflowCode?.describe('Workflow code (WF12 for ESP).'),
    workflowName: EspAlarmsAgentSchema.shape.workflowName?.describe('Workflow name from AlarmDefinition.'),
    subCategory: EspAlarmsAgentSchema.shape.subCategory?.describe('Alarm sub-category for domain filtering.'),
    subWorkflowName: EspAlarmsAgentSchema.shape.subWorkflowName?.describe('Sub-workflow that generated the alarm.'),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'ESP and motor performance alarms (WF12) with medium or high priority.\n\nContains alarms generated by Electric Submersible Pumps (ESPs) and associated\nmotors, medium and high-priority alarms as part of the WF12 workflow. Sourced\nfrom operational monitoring systems that track ESP performance and\ndiagnostics, to analyze alarm occurrences, their severity, and potential\nimpacts on production. It can answer questions regarding the frequency and\ntypes of alarms, trends in alarm priorities, and the relationship between\nalarm occurrences and operational performance. Excludes low-priority or non-WF12 alarms.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12), Real-Time Surveillance (WF18).\n\n@name ESP Alarms (Agent)',
    ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EspCableView = parseView({
  view: { externalId: 'ESPCable' },
  model: EspCableSchema.extend({
    ...InstanceIdType.shape,
    prosperIndex: EspCableSchema.shape.prosperIndex?.describe(
      "Numeric value 'prosperIndex' (integer) for this 'ESPCable' row.",
    ),
    cableType: EspCableSchema.shape.cableType?.describe("Text attribute 'cableType' for this 'ESPCable' row."),
    voltageDropCoefficient: EspCableSchema.shape.voltageDropCoefficient?.describe(
      "Numeric value 'voltageDropCoefficient' (floating point) for this 'ESPCable' row.",
    ),
    maxCurrentAllowed: EspCableSchema.shape.maxCurrentAllowed?.describe(
      "Numeric value 'maxCurrentAllowed' (floating point) for this 'ESPCable' row.",
    ),
    description: EspCableSchema.shape.description?.describe("Text attribute 'description' for this 'ESPCable' row."),
  })?.describe("View 'ESPCable' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EspCalculationsStringAgentView = parseView({
  view: { externalId: 'ESPCalculations_String_Agent' },
  model: EspCalculationsStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: EspCalculationsStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    espqlAnalysisStatus: EspCalculationsStringAgentSchema.shape.espqlAnalysisStatus?.describe(
      'Status of ESP rate calculation',
    ),
    motorEfficiency: EspCalculationsStringAgentSchema.shape.motorEfficiency?.describe('ESP motor efficiency (%, TS)'),
    motorLoad: EspCalculationsStringAgentSchema.shape.motorLoad?.describe('ESP motor load (%, TS)'),
    pumpHead: EspCalculationsStringAgentSchema.shape.pumpHead?.describe('ESP pump head (ft, TS)'),
    pumpAvgRate: EspCalculationsStringAgentSchema.shape.pumpAvgRate?.describe(
      'Average pump rate (stb/d, TS) over the calculation period.',
    ),
  })?.describe(
    'Model-calculated ESP performance outputs per well string (WF12).\n\nMotor efficiency and load, pump head, average pump rate, calculation status.\nUse with ESPMeasurements_String_Agent and ESPLimits_String_Agent for full ESP diagnostics.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12).\n\n@name ESP Calculations - Well String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EspCurveDataStringAgentView = parseView({
  view: { externalId: 'ESPCurveData_String_Agent' },
  model: EspCurveDataStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: EspCurveDataStringAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'JSON plot/curve file references per well string from WF12.\n\nContains file pointers to specialised JSON curve outputs generated during\nESP and motor performance diagnostics (WF12). Covers the gradient plot\n(pressure vs depth) produced by the ESP model run. All files are JSON and\ncannot be represented as scalar timeseries values.\n\nUse with ESPMeasurements_String_Agent and ESPCalculations_String_Agent for\nfull WF12 ESP diagnostics including live sensor data and calculated outputs.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12).\n\n@name ESP Curve Data - String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EspLimitsStringAgentView = parseView({
  view: { externalId: 'ESPLimits_String_Agent' },
  model: EspLimitsStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: EspLimitsStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    espMaxMotorTemp: EspLimitsStringAgentSchema.shape.espMaxMotorTemp?.describe(
      'Maximum allowable motor temperature (Â°F, TS)',
    ),
    espMaxMotorAmps: EspLimitsStringAgentSchema.shape.espMaxMotorAmps?.describe(
      'Maximum allowable motor current (amps, TS)',
    ),
    espMaxMotorPwr: EspLimitsStringAgentSchema.shape.espMaxMotorPwr?.describe(
      'Maximum motor power limit (HP or kW, TS)',
    ),
    espMaxPumpDeltaTemp: EspLimitsStringAgentSchema.shape.espMaxPumpDeltaTemp?.describe(
      'Maximum temperature rise across pump (Â°F, TS)',
    ),
    espMinFluidRate: EspLimitsStringAgentSchema.shape.espMinFluidRate?.describe(
      'Minimum fluid rate for stable operation (stb/d, TS)',
    ),
    espMaxFluidRate: EspLimitsStringAgentSchema.shape.espMaxFluidRate?.describe(
      'Maximum fluid rate pump can handle (stb/d, TS)',
    ),
    espMinIntakePressure: EspLimitsStringAgentSchema.shape.espMinIntakePressure?.describe(
      'Minimum intake pressure limit (psia, TS)',
    ),
    espMaxDischargePressure: EspLimitsStringAgentSchema.shape.espMaxDischargePressure?.describe(
      'Maximum discharge pressure limit (psia, TS)',
    ),
    espMaxHead: EspLimitsStringAgentSchema.shape.espMaxHead?.describe('Maximum head the pump can develop (ft, TS)'),
    espMaxFreeGasInPump: EspLimitsStringAgentSchema.shape.espMaxFreeGasInPump?.describe(
      'Maximum free gas the pump can tolerate (%, TS)',
    ),
    espMaxMotorTemp_active: EspLimitsStringAgentSchema.shape.espMaxMotorTemp_active?.describe(
      'Boolean flag â€” espMaxMotorTemp limit is actively monitored for alarms.',
    ),
    espMaxMotorAmps_active: EspLimitsStringAgentSchema.shape.espMaxMotorAmps_active?.describe(
      'Boolean flag â€” espMaxMotorAmps limit is actively monitored for alarms.',
    ),
    espMinIntakePressure_active: EspLimitsStringAgentSchema.shape.espMinIntakePressure_active?.describe(
      'Boolean flag â€” espMinIntakePressure limit is actively monitored for alarms.',
    ),
    maxLiquidRate: EspLimitsStringAgentSchema.shape.maxLiquidRate?.describe('Maximum liquid rate limit (stb/d, TS)'),
    maxOilRate: EspLimitsStringAgentSchema.shape.maxOilRate?.describe('Maximum oil rate limit (stb/d, TS)'),
    maxGOR: EspLimitsStringAgentSchema.shape.maxGOR?.describe('Maximum GOR limit (scf/stb, TS)'),
    waxRisk: EspLimitsStringAgentSchema.shape.waxRisk?.describe(
      'Wax deposition risk flag or score for this well string.',
    ),
    hydrateRisk: EspLimitsStringAgentSchema.shape.hydrateRisk?.describe(
      'Hydrate formation risk flag or score for this well string.',
    ),
    asphalteneRisk: EspLimitsStringAgentSchema.shape.asphalteneRisk?.describe(
      'Asphaltene deposition risk flag or score for this well string.',
    ),
    pe5StabilityCriteria: EspLimitsStringAgentSchema.shape.pe5StabilityCriteria?.describe(
      'PE5 flow stability criteria threshold for this well string.',
    ),
    fluidVelocity: EspLimitsStringAgentSchema.shape.fluidVelocity?.describe(
      'Fluid velocity limit or reference value (ft/s, TS)',
    ),
  })?.describe(
    'ESP operating limit thresholds per well string (WF12).\n\nEngineering limits: motor temp/current/power, pump delta-T, fluid rates,\nintake/discharge pressures, head, free gas tolerance, monitoring flags.\nCompare against ESPMeasurements_String_Agent for limit exceedances. For gas lift use GasLiftLimits_String_Agent.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12).\n\n@name ESP Operating Limits - Well String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EspMeasurementsStringAgentView = parseView({
  view: { externalId: 'ESPMeasurements_String_Agent' },
  model: EspMeasurementsStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: EspMeasurementsStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    liftType: EspMeasurementsStringAgentSchema.shape.liftType?.describe('Artificial lift type (TS)'),
    pumpFrequency: EspMeasurementsStringAgentSchema.shape.pumpFrequency?.describe(
      'ESP pump operating frequency (Hz, TS)',
    ),
    pumpIntakePress: EspMeasurementsStringAgentSchema.shape.pumpIntakePress?.describe(
      'Pressure at pump intake (psia, TS)',
    ),
    pumpDischargePress: EspMeasurementsStringAgentSchema.shape.pumpDischargePress?.describe(
      'Pressure at pump discharge (psia, TS)',
    ),
    pumpIntakeTemp: EspMeasurementsStringAgentSchema.shape.pumpIntakeTemp?.describe(
      'Temperature at pump intake (Â°F, TS)',
    ),
    pumpDischargeTemp: EspMeasurementsStringAgentSchema.shape.pumpDischargeTemp?.describe(
      'Temperature at pump discharge (Â°F, TS)',
    ),
    pumpMotorTemp: EspMeasurementsStringAgentSchema.shape.pumpMotorTemp?.describe(
      'ESP motor winding temperature (Â°F, TS)',
    ),
    casingHeadPress: EspMeasurementsStringAgentSchema.shape.casingHeadPress?.describe(
      'Casing head pressure (psia, TS)',
    ),
    wellHeadPress: EspMeasurementsStringAgentSchema.shape.wellHeadPress?.describe(
      'Flowing wellhead pressure (psia, TS)',
    ),
    annulusPress: EspMeasurementsStringAgentSchema.shape.annulusPress?.describe('Annulus pressure (psia, TS)'),
    wellHeadTemp: EspMeasurementsStringAgentSchema.shape.wellHeadTemp?.describe(
      'Flowing wellhead temperature (Â°F, TS)',
    ),
    chokeOpening: EspMeasurementsStringAgentSchema.shape.chokeOpening?.describe(
      'Production choke opening (% or 64ths, TS)',
    ),
    chokeSize: EspMeasurementsStringAgentSchema.shape.chokeSize?.describe('Choke size (64ths or mm, TS)'),
    flowLinePress: EspMeasurementsStringAgentSchema.shape.flowLinePress?.describe('Flowline pressure (psia, TS)'),
    flowLineTemp: EspMeasurementsStringAgentSchema.shape.flowLineTemp?.describe('Flowline temperature (Â°F, TS)'),
    pumpCurrent: EspMeasurementsStringAgentSchema.shape.pumpCurrent?.describe('Motor current draw (amps, TS)'),
    pumpVoltage: EspMeasurementsStringAgentSchema.shape.pumpVoltage?.describe(
      'Surface voltage supplied to ESP (volts, TS)',
    ),
    pumpVibration: EspMeasurementsStringAgentSchema.shape.pumpVibration?.describe('Vibration sensor reading (TS)'),
    bottomHolePress: EspMeasurementsStringAgentSchema.shape.bottomHolePress?.describe(
      'Bottom-hole flowing pressure (psia, TS)',
    ),
    bottomHoleTemp: EspMeasurementsStringAgentSchema.shape.bottomHoleTemp?.describe(
      'Bottom-hole temperature (Â°F, TS)',
    ),
  })?.describe(
    'Real-time ESP sensor readings per well string (WF12).\n\nLive measurements: pump frequency, intake/discharge pressures and temperatures,\nmotor current, voltage, vibration, downhole BHP/BHT. Use to monitor pump health\nand compare against ESPLimits_String_Agent. For calculated outputs see ESPCalculations_String_Agent.\n\nUse for: ESP and Motor Performance and Diagnostics (WF12).\n\n@name ESP Measurements - Well String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EspMotorView = parseView({
  view: { externalId: 'ESPMotor' },
  model: EspMotorSchema.extend({
    ...InstanceIdType.shape,
    prosperIndex: EspMotorSchema.shape.prosperIndex?.describe(
      "Numeric value 'prosperIndex' (integer) for this 'ESPMotor' row.",
    ),
    manufacturer: EspMotorSchema.shape.manufacturer?.describe("Text attribute 'manufacturer' for this 'ESPMotor' row."),
    motorSeries: EspMotorSchema.shape.motorSeries?.describe("Text attribute 'motorSeries' for this 'ESPMotor' row."),
    power: EspMotorSchema.shape.power?.describe("Numeric value 'power' (floating point) for this 'ESPMotor' row."),
    voltage: EspMotorSchema.shape.voltage?.describe(
      "Numeric value 'voltage' (floating point) for this 'ESPMotor' row.",
    ),
    current: EspMotorSchema.shape.current?.describe(
      "Numeric value 'current' (floating point) for this 'ESPMotor' row.",
    ),
    description: EspMotorSchema.shape.description?.describe("Text attribute 'description' for this 'ESPMotor' row."),
  })?.describe("View 'ESPMotor' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EspPumpDetailsView = parseView({
  view: { externalId: 'ESP_Pump_Details' },
  model: EspPumpDetailsSchema.extend({
    ...InstanceIdType.shape,
    adcoInstallation: EspPumpDetailsSchema.shape.adcoInstallation?.describe(
      "Numeric value 'adcoInstallation' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    field: EspPumpDetailsSchema.shape.field?.describe(
      "Reference to the related 'Field' entity for this 'ESP_Pump_Details' row.",
    ),
    entityName: EspPumpDetailsSchema.shape.entityName?.describe(
      "Reference to the related 'String_asset' entity for this 'ESP_Pump_Details' row.",
    ),
    wellInstallationNumber: EspPumpDetailsSchema.shape.wellInstallationNumber?.describe(
      "Numeric value 'wellInstallationNumber' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    supplyCompany: EspPumpDetailsSchema.shape.supplyCompany?.describe(
      "Text attribute 'supplyCompany' for this 'ESP_Pump_Details' row.",
    ),
    status: EspPumpDetailsSchema.shape.status?.describe("Text attribute 'status' for this 'ESP_Pump_Details' row."),
    runDate: EspPumpDetailsSchema.shape.runDate?.describe(
      "Timestamp 'runDate' associated with this 'ESP_Pump_Details' row.",
    ),
    commissionDate: EspPumpDetailsSchema.shape.commissionDate?.describe(
      "Timestamp 'commissionDate' associated with this 'ESP_Pump_Details' row.",
    ),
    stopORfailureDate: EspPumpDetailsSchema.shape.stopORfailureDate?.describe(
      "Timestamp 'stopORfailureDate' associated with this 'ESP_Pump_Details' row.",
    ),
    pullDate: EspPumpDetailsSchema.shape.pullDate?.describe(
      "Timestamp 'pullDate' associated with this 'ESP_Pump_Details' row.",
    ),
    pullReason: EspPumpDetailsSchema.shape.pullReason?.describe(
      "Text attribute 'pullReason' for this 'ESP_Pump_Details' row.",
    ),
    espComponent: EspPumpDetailsSchema.shape.espComponent?.describe(
      "Text attribute 'espComponent' for this 'ESP_Pump_Details' row.",
    ),
    rootCause: EspPumpDetailsSchema.shape.rootCause?.describe(
      "Text attribute 'rootCause' for this 'ESP_Pump_Details' row.",
    ),
    comments: EspPumpDetailsSchema.shape.comments?.describe(
      "Text attribute 'comments' for this 'ESP_Pump_Details' row.",
    ),
    espSensorDepth_MD_ft: EspPumpDetailsSchema.shape.espSensorDepth_MD_ft?.describe(
      "Numeric value 'espSensorDepth_MD_ft' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    espSensorDepth_TVD_ft: EspPumpDetailsSchema.shape.espSensorDepth_TVD_ft?.describe(
      "Numeric value 'espSensorDepth_TVD_ft' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    tol_MD: EspPumpDetailsSchema.shape.tol_MD?.describe(
      "Numeric value 'tol_MD' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    tol_TVD: EspPumpDetailsSchema.shape.tol_TVD?.describe(
      "Numeric value 'tol_TVD' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    topReservoirDepth_MD: EspPumpDetailsSchema.shape.topReservoirDepth_MD?.describe(
      "Numeric value 'topReservoirDepth_MD' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    topReservoirDepth_TVD: EspPumpDetailsSchema.shape.topReservoirDepth_TVD?.describe(
      "Numeric value 'topReservoirDepth_TVD' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    bohSeries: EspPumpDetailsSchema.shape.bohSeries?.describe(
      "Numeric value 'bohSeries' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    bohThd: EspPumpDetailsSchema.shape.bohThd?.describe("Text attribute 'bohThd' for this 'ESP_Pump_Details' row."),
    bohMatl: EspPumpDetailsSchema.shape.bohMatl?.describe("Text attribute 'bohMatl' for this 'ESP_Pump_Details' row."),
    nORu: EspPumpDetailsSchema.shape.nORu?.describe("Text attribute 'nORu' for this 'ESP_Pump_Details' row."),
    pumpSeries: EspPumpDetailsSchema.shape.pumpSeries?.describe(
      "Numeric value 'pumpSeries' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    pumpModel: EspPumpDetailsSchema.shape.pumpModel?.describe(
      "Text attribute 'pumpModel' for this 'ESP_Pump_Details' row.",
    ),
    pumpHsg: EspPumpDetailsSchema.shape.pumpHsg?.describe(
      "Numeric value 'pumpHsg' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    totalStages: EspPumpDetailsSchema.shape.totalStages?.describe(
      "Numeric value 'totalStages' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    pumpAr: EspPumpDetailsSchema.shape.pumpAr?.describe("Text attribute 'pumpAr' for this 'ESP_Pump_Details' row."),
    pumpMatl: EspPumpDetailsSchema.shape.pumpMatl?.describe(
      "Text attribute 'pumpMatl' for this 'ESP_Pump_Details' row.",
    ),
    pump_nORu: EspPumpDetailsSchema.shape.pump_nORu?.describe(
      "Text attribute 'pump_nORu' for this 'ESP_Pump_Details' row.",
    ),
    aghModel: EspPumpDetailsSchema.shape.aghModel?.describe(
      "Text attribute 'aghModel' for this 'ESP_Pump_Details' row.",
    ),
    aghMatl: EspPumpDetailsSchema.shape.aghMatl?.describe("Text attribute 'aghMatl' for this 'ESP_Pump_Details' row."),
    agh_nORu: EspPumpDetailsSchema.shape.agh_nORu?.describe(
      "Text attribute 'agh_nORu' for this 'ESP_Pump_Details' row.",
    ),
    intakeVgsaSeries: EspPumpDetailsSchema.shape.intakeVgsaSeries?.describe(
      "Numeric value 'intakeVgsaSeries' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    intakeVgsaModel: EspPumpDetailsSchema.shape.intakeVgsaModel?.describe(
      "Text attribute 'intakeVgsaModel' for this 'ESP_Pump_Details' row.",
    ),
    intakeVgsaMatl: EspPumpDetailsSchema.shape.intakeVgsaMatl?.describe(
      "Text attribute 'intakeVgsaMatl' for this 'ESP_Pump_Details' row.",
    ),
    intakeVgsa_nORu: EspPumpDetailsSchema.shape.intakeVgsa_nORu?.describe(
      "Text attribute 'intakeVgsa_nORu' for this 'ESP_Pump_Details' row.",
    ),
    protectorSeries: EspPumpDetailsSchema.shape.protectorSeries?.describe(
      "Numeric value 'protectorSeries' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    protectorModel: EspPumpDetailsSchema.shape.protectorModel?.describe(
      "Text attribute 'protectorModel' for this 'ESP_Pump_Details' row.",
    ),
    protectorMatl: EspPumpDetailsSchema.shape.protectorMatl?.describe(
      "Text attribute 'protectorMatl' for this 'ESP_Pump_Details' row.",
    ),
    protector_nORu: EspPumpDetailsSchema.shape.protector_nORu?.describe(
      "Text attribute 'protector_nORu' for this 'ESP_Pump_Details' row.",
    ),
    motorSeries: EspPumpDetailsSchema.shape.motorSeries?.describe(
      "Numeric value 'motorSeries' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    numberOfPoles: EspPumpDetailsSchema.shape.numberOfPoles?.describe(
      "Numeric value 'numberOfPoles' (integer) for this 'ESP_Pump_Details' row.",
    ),
    motorHsg: EspPumpDetailsSchema.shape.motorHsg?.describe(
      "Numeric value 'motorHsg' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    motorTotalPower: EspPumpDetailsSchema.shape.motorTotalPower?.describe(
      "Numeric value 'motorTotalPower' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    motorTotalV: EspPumpDetailsSchema.shape.motorTotalV?.describe(
      "Numeric value 'motorTotalV' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    motorA: EspPumpDetailsSchema.shape.motorA?.describe(
      "Numeric value 'motorA' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    motorRefW: EspPumpDetailsSchema.shape.motorRefW?.describe(
      "Numeric value 'motorRefW' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    motorMatl: EspPumpDetailsSchema.shape.motorMatl?.describe(
      "Text attribute 'motorMatl' for this 'ESP_Pump_Details' row.",
    ),
    motor_nORu: EspPumpDetailsSchema.shape.motor_nORu?.describe(
      "Text attribute 'motor_nORu' for this 'ESP_Pump_Details' row.",
    ),
    monitorType: EspPumpDetailsSchema.shape.monitorType?.describe(
      "Text attribute 'monitorType' for this 'ESP_Pump_Details' row.",
    ),
    monitor_nORu: EspPumpDetailsSchema.shape.monitor_nORu?.describe(
      "Text attribute 'monitor_nORu' for this 'ESP_Pump_Details' row.",
    ),
    mleSeries: EspPumpDetailsSchema.shape.mleSeries?.describe(
      "Numeric value 'mleSeries' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    mleType: EspPumpDetailsSchema.shape.mleType?.describe("Text attribute 'mleType' for this 'ESP_Pump_Details' row."),
    mle: EspPumpDetailsSchema.shape.mle?.describe(
      "Numeric value 'mle' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    cableType: EspPumpDetailsSchema.shape.cableType?.describe(
      "Text attribute 'cableType' for this 'ESP_Pump_Details' row.",
    ),
    cableSize: EspPumpDetailsSchema.shape.cableSize?.describe(
      "Numeric value 'cableSize' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    cableTotalLength: EspPumpDetailsSchema.shape.cableTotalLength?.describe(
      "Numeric value 'cableTotalLength' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    cable_nORu: EspPumpDetailsSchema.shape.cable_nORu?.describe(
      "Text attribute 'cable_nORu' for this 'ESP_Pump_Details' row.",
    ),
    panelVsdType: EspPumpDetailsSchema.shape.panelVsdType?.describe(
      "Text attribute 'panelVsdType' for this 'ESP_Pump_Details' row.",
    ),
    panelVsdKVA: EspPumpDetailsSchema.shape.panelVsdKVA?.describe(
      "Numeric value 'panelVsdKVA' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    panelVsdA: EspPumpDetailsSchema.shape.panelVsdA?.describe(
      "Numeric value 'panelVsdA' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    transformerKVA: EspPumpDetailsSchema.shape.transformerKVA?.describe(
      "Numeric value 'transformerKVA' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    transformerA: EspPumpDetailsSchema.shape.transformerA?.describe(
      "Numeric value 'transformerA' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    transformerTapSetting: EspPumpDetailsSchema.shape.transformerTapSetting?.describe(
      "Text attribute 'transformerTapSetting' for this 'ESP_Pump_Details' row.",
    ),
    transformerVoltageRatio: EspPumpDetailsSchema.shape.transformerVoltageRatio?.describe(
      "Numeric value 'transformerVoltageRatio' (floating point) for this 'ESP_Pump_Details' row.",
    ),
    transformerComments: EspPumpDetailsSchema.shape.transformerComments?.describe(
      "Text attribute 'transformerComments' for this 'ESP_Pump_Details' row.",
    ),
    yTool: EspPumpDetailsSchema.shape.yTool?.describe("Text attribute 'yTool' for this 'ESP_Pump_Details' row."),
    packer: EspPumpDetailsSchema.shape.packer?.describe("Text attribute 'packer' for this 'ESP_Pump_Details' row."),
  })?.describe("View 'ESP_Pump_Details' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EspPumpView = parseView({
  view: { externalId: 'ESPPump' },
  model: EspPumpSchema.extend({
    ...InstanceIdType.shape,
    prosperIndex: EspPumpSchema.shape.prosperIndex?.describe(
      "Numeric value 'prosperIndex' (integer) for this 'ESPPump' row.",
    ),
    manufacturer: EspPumpSchema.shape.manufacturer?.describe("Text attribute 'manufacturer' for this 'ESPPump' row."),
    name: EspPumpSchema.shape.name?.describe("Text attribute 'name' for this 'ESPPump' row."),
    pumpSize: EspPumpSchema.shape.pumpSize?.describe(
      "Numeric value 'pumpSize' (floating point) for this 'ESPPump' row.",
    ),
    stages: EspPumpSchema.shape.stages?.describe("Numeric value 'stages' (integer) for this 'ESPPump' row."),
    frequency: EspPumpSchema.shape.frequency?.describe(
      "Numeric value 'frequency' (floating point) for this 'ESPPump' row.",
    ),
    minimumRate: EspPumpSchema.shape.minimumRate?.describe(
      "Numeric value 'minimumRate' (floating point) for this 'ESPPump' row.",
    ),
    maximumRate: EspPumpSchema.shape.maximumRate?.describe(
      "Numeric value 'maximumRate' (floating point) for this 'ESPPump' row.",
    ),
    description: EspPumpSchema.shape.description?.describe("Text attribute 'description' for this 'ESPPump' row."),
  })?.describe("View 'ESPPump' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EstimatedRatesStringAgentView = parseView({
  view: { externalId: 'EstimatedRates_String_Agent' },
  model: EstimatedRatesStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: EstimatedRatesStringAgentSchema.shape.wellString?.describe('Well string identifier.'),
    priorityMethod: EstimatedRatesStringAgentSchema.shape.priorityMethod?.describe(
      'Analysis method that produced the priority rates',
    ),
    priorityOilRateStd: EstimatedRatesStringAgentSchema.shape.priorityOilRateStd?.describe(
      'Best-available estimated oil rate from the priority analysis method (stb/d, TS).',
    ),
    priorityGasRateStd: EstimatedRatesStringAgentSchema.shape.priorityGasRateStd?.describe(
      'Best-available estimated gas rate from the priority analysis method (MSCF/d, TS).',
    ),
    priorityWaterRateStd: EstimatedRatesStringAgentSchema.shape.priorityWaterRateStd?.describe(
      'Best-available estimated water rate from the priority analysis method (stb/d, TS).',
    ),
    priorityLiquidRateStd: EstimatedRatesStringAgentSchema.shape.priorityLiquidRateStd?.describe(
      'Best-available estimated total liquid rate, oil + water (stb/d, TS).',
    ),
    priorityFbhp: EstimatedRatesStringAgentSchema.shape.priorityFbhp?.describe(
      'Best-available flowing bottom-hole pressure from the priority method (psi, TS).',
    ),
    systemAnalysisStatus: EstimatedRatesStringAgentSchema.shape.systemAnalysisStatus?.describe(
      'System analysis calculation status',
    ),
    systemAnalysisOilRateStd: EstimatedRatesStringAgentSchema.shape.systemAnalysisOilRateStd?.describe(
      'Oil rate from IPR/VLP system analysis (stb/d, TS).',
    ),
    systemAnalysisGasRateStd: EstimatedRatesStringAgentSchema.shape.systemAnalysisGasRateStd?.describe(
      'Gas rate from IPR/VLP system analysis (MSCF/d, TS).',
    ),
    systemAnalysisWaterRateStd: EstimatedRatesStringAgentSchema.shape.systemAnalysisWaterRateStd?.describe(
      'Water rate from IPR/VLP system analysis (stb/d, TS).',
    ),
    systemAnalysisLiquidRateStd: EstimatedRatesStringAgentSchema.shape.systemAnalysisLiquidRateStd?.describe(
      'Total liquid rate from IPR/VLP system analysis, oil + water (stb/d, TS).',
    ),
    systemAnalysisFbhp: EstimatedRatesStringAgentSchema.shape.systemAnalysisFbhp?.describe(
      'Flowing bottom-hole pressure from system analysis (psi, TS).',
    ),
    chokeAnalysisStatus: EstimatedRatesStringAgentSchema.shape.chokeAnalysisStatus?.describe(
      'Choke analysis calculation status',
    ),
    chokeAnalysisOilRateStd: EstimatedRatesStringAgentSchema.shape.chokeAnalysisOilRateStd?.describe(
      'Oil rate from choke equation analysis (stb/d, TS).',
    ),
    chokeAnalysisGasRateStd: EstimatedRatesStringAgentSchema.shape.chokeAnalysisGasRateStd?.describe(
      'Gas rate from choke equation analysis (MSCF/d, TS).',
    ),
    chokeAnalysisWaterRateStd: EstimatedRatesStringAgentSchema.shape.chokeAnalysisWaterRateStd?.describe(
      'Water rate from choke equation analysis (stb/d, TS).',
    ),
    chokeAnalysisLiquidRateStd: EstimatedRatesStringAgentSchema.shape.chokeAnalysisLiquidRateStd?.describe(
      'Total liquid rate from choke equation analysis, oil + water (stb/d, TS).',
    ),
    chokeAnalysisFbhp: EstimatedRatesStringAgentSchema.shape.chokeAnalysisFbhp?.describe(
      'Flowing bottom-hole pressure from choke analysis (psi, TS).',
    ),
    iprAnalysisOilRateStd: EstimatedRatesStringAgentSchema.shape.iprAnalysisOilRateStd?.describe(
      'Oil rate from IPR curve at current reservoir/flowing conditions (stb/d, TS).',
    ),
    iprAnalysisGasRateStd: EstimatedRatesStringAgentSchema.shape.iprAnalysisGasRateStd?.describe(
      'Gas rate from IPR curve analysis (MSCF/d, TS).',
    ),
    iprAnalysisWaterRateStd: EstimatedRatesStringAgentSchema.shape.iprAnalysisWaterRateStd?.describe(
      'Water rate from IPR curve analysis (stb/d, TS).',
    ),
    iprAnalysisLiquidRateStd: EstimatedRatesStringAgentSchema.shape.iprAnalysisLiquidRateStd?.describe(
      'Total liquid rate from IPR curve',
    ),
    iprAnalysisFbhp: EstimatedRatesStringAgentSchema.shape.iprAnalysisFbhp?.describe(
      'Flowing BHP used for IPR curve lookup (psi, TS).',
    ),
    vlpAnalysisOilRateStd: EstimatedRatesStringAgentSchema.shape.vlpAnalysisOilRateStd?.describe(
      'Oil rate from VLP curve at current tubing/separator conditions (stb/d, TS).',
    ),
    vlpAnalysisGasRateStd: EstimatedRatesStringAgentSchema.shape.vlpAnalysisGasRateStd?.describe(
      'Gas rate from VLP curve analysis (MSCF/d, TS).',
    ),
    vlpAnalysisWaterRateStd: EstimatedRatesStringAgentSchema.shape.vlpAnalysisWaterRateStd?.describe(
      'Water rate from VLP curve analysis (stb/d, TS).',
    ),
    vlpAnalysisLiquidRateStd: EstimatedRatesStringAgentSchema.shape.vlpAnalysisLiquidRateStd?.describe(
      'Total liquid rate from VLP curve',
    ),
    vlpAnalysisFbhp: EstimatedRatesStringAgentSchema.shape.vlpAnalysisFbhp?.describe(
      'Flowing BHP from VLP curve at current rate and WHP (psi, TS).',
    ),
    curveAnalysisOilRateStd: EstimatedRatesStringAgentSchema.shape.curveAnalysisOilRateStd?.describe(
      'Oil rate from performance curve lookup (stb/d, TS).',
    ),
    curveAnalysisGasRateStd: EstimatedRatesStringAgentSchema.shape.curveAnalysisGasRateStd?.describe(
      'Gas rate from performance curve analysis (MSCF/d, TS).',
    ),
    curveAnalysisWaterRateStd: EstimatedRatesStringAgentSchema.shape.curveAnalysisWaterRateStd?.describe(
      'Water rate from performance curve analysis (stb/d, TS).',
    ),
    curveAnalysisLiquidRateStd: EstimatedRatesStringAgentSchema.shape.curveAnalysisLiquidRateStd?.describe(
      'Total liquid rate from performance curve lookup (stb/d, TS).',
    ),
    curveAnalysisFbhp: EstimatedRatesStringAgentSchema.shape.curveAnalysisFbhp?.describe(
      'Flowing BHP from performance curve analysis (psi, TS).',
    ),
    dataAnalysisOilRateStd: EstimatedRatesStringAgentSchema.shape.dataAnalysisOilRateStd?.describe(
      'Oil rate from data-driven analysis / ML models (stb/d, TS).',
    ),
    dataAnalysisGasRateStd: EstimatedRatesStringAgentSchema.shape.dataAnalysisGasRateStd?.describe(
      'Gas rate from data-driven analysis / ML models (MSCF/d, TS).',
    ),
    dataAnalysisWaterRateStd: EstimatedRatesStringAgentSchema.shape.dataAnalysisWaterRateStd?.describe(
      'Water rate from data-driven analysis / ML models (stb/d, TS).',
    ),
    dataAnalysisLiquidRateStd: EstimatedRatesStringAgentSchema.shape.dataAnalysisLiquidRateStd?.describe(
      'Total liquid rate from data-driven analysis / ML models (stb/d, TS).',
    ),
    dataAnalysisFbhp: EstimatedRatesStringAgentSchema.shape.dataAnalysisFbhp?.describe(
      'Flowing BHP from data-driven analysis / ML models (psi, TS).',
    ),
    reservoirPressureDatum: EstimatedRatesStringAgentSchema.shape.reservoirPressureDatum?.describe(
      'Current reservoir pressure at datum depth (psi, TS).',
    ),
    reservoirPressureMidPerforation: EstimatedRatesStringAgentSchema.shape.reservoirPressureMidPerforation?.describe(
      'Reservoir pressure corrected to mid-perforation depth',
    ),
    pressureSource: EstimatedRatesStringAgentSchema.shape.pressureSource?.describe('Source of the BHP value'),
  })?.describe(
    'All estimated rates and BHP per well string across every estimation method.\n\nFor simple rate lookups use PriorityRates_String_Agent. Use this view when\ncomparing estimation methods. Exposes priority, system analysis (IPR+VLP),\nchoke, IPR-only, VLP-only, performance curve, and data-driven/ML. For\nperformance scores and analysis status see RateDiagnostics_String_Agent.\n\nUse for: comparing estimation methods (WF10).\n\n@name Estimated Rates - Well String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const EventsStringView = parseView({
  view: { externalId: 'Events_String' },
  model: EventsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: EventsStringSchema.shape.entityName?.describe(
      "Reference to the related 'String_asset' entity for this 'Events_String' row.",
    ),
    wellheadPressure: EventsStringSchema.shape.wellheadPressure?.describe(
      "Reference to a time series for 'wellheadPressure' in this 'Events_String' view.",
    ),
    wellheadTemperature: EventsStringSchema.shape.wellheadTemperature?.describe(
      "Reference to a time series for 'wellheadTemperature' in this 'Events_String' view.",
    ),
    bottomholePressure: EventsStringSchema.shape.bottomholePressure?.describe(
      "Reference to a time series for 'bottomholePressure' in this 'Events_String' view.",
    ),
    bottomholeTemperature: EventsStringSchema.shape.bottomholeTemperature?.describe(
      "Reference to a time series for 'bottomholeTemperature' in this 'Events_String' view.",
    ),
    casingPressure: EventsStringSchema.shape.casingPressure?.describe(
      "Reference to a time series for 'casingPressure' in this 'Events_String' view.",
    ),
    eventStartDateTime: EventsStringSchema.shape.eventStartDateTime?.describe(
      "Reference to a time series for 'eventStartDateTime' in this 'Events_String' view.",
    ),
    currentStatus: EventsStringSchema.shape.currentStatus?.describe(
      "Reference to a time series for 'currentStatus' in this 'Events_String' view.",
    ),
    statusCode: EventsStringSchema.shape.statusCode?.describe(
      "Reference to a time series for 'statusCode' in this 'Events_String' view.",
    ),
    eventReason: EventsStringSchema.shape.eventReason?.describe(
      "Reference to a time series for 'eventReason' in this 'Events_String' view.",
    ),
    eventDesc: EventsStringSchema.shape.eventDesc?.describe(
      "Reference to a time series for 'eventDesc' in this 'Events_String' view.",
    ),
    downType: EventsStringSchema.shape.downType?.describe(
      "Reference to a time series for 'downType' in this 'Events_String' view.",
    ),
    remarks: EventsStringSchema.shape.remarks?.describe(
      "Reference to a time series for 'remarks' in this 'Events_String' view.",
    ),
    producingMethod: EventsStringSchema.shape.producingMethod?.describe(
      "Reference to a time series for 'producingMethod' in this 'Events_String' view.",
    ),
    producingMethodDesc: EventsStringSchema.shape.producingMethodDesc?.describe(
      "Reference to a time series for 'producingMethodDesc' in this 'Events_String' view.",
    ),
    producingStatusDesc: EventsStringSchema.shape.producingStatusDesc?.describe(
      "Reference to a time series for 'producingStatusDesc' in this 'Events_String' view.",
    ),
    producingStatus: EventsStringSchema.shape.producingStatus?.describe(
      "Reference to a time series for 'producingStatus' in this 'Events_String' view.",
    ),
    stringFunction: EventsStringSchema.shape.stringFunction?.describe(
      "Reference to a time series for 'stringFunction' in this 'Events_String' view.",
    ),
    waterCut: EventsStringSchema.shape.waterCut?.describe(
      "Reference to a time series for 'waterCut' in this 'Events_String' view.",
    ),
    gor: EventsStringSchema.shape.gor?.describe("Reference to a time series for 'gor' in this 'Events_String' view."),
    chokeSize: EventsStringSchema.shape.chokeSize?.describe(
      "Reference to a time series for 'chokeSize' in this 'Events_String' view.",
    ),
    chokeSizePct: EventsStringSchema.shape.chokeSizePct?.describe(
      "Reference to a time series for 'chokeSizePct' in this 'Events_String' view.",
    ),
    waterInjRate: EventsStringSchema.shape.waterInjRate?.describe(
      "Reference to a time series for 'waterInjRate' in this 'Events_String' view.",
    ),
    oilRate: EventsStringSchema.shape.oilRate?.describe(
      "Reference to a time series for 'oilRate' in this 'Events_String' view.",
    ),
    gasRate: EventsStringSchema.shape.gasRate?.describe(
      "Reference to a time series for 'gasRate' in this 'Events_String' view.",
    ),
    gasInjRate: EventsStringSchema.shape.gasInjRate?.describe(
      "Reference to a time series for 'gasInjRate' in this 'Events_String' view.",
    ),
  })?.describe("View 'Events_String' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const FieldFormationView = parseView({
  view: { externalId: 'FieldFormation' },
  model: FieldFormationSchema.extend({
    ...InstanceIdType.shape,
    field: FieldFormationSchema.shape.field?.describe(
      'Field attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    reservoir: FieldFormationSchema.shape.reservoir?.describe(
      'Reservoir attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    reservoirType: FieldFormationSchema.shape.reservoirType?.describe(
      'Reservoir Type attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    rw: FieldFormationSchema.shape.rw?.describe(
      'Numeric value storing rw for this field, used in calculations, reporting, or model configuration.',
    ),
    datumDepth: FieldFormationSchema.shape.datumDepth?.describe(
      'Numeric value storing datum depth for this field, used in calculations, reporting, or model configuration.',
    ),
    oilWaterContact: FieldFormationSchema.shape.oilWaterContact?.describe(
      'Numeric value storing oil water contact for this field, used in calculations, reporting, or model configuration.',
    ),
    gasOilContact: FieldFormationSchema.shape.gasOilContact?.describe(
      'Numeric value storing gas oil contact for this field, used in calculations, reporting, or model configuration.',
    ),
    gaswaterContact: FieldFormationSchema.shape.gaswaterContact?.describe(
      'Numeric value storing gaswater contact for this field, used in calculations, reporting, or model configuration.',
    ),
    waterGradient: FieldFormationSchema.shape.waterGradient?.describe(
      'Numeric value storing water gradient for this field, used in calculations, reporting, or model configuration.',
    ),
    gasGradient: FieldFormationSchema.shape.gasGradient?.describe(
      'Numeric value storing gas gradient for this field, used in calculations, reporting, or model configuration.',
    ),
    oilGradient: FieldFormationSchema.shape.oilGradient?.describe(
      'Numeric value storing oil gradient for this field, used in calculations, reporting, or model configuration.',
    ),
    startDateTime: FieldFormationSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this field in the production optimization context.',
    ),
    stopDateTime: FieldFormationSchema.shape.stopDateTime?.describe(
      'Attribute capturing stop date time for this field in the production optimization context.',
    ),
  })
    .omit({ startDateTime: true, stopDateTime: true })
    ?.describe(
      'Field Formation view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
    ),
  dataModel: DataModel.IpsoSolution,
});

export const FieldInputsView = parseView({
  view: { externalId: 'FieldInputs' },
  model: FieldInputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: FieldInputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    actualOilProduction: FieldInputsSchema.shape.actualOilProduction?.describe(
      'Time series signal representing actual oil production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    targetOilProduction: FieldInputsSchema.shape.targetOilProduction?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    actualWaterProduction: FieldInputsSchema.shape.actualWaterProduction?.describe(
      'Time series signal representing actual water production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    actualWaterInjection: FieldInputsSchema.shape.actualWaterInjection?.describe(
      'Time series signal representing actual water injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    targetWaterProduction: FieldInputsSchema.shape.targetWaterProduction?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    targetWaterInjection: FieldInputsSchema.shape.targetWaterInjection?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    actualGasProduction: FieldInputsSchema.shape.actualGasProduction?.describe(
      'Time series signal representing actual gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    actualGasInjection: FieldInputsSchema.shape.actualGasInjection?.describe(
      'Time series signal representing actual gas injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    targetGasProduction: FieldInputsSchema.shape.targetGasProduction?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    targetGasInjection: FieldInputsSchema.shape.targetGasInjection?.describe(
      'Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    associatedGasProduction: FieldInputsSchema.shape.associatedGasProduction?.describe(
      'Time series signal representing associated gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    nonAssociatedGasProduction: FieldInputsSchema.shape.nonAssociatedGasProduction?.describe(
      'Time series signal representing non associated gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    nonASRGasInjection: FieldInputsSchema.shape.nonASRGasInjection?.describe(
      'Time series signal representing non asrgas injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    potentialOilProduction: FieldInputsSchema.shape.potentialOilProduction?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    potentialWaterProduction: FieldInputsSchema.shape.potentialWaterProduction?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    potentialWaterInjection: FieldInputsSchema.shape.potentialWaterInjection?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    potentialGasProduction: FieldInputsSchema.shape.potentialGasProduction?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    potentialGasInjection: FieldInputsSchema.shape.potentialGasInjection?.describe(
      'Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance.',
    ),
    actualOilProductionRate: FieldInputsSchema.shape.actualOilProductionRate?.describe(
      'Time series signal representing actual oil production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    actualWaterProductionRate: FieldInputsSchema.shape.actualWaterProductionRate?.describe(
      'Time series signal representing actual water production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    actualGasProductionRate: FieldInputsSchema.shape.actualGasProductionRate?.describe(
      'Time series signal representing actual gas production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    associatedGasProductionRate: FieldInputsSchema.shape.associatedGasProductionRate?.describe(
      'Time series signal representing associated gas production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    nonAssociatedGasProductionRate: FieldInputsSchema.shape.nonAssociatedGasProductionRate?.describe(
      'Time series signal representing non associated gas production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    actualWaterInjectionRate: FieldInputsSchema.shape.actualWaterInjectionRate?.describe(
      'Time series signal representing actual water injection rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    actualGasInjectionRate: FieldInputsSchema.shape.actualGasInjectionRate?.describe(
      'Time series signal representing actual gas injection rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    nonASRGasInjectionRate: FieldInputsSchema.shape.nonASRGasInjectionRate?.describe(
      'Time series signal representing non asrgas injection rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    ambientTemperature: FieldInputsSchema.shape.ambientTemperature?.describe(
      'Time series signal representing ambient temperature for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Field Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const FieldOutputsView = parseView({
  view: { externalId: 'FieldOutputs' },
  model: FieldOutputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: FieldOutputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellsActiveOpNf: FieldOutputsSchema.shape.wellsActiveOpNf?.describe(
      'Time series signal representing wells active op nf for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveGpNf: FieldOutputsSchema.shape.wellsActiveGpNf?.describe(
      'Time series signal representing wells active gp nf for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveOpEsp: FieldOutputsSchema.shape.wellsActiveOpEsp?.describe(
      'Time series signal representing wells active op esp for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveOpGl: FieldOutputsSchema.shape.wellsActiveOpGl?.describe(
      'Time series signal representing wells active op gl for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveGi: FieldOutputsSchema.shape.wellsActiveGi?.describe(
      'Time series signal representing wells active gi for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveWi: FieldOutputsSchema.shape.wellsActiveWi?.describe(
      'Time series signal representing wells active wi for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpNf: FieldOutputsSchema.shape.wellsInActiveOpNf?.describe(
      'Time series signal representing wells in active op nf for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveGpNf: FieldOutputsSchema.shape.wellsInActiveGpNf?.describe(
      'Time series signal representing wells in active gp nf for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpEsp: FieldOutputsSchema.shape.wellsInActiveOpEsp?.describe(
      'Time series signal representing wells in active op esp for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpGl: FieldOutputsSchema.shape.wellsInActiveOpGl?.describe(
      'Time series signal representing wells in active op gl for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveGi: FieldOutputsSchema.shape.wellsInActiveGi?.describe(
      'Time series signal representing wells in active gi for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveWi: FieldOutputsSchema.shape.wellsInActiveWi?.describe(
      'Time series signal representing wells in active wi for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveWAG: FieldOutputsSchema.shape.wellsActiveWAG?.describe(
      'Time series signal representing wells active wag for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInactiveWAG: FieldOutputsSchema.shape.wellsInactiveWAG?.describe(
      'Time series signal representing wells inactive wag for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Aggregated field-level outputs including counts of active and inactive wells by lift type and service (producers, gas injectors, water injectors, WAG wells) used for monitoring field performance and optimization decisions.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const FieldView = parseView({
  view: { externalId: 'Field' },
  model: FieldSchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const FlatHierarchyAgentView = parseView({
  view: { externalId: 'FlatHierarchy_Agent' },
  model: FlatHierarchyAgentSchema.extend({
    ...InstanceIdType.shape,
    company: FlatHierarchyAgentSchema.shape.company?.describe('Top-level parent entity, e.g'),
    asset: FlatHierarchyAgentSchema.shape.asset?.describe('Operating concession or business unit.'),
    well: FlatHierarchyAgentSchema.shape.well?.describe('Physical wellbore'),
    location: FlatHierarchyAgentSchema.shape.location?.describe(
      'Surface infrastructure where the well connects, such as cluster, platform, manifold, drilling island, or onshore facility.',
    ),
    startDateTime: FlatHierarchyAgentSchema.shape.startDateTime?.describe(
      'Timestamp at which this hierarchy relationship became effective.',
    ),
    endDateTime: FlatHierarchyAgentSchema.shape.endDateTime?.describe(
      'Timestamp at which this hierarchy relationship ended.',
    ),
    field: FlatHierarchyAgentSchema.shape.field?.describe('Oil or gas field containing the well.'),
    reservoir: FlatHierarchyAgentSchema.shape.reservoir?.describe(
      'Subsurface reservoir formation the string produces from.',
    ),
    string: FlatHierarchyAgentSchema.shape.string?.describe('Completion or producing interval within the well'),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Flattened company â†’ asset â†’ field â†’ reservoir â†’ location â†’ well â†’ string\nhierarchy, scoped to in-scope assets.\n\nOne row per string with its full ancestry across the production hierarchy\nand the effective date range of that relationship. Sourced from the base\nFlatHierarchy and refined via the in_scope_asset_node_refs configuration.\nExcludes operational or measurement data.\n\n@name FlatHierarchy (Agent Scoped)',
    ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const FlatHierarchyView = parseView({
  view: { externalId: 'FlatHierarchy' },
  model: FlatHierarchySchema.extend({
    ...InstanceIdType.shape,
    company: FlatHierarchySchema.shape.company?.describe(
      'Top-level parent entity (e.g., ADNOC ONSHORE, ADNOC OFFSHORE)',
    ),
    asset: FlatHierarchySchema.shape.asset?.describe('Operating concession or business unit'),
    well: FlatHierarchySchema.shape.well?.describe('Physical wellbore containing this string'),
    location: FlatHierarchySchema.shape.location?.describe(
      'Surface infrastructure where the well connects (platform, manifold, drilling island, or onshore facility)',
    ),
    startDateTime: FlatHierarchySchema.shape.startDateTime?.describe(
      'When this hierarchy relationship became effective',
    ),
    endDateTime: FlatHierarchySchema.shape.endDateTime?.describe('When this hierarchy relationship ended'),
    field: FlatHierarchySchema.shape.field?.describe('Oil/gas field containing the well'),
    reservoir: FlatHierarchySchema.shape.reservoir?.describe('Subsurface reservoir formation the string produces from'),
    string: FlatHierarchySchema.shape.string?.describe('Completion/producing interval within the well'),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      "DENORMALIZED HIERARCHY LOOKUP TABLE - Primary view for navigating the asset hierarchy.\n\nSTRUCTURE: Each row = one String (completion) with all its parent entities pre-joined.\nHierarchy: Company → Asset → Field → Reservoir/Location → Well → String\n\nWHY USE THIS: Avoids complex multi-hop joins. Query ANY hierarchy relationship in a single step.\n\nQUERY PATTERNS:\n- Find wells in a field: Filter field.name = 'X', select well\n- Find strings in a reservoir: Filter reservoir.name = 'Y', select string  \n- Find fields in an asset: Filter asset.name = 'A', select DISTINCT field\n- Find parent of any entity: Filter on child, select parent property\n\nKEY BEHAVIORS:\n- One row per string means parent entities repeat (use DISTINCT for unique parents)\n- References return full entity objects - access .name, .externalId, etc.\n- Use startDateTime/endDateTime for historical hierarchy lookups",
    ),
  dataModel: DataModel.IpsoSolution,
});

export const FlowAssuranceAlarmsAgentView = parseView({
  view: { externalId: 'FlowAssuranceAlarms_Agent' },
  model: FlowAssuranceAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: FlowAssuranceAlarmsAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'Flow assurance detection and mitigation alarms with medium or high priority.\n\nContains flow assurance alarms, medium or high priority, sourced from\noperational monitoring systems within petroleum production environments.\nAnswers questions on the frequency, duration, and types of alarms triggered,\nto assess mitigation and prioritize responses. Excludes low-priority or non-WF20 alarms.\n\nUse for: Flow Assurance Detection and Mitigation (WF20), Real-Time Surveillance (WF18).\n\n@name Flow Assurance Alarms (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const FlowlineOutputsNetworkAgentView = parseView({
  view: { externalId: 'FlowlineOutputs_Network_Agent' },
  model: FlowlineOutputsNetworkAgentSchema.extend({
    ...InstanceIdType.shape,
    entityName: FlowlineOutputsNetworkAgentSchema.shape.entityName?.describe('Flowline entity name.'),
    network: FlowlineOutputsNetworkAgentSchema.shape.network?.describe('Reference to parent network model.'),
    nmvFlowlinePressure: FlowlineOutputsNetworkAgentSchema.shape.nmvFlowlinePressure?.describe(
      'Simulated flowline outlet pressure (TS).',
    ),
    nmvPressureMatchIndex: FlowlineOutputsNetworkAgentSchema.shape.nmvPressureMatchIndex?.describe(
      'Pressure match quality (0-1, TS)',
    ),
    nmvBottleneckFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvBottleneckFlag?.describe(
      'Flowline identified as production bottleneck (0/1, TS).',
    ),
    nmvUnstableFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvUnstableFlag?.describe(
      'Unstable flow detected (0/1, TS).',
    ),
    nmvHydrateFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvHydrateFlag?.describe(
      'Hydrate formation risk (0/1, TS).',
    ),
    nmvWaxFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvWaxFlag?.describe('Wax deposition risk (0/1, TS).'),
    nmvScaleFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvScaleFlag?.describe('Scale formation risk (0/1, TS).'),
    nmvAsphalteneFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvAsphalteneFlag?.describe(
      'Asphaltene deposition risk (0/1, TS).',
    ),
    nmvViolatingConstraintsFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvViolatingConstraintsFlag?.describe(
      'Operating outside defined constraints (0/1, TS).',
    ),
    nmvPressureMatchIndexFLP: FlowlineOutputsNetworkAgentSchema.shape.nmvPressureMatchIndexFLP?.describe(
      'Flowline-specific pressure match quality (0-1, TS).',
    ),
    nmvOilRate: FlowlineOutputsNetworkAgentSchema.shape.nmvOilRate?.describe('Oil flow rate through flowline (TS).'),
    nmvGasRate: FlowlineOutputsNetworkAgentSchema.shape.nmvGasRate?.describe('Gas flow rate through flowline (TS).'),
    nmvWaterRate: FlowlineOutputsNetworkAgentSchema.shape.nmvWaterRate?.describe(
      'Water flow rate through flowline (TS).',
    ),
    nmvLiquidRate: FlowlineOutputsNetworkAgentSchema.shape.nmvLiquidRate?.describe(
      'Total liquid flow rate through flowline (TS).',
    ),
    nmvGor: FlowlineOutputsNetworkAgentSchema.shape.nmvGor?.describe('Gas-oil ratio (TS).'),
    nmvWaterCut: FlowlineOutputsNetworkAgentSchema.shape.nmvWaterCut?.describe('Water cut fraction (TS).'),
    nmvCgr: FlowlineOutputsNetworkAgentSchema.shape.nmvCgr?.describe('Condensate-gas ratio (TS).'),
    nmvPressure: FlowlineOutputsNetworkAgentSchema.shape.nmvPressure?.describe('Pressure at flowline node (TS).'),
    nmvTemperature: FlowlineOutputsNetworkAgentSchema.shape.nmvTemperature?.describe(
      'Temperature at flowline node (TS).',
    ),
    nmvErosionVelocity:
      FlowlineOutputsNetworkAgentSchema.shape.nmvErosionVelocity?.describe('Erosion velocity ratio (TS)'),
    nmvMixtureVelocity: FlowlineOutputsNetworkAgentSchema.shape.nmvMixtureVelocity?.describe(
      'Mixture velocity in flowline (TS).',
    ),
    nmvWgr: FlowlineOutputsNetworkAgentSchema.shape.nmvWgr?.describe('Water-gas ratio (TS).'),
    nmvGlr: FlowlineOutputsNetworkAgentSchema.shape.nmvGlr?.describe('Gas-liquid ratio (TS).'),
    nmvPe5StabilityFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvPe5StabilityFlag?.describe(
      'PE5 flow stability indicator (0/1, TS)',
    ),
    nmvCFactor: FlowlineOutputsNetworkAgentSchema.shape.nmvCFactor?.describe('C-factor for inflow performance (TS).'),
    nmvDp: FlowlineOutputsNetworkAgentSchema.shape.nmvDp?.describe('Differential pressure across flowline (TS).'),
    nmvAboveErosionVelocity: FlowlineOutputsNetworkAgentSchema.shape.nmvAboveErosionVelocity?.describe(
      'Above erosion velocity threshold (0/1, TS).',
    ),
    nmvErosionalVelocityFlag: FlowlineOutputsNetworkAgentSchema.shape.nmvErosionalVelocityFlag?.describe(
      'Erosional velocity limit flag (0/1, TS).',
    ),
    nmvMeasuredFlowlinePressure: FlowlineOutputsNetworkAgentSchema.shape.nmvMeasuredFlowlinePressure?.describe(
      'Measured flowline pressure for comparison to simulated (TS).',
    ),
    estimatedFlowlineDeltaP: FlowlineOutputsNetworkAgentSchema.shape.estimatedFlowlineDeltaP?.describe(
      'Estimated pressure drop across flowline (TS).',
    ),
    nmvConnectedManifoldId: FlowlineOutputsNetworkAgentSchema.shape.nmvConnectedManifoldId?.describe(
      'ID of connected production manifold/junction.',
    ),
    nmvInjectionWaterRate: FlowlineOutputsNetworkAgentSchema.shape.nmvInjectionWaterRate?.describe(
      'Water injection flow rate through flowline (TS).',
    ),
    nmvInjectionGasRate: FlowlineOutputsNetworkAgentSchema.shape.nmvInjectionGasRate?.describe(
      'Gas injection flow rate through flowline (TS).',
    ),
    connectedManifoldIdWI: FlowlineOutputsNetworkAgentSchema.shape.connectedManifoldIdWI?.describe(
      'Connected manifold for water injection path.',
    ),
    connectedManifoldIdGI: FlowlineOutputsNetworkAgentSchema.shape.connectedManifoldIdGI?.describe(
      'Connected manifold for gas injection path.',
    ),
  })?.describe(
    'Flowline-level outputs from GAP network simulation (WF20).\n\nPressure drops, flow rates, erosion/corrosion metrics per flowline. Use for\nflowline performance, constraints, and failure points. Excludes historical or real-time time-series.\n\nUse for: Flow Assurance Detection and Mitigation (WF20).\n\n@name Flowline Outputs - Network (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const FluidCompositionView = parseView({
  view: { externalId: 'FluidComposition' },
  model: FluidCompositionSchema.extend({
    ...InstanceIdType.shape,
    entityName: FluidCompositionSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    n2: FluidCompositionSchema.shape.n2?.describe(
      'Time series signal representing n2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    co2: FluidCompositionSchema.shape.co2?.describe(
      'Time series signal representing co2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    h2s: FluidCompositionSchema.shape.h2s?.describe(
      'Time series signal representing h2s for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c1: FluidCompositionSchema.shape.c1?.describe(
      'Time series signal representing c1 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c2: FluidCompositionSchema.shape.c2?.describe(
      'Time series signal representing c2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c3: FluidCompositionSchema.shape.c3?.describe(
      'Time series signal representing c3 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    iC4: FluidCompositionSchema.shape.iC4?.describe(
      'Time series signal representing i c4 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    nC4: FluidCompositionSchema.shape.nC4?.describe(
      'Time series signal representing n c4 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    iC5: FluidCompositionSchema.shape.iC5?.describe(
      'Time series signal representing i c5 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    nC5: FluidCompositionSchema.shape.nC5?.describe(
      'Time series signal representing n c5 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c6: FluidCompositionSchema.shape.c6?.describe(
      'Time series signal representing c6 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c7c14: FluidCompositionSchema.shape.c7c14?.describe(
      'Time series signal representing c7c14 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c15c25: FluidCompositionSchema.shape.c15c25?.describe(
      'Time series signal representing c15c25 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c26c80: FluidCompositionSchema.shape.c26c80?.describe(
      'Time series signal representing c26c80 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificGasGravity: FluidCompositionSchema.shape.specificGasGravity?.describe(
      'Time series signal representing specific gas gravity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wgr: FluidCompositionSchema.shape.wgr?.describe(
      'Time series signal representing wgr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    condensateGravity: FluidCompositionSchema.shape.condensateGravity?.describe(
      'Time series signal representing condensate gravity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterSalinity: FluidCompositionSchema.shape.waterSalinity?.describe(
      'Time series signal representing water salinity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cgr: FluidCompositionSchema.shape.cgr?.describe(
      'Time series signal representing cgr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Fluid Composition view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const FormationVolumeFactorView = parseView({
  view: { externalId: 'Formation_Volume_Factor' },
  model: FormationVolumeFactorSchema.extend({
    ...InstanceIdType.shape,
    entityName: FormationVolumeFactorSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    effectiveDate: FormationVolumeFactorSchema.shape.effectiveDate?.describe(
      'Attribute capturing effective date for this entity in the production optimization context.',
    ),
    bOil: FormationVolumeFactorSchema.shape.bOil?.describe(
      'Numeric value storing b oil for this entity, used in calculations, reporting, or model configuration.',
    ),
    bGas: FormationVolumeFactorSchema.shape.bGas?.describe(
      'Numeric value storing b gas for this entity, used in calculations, reporting, or model configuration.',
    ),
    bWater: FormationVolumeFactorSchema.shape.bWater?.describe(
      'Numeric value storing b water for this entity, used in calculations, reporting, or model configuration.',
    ),
    bGasInjector: FormationVolumeFactorSchema.shape.bGasInjector?.describe(
      'Numeric value storing b gas injector for this entity, used in calculations, reporting, or model configuration.',
    ),
    bWaterInjector: FormationVolumeFactorSchema.shape.bWaterInjector?.describe(
      'Numeric value storing b water injector for this entity, used in calculations, reporting, or model configuration.',
    ),
    pressure: FormationVolumeFactorSchema.shape.pressure?.describe(
      'Numeric value storing pressure for this entity, used in calculations, reporting, or model configuration.',
    ),
    reservoir: FormationVolumeFactorSchema.shape.reservoir?.describe(
      'Reservoir attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    rs: FormationVolumeFactorSchema.shape.rs?.describe(
      'Numeric value storing rs for this entity, used in calculations, reporting, or model configuration.',
    ),
    pb: FormationVolumeFactorSchema.shape.pb?.describe(
      'Numeric value storing pb for this entity, used in calculations, reporting, or model configuration.',
    ),
    temperature: FormationVolumeFactorSchema.shape.temperature?.describe(
      'Numeric value storing temperature for this entity, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'Formation Volume Factor view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const GasLiftAlarmsAgentView = parseView({
  view: { externalId: 'GasLiftAlarms_Agent' },
  model: GasLiftAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: GasLiftAlarmsAgentSchema.shape.wellString?.describe('Reference to well string'),
    subCategory: GasLiftAlarmsAgentSchema.shape.subCategory?.describe('Alarm sub-category for domain filtering.'),
    subWorkflowName: GasLiftAlarmsAgentSchema.shape.subWorkflowName?.describe('Sub-workflow that generated the alarm.'),
    alarmCounter: GasLiftAlarmsAgentSchema.shape.alarmCounter?.describe(
      'Number of consecutive occurrences of this alarm.',
    ),
    ticketId: GasLiftAlarmsAgentSchema.shape.ticketId?.describe(
      'Associated ticket/action ID if alarm has been acknowledged.',
    ),
  })?.describe(
    'Gas lift troubleshooting and diagnostic alarms with medium or high priority.\n\nContains diagnostic alarms, gas lift operations, focusing on those with medium\nor high priority. Sourced from operational monitoring systems that track alarm\nevents, to analyze alarm occurrences and their implications on gas lift\nperformance. It answers analytical questions such as the frequency of high-\npriority alarms and troubleshooting effectiveness. Excludes low-priority or non-WF14 alarms.\n\nUse for: Gas Lift Troubleshooting and Diagnostics (WF14), Real-Time Surveillance (WF18).\n\n@name Gas Lift Diagnostic Alarms (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const GasLiftCalculationsStringAgentView = parseView({
  view: { externalId: 'GasLiftCalculations_String_Agent' },
  model: GasLiftCalculationsStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: GasLiftCalculationsStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    glqlAnalysisStatus: GasLiftCalculationsStringAgentSchema.shape.glqlAnalysisStatus?.describe(
      'Status of gas lift rate calculation',
    ),
    glirSelected: GasLiftCalculationsStringAgentSchema.shape.glirSelected?.describe(
      'Selected/priority gas lift injection rate (MSCF/d, TS)',
    ),
    glirSelectedType: GasLiftCalculationsStringAgentSchema.shape.glirSelectedType?.describe('Source of selected GLIR'),
    glirMeasured: GasLiftCalculationsStringAgentSchema.shape.glirMeasured?.describe(
      'Measured gas lift injection rate from flow meter (MSCF/d, TS).',
    ),
    glirNetworkSimulation: GasLiftCalculationsStringAgentSchema.shape.glirNetworkSimulation?.describe(
      'Gas lift injection rate from network simulation model (MSCF/d, TS).',
    ),
    glirChokeEquation: GasLiftCalculationsStringAgentSchema.shape.glirChokeEquation?.describe(
      'Gas lift injection rate calculated from GL choke equation (MSCF/d, TS).',
    ),
    glirAllocated: GasLiftCalculationsStringAgentSchema.shape.glirAllocated?.describe(
      'Allocated gas lift injection rate from daily allocation (MSCF/d, TS).',
    ),
    glChokeSizeCalc: GasLiftCalculationsStringAgentSchema.shape.glChokeSizeCalc?.describe(
      'Calculated GL choke size required to achieve current GLIR given upstream\npressure conditions (64ths inch, TS).',
    ),
    glChokeCdCalc: GasLiftCalculationsStringAgentSchema.shape.glChokeCdCalc?.describe(
      'Calculated GL choke discharge coefficient (Cd, TS)',
    ),
  })?.describe(
    'Model-calculated gas lift outputs per well string (WF14).\n\nGLIR variants (measured, network, choke, allocated, priority), GL analysis status,\nchoke parameters. Use glirSelected for best-available GLIR. Use with GasLiftMeasurements_String_Agent and GasLiftLimits_String_Agent.\n\nUse for: Gas Lift Troubleshooting and Diagnostics (WF14).\n\n@name Gas Lift Calculations - Well String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const GasLiftLimitsStringAgentView = parseView({
  view: { externalId: 'GasLiftLimits_String_Agent' },
  model: GasLiftLimitsStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: GasLiftLimitsStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    glMaxCasingHeadPressure: GasLiftLimitsStringAgentSchema.shape.glMaxCasingHeadPressure?.describe(
      'Maximum allowable casing head pressure (psia, TS)',
    ),
    glMinCasingHeadPressure: GasLiftLimitsStringAgentSchema.shape.glMinCasingHeadPressure?.describe(
      'Minimum casing head pressure for stable injection (psia, TS)',
    ),
    glMaxWellHeadTemp: GasLiftLimitsStringAgentSchema.shape.glMaxWellHeadTemp?.describe(
      'Maximum wellhead temperature limit (Â°F, TS).',
    ),
    glMinWellHeadPressure: GasLiftLimitsStringAgentSchema.shape.glMinWellHeadPressure?.describe(
      'Minimum wellhead pressure for stable flow (psia, TS)',
    ),
    maxWellHeadPressure: GasLiftLimitsStringAgentSchema.shape.maxWellHeadPressure?.describe(
      'Maximum wellhead pressure limit (psia, TS)',
    ),
    glMaxManifoldPressure: GasLiftLimitsStringAgentSchema.shape.glMaxManifoldPressure?.describe(
      'Maximum manifold pressure limit (psia, TS)',
    ),
    glMinManifolddPressure: GasLiftLimitsStringAgentSchema.shape.glMinManifolddPressure?.describe(
      'Minimum manifold pressure limit (psia, TS)',
    ),
    glMinBHP: GasLiftLimitsStringAgentSchema.shape.glMinBHP?.describe('Minimum bottomhole pressure target (psia, TS)'),
    glMaxLiftChokeDeltaTemp: GasLiftLimitsStringAgentSchema.shape.glMaxLiftChokeDeltaTemp?.describe(
      'Maximum temperature drop across gas lift choke (Â°F, TS)',
    ),
    maxLiquidRate: GasLiftLimitsStringAgentSchema.shape.maxLiquidRate?.describe(
      'Maximum liquid rate limit (stb/d, TS)',
    ),
    maxOilRate: GasLiftLimitsStringAgentSchema.shape.maxOilRate?.describe('Maximum oil rate limit (stb/d, TS)'),
    maxGOR: GasLiftLimitsStringAgentSchema.shape.maxGOR?.describe('Maximum GOR limit (scf/stb, TS)'),
    glMaxCasingHeadPressure_active: GasLiftLimitsStringAgentSchema.shape.glMaxCasingHeadPressure_active?.describe(
      'Boolean flag â€” glMaxCasingHeadPressure limit is actively monitored for alarms.',
    ),
    glMinCasingHeadPressure_active: GasLiftLimitsStringAgentSchema.shape.glMinCasingHeadPressure_active?.describe(
      'Boolean flag â€” glMinCasingHeadPressure limit is actively monitored for alarms.',
    ),
    waxRisk: GasLiftLimitsStringAgentSchema.shape.waxRisk?.describe(
      'Wax deposition risk flag or score for this well string.',
    ),
    hydrateRisk: GasLiftLimitsStringAgentSchema.shape.hydrateRisk?.describe(
      'Hydrate formation risk flag or score for this well string.',
    ),
    asphalteneRisk: GasLiftLimitsStringAgentSchema.shape.asphalteneRisk?.describe(
      'Asphaltene deposition risk flag or score for this well string.',
    ),
    pe5StabilityCriteria: GasLiftLimitsStringAgentSchema.shape.pe5StabilityCriteria?.describe(
      'PE5 flow stability criteria threshold for this well string.',
    ),
    fluidVelocity: GasLiftLimitsStringAgentSchema.shape.fluidVelocity?.describe(
      'Fluid velocity limit or reference value (ft/s, TS)',
    ),
  })?.describe(
    'Gas lift operating limit thresholds per well string (WF14).\n\nEngineering limits: casing/wellhead pressures, manifold pressure, BHP target,\ntemperature, rate limits (liquid, oil, GOR), monitoring flags. Compare against GasLiftMeasurements_String_Agent for exceedances. For ESP use ESPLimits_String_Agent.\n\nUse for: Gas Lift Troubleshooting and Diagnostics (WF14).\n\n@name Gas Lift Operating Limits - Well String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const GasLiftMeasurementsStringAgentView = parseView({
  view: { externalId: 'GasLiftMeasurements_String_Agent' },
  model: GasLiftMeasurementsStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: GasLiftMeasurementsStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    liftType: GasLiftMeasurementsStringAgentSchema.shape.liftType?.describe('Artificial lift type (TS)'),
    gasLiftInjRate: GasLiftMeasurementsStringAgentSchema.shape.gasLiftInjRate?.describe(
      'Current gas lift injection rate (Mscf/d, TS)',
    ),
    gasLiftFlowCVInletPress: GasLiftMeasurementsStringAgentSchema.shape.gasLiftFlowCVInletPress?.describe(
      'Inlet pressure at the gas lift flow control valve (psia, TS)',
    ),
    gasLiftInjTemp: GasLiftMeasurementsStringAgentSchema.shape.gasLiftInjTemp?.describe(
      'Gas lift injection temperature (Â°F, TS)',
    ),
    gasLiftFlowCVSize: GasLiftMeasurementsStringAgentSchema.shape.gasLiftFlowCVSize?.describe(
      'Effective orifice/trim size of the gas lift flow control valve (TS).',
    ),
    casingHeadPress: GasLiftMeasurementsStringAgentSchema.shape.casingHeadPress?.describe(
      'Casing head pressure (psia, TS)',
    ),
    wellHeadPress: GasLiftMeasurementsStringAgentSchema.shape.wellHeadPress?.describe(
      'Flowing wellhead pressure (psia, TS)',
    ),
    wellHeadTemp: GasLiftMeasurementsStringAgentSchema.shape.wellHeadTemp?.describe(
      'Flowing wellhead temperature (Â°F, TS)',
    ),
    annulusPress: GasLiftMeasurementsStringAgentSchema.shape.annulusPress?.describe('Annulus pressure (psia, TS)'),
    chokeOpening: GasLiftMeasurementsStringAgentSchema.shape.chokeOpening?.describe(
      'Production choke opening (% or 64ths, TS)',
    ),
    chokeSize: GasLiftMeasurementsStringAgentSchema.shape.chokeSize?.describe('Surface choke size setting (TS)'),
    flowLinePress: GasLiftMeasurementsStringAgentSchema.shape.flowLinePress?.describe(
      'Downstream flowline pressure (psia, TS)',
    ),
    flowLineTemp: GasLiftMeasurementsStringAgentSchema.shape.flowLineTemp?.describe('Flowline temperature (Â°F, TS)'),
    bottomHolePress: GasLiftMeasurementsStringAgentSchema.shape.bottomHolePress?.describe(
      'Bottom-hole flowing pressure (psia, TS)',
    ),
    bottomHoleTemp: GasLiftMeasurementsStringAgentSchema.shape.bottomHoleTemp?.describe(
      'Bottom-hole temperature (Â°F, TS)',
    ),
  })?.describe(
    'Real-time gas lift sensor readings per well string (WF14).\n\nLive measurements: injection rate, CV inlet pressure/temperature, CV size,\ncasing/wellhead pressures and temperatures, annulus pressure, choke settings,\ndownhole BHP/BHT. Compare against GasLiftLimits_String_Agent. For calculated outputs see GasLiftCalculations_String_Agent.\n\nUse for: Gas Lift Troubleshooting and Diagnostics (WF14).\n\n@name Gas Lift Measurements - Well String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const GlValveDataView = parseView({
  view: { externalId: 'GL_Valve_Data' },
  model: GlValveDataSchema.extend({
    ...InstanceIdType.shape,
    field: GlValveDataSchema.shape.field?.describe(
      "Reference to the related 'Field' entity for this 'GL_Valve_Data' row.",
    ),
    entityName: GlValveDataSchema.shape.entityName?.describe(
      "Reference to the related 'String_asset' entity for this 'GL_Valve_Data' row.",
    ),
    gasLiftMandrel: GlValveDataSchema.shape.gasLiftMandrel?.describe(
      "Numeric value 'gasLiftMandrel' (integer) for this 'GL_Valve_Data' row.",
    ),
    installationDate: GlValveDataSchema.shape.installationDate?.describe(
      "Timestamp 'installationDate' associated with this 'GL_Valve_Data' row.",
    ),
    measuredDepth: GlValveDataSchema.shape.measuredDepth?.describe(
      "Numeric value 'measuredDepth' (floating point) for this 'GL_Valve_Data' row.",
    ),
    trueVerticalDepth: GlValveDataSchema.shape.trueVerticalDepth?.describe(
      "Numeric value 'trueVerticalDepth' (floating point) for this 'GL_Valve_Data' row.",
    ),
    type: GlValveDataSchema.shape.type?.describe("Text attribute 'type' for this 'GL_Valve_Data' row."),
    glValveOrificeSeries: GlValveDataSchema.shape.glValveOrificeSeries?.describe(
      "Text attribute 'glValveOrificeSeries' for this 'GL_Valve_Data' row.",
    ),
    glValveMaterial: GlValveDataSchema.shape.glValveMaterial?.describe(
      "Text attribute 'glValveMaterial' for this 'GL_Valve_Data' row.",
    ),
    glValveSize: GlValveDataSchema.shape.glValveSize?.describe(
      "Numeric value 'glValveSize' (floating point) for this 'GL_Valve_Data' row.",
    ),
    glPortSize: GlValveDataSchema.shape.glPortSize?.describe(
      "Numeric value 'glPortSize' (integer) for this 'GL_Valve_Data' row.",
    ),
    rValue: GlValveDataSchema.shape.rValue?.describe(
      "Numeric value 'rValue' (floating point) for this 'GL_Valve_Data' row.",
    ),
    domePressure: GlValveDataSchema.shape.domePressure?.describe(
      "Numeric value 'domePressure' (floating point) for this 'GL_Valve_Data' row.",
    ),
    testRackOpeningPressure: GlValveDataSchema.shape.testRackOpeningPressure?.describe(
      "Numeric value 'testRackOpeningPressure' (floating point) for this 'GL_Valve_Data' row.",
    ),
  })?.describe("View 'GL_Valve_Data' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const InactiveStringAgentView = parseView({
  view: { externalId: 'InactiveString_Agent' },
  model: InactiveStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: InactiveStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    stringStatus: InactiveStringAgentSchema.shape.stringStatus?.describe(
      "Activity status of the string: 'ACTIVE' or 'INACTIVE'",
    ),
    inactiveCategory: InactiveStringAgentSchema.shape.inactiveCategory?.describe(
      "Category of inactivity explaining why the string is inactive, e.g.,\n'MECHANICAL_FAILURE', 'AWAITING_WORKOVER', 'LOW_PRODUCTIVITY', 'ABANDONED'.",
    ),
    downtimeStartDate: InactiveStringAgentSchema.shape.downtimeStartDate?.describe(
      'Date when the string became inactive',
    ),
  })?.describe(
    'Long-term well string inactivity with reasons and downtime start dates (WF25/WF18).\n\nStrings classified INACTIVE (extended/indefinite offline). Distinct from\nWellStatus_String_Agent (real-time flowing/shut-in). Use for inactive well\naging, downtime impact, workover candidate screening, well availability.\n\nUse for: Well Status Detection (WF25), Real-Time Surveillance (WF18).',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const InactiveStringView = parseView({
  view: { externalId: 'Inactive_String' },
  model: InactiveStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: InactiveStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    stringStatus: InactiveStringSchema.shape.stringStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    inactiveCategory: InactiveStringSchema.shape.inactiveCategory?.describe(
      'Time series signal representing inactive category for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    categoryCode: InactiveStringSchema.shape.categoryCode?.describe(
      'Time series signal representing category code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    problemName: InactiveStringSchema.shape.problemName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    actionStatus: InactiveStringSchema.shape.actionStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    stringStatusAll: InactiveStringSchema.shape.stringStatusAll?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    downtimeStartDate: InactiveStringSchema.shape.downtimeStartDate?.describe(
      'Time series signal representing downtime start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    actionDate: InactiveStringSchema.shape.actionDate?.describe(
      'Time series signal representing action date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    duration: InactiveStringSchema.shape.duration?.describe(
      'Time series signal representing duration for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    expectedRate: InactiveStringSchema.shape.expectedRate?.describe(
      'Time series signal representing expected rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Inactive String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const InjectionAlarmsAgentView = parseView({
  view: { externalId: 'InjectionAlarms_Agent' },
  model: InjectionAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: InjectionAlarmsAgentSchema.shape.wellString?.describe('Reference to well string'),
    subCategory: InjectionAlarmsAgentSchema.shape.subCategory?.describe('Alarm sub-category for domain filtering.'),
    subWorkflowName: InjectionAlarmsAgentSchema.shape.subWorkflowName?.describe(
      'Sub-workflow that generated the alarm.',
    ),
    alarmCounter: InjectionAlarmsAgentSchema.shape.alarmCounter?.describe(
      'Number of consecutive occurrences of this alarm.',
    ),
    ticketId: InjectionAlarmsAgentSchema.shape.ticketId?.describe(
      'Associated ticket/action ID if alarm has been acknowledged.',
    ),
  })?.describe(
    'Injection monitoring and VRR alarms with medium or high priority.\n\nThe Injection Monitoring Alarms (Agent) view contains data related to medium\nand high-priority alarms associated with water or gas injection and VRR\n(Volume Reduction Ratio) monitoring. This data is sourced from operational\nworkflows focused on injection monitoring and includes alarm codes,\npriorities, and timestamps, allowing for the analysis of alarm occurrences and\ntheir implications on operational efficiency. It can answer questions\nregarding frequency, criticality, and duration of injection/VRR alarms. Excludes low-priority alarms.\n\nUse for: Water or Gas Injection Monitoring (WF15), VRR (WF16/WF17), Real-Time Surveillance (WF18).\n\n@name Injection Monitoring Alarms (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const InjectionAllocationFactorView = parseView({
  view: { externalId: 'Injection_Allocation_Factor' },
  model: InjectionAllocationFactorSchema.extend({
    ...InstanceIdType.shape,
    injectorString: InjectionAllocationFactorSchema.shape.injectorString?.describe(
      "Reference to the related 'String_asset' entity for this 'Injection_Allocation_Factor' row.",
    ),
    producerString: InjectionAllocationFactorSchema.shape.producerString?.describe(
      "Reference to the related 'String_asset' entity for this 'Injection_Allocation_Factor' row.",
    ),
    effectiveDate: InjectionAllocationFactorSchema.shape.effectiveDate?.describe(
      "Timestamp 'effectiveDate' associated with this 'Injection_Allocation_Factor' row.",
    ),
    allocationFactor: InjectionAllocationFactorSchema.shape.allocationFactor?.describe(
      "Numeric value 'allocationFactor' (floating point) for this 'Injection_Allocation_Factor' row.",
    ),
    source: InjectionAllocationFactorSchema.shape.source?.describe(
      "Text attribute 'source' for this 'Injection_Allocation_Factor' row.",
    ),
    field: InjectionAllocationFactorSchema.shape.field?.describe(
      "Reference to the related 'Field' entity for this 'Injection_Allocation_Factor' row.",
    ),
    reservoir: InjectionAllocationFactorSchema.shape.reservoir?.describe(
      "Reference to the related 'Reservoir' entity for this 'Injection_Allocation_Factor' row.",
    ),
    executionDate: InjectionAllocationFactorSchema.shape.executionDate?.describe(
      "Timestamp 'executionDate' associated with this 'Injection_Allocation_Factor' row.",
    ),
  })?.describe("View 'Injection_Allocation_Factor' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const InjectionPerformanceStringAgentView = parseView({
  view: { externalId: 'InjectionPerformance_String_Agent' },
  model: InjectionPerformanceStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: InjectionPerformanceStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    giRate: InjectionPerformanceStringAgentSchema.shape.giRate?.describe('Current gas injection rate (MSCF/d, TS)'),
    giTargetRate: InjectionPerformanceStringAgentSchema.shape.giTargetRate?.describe(
      'Target gas injection rate (MSCF/d, TS) from production plan or optimization.\nCompare to giRate to assess injection compliance.',
    ),
    giTechnicalRate: InjectionPerformanceStringAgentSchema.shape.giTechnicalRate?.describe(
      'Maximum technically achievable gas injection rate (MSCF/d, TS) given\ncurrent well and facility constraints.',
    ),
    giWHP: InjectionPerformanceStringAgentSchema.shape.giWHP?.describe(
      'Wellhead pressure during gas injection (psi, TS).',
    ),
    giBHP: InjectionPerformanceStringAgentSchema.shape.giBHP?.describe(
      'Bottom-hole pressure during gas injection (psi, TS)',
    ),
    wiRate: InjectionPerformanceStringAgentSchema.shape.wiRate?.describe('Current water injection rate (stb/d, TS)'),
    wiTargetRate: InjectionPerformanceStringAgentSchema.shape.wiTargetRate?.describe(
      'Target water injection rate (stb/d, TS) from production plan or optimization.',
    ),
    wiTechnicalRate: InjectionPerformanceStringAgentSchema.shape.wiTechnicalRate?.describe(
      'Maximum technically achievable water injection rate (stb/d, TS).',
    ),
    wiWHP: InjectionPerformanceStringAgentSchema.shape.wiWHP?.describe(
      'Wellhead pressure during water injection (psi, TS).',
    ),
    wiBHP: InjectionPerformanceStringAgentSchema.shape.wiBHP?.describe(
      'Bottom-hole pressure during water injection (psi, TS).',
    ),
    cumulativeWaterInjVol: InjectionPerformanceStringAgentSchema.shape.cumulativeWaterInjVol?.describe(
      'Cumulative water injection volume (stb, TS)',
    ),
    cumulativeWaterInjPress: InjectionPerformanceStringAgentSchema.shape.cumulativeWaterInjPress?.describe(
      'Average WHP during cumulative water injection period (psi, TS).',
    ),
    cumulativeGasInjVol: InjectionPerformanceStringAgentSchema.shape.cumulativeGasInjVol?.describe(
      'Cumulative gas injection volume (MSCF, TS)',
    ),
    cumulativeGasInjPress: InjectionPerformanceStringAgentSchema.shape.cumulativeGasInjPress?.describe(
      'Average WHP during cumulative gas injection period (psi, TS).',
    ),
    injectionEfficiency:
      InjectionPerformanceStringAgentSchema.shape.injectionEfficiency?.describe('Injection efficiency (%, TS)'),
    injectionEfficiencyRank: InjectionPerformanceStringAgentSchema.shape.injectionEfficiencyRank?.describe(
      'Rank among all injectors (1 = best, TS)',
    ),
    injectionEfficiencyFlag: InjectionPerformanceStringAgentSchema.shape.injectionEfficiencyFlag?.describe(
      'Flag: 1 = below efficiency threshold (needs attention), 0 = acceptable.',
    ),
    hallLine: InjectionPerformanceStringAgentSchema.shape.hallLine?.describe(
      'Hall plot cumulative value or slope (TS)',
    ),
    hallInterpretation: InjectionPerformanceStringAgentSchema.shape.hallInterpretation?.describe(
      "Hall plot trend interpretation: 'STABLE', 'IMPROVING', 'DECLINING',\n'STIMULATION_NEEDED'",
    ),
    injectivityIndex: InjectionPerformanceStringAgentSchema.shape.injectivityIndex?.describe(
      'Injectivity index (stb/d/psi, TS)',
    ),
    downholeWaterInjectionVolume: InjectionPerformanceStringAgentSchema.shape.downholeWaterInjectionVolume?.describe(
      'Cumulative water injection at reservoir conditions (rb, TS)',
    ),
    downholeGasInjectionVolume: InjectionPerformanceStringAgentSchema.shape.downholeGasInjectionVolume?.describe(
      'Cumulative gas injection at reservoir conditions (rb, TS).',
    ),
  })?.describe(
    'Injection well performance metrics at string level (WF15).\n\nGas and water injection rates, pressures, efficiency, Hall plot. Use for\neffectiveness of injection strategies, injectivity trends, compliance with\ntargets, and Hall plot diagnostics. Excludes surface facility or reservoir views.\n\nUse for: Water or Gas Injection Monitoring (WF15).\n\n@name Injection Performance - String Level (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const InjPressGuidelineStringAgentView = parseView({
  view: { externalId: 'InjPressGuideline_String_Agent' },
  model: InjPressGuidelineStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: InjPressGuidelineStringAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'Injection pressure guidelines and operating limits per well string (WF15).\n\nMax WHP, min BHP, fracture gradient, operating pressure bands. Use for safe\ninjection practices, optimal pressure settings, over-pressurization risk. For\nperformance trends see InjectionPerformance_String_Agent.\n\nUse for: Water or Gas Injection Monitoring (WF15).\n\n@name Injection Pressure Guidelines - String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const InjPressGuidelineStringView = parseView({
  view: { externalId: 'InjPressGuideline_String' },
  model: InjPressGuidelineStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: InjPressGuidelineStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wiMaxWHIP: InjPressGuidelineStringSchema.shape.wiMaxWHIP?.describe(
      'Numeric value storing wi max whip for this production string, used in calculations, reporting, or model configuration.',
    ),
    wiMaxBHIP: InjPressGuidelineStringSchema.shape.wiMaxBHIP?.describe(
      'Numeric value storing wi max bhip for this production string, used in calculations, reporting, or model configuration.',
    ),
    giMaxWHIP: InjPressGuidelineStringSchema.shape.giMaxWHIP?.describe(
      'Numeric value storing gi max whip for this production string, used in calculations, reporting, or model configuration.',
    ),
    giMaxBHIP: InjPressGuidelineStringSchema.shape.giMaxBHIP?.describe(
      'Numeric value storing gi max bhip for this production string, used in calculations, reporting, or model configuration.',
    ),
    wiMaxInjRate: InjPressGuidelineStringSchema.shape.wiMaxInjRate?.describe(
      'Numeric value storing wi max inj rate for this production string, used in calculations, reporting, or model configuration.',
    ),
    giMaxInjRate: InjPressGuidelineStringSchema.shape.giMaxInjRate?.describe(
      'Numeric value storing gi max inj rate for this production string, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'Inj Press Guideline String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const LiftTypeParameterStringView = parseView({
  view: { externalId: 'LiftTypeParameter_String' },
  model: LiftTypeParameterStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: LiftTypeParameterStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    espMaxPumpDeltaTemp: LiftTypeParameterStringSchema.shape.espMaxPumpDeltaTemp?.describe(
      'Time series signal representing esp max pump delta temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxMotorTemp: LiftTypeParameterStringSchema.shape.espMaxMotorTemp?.describe(
      'Time series signal representing esp max motor temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxMotorAmps: LiftTypeParameterStringSchema.shape.espMaxMotorAmps?.describe(
      'Time series signal representing esp max motor amps for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxMotorPwr: LiftTypeParameterStringSchema.shape.espMaxMotorPwr?.describe(
      'Time series signal representing esp max motor pwr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxMotorSpeed_InductorType: LiftTypeParameterStringSchema.shape.espMaxMotorSpeed_InductorType?.describe(
      'Time series signal representing esp max motor speed inductor type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxMotorSpeed_PmmType: LiftTypeParameterStringSchema.shape.espMaxMotorSpeed_PmmType?.describe(
      'Time series signal representing esp max motor speed pmm type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxVoltageDropAlongCable: LiftTypeParameterStringSchema.shape.espMaxVoltageDropAlongCable?.describe(
      'Time series signal representing esp max voltage drop along cable for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxSurfaceKva: LiftTypeParameterStringSchema.shape.espMaxSurfaceKva?.describe(
      'Time series signal representing esp max surface kva for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxTrqOnShaft: LiftTypeParameterStringSchema.shape.espMaxTrqOnShaft?.describe(
      'Time series signal representing esp max trq on shaft for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMinPumpFluidVelocity: LiftTypeParameterStringSchema.shape.espMinPumpFluidVelocity?.describe(
      'Time series signal representing esp min pump fluid velocity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxPumpFluidVelocity: LiftTypeParameterStringSchema.shape.espMaxPumpFluidVelocity?.describe(
      'Time series signal representing esp max pump fluid velocity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMinIntakePressure: LiftTypeParameterStringSchema.shape.espMinIntakePressure?.describe(
      'Time series signal representing esp min intake pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxDischargePressure: LiftTypeParameterStringSchema.shape.espMaxDischargePressure?.describe(
      'Time series signal representing esp max discharge pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMinIntakeTemperature: LiftTypeParameterStringSchema.shape.espMinIntakeTemperature?.describe(
      'Time series signal representing esp min intake temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxHead: LiftTypeParameterStringSchema.shape.espMaxHead?.describe(
      'Time series signal representing esp max head for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxPwrAvail_Generated: LiftTypeParameterStringSchema.shape.espMaxPwrAvail_Generated?.describe(
      'Time series signal representing esp max pwr avail generated for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxFluidRate: LiftTypeParameterStringSchema.shape.espMaxFluidRate?.describe(
      'Time series signal representing esp max fluid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMinFluidRate: LiftTypeParameterStringSchema.shape.espMinFluidRate?.describe(
      'Time series signal representing esp min fluid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxMotorEfficiency: LiftTypeParameterStringSchema.shape.espMaxMotorEfficiency?.describe(
      'Time series signal representing esp max motor efficiency for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxMotorLoadPermissible: LiftTypeParameterStringSchema.shape.espMaxMotorLoadPermissible?.describe(
      'Time series signal representing esp max motor load permissible for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMinMotorPowerFactor: LiftTypeParameterStringSchema.shape.espMinMotorPowerFactor?.describe(
      'Time series signal representing esp min motor power factor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxFreeGasInPump: LiftTypeParameterStringSchema.shape.espMaxFreeGasInPump?.describe(
      'Time series signal representing esp max free gas in pump for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glMaxLiftChokeDeltaTemp: LiftTypeParameterStringSchema.shape.glMaxLiftChokeDeltaTemp?.describe(
      'Time series signal representing gl max lift choke delta temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glMaxWellHeadTemp: LiftTypeParameterStringSchema.shape.glMaxWellHeadTemp?.describe(
      'Time series signal representing gl max well head temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glMaxCasingHeadPressure: LiftTypeParameterStringSchema.shape.glMaxCasingHeadPressure?.describe(
      'Time series signal representing gl max casing head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    maxWellHeadPressure: LiftTypeParameterStringSchema.shape.maxWellHeadPressure?.describe(
      'Time series signal representing max well head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glMinWellHeadPressure: LiftTypeParameterStringSchema.shape.glMinWellHeadPressure?.describe(
      'Time series signal representing gl min well head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glMinCasingHeadPressure: LiftTypeParameterStringSchema.shape.glMinCasingHeadPressure?.describe(
      'Time series signal representing gl min casing head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glMinManifolddPressure: LiftTypeParameterStringSchema.shape.glMinManifolddPressure?.describe(
      'Time series signal representing gl min manifoldd pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glMaxManifoldPressure: LiftTypeParameterStringSchema.shape.glMaxManifoldPressure?.describe(
      'Time series signal representing gl max manifold pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glMinBHP: LiftTypeParameterStringSchema.shape.glMinBHP?.describe(
      'Time series signal representing gl min bhp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    maxLiquidRate: LiftTypeParameterStringSchema.shape.maxLiquidRate?.describe(
      'Time series signal representing max liquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    maxOilRate: LiftTypeParameterStringSchema.shape.maxOilRate?.describe(
      'Time series signal representing max oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    maxGOR: LiftTypeParameterStringSchema.shape.maxGOR?.describe(
      'Time series signal representing max gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espMaxPumpDeltaTemp_active: LiftTypeParameterStringSchema.shape.espMaxPumpDeltaTemp_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxMotorTemp_active: LiftTypeParameterStringSchema.shape.espMaxMotorTemp_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxMotorAmps_active: LiftTypeParameterStringSchema.shape.espMaxMotorAmps_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxMotorPwr_active: LiftTypeParameterStringSchema.shape.espMaxMotorPwr_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxMotorSpeed_InductorType_active:
      LiftTypeParameterStringSchema.shape.espMaxMotorSpeed_InductorType_active?.describe(
        'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
      ),
    espMaxMotorSpeed_PmmType_active: LiftTypeParameterStringSchema.shape.espMaxMotorSpeed_PmmType_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxVoltageDropAlongCable_active:
      LiftTypeParameterStringSchema.shape.espMaxVoltageDropAlongCable_active?.describe(
        'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
      ),
    espMaxSurfaceKva_active: LiftTypeParameterStringSchema.shape.espMaxSurfaceKva_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxTrqOnShaft_active: LiftTypeParameterStringSchema.shape.espMaxTrqOnShaft_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMinPumpFluidVelocity_active: LiftTypeParameterStringSchema.shape.espMinPumpFluidVelocity_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxPumpFluidVelocity_active: LiftTypeParameterStringSchema.shape.espMaxPumpFluidVelocity_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMinIntakePressure_active: LiftTypeParameterStringSchema.shape.espMinIntakePressure_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxDischargePressure_active: LiftTypeParameterStringSchema.shape.espMaxDischargePressure_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMinIntakeTemperature_active: LiftTypeParameterStringSchema.shape.espMinIntakeTemperature_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxHead_active: LiftTypeParameterStringSchema.shape.espMaxHead_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxPwrAvail_Generated_active: LiftTypeParameterStringSchema.shape.espMaxPwrAvail_Generated_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxFluidRate_active: LiftTypeParameterStringSchema.shape.espMaxFluidRate_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMinFluidRate_active: LiftTypeParameterStringSchema.shape.espMinFluidRate_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxMotorEfficiency_active: LiftTypeParameterStringSchema.shape.espMaxMotorEfficiency_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxMotorLoadPermissible_active: LiftTypeParameterStringSchema.shape.espMaxMotorLoadPermissible_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMinMotorPowerFactor_active: LiftTypeParameterStringSchema.shape.espMinMotorPowerFactor_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    espMaxFreeGasInPump_active: LiftTypeParameterStringSchema.shape.espMaxFreeGasInPump_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    glMaxLiftChokeDeltaTemp_active: LiftTypeParameterStringSchema.shape.glMaxLiftChokeDeltaTemp_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    glMaxWellHeadTemp_active: LiftTypeParameterStringSchema.shape.glMaxWellHeadTemp_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    glMaxCasingHeadPressure_active: LiftTypeParameterStringSchema.shape.glMaxCasingHeadPressure_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    maxWellHeadPressure_active: LiftTypeParameterStringSchema.shape.maxWellHeadPressure_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    glMinWellHeadPressure_active: LiftTypeParameterStringSchema.shape.glMinWellHeadPressure_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    glMinCasingHeadPressure_active: LiftTypeParameterStringSchema.shape.glMinCasingHeadPressure_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    glMinManifolddPressure_active: LiftTypeParameterStringSchema.shape.glMinManifolddPressure_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    glMaxManifoldPressure_active: LiftTypeParameterStringSchema.shape.glMaxManifoldPressure_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    glMinBHP_active: LiftTypeParameterStringSchema.shape.glMinBHP_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    maxLiquidRate_active: LiftTypeParameterStringSchema.shape.maxLiquidRate_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    maxOilRate_active: LiftTypeParameterStringSchema.shape.maxOilRate_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    maxGOR_active: LiftTypeParameterStringSchema.shape.maxGOR_active?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    waxRisk: LiftTypeParameterStringSchema.shape.waxRisk?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    hydrateRisk: LiftTypeParameterStringSchema.shape.hydrateRisk?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    asphalteneRisk: LiftTypeParameterStringSchema.shape.asphalteneRisk?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    pe5StabilityCriteria: LiftTypeParameterStringSchema.shape.pe5StabilityCriteria?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    fluidVelocity: LiftTypeParameterStringSchema.shape.fluidVelocity?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    corrosionRelativeWT: LiftTypeParameterStringSchema.shape.corrosionRelativeWT?.describe(
      'Numeric value storing corrosion relative wt for this production string, used in calculations, reporting, or model configuration.',
    ),
    corrosionMinLimit: LiftTypeParameterStringSchema.shape.corrosionMinLimit?.describe(
      'Numeric value storing corrosion min limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    corrosionMaxLimit: LiftTypeParameterStringSchema.shape.corrosionMaxLimit?.describe(
      'Numeric value storing corrosion max limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    erosionRelativeWT: LiftTypeParameterStringSchema.shape.erosionRelativeWT?.describe(
      'Numeric value storing erosion relative wt for this production string, used in calculations, reporting, or model configuration.',
    ),
    erosionMinLimit: LiftTypeParameterStringSchema.shape.erosionMinLimit?.describe(
      'Numeric value storing erosion min limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    erosionMaxLimit: LiftTypeParameterStringSchema.shape.erosionMaxLimit?.describe(
      'Numeric value storing erosion max limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    liquidLoadingRelativeWT: LiftTypeParameterStringSchema.shape.liquidLoadingRelativeWT?.describe(
      'Numeric value storing liquid loading relative wt for this production string, used in calculations, reporting, or model configuration.',
    ),
    liquidLoadingMinLimit: LiftTypeParameterStringSchema.shape.liquidLoadingMinLimit?.describe(
      'Numeric value storing liquid loading min limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    liquidLoadingMaxLimit: LiftTypeParameterStringSchema.shape.liquidLoadingMaxLimit?.describe(
      'Numeric value storing liquid loading max limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    waxRelativeWT: LiftTypeParameterStringSchema.shape.waxRelativeWT?.describe(
      'Numeric value storing wax relative wt for this production string, used in calculations, reporting, or model configuration.',
    ),
    waxMinLimit: LiftTypeParameterStringSchema.shape.waxMinLimit?.describe(
      'Numeric value storing wax min limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    waxMaxLimit: LiftTypeParameterStringSchema.shape.waxMaxLimit?.describe(
      'Numeric value storing wax max limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    hydrateRelativeWT: LiftTypeParameterStringSchema.shape.hydrateRelativeWT?.describe(
      'Numeric value storing hydrate relative wt for this production string, used in calculations, reporting, or model configuration.',
    ),
    hydrateMinLimit: LiftTypeParameterStringSchema.shape.hydrateMinLimit?.describe(
      'Numeric value storing hydrate min limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    hydrateMaxLimit: LiftTypeParameterStringSchema.shape.hydrateMaxLimit?.describe(
      'Numeric value storing hydrate max limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    asphalteneRelativeWT: LiftTypeParameterStringSchema.shape.asphalteneRelativeWT?.describe(
      'Numeric value storing asphaltene relative wt for this production string, used in calculations, reporting, or model configuration.',
    ),
    asphalteneMinLimit: LiftTypeParameterStringSchema.shape.asphalteneMinLimit?.describe(
      'Numeric value storing asphaltene min limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    asphalteneMaxLimit: LiftTypeParameterStringSchema.shape.asphalteneMaxLimit?.describe(
      'Numeric value storing asphaltene max limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    pe5RelativeWT: LiftTypeParameterStringSchema.shape.pe5RelativeWT?.describe(
      'Numeric value storing pe5 relative wt for this production string, used in calculations, reporting, or model configuration.',
    ),
    pe5MinLimit: LiftTypeParameterStringSchema.shape.pe5MinLimit?.describe(
      'Numeric value storing pe5 min limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    pe5MaxLimit: LiftTypeParameterStringSchema.shape.pe5MaxLimit?.describe(
      'Numeric value storing pe5 max limit for this production string, used in calculations, reporting, or model configuration.',
    ),
    fourCalcOptions: LiftTypeParameterStringSchema.shape.fourCalcOptions?.describe(
      'Time series signal representing four calc options for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    usePhTuning: LiftTypeParameterStringSchema.shape.usePhTuning?.describe(
      'Time series signal representing use ph tuning for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calcite: LiftTypeParameterStringSchema.shape.calcite?.describe(
      'Time series signal representing calcite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    barite: LiftTypeParameterStringSchema.shape.barite?.describe(
      'Time series signal representing barite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    halite: LiftTypeParameterStringSchema.shape.halite?.describe(
      'Time series signal representing halite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gypsum: LiftTypeParameterStringSchema.shape.gypsum?.describe(
      'Time series signal representing gypsum for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    hemihydrate: LiftTypeParameterStringSchema.shape.hemihydrate?.describe(
      'Time series signal representing hemihydrate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    anhydrite: LiftTypeParameterStringSchema.shape.anhydrite?.describe(
      'Time series signal representing anhydrite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calestite: LiftTypeParameterStringSchema.shape.calestite?.describe(
      'Time series signal representing calestite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mackinawite: LiftTypeParameterStringSchema.shape.mackinawite?.describe(
      'Time series signal representing mackinawite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    znS: LiftTypeParameterStringSchema.shape.znS?.describe(
      'Time series signal representing zn s for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    caF2: LiftTypeParameterStringSchema.shape.caF2?.describe(
      'Time series signal representing ca f2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    feCO3: LiftTypeParameterStringSchema.shape.feCO3?.describe(
      'Time series signal representing fe co3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    amorphousSilica: LiftTypeParameterStringSchema.shape.amorphousSilica?.describe(
      'Time series signal representing amorphous silica for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    quartz: LiftTypeParameterStringSchema.shape.quartz?.describe(
      'Time series signal representing quartz for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chrysotile: LiftTypeParameterStringSchema.shape.chrysotile?.describe(
      'Time series signal representing chrysotile for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    diopside: LiftTypeParameterStringSchema.shape.diopside?.describe(
      'Time series signal representing diopside for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    greenalite: LiftTypeParameterStringSchema.shape.greenalite?.describe(
      'Time series signal representing greenalite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    amorphousFeS: LiftTypeParameterStringSchema.shape.amorphousFeS?.describe(
      'Time series signal representing amorphous fe s for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    troilitePyrrhotite: LiftTypeParameterStringSchema.shape.troilitePyrrhotite?.describe(
      'Time series signal representing troilite pyrrhotite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    znCO3: LiftTypeParameterStringSchema.shape.znCO3?.describe(
      'Time series signal representing zn co3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pbSGalena: LiftTypeParameterStringSchema.shape.pbSGalena?.describe(
      'Time series signal representing pb sgalena for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    srCO3: LiftTypeParameterStringSchema.shape.srCO3?.describe(
      'Time series signal representing sr co3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    baCO3: LiftTypeParameterStringSchema.shape.baCO3?.describe(
      'Time series signal representing ba co3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mgOH2Brucite: LiftTypeParameterStringSchema.shape.mgOH2Brucite?.describe(
      'Time series signal representing mg oh2 brucite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    caOH2Portlandite: LiftTypeParameterStringSchema.shape.caOH2Portlandite?.describe(
      'Time series signal representing ca oh2 portlandite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Lift Type Parameter String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const LocationInputsView = parseView({
  view: { externalId: 'LocationInputs' },
  model: LocationInputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: LocationInputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    flowLinePressure: LocationInputsSchema.shape.flowLinePressure?.describe(
      'Time series signal representing flow line pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterHeaderTemperature: LocationInputsSchema.shape.waterHeaderTemperature?.describe(
      'Time series signal representing water header temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterHeaderPressure: LocationInputsSchema.shape.waterHeaderPressure?.describe(
      'Time series signal representing water header pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Location Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const LocationView = parseView({
  view: { externalId: 'Location' },
  model: LocationSchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ManifoldInputsView = parseView({
  view: { externalId: 'ManifoldInputs' },
  model: ManifoldInputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: ManifoldInputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    manifoldWaterInjRate: ManifoldInputsSchema.shape.manifoldWaterInjRate?.describe(
      'Time series signal representing manifold water inj rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    manifoldWaterInjPressure: ManifoldInputsSchema.shape.manifoldWaterInjPressure?.describe(
      'Time series signal representing manifold water inj pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    manifoldWaterInjTemperature: ManifoldInputsSchema.shape.manifoldWaterInjTemperature?.describe(
      'Time series signal representing manifold water inj temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    manifoldGasInjRate: ManifoldInputsSchema.shape.manifoldGasInjRate?.describe(
      'Time series signal representing manifold gas inj rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    manifoldGasInjPressure: ManifoldInputsSchema.shape.manifoldGasInjPressure?.describe(
      'Time series signal representing manifold gas inj pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    manifoldGasInjTemperature: ManifoldInputsSchema.shape.manifoldGasInjTemperature?.describe(
      'Time series signal representing manifold gas inj temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Manifold Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const MapGridMappingView = parseView({
  view: { externalId: 'MapGrid_Mapping' },
  model: MapGridMappingSchema.extend({
    ...InstanceIdType.shape,
    date: MapGridMappingSchema.shape.date?.describe(
      'Attribute capturing date for this entity in the production optimization context.',
    ),
    reservoirPressureMapGrid: MapGridMappingSchema.shape.reservoirPressureMapGrid?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    fieldName: MapGridMappingSchema.shape.fieldName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    reservoirName: MapGridMappingSchema.shape.reservoirName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    p10: MapGridMappingSchema.shape.p10?.describe(
      'Numeric value storing p10 for this entity, used in calculations, reporting, or model configuration.',
    ),
    p50: MapGridMappingSchema.shape.p50?.describe(
      'Numeric value storing p50 for this entity, used in calculations, reporting, or model configuration.',
    ),
    p90: MapGridMappingSchema.shape.p90?.describe(
      'Numeric value storing p90 for this entity, used in calculations, reporting, or model configuration.',
    ),
    lat: MapGridMappingSchema.shape.lat?.describe(
      'Numeric value storing lat for this entity, used in calculations, reporting, or model configuration.',
    ),
    long: MapGridMappingSchema.shape.long?.describe(
      'Numeric value storing long for this entity, used in calculations, reporting, or model configuration.',
    ),
    x: MapGridMappingSchema.shape.x?.describe(
      'Numeric value storing x for this entity, used in calculations, reporting, or model configuration.',
    ),
    y: MapGridMappingSchema.shape.y?.describe(
      'Numeric value storing y for this entity, used in calculations, reporting, or model configuration.',
    ),
    reservoirPressureRMSError: MapGridMappingSchema.shape.reservoirPressureRMSError?.describe(
      'Numeric value storing reservoir pressure rmserror for this entity, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'Map Grid Mapping view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const MeasuredInjectionStringAgentView = parseView({
  view: { externalId: 'MeasuredInjection_String_Agent' },
  model: MeasuredInjectionStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: MeasuredInjectionStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    gasInjRate: MeasuredInjectionStringAgentSchema.shape.gasInjRate?.describe(
      'Measured gas injection rate (MSCF/d) from wellhead flow meter',
    ),
    waterInjRate: MeasuredInjectionStringAgentSchema.shape.waterInjRate?.describe(
      'Measured water injection rate (stb/d) from wellhead flow meter',
    ),
    gasInjWellheadPress: MeasuredInjectionStringAgentSchema.shape.gasInjWellheadPress?.describe(
      'Gas injection wellhead pressure (psia, TS)',
    ),
    waterInjWellheadPress: MeasuredInjectionStringAgentSchema.shape.waterInjWellheadPress?.describe(
      'Water injection wellhead pressure (psia, TS)',
    ),
    gasInjChokeOpening: MeasuredInjectionStringAgentSchema.shape.gasInjChokeOpening?.describe(
      'Gas injection choke opening (TS)',
    ),
    waterInjChokeOpening: MeasuredInjectionStringAgentSchema.shape.waterInjChokeOpening?.describe(
      'Water injection choke opening (TS)',
    ),
  })?.describe(
    'Measured injection rates from wellhead meters per well string (WF15).\n\nReal-time gas and water injection from wellhead meters; no allocation. Use for\nactual injection rates, trends, and well-string comparisons. For allocated volumes see AllocatedInjection_String_Agent.\n\nUse for: Water or Gas Injection Monitoring (WF15).',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const MeasuredRatesWellTestStringAgentView = parseView({
  view: { externalId: 'MeasuredRates_WellTest_String_Agent' },
  model: MeasuredRatesWellTestStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: MeasuredRatesWellTestStringAgentSchema.shape.wellString?.describe('Well string identifier.'),
    wellTestOilRateStd: MeasuredRatesWellTestStringAgentSchema.shape.wellTestOilRateStd?.describe(
      'Measured oil production rate at standard conditions (stb/d, TS).\n@name oilRateStd',
    ),
    wellTestGasRateStd: MeasuredRatesWellTestStringAgentSchema.shape.wellTestGasRateStd?.describe(
      'Measured gas production rate at standard conditions (MMscfd, TS).\n@name gasRateStd',
    ),
    wellTestWaterRateStd: MeasuredRatesWellTestStringAgentSchema.shape.wellTestWaterRateStd?.describe(
      'Measured water production rate at standard conditions (stb/d, TS).\n@name waterRateStd',
    ),
    wellTestLiquidRatePts: MeasuredRatesWellTestStringAgentSchema.shape.wellTestLiquidRatePts?.describe(
      'Total liquid rate (oil + water) at PTS conditions (stb/d, TS).\n@name liquidRatePts',
    ),
    wellTestTotalGorStd: MeasuredRatesWellTestStringAgentSchema.shape.wellTestTotalGorStd?.describe(
      'Total gas-oil ratio at standard conditions (scf/stb, TS).\n@name totalGorStd',
    ),
    wellTestWaterCut: MeasuredRatesWellTestStringAgentSchema.shape.wellTestWaterCut?.describe(
      'Water cut at standard conditions: water / (oil + water) * 100 (%, TS).\n@name waterCut',
    ),
    wellTestWGR: MeasuredRatesWellTestStringAgentSchema.shape.wellTestWGR?.describe(
      'Water-gas ratio at standard conditions (stb/MMscf, TS).\n@name waterGasRatio',
    ),
    wellTestCGR: MeasuredRatesWellTestStringAgentSchema.shape.wellTestCGR?.describe(
      'Condensate-gas ratio at standard conditions (stb/MMscf, TS).\n@name condensateGasRatio',
    ),
    formationGOR: MeasuredRatesWellTestStringAgentSchema.shape.formationGOR?.describe(
      'Formation/reservoir gas-oil ratio (scf/stb, TS).',
    ),
    wellTestGOR: MeasuredRatesWellTestStringAgentSchema.shape.wellTestGOR?.describe(
      'Separator gas-oil ratio from well test (scf/stb, TS).',
    ),
    wellTestGorInsitu: MeasuredRatesWellTestStringAgentSchema.shape.wellTestGorInsitu?.describe(
      'Gas-oil ratio at downhole/insitu conditions (scf/stb, TS).\n@name gorInsitu',
    ),
    wellTestGorPts: MeasuredRatesWellTestStringAgentSchema.shape.wellTestGorPts?.describe(
      'Gas-oil ratio at PTS conditions (scf/stb, TS).\n@name gorPts',
    ),
    wellTestWaterCutPts: MeasuredRatesWellTestStringAgentSchema.shape.wellTestWaterCutPts?.describe(
      'Water cut at PTS conditions (%, TS).\n@name waterCutPts',
    ),
    wellTestWaterCutInsitu: MeasuredRatesWellTestStringAgentSchema.shape.wellTestWaterCutInsitu?.describe(
      'Water cut at downhole/insitu conditions (%, TS).\n@name waterCutInsitu',
    ),
    cgrLC: MeasuredRatesWellTestStringAgentSchema.shape.cgrLC?.describe(
      'Condensate-gas ratio at live/local conditions (stb/MMscf, TS).',
    ),
    wgrLC: MeasuredRatesWellTestStringAgentSchema.shape.wgrLC?.describe(
      'Water-gas ratio at live/local conditions (stb/MMscf, TS).',
    ),
    wellTestStartDate: MeasuredRatesWellTestStringAgentSchema.shape.wellTestStartDate?.describe(
      'Well test start date (TS).\n@name testDate',
    ),
    wellTestApprovedAllocationFlag:
      MeasuredRatesWellTestStringAgentSchema.shape.wellTestApprovedAllocationFlag?.describe(
        'Well test allocation approval status (TS)',
      ),
  })?.describe(
    'Well test measured rates per well string from separator measurements.\n\nContains comprehensive measurements from well tests, separator-measured rates\nof oil, gas, and water at standard conditions, along with pertinent metadata\nsuch as test dates and allocation approval flags. Sourced from actual well\ntests conducted in the field, providing a reliable basis for production rate\ncalibration and validation of network models. It can address analytical\nquestions regarding the latest well test results, approved tests, and specific\nratios like gas-to-oil and water-cut metrics. Excludes simulated or estimated\nrates, which may be present in other views, ensuring that users are working\nwith verified physical measurements.\n\n@name Measured Rates - Well Test (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ModelManagementAlarmsAgentView = parseView({
  view: { externalId: 'ModelManagementAlarms_Agent' },
  model: ModelManagementAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: ModelManagementAlarmsAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'Model management alarms with medium or high priority.\n\nContains alarms generated during the model management processes, those with\nmedium or high priority. Sourced from the workflows associated with well and\nnetwork model updates and calibrations, allowing users to analyze alarm\noccurrences and their implications on model performance. It can answer\nquestions regarding the frequency and types of alarms triggered, their impact\non operations and entities affected. Excludes low-priority or non-WF9 alarms.\n\nUse for: Well and Network Model Update and Management (WF9), Real-Time Surveillance (WF18).\n\n@name Model Management Alarms (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ModelMatchedRatesStringAgentView = parseView({
  view: { externalId: 'ModelMatchedRates_String_Agent' },
  model: ModelMatchedRatesStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: ModelMatchedRatesStringAgentSchema.shape.wellString?.describe('Well string identifier.'),
    modelAlarms: ModelMatchedRatesStringAgentSchema.shape.modelAlarms?.describe('Prosper model validation alarm (TS)'),
    historicalAlarms: ModelMatchedRatesStringAgentSchema.shape.historicalAlarms?.describe(
      'Historical trend validation alarm (TS)',
    ),
    chokeAlarms: ModelMatchedRatesStringAgentSchema.shape.chokeAlarms?.describe('Choke model validation alarm (TS)'),
    pvtAlarms: ModelMatchedRatesStringAgentSchema.shape.pvtAlarms?.describe('PVT validation alarm (TS)'),
    modelMatchedoilRate: ModelMatchedRatesStringAgentSchema.shape.modelMatchedoilRate?.describe(
      'Prosper model-matched oil rate (stb/d, TS).\n@name modelMatchedOilRate',
    ),
    modelMatchedgasRate: ModelMatchedRatesStringAgentSchema.shape.modelMatchedgasRate?.describe(
      'Prosper model-matched gas rate (MMscfd, TS).\n@name modelMatchedGasRate',
    ),
    modelMatchedwaterRate: ModelMatchedRatesStringAgentSchema.shape.modelMatchedwaterRate?.describe(
      'Prosper model-matched water rate (stb/d, TS).\n@name modelMatchedWaterRate',
    ),
    modelMatchedliquidRate: ModelMatchedRatesStringAgentSchema.shape.modelMatchedliquidRate?.describe(
      'Prosper model-matched total liquid rate (stb/d, TS).\n@name modelMatchedLiquidRate',
    ),
    modelMatchedBHP: ModelMatchedRatesStringAgentSchema.shape.modelMatchedBHP?.describe(
      'Prosper model-matched flowing bottom-hole pressure (psi, TS).',
    ),
    chokeMatchedliquidRate: ModelMatchedRatesStringAgentSchema.shape.chokeMatchedliquidRate?.describe(
      'Choke equation liquid rate (stb/d, TS).\n@name chokeCalculatedLiquidRate',
    ),
    chokeMatchedgasRate: ModelMatchedRatesStringAgentSchema.shape.chokeMatchedgasRate?.describe(
      'Choke equation gas rate (MMscfd, TS).\n@name chokeCalculatedGasRate',
    ),
    oilRateSC: ModelMatchedRatesStringAgentSchema.shape.oilRateSC?.describe(
      'Measured oil rate at standard conditions (stb/d, TS).\n@name measuredOilRate',
    ),
    gasRateSC: ModelMatchedRatesStringAgentSchema.shape.gasRateSC?.describe(
      'Measured gas rate at standard conditions (MMscfd, TS).\n@name measuredGasRate',
    ),
    totalGorSC: ModelMatchedRatesStringAgentSchema.shape.totalGorSC?.describe(
      'Model-matched total gas-oil ratio at standard conditions (scf/stb, TS).',
    ),
    waterCutSC: ModelMatchedRatesStringAgentSchema.shape.waterCutSC?.describe(
      'Model-matched water cut at standard conditions (fraction, TS).',
    ),
    cgrSC: ModelMatchedRatesStringAgentSchema.shape.cgrSC?.describe(
      'Model-matched condensate-gas ratio at standard conditions (stb/MMscf, TS).',
    ),
    wgrSC: ModelMatchedRatesStringAgentSchema.shape.wgrSC?.describe(
      'Model-matched water-gas ratio at standard conditions (stb/MMscf, TS).',
    ),
    gorLC: ModelMatchedRatesStringAgentSchema.shape.gorLC?.describe(
      'Model-matched gas-oil ratio at live/local conditions (scf/stb, TS).',
    ),
    waterCutLC: ModelMatchedRatesStringAgentSchema.shape.waterCutLC?.describe(
      'Model-matched water cut at live/local conditions (fraction, TS).',
    ),
    cgrLC: ModelMatchedRatesStringAgentSchema.shape.cgrLC?.describe(
      'Model-matched condensate-gas ratio at live/local conditions (stb/MMscf, TS).',
    ),
    wgrLC: ModelMatchedRatesStringAgentSchema.shape.wgrLC?.describe(
      'Model-matched water-gas ratio at live/local conditions (stb/MMscf, TS).',
    ),
  })?.describe(
    'Model-matched rates from Prosper well model calibration per well string.\n\nContains model-matched rates generated by the Prosper well model, which are\naligned with well test data, including oil, gas, water, liquid rates, and\nbottom hole pressure (BHP). Sourced from calibrated Prosper models and is used\nto evaluate the accuracy of the model against actual measurements, answering\nquestions related to model performance and well efficiency. It excludes raw\nwell test data or uncalibrated model outputs, distinguishing it from other\nviews that may focus on unprocessed measurements. Use cases: assessing model\nquality through alarm flags that highlight deviations from both measured data\nand historical performance trends.\n\n@name Model-Matched Rates - String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const MpfmInputsView = parseView({
  view: { externalId: 'MpfmInputs' },
  model: MpfmInputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: MpfmInputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    mpfmFlagOnTest: MpfmInputsSchema.shape.mpfmFlagOnTest?.describe(
      'Time series signal representing mpfm flag on test for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilRateInSitu: MpfmInputsSchema.shape.mpfmOilRateInSitu?.describe(
      'Time series signal representing mpfm oil rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterRateInSitu: MpfmInputsSchema.shape.mpfmWaterRateInSitu?.describe(
      'Time series signal representing mpfm water rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasRateInSitu: MpfmInputsSchema.shape.mpfmGasRateInSitu?.describe(
      'Time series signal representing mpfm gas rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilRateStd: MpfmInputsSchema.shape.mpfmOilRateStd?.describe(
      'Time series signal representing mpfm oil rate std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasRateStd: MpfmInputsSchema.shape.mpfmGasRateStd?.describe(
      'Time series signal representing mpfm gas rate std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterRateStd: MpfmInputsSchema.shape.mpfmWaterRateStd?.describe(
      'Time series signal representing mpfm water rate std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLinePress: MpfmInputsSchema.shape.mpfmLinePress?.describe(
      'Time series signal representing mpfm line press for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLineTemp: MpfmInputsSchema.shape.mpfmLineTemp?.describe(
      'Time series signal representing mpfm line temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmDifferentialPress: MpfmInputsSchema.shape.mpfmDifferentialPress?.describe(
      'Time series signal representing mpfm differential press for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLiqMinRange: MpfmInputsSchema.shape.mpfmLiqMinRange?.describe(
      'Time series signal representing mpfm liq min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLiqMaxRange: MpfmInputsSchema.shape.mpfmLiqMaxRange?.describe(
      'Time series signal representing mpfm liq max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilMinRange: MpfmInputsSchema.shape.mpfmOilMinRange?.describe(
      'Time series signal representing mpfm oil min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilMaxRange: MpfmInputsSchema.shape.mpfmOilMaxRange?.describe(
      'Time series signal representing mpfm oil max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterMinRange: MpfmInputsSchema.shape.mpfmWaterMinRange?.describe(
      'Time series signal representing mpfm water min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterMaxRange: MpfmInputsSchema.shape.mpfmWaterMaxRange?.describe(
      'Time series signal representing mpfm water max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasMinRange: MpfmInputsSchema.shape.mpfmGasMinRange?.describe(
      'Time series signal representing mpfm gas min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasMaxRange: MpfmInputsSchema.shape.mpfmGasMaxRange?.describe(
      'Time series signal representing mpfm gas max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmPressMinRange: MpfmInputsSchema.shape.mpfmPressMinRange?.describe(
      'Time series signal representing mpfm press min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmTempMinRange: MpfmInputsSchema.shape.mpfmTempMinRange?.describe(
      'Time series signal representing mpfm temp min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmDeltaPressMinRange: MpfmInputsSchema.shape.mpfmDeltaPressMinRange?.describe(
      'Time series signal representing mpfm delta press min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmPressMaxRange: MpfmInputsSchema.shape.mpfmPressMaxRange?.describe(
      'Time series signal representing mpfm press max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmTempMaxRange: MpfmInputsSchema.shape.mpfmTempMaxRange?.describe(
      'Time series signal representing mpfm temp max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmDeltaPressMaxRange: MpfmInputsSchema.shape.mpfmDeltaPressMaxRange?.describe(
      'Time series signal representing mpfm delta press max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGORSTB: MpfmInputsSchema.shape.mpfmGORSTB?.describe(
      'Time series signal representing mpfm gorstb for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGVFInSitu: MpfmInputsSchema.shape.mpfmGVFInSitu?.describe(
      'Time series signal representing mpfm gvfin situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasMassFlowInSitu: MpfmInputsSchema.shape.mpfmGasMassFlowInSitu?.describe(
      'Time series signal representing mpfm gas mass flow in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLiquidRateSTB: MpfmInputsSchema.shape.mpfmLiquidRateSTB?.describe(
      'Time series signal representing mpfm liquid rate stb for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilMassFlowInSitu: MpfmInputsSchema.shape.mpfmOilMassFlowInSitu?.describe(
      'Time series signal representing mpfm oil mass flow in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmStatus: MpfmInputsSchema.shape.mpfmStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    mpfmTotalMassFlow: MpfmInputsSchema.shape.mpfmTotalMassFlow?.describe(
      'Time series signal representing mpfm total mass flow for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterMassFlowInSitu: MpfmInputsSchema.shape.mpfmWaterMassFlowInSitu?.describe(
      'Time series signal representing mpfm water mass flow in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilDensityInSitu: MpfmInputsSchema.shape.mpfmOilDensityInSitu?.describe(
      'Time series signal representing mpfm oil density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasDensityInSitu: MpfmInputsSchema.shape.mpfmGasDensityInSitu?.describe(
      'Time series signal representing mpfm gas density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterDensityInSitu: MpfmInputsSchema.shape.mpfmWaterDensityInSitu?.describe(
      'Time series signal representing mpfm water density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterCutInSitu: MpfmInputsSchema.shape.mpfmWaterCutInSitu?.describe(
      'Time series signal representing mpfm water cut in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterCutSTB: MpfmInputsSchema.shape.mpfmWaterCutSTB?.describe(
      'Time series signal representing mpfm water cut stb for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterSalinity: MpfmInputsSchema.shape.mpfmWaterSalinity?.describe(
      'Time series signal representing mpfm water salinity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasDensityStd: MpfmInputsSchema.shape.mpfmGasDensityStd?.describe(
      'Time series signal representing mpfm gas density std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasMassFlowStd: MpfmInputsSchema.shape.mpfmGasMassFlowStd?.describe(
      'Time series signal representing mpfm gas mass flow std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilDensityStd: MpfmInputsSchema.shape.mpfmOilDensityStd?.describe(
      'Time series signal representing mpfm oil density std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilVolFractionInSitu: MpfmInputsSchema.shape.mpfmOilVolFractionInSitu?.describe(
      'Time series signal representing mpfm oil vol fraction in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterDensityStd: MpfmInputsSchema.shape.mpfmWaterDensityStd?.describe(
      'Time series signal representing mpfm water density std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterMassFlowStd: MpfmInputsSchema.shape.mpfmWaterMassFlowStd?.describe(
      'Time series signal representing mpfm water mass flow std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterVolumeFractionInSitu: MpfmInputsSchema.shape.mpfmWaterVolumeFractionInSitu?.describe(
      'Time series signal representing mpfm water volume fraction in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLiquidRateInSitu: MpfmInputsSchema.shape.mpfmLiquidRateInSitu?.describe(
      'Time series signal representing mpfm liquid rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilMassFlowStd: MpfmInputsSchema.shape.mpfmOilMassFlowStd?.describe(
      'Time series signal representing mpfm oil mass flow std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcLiquidRateInSitu: MpfmInputsSchema.shape.mpfmCalcLiquidRateInSitu?.describe(
      'Time series signal representing mpfm calc liquid rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcLiquidRateStd: MpfmInputsSchema.shape.mpfmCalcLiquidRateStd?.describe(
      'Time series signal representing mpfm calc liquid rate std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcGORInsitu: MpfmInputsSchema.shape.mpfmCalcGORInsitu?.describe(
      'Time series signal representing mpfm calc gorinsitu for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcGORStd: MpfmInputsSchema.shape.mpfmCalcGORStd?.describe(
      'Time series signal representing mpfm calc gorstd for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcCGRInSitu: MpfmInputsSchema.shape.mpfmCalcCGRInSitu?.describe(
      'Time series signal representing mpfm calc cgrin situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcCGRStd: MpfmInputsSchema.shape.mpfmCalcCGRStd?.describe(
      'Time series signal representing mpfm calc cgrstd for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcWGRInSitu: MpfmInputsSchema.shape.mpfmCalcWGRInSitu?.describe(
      'Time series signal representing mpfm calc wgrin situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcWGRStd: MpfmInputsSchema.shape.mpfmCalcWGRStd?.describe(
      'Time series signal representing mpfm calc wgrstd for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCumLiquidVolInSitu: MpfmInputsSchema.shape.mpfmCumLiquidVolInSitu?.describe(
      'Time series signal representing mpfm cum liquid vol in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCumLiquidVolStd: MpfmInputsSchema.shape.mpfmCumLiquidVolStd?.describe(
      'Time series signal representing mpfm cum liquid vol std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCumGasVolInSitu: MpfmInputsSchema.shape.mpfmCumGasVolInSitu?.describe(
      'Time series signal representing mpfm cum gas vol in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCumGasVolStd: MpfmInputsSchema.shape.mpfmCumGasVolStd?.describe(
      'Time series signal representing mpfm cum gas vol std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcWLRInSitu: MpfmInputsSchema.shape.mpfmCalcWLRInSitu?.describe(
      'Time series signal representing mpfm calc wlrin situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilMassFlowRateMinRange: MpfmInputsSchema.shape.mpfmOilMassFlowRateMinRange?.describe(
      'Time series signal representing mpfm oil mass flow rate min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilMassFlowRateMaxRange: MpfmInputsSchema.shape.mpfmOilMassFlowRateMaxRange?.describe(
      'Time series signal representing mpfm oil mass flow rate max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterMassFlowRateMinRange: MpfmInputsSchema.shape.mpfmWaterMassFlowRateMinRange?.describe(
      'Time series signal representing mpfm water mass flow rate min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterMassFlowRateMaxRange: MpfmInputsSchema.shape.mpfmWaterMassFlowRateMaxRange?.describe(
      'Time series signal representing mpfm water mass flow rate max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasMassFlowRateMinRange: MpfmInputsSchema.shape.mpfmGasMassFlowRateMinRange?.describe(
      'Time series signal representing mpfm gas mass flow rate min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasMassFlowRateMaxRange: MpfmInputsSchema.shape.mpfmGasMassFlowRateMaxRange?.describe(
      'Time series signal representing mpfm gas mass flow rate max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWLRMinRange: MpfmInputsSchema.shape.mpfmWLRMinRange?.describe(
      'Time series signal representing mpfm wlrmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWLRMaxRange: MpfmInputsSchema.shape.mpfmWLRMaxRange?.describe(
      'Time series signal representing mpfm wlrmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilDensityMinRange: MpfmInputsSchema.shape.mpfmOilDensityMinRange?.describe(
      'Time series signal representing mpfm oil density min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOilDensityMaxRange: MpfmInputsSchema.shape.mpfmOilDensityMaxRange?.describe(
      'Time series signal representing mpfm oil density max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterDensityMinRange: MpfmInputsSchema.shape.mpfmWaterDensityMinRange?.describe(
      'Time series signal representing mpfm water density min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWaterDensityMaxRange: MpfmInputsSchema.shape.mpfmWaterDensityMaxRange?.describe(
      'Time series signal representing mpfm water density max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasDensityMinRange: MpfmInputsSchema.shape.mpfmGasDensityMinRange?.describe(
      'Time series signal representing mpfm gas density min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGasDensityMaxRange: MpfmInputsSchema.shape.mpfmGasDensityMaxRange?.describe(
      'Time series signal representing mpfm gas density max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGORLCMinRange: MpfmInputsSchema.shape.mpfmGORLCMinRange?.describe(
      'Time series signal representing mpfm gorlcmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGORLCMaxRange: MpfmInputsSchema.shape.mpfmGORLCMaxRange?.describe(
      'Time series signal representing mpfm gorlcmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmTotalGORSCMinRange: MpfmInputsSchema.shape.mpfmTotalGORSCMinRange?.describe(
      'Time series signal representing mpfm total gorscmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmTotalGORSCMaxRange: MpfmInputsSchema.shape.mpfmTotalGORSCMaxRange?.describe(
      'Time series signal representing mpfm total gorscmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmBSWMinRange: MpfmInputsSchema.shape.mpfmBSWMinRange?.describe(
      'Time series signal representing mpfm bswmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmBSWMaxRange: MpfmInputsSchema.shape.mpfmBSWMaxRange?.describe(
      'Time series signal representing mpfm bswmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGVFMinRange: MpfmInputsSchema.shape.mpfmGVFMinRange?.describe(
      'Time series signal representing mpfm gvfmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmGVFMaxRange: MpfmInputsSchema.shape.mpfmGVFMaxRange?.describe(
      'Time series signal representing mpfm gvfmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOVFMinRange: MpfmInputsSchema.shape.mpfmOVFMinRange?.describe(
      'Time series signal representing mpfm ovfmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmOVFMaxRange: MpfmInputsSchema.shape.mpfmOVFMaxRange?.describe(
      'Time series signal representing mpfm ovfmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWVFMinRange: MpfmInputsSchema.shape.mpfmWVFMinRange?.describe(
      'Time series signal representing mpfm wvfmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmWVFMaxRange: MpfmInputsSchema.shape.mpfmWVFMaxRange?.describe(
      'Time series signal representing mpfm wvfmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcOilDensityInSitu: MpfmInputsSchema.shape.mpfmCalcOilDensityInSitu?.describe(
      'Time series signal representing mpfm calc oil density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcGasDensityInSitu: MpfmInputsSchema.shape.mpfmCalcGasDensityInSitu?.describe(
      'Time series signal representing mpfm calc gas density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmCalcWaterDensityInSitu: MpfmInputsSchema.shape.mpfmCalcWaterDensityInSitu?.describe(
      'Time series signal representing mpfm calc water density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Configuration parameters and input signals for the multiphase flow meter (MPFM) model, such as PVT properties, calibration factors, and operating settings used to compute phase rates and diagnostics.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const MpfmOutputsView = parseView({
  view: { externalId: 'MpfmOutputs' },
  model: MpfmOutputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: MpfmOutputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellTestStartDate: MpfmOutputsSchema.shape.wellTestStartDate?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestEndDate: MpfmOutputsSchema.shape.wellTestEndDate?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestEspMotorVoltage: MpfmOutputsSchema.shape.wellTestEspMotorVoltage?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestEspPumpDischargePressure: MpfmOutputsSchema.shape.wellTestEspPumpDischargePressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestEspPumpFrequency: MpfmOutputsSchema.shape.wellTestEspPumpFrequency?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestEspPumpIntakePressure: MpfmOutputsSchema.shape.wellTestEspPumpIntakePressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestEspPumpIntakeTemperature: MpfmOutputsSchema.shape.wellTestEspPumpIntakeTemperature?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGlFlControlValveInletTemp: MpfmOutputsSchema.shape.wellTestGlFlControlValveInletTemp?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGlInjectionChokeOpening: MpfmOutputsSchema.shape.wellTestGlInjectionChokeOpening?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGlFlControlValveInletPres: MpfmOutputsSchema.shape.wellTestGlFlControlValveInletPres?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGasLiftVolume: MpfmOutputsSchema.shape.wellTestGasLiftVolume?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGlFlControlValvOutletPres: MpfmOutputsSchema.shape.wellTestGlFlControlValvOutletPres?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestTestSeparatorLinePressure: MpfmOutputsSchema.shape.wellTestTestSeparatorLinePressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestTestSeparatorLineTemperature: MpfmOutputsSchema.shape.wellTestTestSeparatorLineTemperature?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestWGR: MpfmOutputsSchema.shape.wellTestWGR?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestCGR: MpfmOutputsSchema.shape.wellTestCGR?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestWellheadPressure: MpfmOutputsSchema.shape.wellTestWellheadPressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestWellheadTemperature: MpfmOutputsSchema.shape.wellTestWellheadTemperature?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGasRateStd: MpfmOutputsSchema.shape.wellTestGasRateStd?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestGasRateInsitu: MpfmOutputsSchema.shape.wellTestGasRateInsitu?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestGasRatePts: MpfmOutputsSchema.shape.wellTestGasRatePts?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestEgorVendorStdGasRate: MpfmOutputsSchema.shape.wellTestEgorVendorStdGasRate?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestOilRateStd: MpfmOutputsSchema.shape.wellTestOilRateStd?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestOilRateInsitu: MpfmOutputsSchema.shape.wellTestOilRateInsitu?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestOilRatePts: MpfmOutputsSchema.shape.wellTestOilRatePts?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestEgorVendorStdOilRate: MpfmOutputsSchema.shape.wellTestEgorVendorStdOilRate?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestWaterRateStd: MpfmOutputsSchema.shape.wellTestWaterRateStd?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestWaterRateInsitu: MpfmOutputsSchema.shape.wellTestWaterRateInsitu?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestWaterRatePts: MpfmOutputsSchema.shape.wellTestWaterRatePts?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestEgorVendorStdWaterRate: MpfmOutputsSchema.shape.wellTestEgorVendorStdWaterRate?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestGorInsitu: MpfmOutputsSchema.shape.wellTestGorInsitu?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGorPts: MpfmOutputsSchema.shape.wellTestGorPts?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestTotalGorStd: MpfmOutputsSchema.shape.wellTestTotalGorStd?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestWaterCut: MpfmOutputsSchema.shape.wellTestWaterCut?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestWaterCutPts: MpfmOutputsSchema.shape.wellTestWaterCutPts?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestWaterCutInsitu: MpfmOutputsSchema.shape.wellTestWaterCutInsitu?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestLiquidRatePts: MpfmOutputsSchema.shape.wellTestLiquidRatePts?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    wellTestChokeSize: MpfmOutputsSchema.shape.wellTestChokeSize?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestCasingHeadPressure: MpfmOutputsSchema.shape.wellTestCasingHeadPressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestCasingHeadTemperature: MpfmOutputsSchema.shape.wellTestCasingHeadTemperature?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestBottomHolePressure: MpfmOutputsSchema.shape.wellTestBottomHolePressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestBottomHoleTemperature: MpfmOutputsSchema.shape.wellTestBottomHoleTemperature?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestFlowlineTemperature: MpfmOutputsSchema.shape.wellTestFlowlineTemperature?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestFlowlinePressure: MpfmOutputsSchema.shape.wellTestFlowlinePressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestEspMotorCurrent: MpfmOutputsSchema.shape.wellTestEspMotorCurrent?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestEspMotorPower: MpfmOutputsSchema.shape.wellTestEspMotorPower?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestDuration: MpfmOutputsSchema.shape.wellTestDuration?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestStringFunction: MpfmOutputsSchema.shape.wellTestStringFunction?.describe(
      'Text describing the functional role of the production string (for example main producer, backup, injector, idle), used in surveillance and planning.',
    ),
    wellTestApprovedAllocationFlag: MpfmOutputsSchema.shape.wellTestApprovedAllocationFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    wellTestTestTypeDesc: MpfmOutputsSchema.shape.wellTestTestTypeDesc?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestMpfmName: MpfmOutputsSchema.shape.wellTestMpfmName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    wellTestTestMethod: MpfmOutputsSchema.shape.wellTestTestMethod?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestArtificialLiftType: MpfmOutputsSchema.shape.wellTestArtificialLiftType?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestValidationFlag: MpfmOutputsSchema.shape.wellTestValidationFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    wellTestTestType: MpfmOutputsSchema.shape.wellTestTestType?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    ptsDateTime: MpfmOutputsSchema.shape.ptsDateTime?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    composition: MpfmOutputsSchema.shape.composition?.describe(
      'Fluid composition vector used by the MPFM model, such as gas–oil ratio, water cut, or component fractions, important for accurate rate computation and diagnostics.',
    ),
    modelComposition: MpfmOutputsSchema.shape.modelComposition?.describe(
      'Fluid composition vector used by the MPFM model, such as gas–oil ratio, water cut, or component fractions, important for accurate rate computation and diagnostics.',
    ),
    sampleDateTime: MpfmOutputsSchema.shape.sampleDateTime?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    validatedBy: MpfmOutputsSchema.shape.validatedBy?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    comments: MpfmOutputsSchema.shape.comments?.describe(
      'Free-text comments field capturing operator or engineer notes related to this measurement, configuration, or event.',
    ),
    fluidProperties: MpfmOutputsSchema.shape.fluidProperties?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGOR: MpfmOutputsSchema.shape.wellTestGOR?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestTotalMassFlowRateOil: MpfmOutputsSchema.shape.wellTestTotalMassFlowRateOil?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestTotalMassFlowRateWater: MpfmOutputsSchema.shape.wellTestTotalMassFlowRateWater?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestTotalMassFlowRateGas: MpfmOutputsSchema.shape.wellTestTotalMassFlowRateGas?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestGasDensityInSitu: MpfmOutputsSchema.shape.wellTestGasDensityInSitu?.describe(
      'Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations.',
    ),
    wellTestOilDensityInSitu: MpfmOutputsSchema.shape.wellTestOilDensityInSitu?.describe(
      'Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations.',
    ),
    cgrLC: MpfmOutputsSchema.shape.cgrLC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wgrLC: MpfmOutputsSchema.shape.wgrLC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    pumpMotorTemp: MpfmOutputsSchema.shape.pumpMotorTemp?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    pumpVibration: MpfmOutputsSchema.shape.pumpVibration?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    pumpPower: MpfmOutputsSchema.shape.pumpPower?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    mpfmDifferentialPressure: MpfmOutputsSchema.shape.mpfmDifferentialPressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    mpfmLinePressure: MpfmOutputsSchema.shape.mpfmLinePressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    mpfmLineTemperature: MpfmOutputsSchema.shape.mpfmLineTemperature?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    liquidRateSc: MpfmOutputsSchema.shape.liquidRateSc?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    liquidRateLc: MpfmOutputsSchema.shape.liquidRateLc?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    oilVolumeFractionLC: MpfmOutputsSchema.shape.oilVolumeFractionLC?.describe(
      'Phase volume fraction at line conditions derived from MPFM measurements, indicating the proportion of each phase in the flow stream and helping to diagnose flow regime and measurement quality.',
    ),
    gasVolumeFractionLC: MpfmOutputsSchema.shape.gasVolumeFractionLC?.describe(
      'Phase volume fraction at line conditions derived from MPFM measurements, indicating the proportion of each phase in the flow stream and helping to diagnose flow regime and measurement quality.',
    ),
    waterVolumeFractionLC: MpfmOutputsSchema.shape.waterVolumeFractionLC?.describe(
      'Phase volume fraction at line conditions derived from MPFM measurements, indicating the proportion of each phase in the flow stream and helping to diagnose flow regime and measurement quality.',
    ),
    stablePeriodStartDate: MpfmOutputsSchema.shape.stablePeriodStartDate?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    stablePeriodEndDate: MpfmOutputsSchema.shape.stablePeriodEndDate?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    waterMassFlowRateSC: MpfmOutputsSchema.shape.waterMassFlowRateSC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    oilMassFlowRateSC: MpfmOutputsSchema.shape.oilMassFlowRateSC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    gasMassFlowRateSC: MpfmOutputsSchema.shape.gasMassFlowRateSC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    waterMassFlowRateLC: MpfmOutputsSchema.shape.waterMassFlowRateLC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    oilMassFlowRateLC: MpfmOutputsSchema.shape.oilMassFlowRateLC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    gasMassFlowRateLC: MpfmOutputsSchema.shape.gasMassFlowRateLC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    oilDensitySC: MpfmOutputsSchema.shape.oilDensitySC?.describe(
      'Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations.',
    ),
    gasDensitySC: MpfmOutputsSchema.shape.gasDensitySC?.describe(
      'Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations.',
    ),
    waterDensitySC: MpfmOutputsSchema.shape.waterDensitySC?.describe(
      'Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations.',
    ),
    oilDensityLC: MpfmOutputsSchema.shape.oilDensityLC?.describe(
      'Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations.',
    ),
    gasDensityLC: MpfmOutputsSchema.shape.gasDensityLC?.describe(
      'Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations.',
    ),
    waterDensityLC: MpfmOutputsSchema.shape.waterDensityLC?.describe(
      'Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations.',
    ),
    glinjectionRate: MpfmOutputsSchema.shape.glinjectionRate?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    glFcvOutletTemp: MpfmOutputsSchema.shape.glFcvOutletTemp?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    pumpDischargeTemp: MpfmOutputsSchema.shape.pumpDischargeTemp?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    mpfmAlarms: MpfmOutputsSchema.shape.mpfmAlarms?.describe(
      'MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges.',
    ),
    pvtAlarms: MpfmOutputsSchema.shape.pvtAlarms?.describe(
      'MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges.',
    ),
    historicalAlarms: MpfmOutputsSchema.shape.historicalAlarms?.describe(
      'MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges.',
    ),
    modelAlarms: MpfmOutputsSchema.shape.modelAlarms?.describe(
      'MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges.',
    ),
    chokeAlarms: MpfmOutputsSchema.shape.chokeAlarms?.describe(
      'MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges.',
    ),
    espwear: MpfmOutputsSchema.shape.espwear?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    modelProductivityIndex: MpfmOutputsSchema.shape.modelProductivityIndex?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    modelReservoirPressure: MpfmOutputsSchema.shape.modelReservoirPressure?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    modelStabilityFlag: MpfmOutputsSchema.shape.modelStabilityFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    modelMinStableRate: MpfmOutputsSchema.shape.modelMinStableRate?.describe(
      'Model-derived diagnostic metric from the MPFM solution, indicating how well the internal model matches measured data and whether the flow is within stable operating envelopes.',
    ),
    modelReservoirModel: MpfmOutputsSchema.shape.modelReservoirModel?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    modelVlpModel: MpfmOutputsSchema.shape.modelVlpModel?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    modelWellTestTimestamp: MpfmOutputsSchema.shape.modelWellTestTimestamp?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    modelMatchedoilRate: MpfmOutputsSchema.shape.modelMatchedoilRate?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    modelMatchedliquidRate: MpfmOutputsSchema.shape.modelMatchedliquidRate?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    modelMatchedgasRate: MpfmOutputsSchema.shape.modelMatchedgasRate?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    modelMatchedwaterRate: MpfmOutputsSchema.shape.modelMatchedwaterRate?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    chokeMatchedliquidRate: MpfmOutputsSchema.shape.chokeMatchedliquidRate?.describe(
      'Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation.',
    ),
    modelMatchedBHP: MpfmOutputsSchema.shape.modelMatchedBHP?.describe(
      'Model-derived diagnostic metric from the MPFM solution, indicating how well the internal model matches measured data and whether the flow is within stable operating envelopes.',
    ),
    wellTestStartDateDH: MpfmOutputsSchema.shape.wellTestStartDateDH?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    historicalAlarmsCode: MpfmOutputsSchema.shape.historicalAlarmsCode?.describe(
      'MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges.',
    ),
    modelAlarmsCode: MpfmOutputsSchema.shape.modelAlarmsCode?.describe(
      'MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges.',
    ),
    chokeAlarmsCode: MpfmOutputsSchema.shape.chokeAlarmsCode?.describe(
      'MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges.',
    ),
    formationGOR: MpfmOutputsSchema.shape.formationGOR?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wlrLC: MpfmOutputsSchema.shape.wlrLC?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
    wellTestChokeOpening: MpfmOutputsSchema.shape.wellTestChokeOpening?.describe(
      'Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation.',
    ),
  })?.describe(
    'Measured and modeled outputs from the multiphase flow meter (MPFM) for a well or production stream, covering phase rates, pressures, compositions, diagnostics, and model match indicators used for calibration and surveillance.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const MpfmView = parseView({
  view: { externalId: 'Mpfm' },
  model: MpfmSchema.extend({
    ...InstanceIdType.shape,
    name: MpfmSchema.shape.name?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    startDateTime: MpfmSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this entity in the production optimization context.',
    ),
    endDateTime: MpfmSchema.shape.endDateTime?.describe(
      'Attribute capturing end date time for this entity in the production optimization context.',
    ),
    location: MpfmSchema.shape.location?.describe(
      'Location attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    entityType: MpfmSchema.shape.entityType?.describe(
      'Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelName: MpfmSchema.shape.modelName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Mpfm view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
    ),
  dataModel: DataModel.IpsoSolution,
});

export const MpfmWellTestOutputsView = parseView({
  view: { externalId: 'MpfmWellTestOutputs' },
  model: MpfmWellTestOutputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: MpfmWellTestOutputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellOnTest: MpfmWellTestOutputsSchema.shape.wellOnTest?.describe(
      'Well On Test attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    wellTestDateTime: MpfmWellTestOutputsSchema.shape.wellTestDateTime?.describe(
      'Attribute capturing well test date time for this well in the production optimization context.',
    ),
    alarmCount: MpfmWellTestOutputsSchema.shape.alarmCount?.describe(
      'Numeric value storing alarm count for this well, used in calculations, reporting, or model configuration.',
    ),
    field: MpfmWellTestOutputsSchema.shape.field?.describe(
      'Field attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    startDateTime: MpfmWellTestOutputsSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this well in the production optimization context.',
    ),
    stringOnTest: MpfmWellTestOutputsSchema.shape.stringOnTest?.describe(
      'String On Test attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    stablePeriodFlag: MpfmWellTestOutputsSchema.shape.stablePeriodFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    singlePointWellTestFlag: MpfmWellTestOutputsSchema.shape.singlePointWellTestFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    stablePeriodStartDateTime: MpfmWellTestOutputsSchema.shape.stablePeriodStartDateTime?.describe(
      'Attribute capturing stable period start date time for this well in the production optimization context.',
    ),
    stablePeriodEndDateTime: MpfmWellTestOutputsSchema.shape.stablePeriodEndDateTime?.describe(
      'Attribute capturing stable period end date time for this well in the production optimization context.',
    ),
    process1Flag: MpfmWellTestOutputsSchema.shape.process1Flag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    process2Flag: MpfmWellTestOutputsSchema.shape.process2Flag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    process3Flag: MpfmWellTestOutputsSchema.shape.process3Flag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    process4Flag: MpfmWellTestOutputsSchema.shape.process4Flag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
  })
    .omit({ startDateTime: true })
    ?.describe(
      'Well test results derived from the multiphase flow meter (MPFM), including stabilized phase rates and key test conditions, used to calibrate allocation and network models.',
    ),
  dataModel: DataModel.IpsoSolution,
});

export const NetworkInputsView = parseView({
  view: { externalId: 'NetworkInputs' },
  model: NetworkInputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: NetworkInputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    manifoldPress: NetworkInputsSchema.shape.manifoldPress?.describe(
      'Time series signal representing manifold press for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    manifoldTemp: NetworkInputsSchema.shape.manifoldTemp?.describe(
      'Time series signal representing manifold temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorOilRate: NetworkInputsSchema.shape.separatorOilRate?.describe(
      'Time series signal representing separator oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorGasRate: NetworkInputsSchema.shape.separatorGasRate?.describe(
      'Time series signal representing separator gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorPressure: NetworkInputsSchema.shape.separatorPressure?.describe(
      'Time series signal representing separator pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorWaterRate: NetworkInputsSchema.shape.separatorWaterRate?.describe(
      'Time series signal representing separator water rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    flowlineMaxMixtureVelocity: NetworkInputsSchema.shape.flowlineMaxMixtureVelocity?.describe(
      'Time series signal representing flowline max mixture velocity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellMaxGOR: NetworkInputsSchema.shape.wellMaxGOR?.describe(
      'Time series signal representing well max gor for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorMaxOilRate: NetworkInputsSchema.shape.separatorMaxOilRate?.describe(
      'Time series signal representing separator max oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorMaxGasRate: NetworkInputsSchema.shape.separatorMaxGasRate?.describe(
      'Time series signal representing separator max gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorMaxWaterRate: NetworkInputsSchema.shape.separatorMaxWaterRate?.describe(
      'Time series signal representing separator max water rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    flowlineMaxCFactor: NetworkInputsSchema.shape.flowlineMaxCFactor?.describe(
      'Time series signal representing flowline max cfactor for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    flowlineMaxLinePressure: NetworkInputsSchema.shape.flowlineMaxLinePressure?.describe(
      'Time series signal representing flowline max line pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    jointMaxOilRate: NetworkInputsSchema.shape.jointMaxOilRate?.describe(
      'Time series signal representing joint max oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    jointMaxGasRate: NetworkInputsSchema.shape.jointMaxGasRate?.describe(
      'Time series signal representing joint max gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    jointMaxLiquidRate: NetworkInputsSchema.shape.jointMaxLiquidRate?.describe(
      'Time series signal representing joint max liquid rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    jointMinPressure: NetworkInputsSchema.shape.jointMinPressure?.describe(
      'Time series signal representing joint min pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    jointMaxPressure: NetworkInputsSchema.shape.jointMaxPressure?.describe(
      'Time series signal representing joint max pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    jointMaxCO2: NetworkInputsSchema.shape.jointMaxCO2?.describe(
      'Time series signal representing joint max co2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    jointMaxN2: NetworkInputsSchema.shape.jointMaxN2?.describe(
      'Time series signal representing joint max n2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    jointMaxH2S: NetworkInputsSchema.shape.jointMaxH2S?.describe(
      'Time series signal representing joint max h2 s for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    surfacePumpMaxLiquidRate: NetworkInputsSchema.shape.surfacePumpMaxLiquidRate?.describe(
      'Time series signal representing surface pump max liquid rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    hydrateTable: NetworkInputsSchema.shape.hydrateTable?.describe(
      'Time series signal representing hydrate table for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waxTable: NetworkInputsSchema.shape.waxTable?.describe(
      'Time series signal representing wax table for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    asphalteneTable: NetworkInputsSchema.shape.asphalteneTable?.describe(
      'Time series signal representing asphaltene table for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    scaleTable: NetworkInputsSchema.shape.scaleTable?.describe(
      'Time series signal representing scale table for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    availableGLRate: NetworkInputsSchema.shape.availableGLRate?.describe(
      'Time series signal representing available glrate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    availablePower: NetworkInputsSchema.shape.availablePower?.describe(
      'Time series signal representing available power for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    capacityGasRate: NetworkInputsSchema.shape.capacityGasRate?.describe(
      'Time series signal representing capacity gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    capacityOilRate: NetworkInputsSchema.shape.capacityOilRate?.describe(
      'Time series signal representing capacity oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    capacityWaterRate: NetworkInputsSchema.shape.capacityWaterRate?.describe(
      'Time series signal representing capacity water rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    plannedFacilityDowntime: NetworkInputsSchema.shape.plannedFacilityDowntime?.describe(
      'Time series signal representing planned facility downtime for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilPrice: NetworkInputsSchema.shape.oilPrice?.describe(
      'Time series signal representing oil price for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasPrice: NetworkInputsSchema.shape.gasPrice?.describe(
      'Time series signal representing gas price for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasBarrelOfOilEquivalent: NetworkInputsSchema.shape.gasBarrelOfOilEquivalent?.describe(
      'Time series signal representing gas barrel of oil equivalent for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilProcessingCost: NetworkInputsSchema.shape.oilProcessingCost?.describe(
      'Time series signal representing oil processing cost for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasProcessingCost: NetworkInputsSchema.shape.gasProcessingCost?.describe(
      'Time series signal representing gas processing cost for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    liftCost: NetworkInputsSchema.shape.liftCost?.describe(
      'Time series signal representing lift cost for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterDisposalCost: NetworkInputsSchema.shape.waterDisposalCost?.describe(
      'Time series signal representing water disposal cost for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorTemperature: NetworkInputsSchema.shape.separatorTemperature?.describe(
      'Time series signal representing separator temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Input parameters, constraints, and configuration used by the integrated production network model, such as equipment limits, control settings, and boundary conditions for simulations and optimizations.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const NetworkModelView = parseView({
  view: { externalId: 'NetworkModel' },
  model: NetworkModelSchema.extend({
    ...InstanceIdType.shape,
    garFileName: NetworkModelSchema.shape.garFileName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    originalGarFileName: NetworkModelSchema.shape.originalGarFileName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    description: NetworkModelSchema.shape.description?.describe(
      'Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting.',
    ),
    changeDetails: NetworkModelSchema.shape.changeDetails?.describe(
      'Change Details attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelUploadedBy: NetworkModelSchema.shape.modelUploadedBy?.describe(
      'Model Uploaded By attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelUploadedTime: NetworkModelSchema.shape.modelUploadedTime?.describe(
      'Attribute capturing model uploaded time for this entity in the production optimization context.',
    ),
    modelUpdatedBy: NetworkModelSchema.shape.modelUpdatedBy?.describe(
      'Model Updated By attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelUpdatedTime: NetworkModelSchema.shape.modelUpdatedTime?.describe(
      'Attribute capturing model updated time for this entity in the production optimization context.',
    ),
    legacyGarFileExternalId: NetworkModelSchema.shape.legacyGarFileExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    legacyGarFileId: NetworkModelSchema.shape.legacyGarFileId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    status: NetworkModelSchema.shape.status?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    networkType: NetworkModelSchema.shape.networkType?.describe(
      'Network Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    network: NetworkModelSchema.shape.network?.describe(
      'Network attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    wf9Processed: NetworkModelSchema.shape.wf9Processed?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    modelConfig: NetworkModelSchema.shape.modelConfig?.describe(
      'Attribute capturing model config for this entity in the production optimization context.',
    ),
    simIntModelExternalId: NetworkModelSchema.shape.simIntModelExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionExternalId: NetworkModelSchema.shape.simIntModelRevisionExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionVersionId: NetworkModelSchema.shape.simIntModelRevisionVersionId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntExternalId: NetworkModelSchema.shape.simIntExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionId: NetworkModelSchema.shape.simIntModelRevisionId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionDescription: NetworkModelSchema.shape.simIntModelRevisionDescription?.describe(
      'Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting.',
    ),
    simIntModelRevisionStatus: NetworkModelSchema.shape.simIntModelRevisionStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    simIntModelRevisionStatusMessage: NetworkModelSchema.shape.simIntModelRevisionStatusMessage?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    simIntModelRevisionLogId: NetworkModelSchema.shape.simIntModelRevisionLogId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionCreatedTime: NetworkModelSchema.shape.simIntModelRevisionCreatedTime?.describe(
      'Attribute capturing sim int model revision created time for this entity in the production optimization context.',
    ),
    simIntModelRevisionUpdatedTime: NetworkModelSchema.shape.simIntModelRevisionUpdatedTime?.describe(
      'Attribute capturing sim int model revision updated time for this entity in the production optimization context.',
    ),
    source: NetworkModelSchema.shape.source?.describe(
      'Source attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelEffectiveTime: NetworkModelSchema.shape.modelEffectiveTime?.describe(
      'Attribute capturing model effective time for this entity in the production optimization context.',
    ),
    legacyGapFileExternalId: NetworkModelSchema.shape.legacyGapFileExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    legacyGapFileId: NetworkModelSchema.shape.legacyGapFileId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelConfigLegacyFileExternalId: NetworkModelSchema.shape.modelConfigLegacyFileExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    wf8Processed: NetworkModelSchema.shape.wf8Processed?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    productivityIndexDifferencePercentage: NetworkModelSchema.shape.productivityIndexDifferencePercentage?.describe(
      'Attribute capturing productivity index difference percentage for this entity in the production optimization context.',
    ),
    pressureMatchedWellModels: NetworkModelSchema.shape.pressureMatchedWellModels?.describe(
      'Numeric value storing pressure matched well models for this entity, used in calculations, reporting, or model configuration.',
    ),
    totalWellModels: NetworkModelSchema.shape.totalWellModels?.describe(
      'Numeric value storing total well models for this entity, used in calculations, reporting, or model configuration.',
    ),
    modelSimIntRevisionConfigLegacyFileExternalId:
      NetworkModelSchema.shape.modelSimIntRevisionConfigLegacyFileExternalId?.describe(
        'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
      ),
    connectedFields: NetworkModelSchema.shape.connectedFields?.describe(
      'Attribute capturing connected fields for this entity in the production optimization context.',
    ),
    wf9Consumed: NetworkModelSchema.shape.wf9Consumed?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    legacyInputGarFileId: NetworkModelSchema.shape.legacyInputGarFileId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    legacyInputGapFileId: NetworkModelSchema.shape.legacyInputGapFileId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
  })?.describe(
    'Definition and metadata for the integrated production network model, including topology, fluid systems, and configuration versions used to support simulation and optimization scenarios.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const NetworkOutputsFieldView = parseView({
  view: { externalId: 'NetworkOutputs_Field' },
  model: NetworkOutputsFieldSchema.extend({
    ...InstanceIdType.shape,
    entityName: NetworkOutputsFieldSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    calculatedTotalOilRate: NetworkOutputsFieldSchema.shape.calculatedTotalOilRate?.describe(
      'Total simulated oil rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    calculatedTotalGasRate: NetworkOutputsFieldSchema.shape.calculatedTotalGasRate?.describe(
      'Total simulated gas rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    calculatedTotalWaterRate: NetworkOutputsFieldSchema.shape.calculatedTotalWaterRate?.describe(
      'Total simulated water rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    calculatedTotalLiquidRate: NetworkOutputsFieldSchema.shape.calculatedTotalLiquidRate?.describe(
      'Total simulated fluid rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    calculatedJointOilRate: NetworkOutputsFieldSchema.shape.calculatedJointOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedJointGasRate: NetworkOutputsFieldSchema.shape.calculatedJointGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedJointLiquidRate: NetworkOutputsFieldSchema.shape.calculatedJointLiquidRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedJointPressure: NetworkOutputsFieldSchema.shape.calculatedJointPressure?.describe(
      'Simulated pressure at the relevant point in the production network for this field, derived from the network model and used to check constraints and diagnose bottlenecks.',
    ),
    calculatedJointCo2: NetworkOutputsFieldSchema.shape.calculatedJointCo2?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedJointN2: NetworkOutputsFieldSchema.shape.calculatedJointN2?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedJointH2S: NetworkOutputsFieldSchema.shape.calculatedJointH2S?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedSeparatorOilRate: NetworkOutputsFieldSchema.shape.calculatedSeparatorOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calcualtedSeparatorGasRate: NetworkOutputsFieldSchema.shape.calcualtedSeparatorGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedSepratorWaterRate: NetworkOutputsFieldSchema.shape.calculatedSepratorWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedFlowLinePressure: NetworkOutputsFieldSchema.shape.calculatedFlowLinePressure?.describe(
      'Simulated pressure at the relevant point in the production network for this field, derived from the network model and used to check constraints and diagnose bottlenecks.',
    ),
    calculatedPressureMatchIndex: NetworkOutputsFieldSchema.shape.calculatedPressureMatchIndex?.describe(
      'Simulated pressure at the relevant point in the production network for this field, derived from the network model and used to check constraints and diagnose bottlenecks.',
    ),
    estimatedFlowlineUnstableflowFlag: NetworkOutputsFieldSchema.shape.estimatedFlowlineUnstableflowFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    estimatedFlowlineflowassuranceflag: NetworkOutputsFieldSchema.shape.estimatedFlowlineflowassuranceflag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    systemOptimizedOilRate: NetworkOutputsFieldSchema.shape.systemOptimizedOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedWaterRate: NetworkOutputsFieldSchema.shape.systemOptimizedWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedGasRate: NetworkOutputsFieldSchema.shape.systemOptimizedGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedGasLiftRate: NetworkOutputsFieldSchema.shape.systemOptimizedGasLiftRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedPower: NetworkOutputsFieldSchema.shape.systemOptimizedPower?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalOilRate: NetworkOutputsFieldSchema.shape.technicalOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalWaterRate: NetworkOutputsFieldSchema.shape.technicalWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalGasRate: NetworkOutputsFieldSchema.shape.technicalGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicOilRate: NetworkOutputsFieldSchema.shape.hydraulicOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicWaterRate: NetworkOutputsFieldSchema.shape.hydraulicWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicGasRate: NetworkOutputsFieldSchema.shape.hydraulicGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprOilRate: NetworkOutputsFieldSchema.shape.fsoprOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprWaterRate: NetworkOutputsFieldSchema.shape.fsoprWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprGasRate: NetworkOutputsFieldSchema.shape.fsoprGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverEstimatedTotalOilRate: NetworkOutputsFieldSchema.shape.wellSolverEstimatedTotalOilRate?.describe(
      'Total simulated oil rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    wellSolverEstimatedTotalGasRate: NetworkOutputsFieldSchema.shape.wellSolverEstimatedTotalGasRate?.describe(
      'Total simulated gas rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    wellSolverEstimatedTotalWaterRate: NetworkOutputsFieldSchema.shape.wellSolverEstimatedTotalWaterRate?.describe(
      'Total simulated water rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    wellSolverEstimatedTotalLiquidRate: NetworkOutputsFieldSchema.shape.wellSolverEstimatedTotalLiquidRate?.describe(
      'Total simulated fluid rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    wellSolverMeasuredTotalOilRate: NetworkOutputsFieldSchema.shape.wellSolverMeasuredTotalOilRate?.describe(
      'Total simulated oil rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    wellSolverMeasuredTotalGasRate: NetworkOutputsFieldSchema.shape.wellSolverMeasuredTotalGasRate?.describe(
      'Total simulated gas rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    wellSolverMeasuredTotalWaterRate: NetworkOutputsFieldSchema.shape.wellSolverMeasuredTotalWaterRate?.describe(
      'Total simulated water rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    wellSolverMeasuredTotalLiquidRate: NetworkOutputsFieldSchema.shape.wellSolverMeasuredTotalLiquidRate?.describe(
      'Total simulated fluid rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    wellSolverOilDifference: NetworkOutputsFieldSchema.shape.wellSolverOilDifference?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverGasDifference: NetworkOutputsFieldSchema.shape.wellSolverGasDifference?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverWaterDifference: NetworkOutputsFieldSchema.shape.wellSolverWaterDifference?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverLiquidDifference: NetworkOutputsFieldSchema.shape.wellSolverLiquidDifference?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverOilDeviation: NetworkOutputsFieldSchema.shape.wellSolverOilDeviation?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverGasDeviation: NetworkOutputsFieldSchema.shape.wellSolverGasDeviation?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverWaterDeviation: NetworkOutputsFieldSchema.shape.wellSolverWaterDeviation?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverOilFlowMatchIndex: NetworkOutputsFieldSchema.shape.wellSolverOilFlowMatchIndex?.describe(
      'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
    ),
    wellSolverGasFlowMatchIndex: NetworkOutputsFieldSchema.shape.wellSolverGasFlowMatchIndex?.describe(
      'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
    ),
    wellSolverWaterFlowMatchIndex: NetworkOutputsFieldSchema.shape.wellSolverWaterFlowMatchIndex?.describe(
      'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
    ),
    wellSolverWaterFlowMatchIndexTolerance:
      NetworkOutputsFieldSchema.shape.wellSolverWaterFlowMatchIndexTolerance?.describe(
        'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
      ),
    wellSolverGasFlowMatchIndexTolerance:
      NetworkOutputsFieldSchema.shape.wellSolverGasFlowMatchIndexTolerance?.describe(
        'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
      ),
    wellSolverOilFlowMatchIndexTolerance:
      NetworkOutputsFieldSchema.shape.wellSolverOilFlowMatchIndexTolerance?.describe(
        'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
      ),
    adHocOptimization1GasRate: NetworkOutputsFieldSchema.shape.adHocOptimization1GasRate?.describe(
      'Resulting gas rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization1OilRate: NetworkOutputsFieldSchema.shape.adHocOptimization1OilRate?.describe(
      'Resulting oil rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization1WaterRate: NetworkOutputsFieldSchema.shape.adHocOptimization1WaterRate?.describe(
      'Resulting water rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization2GasRate: NetworkOutputsFieldSchema.shape.adHocOptimization2GasRate?.describe(
      'Resulting gas rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization2OilRate: NetworkOutputsFieldSchema.shape.adHocOptimization2OilRate?.describe(
      'Resulting oil rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization2WaterRate: NetworkOutputsFieldSchema.shape.adHocOptimization2WaterRate?.describe(
      'Resulting water rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation1GasRate: NetworkOutputsFieldSchema.shape.adHocSimulation1GasRate?.describe(
      'Resulting gas rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation1OilRate: NetworkOutputsFieldSchema.shape.adHocSimulation1OilRate?.describe(
      'Resulting oil rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation1WaterRate: NetworkOutputsFieldSchema.shape.adHocSimulation1WaterRate?.describe(
      'Resulting water rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation2GasRate: NetworkOutputsFieldSchema.shape.adHocSimulation2GasRate?.describe(
      'Resulting gas rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation2OilRate: NetworkOutputsFieldSchema.shape.adHocSimulation2OilRate?.describe(
      'Resulting oil rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation2WaterRate: NetworkOutputsFieldSchema.shape.adHocSimulation2WaterRate?.describe(
      'Resulting water rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization1ExecutedBy: NetworkOutputsFieldSchema.shape.adHocOptimization1ExecutedBy?.describe(
      'User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results.',
    ),
    adHocOptimization2ExecutedBy: NetworkOutputsFieldSchema.shape.adHocOptimization2ExecutedBy?.describe(
      'User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results.',
    ),
    adHocSimulation1ExecutedBy: NetworkOutputsFieldSchema.shape.adHocSimulation1ExecutedBy?.describe(
      'User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results.',
    ),
    adHocSimulation2ExecutedBy: NetworkOutputsFieldSchema.shape.adHocSimulation2ExecutedBy?.describe(
      'User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results.',
    ),
    calculatedTotalGasRateGI: NetworkOutputsFieldSchema.shape.calculatedTotalGasRateGI?.describe(
      'Total simulated gas rate for this field from gas injection wells or streams from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    calculatedTotalWaterRateWI: NetworkOutputsFieldSchema.shape.calculatedTotalWaterRateWI?.describe(
      'Total simulated water rate for this field from water injection wells or streams from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
    calculatedTotalLiquidRateWI: NetworkOutputsFieldSchema.shape.calculatedTotalLiquidRateWI?.describe(
      'Total simulated fluid rate for this field from water injection wells or streams from the integrated production network model, used to understand system behavior and compare against measured rates.',
    ),
  })?.describe(
    'Outputs from the integrated production network model at the specified aggregation level, including simulated phase rates, pressures, bottleneck indicators, and scenario results used in optimization and planning.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const NetworkOutputsStringView = parseView({
  view: { externalId: 'NetworkOutputs_String' },
  model: NetworkOutputsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: NetworkOutputsStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    calculatedWellOilRate: NetworkOutputsStringSchema.shape.calculatedWellOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellGasRate: NetworkOutputsStringSchema.shape.calculatedWellGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellWaterRate: NetworkOutputsStringSchema.shape.calculatedWellWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellLiquidRate: NetworkOutputsStringSchema.shape.calculatedWellLiquidRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellBHP: NetworkOutputsStringSchema.shape.calculatedWellBHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellESPMotorLoad: NetworkOutputsStringSchema.shape.calculatedWellESPMotorLoad?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedPumpLquidRate: NetworkOutputsStringSchema.shape.calculatedPumpLquidRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedOilRateMatchIndex: NetworkOutputsStringSchema.shape.calculatedOilRateMatchIndex?.describe(
      'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
    ),
    calculatedGasRateMatchIndex: NetworkOutputsStringSchema.shape.calculatedGasRateMatchIndex?.describe(
      'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
    ),
    calculatedWaterRateMatchIndex: NetworkOutputsStringSchema.shape.calculatedWaterRateMatchIndex?.describe(
      'Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization.',
    ),
    pe5StabilityFlag_well: NetworkOutputsStringSchema.shape.pe5StabilityFlag_well?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydrateFlag_well: NetworkOutputsStringSchema.shape.hydrateFlag_well?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    waxFlag_well: NetworkOutputsStringSchema.shape.waxFlag_well?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    scaleFlag_well: NetworkOutputsStringSchema.shape.scaleFlag_well?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    asphalteneFlag_well: NetworkOutputsStringSchema.shape.asphalteneFlag_well?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    constraintFlag_well: NetworkOutputsStringSchema.shape.constraintFlag_well?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    gasLiftInjection: NetworkOutputsStringSchema.shape.gasLiftInjection?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    formationWellGasOilRatio: NetworkOutputsStringSchema.shape.formationWellGasOilRatio?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedOilRate: NetworkOutputsStringSchema.shape.systemOptimizedOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedWaterRate: NetworkOutputsStringSchema.shape.systemOptimizedWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedGasRate: NetworkOutputsStringSchema.shape.systemOptimizedGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedGasLiftRate: NetworkOutputsStringSchema.shape.systemOptimizedGasLiftRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedPower: NetworkOutputsStringSchema.shape.systemOptimizedPower?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalOilRate: NetworkOutputsStringSchema.shape.technicalOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalWaterRate: NetworkOutputsStringSchema.shape.technicalWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalGasRate: NetworkOutputsStringSchema.shape.technicalGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicOilRate: NetworkOutputsStringSchema.shape.hydraulicOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicWaterRate: NetworkOutputsStringSchema.shape.hydraulicWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicGasRate: NetworkOutputsStringSchema.shape.hydraulicGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprOilRate: NetworkOutputsStringSchema.shape.fsoprOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprWaterRate: NetworkOutputsStringSchema.shape.fsoprWaterRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprGasRate: NetworkOutputsStringSchema.shape.fsoprGasRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    gasLiftInjectionPress: NetworkOutputsStringSchema.shape.gasLiftInjectionPress?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    chokeDP: NetworkOutputsStringSchema.shape.chokeDP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverEstimatedOilRate: NetworkOutputsStringSchema.shape.wellSolverEstimatedOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverMeasuredOilRate: NetworkOutputsStringSchema.shape.wellSolverMeasuredOilRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    wellSolverDifference: NetworkOutputsStringSchema.shape.wellSolverDifference?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedChokeBeanSize: NetworkOutputsStringSchema.shape.systemOptimizedChokeBeanSize?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedChokeOpening: NetworkOutputsStringSchema.shape.systemOptimizedChokeOpening?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedEspFrequency: NetworkOutputsStringSchema.shape.systemOptimizedEspFrequency?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalChokeBeanSize: NetworkOutputsStringSchema.shape.technicalChokeBeanSize?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalChokeOpening: NetworkOutputsStringSchema.shape.technicalChokeOpening?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalEspFrequency: NetworkOutputsStringSchema.shape.technicalEspFrequency?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalPower: NetworkOutputsStringSchema.shape.technicalPower?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalGasLiftRate: NetworkOutputsStringSchema.shape.technicalGasLiftRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicChokeBeanSize: NetworkOutputsStringSchema.shape.hydraulicChokeBeanSize?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicChokeOpening: NetworkOutputsStringSchema.shape.hydraulicChokeOpening?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicEspFrequency: NetworkOutputsStringSchema.shape.hydraulicEspFrequency?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicPower: NetworkOutputsStringSchema.shape.hydraulicPower?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicGasLiftRate: NetworkOutputsStringSchema.shape.hydraulicGasLiftRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprChokeBeanSize: NetworkOutputsStringSchema.shape.fsoprChokeBeanSize?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprChokeOpening: NetworkOutputsStringSchema.shape.fsoprChokeOpening?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprEspFrequency: NetworkOutputsStringSchema.shape.fsoprEspFrequency?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprPower: NetworkOutputsStringSchema.shape.fsoprPower?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprGasLiftRate: NetworkOutputsStringSchema.shape.fsoprGasLiftRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedChokeBeanSize: NetworkOutputsStringSchema.shape.calculatedChokeBeanSize?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedChokeOpening: NetworkOutputsStringSchema.shape.calculatedChokeOpening?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedEspFrequency: NetworkOutputsStringSchema.shape.calculatedEspFrequency?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedPower: NetworkOutputsStringSchema.shape.calculatedPower?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedGasLiftRate: NetworkOutputsStringSchema.shape.calculatedGasLiftRate?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedRunID: NetworkOutputsStringSchema.shape.systemOptimizedRunID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    technicalRunID: NetworkOutputsStringSchema.shape.technicalRunID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    hydraulicRunID: NetworkOutputsStringSchema.shape.hydraulicRunID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    fsoprRunID: NetworkOutputsStringSchema.shape.fsoprRunID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    systemOptimizedOptimizedParameter: NetworkOutputsStringSchema.shape.systemOptimizedOptimizedParameter?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalOptimizedParameter: NetworkOutputsStringSchema.shape.technicalOptimizedParameter?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicOptimizedParameter: NetworkOutputsStringSchema.shape.hydraulicOptimizedParameter?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprOptimizedParameter: NetworkOutputsStringSchema.shape.fsoprOptimizedParameter?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    gapWellName: NetworkOutputsStringSchema.shape.gapWellName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    gapOptimizedParameter: NetworkOutputsStringSchema.shape.gapOptimizedParameter?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    espEfficiency: NetworkOutputsStringSchema.shape.espEfficiency?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    adHocOptimization1ChokeBeanSize: NetworkOutputsStringSchema.shape.adHocOptimization1ChokeBeanSize?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization1ChokeOpening: NetworkOutputsStringSchema.shape.adHocOptimization1ChokeOpening?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization1EspFrequency: NetworkOutputsStringSchema.shape.adHocOptimization1EspFrequency?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization1GasLiftRate: NetworkOutputsStringSchema.shape.adHocOptimization1GasLiftRate?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization1GasRate: NetworkOutputsStringSchema.shape.adHocOptimization1GasRate?.describe(
      'Resulting gas rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization1OilRate: NetworkOutputsStringSchema.shape.adHocOptimization1OilRate?.describe(
      'Resulting oil rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization1OptimizedParameter:
      NetworkOutputsStringSchema.shape.adHocOptimization1OptimizedParameter?.describe(
        'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
      ),
    adHocOptimization1Power: NetworkOutputsStringSchema.shape.adHocOptimization1Power?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization1RunID: NetworkOutputsStringSchema.shape.adHocOptimization1RunID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    adHocOptimization1WaterRate: NetworkOutputsStringSchema.shape.adHocOptimization1WaterRate?.describe(
      'Resulting water rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization2ChokeBeanSize: NetworkOutputsStringSchema.shape.adHocOptimization2ChokeBeanSize?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization2ChokeOpening: NetworkOutputsStringSchema.shape.adHocOptimization2ChokeOpening?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization2EspFrequency: NetworkOutputsStringSchema.shape.adHocOptimization2EspFrequency?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization2GasLiftRate: NetworkOutputsStringSchema.shape.adHocOptimization2GasLiftRate?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization2GasRate: NetworkOutputsStringSchema.shape.adHocOptimization2GasRate?.describe(
      'Resulting gas rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization2OilRate: NetworkOutputsStringSchema.shape.adHocOptimization2OilRate?.describe(
      'Resulting oil rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization2OptimizedParameter:
      NetworkOutputsStringSchema.shape.adHocOptimization2OptimizedParameter?.describe(
        'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
      ),
    adHocOptimization2Power: NetworkOutputsStringSchema.shape.adHocOptimization2Power?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization2RunID: NetworkOutputsStringSchema.shape.adHocOptimization2RunID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    adHocOptimization2WaterRate: NetworkOutputsStringSchema.shape.adHocOptimization2WaterRate?.describe(
      'Resulting water rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation1ChokeBeanSize: NetworkOutputsStringSchema.shape.adHocSimulation1ChokeBeanSize?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation1ChokeOpening: NetworkOutputsStringSchema.shape.adHocSimulation1ChokeOpening?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation1EspFrequency: NetworkOutputsStringSchema.shape.adHocSimulation1EspFrequency?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation1GasLiftRate: NetworkOutputsStringSchema.shape.adHocSimulation1GasLiftRate?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation1GasRate: NetworkOutputsStringSchema.shape.adHocSimulation1GasRate?.describe(
      'Resulting gas rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation1OilRate: NetworkOutputsStringSchema.shape.adHocSimulation1OilRate?.describe(
      'Resulting oil rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation1OptimizedParameter: NetworkOutputsStringSchema.shape.adHocSimulation1OptimizedParameter?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation1Power: NetworkOutputsStringSchema.shape.adHocSimulation1Power?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation1RunID: NetworkOutputsStringSchema.shape.adHocSimulation1RunID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    adHocSimulation1WaterRate: NetworkOutputsStringSchema.shape.adHocSimulation1WaterRate?.describe(
      'Resulting water rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation2ChokeBeanSize: NetworkOutputsStringSchema.shape.adHocSimulation2ChokeBeanSize?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation2ChokeOpening: NetworkOutputsStringSchema.shape.adHocSimulation2ChokeOpening?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation2EspFrequency: NetworkOutputsStringSchema.shape.adHocSimulation2EspFrequency?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation2GasLiftRate: NetworkOutputsStringSchema.shape.adHocSimulation2GasLiftRate?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation2GasRate: NetworkOutputsStringSchema.shape.adHocSimulation2GasRate?.describe(
      'Resulting gas rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation2OilRate: NetworkOutputsStringSchema.shape.adHocSimulation2OilRate?.describe(
      'Resulting oil rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocSimulation2OptimizedParameter: NetworkOutputsStringSchema.shape.adHocSimulation2OptimizedParameter?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation2Power: NetworkOutputsStringSchema.shape.adHocSimulation2Power?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation2RunID: NetworkOutputsStringSchema.shape.adHocSimulation2RunID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    adHocSimulation2WaterRate: NetworkOutputsStringSchema.shape.adHocSimulation2WaterRate?.describe(
      'Resulting water rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity.',
    ),
    adHocOptimization1ExecutedBy: NetworkOutputsStringSchema.shape.adHocOptimization1ExecutedBy?.describe(
      'User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results.',
    ),
    adHocOptimization2ExecutedBy: NetworkOutputsStringSchema.shape.adHocOptimization2ExecutedBy?.describe(
      'User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results.',
    ),
    adHocSimulation1ExecutedBy: NetworkOutputsStringSchema.shape.adHocSimulation1ExecutedBy?.describe(
      'User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results.',
    ),
    adHocSimulation2ExecutedBy: NetworkOutputsStringSchema.shape.adHocSimulation2ExecutedBy?.describe(
      'User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results.',
    ),
    gapWellNameHistorical: NetworkOutputsStringSchema.shape.gapWellNameHistorical?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    calculatedWellFWHP: NetworkOutputsStringSchema.shape.calculatedWellFWHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellFBHP: NetworkOutputsStringSchema.shape.calculatedWellFBHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedFWHP: NetworkOutputsStringSchema.shape.systemOptimizedFWHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    systemOptimizedFBHP: NetworkOutputsStringSchema.shape.systemOptimizedFBHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalFWHP: NetworkOutputsStringSchema.shape.technicalFWHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    technicalFBHP: NetworkOutputsStringSchema.shape.technicalFBHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicFWHP: NetworkOutputsStringSchema.shape.hydraulicFWHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    hydraulicFBHP: NetworkOutputsStringSchema.shape.hydraulicFBHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprFBHP: NetworkOutputsStringSchema.shape.fsoprFBHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    fsoprFWHP: NetworkOutputsStringSchema.shape.fsoprFWHP?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    adHocOptimization1FWHP: NetworkOutputsStringSchema.shape.adHocOptimization1FWHP?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization1FBHP: NetworkOutputsStringSchema.shape.adHocOptimization1FBHP?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization2FWHP: NetworkOutputsStringSchema.shape.adHocOptimization2FWHP?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocOptimization2FBHP: NetworkOutputsStringSchema.shape.adHocOptimization2FBHP?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation1FWHP: NetworkOutputsStringSchema.shape.adHocSimulation1FWHP?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation1FBHP: NetworkOutputsStringSchema.shape.adHocSimulation1FBHP?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation2FWHP: NetworkOutputsStringSchema.shape.adHocSimulation2FWHP?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    adHocSimulation2FBHP: NetworkOutputsStringSchema.shape.adHocSimulation2FBHP?.describe(
      'Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support.',
    ),
    calculatedChokeBeanSizeWI: NetworkOutputsStringSchema.shape.calculatedChokeBeanSizeWI?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedChokeBeanSizeGI: NetworkOutputsStringSchema.shape.calculatedChokeBeanSizeGI?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellBHPWI: NetworkOutputsStringSchema.shape.calculatedWellBHPWI?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellBHPGI: NetworkOutputsStringSchema.shape.calculatedWellBHPGI?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellWaterRateWI: NetworkOutputsStringSchema.shape.calculatedWellWaterRateWI?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
    calculatedWellGasRateGI: NetworkOutputsStringSchema.shape.calculatedWellGasRateGI?.describe(
      'Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses.',
    ),
  })?.describe(
    'Outputs from the integrated production network model at the specified aggregation level, including simulated phase rates, pressures, bottleneck indicators, and scenario results used in optimization and planning.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const NetworkRatesStringAgentView = parseView({
  view: { externalId: 'NetworkRates_String_Agent' },
  model: NetworkRatesStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: NetworkRatesStringAgentSchema.shape.wellString?.describe('Well string identifier.'),
    gapWellName: NetworkRatesStringAgentSchema.shape.gapWellName?.describe('GAP model well name mapping.'),
    formationWellGasOilRatio: NetworkRatesStringAgentSchema.shape.formationWellGasOilRatio?.describe(
      'Formation gas-oil ratio input to GAP network model (scf/stb, TS).\n@name formationGOR',
    ),
    calculatedWellOilRate: NetworkRatesStringAgentSchema.shape.calculatedWellOilRate?.describe(
      'Network-solved oil production rate (stb/d, TS).',
    ),
    calculatedWellGasRate: NetworkRatesStringAgentSchema.shape.calculatedWellGasRate?.describe(
      'Network-solved gas production rate (MSCF/d, TS).',
    ),
    calculatedWellWaterRate: NetworkRatesStringAgentSchema.shape.calculatedWellWaterRate?.describe(
      'Network-solved water production rate (stb/d, TS).',
    ),
    calculatedWellLiquidRate: NetworkRatesStringAgentSchema.shape.calculatedWellLiquidRate?.describe(
      'Network-solved total liquid rate (stb/d, TS).',
    ),
    calculatedOilRateMatchIndex: NetworkRatesStringAgentSchema.shape.calculatedOilRateMatchIndex?.describe(
      'Oil rate match index, calculated vs measured (0-1 scale, TS).',
    ),
    calculatedGasRateMatchIndex: NetworkRatesStringAgentSchema.shape.calculatedGasRateMatchIndex?.describe(
      'Gas rate match index, calculated vs measured (0-1 scale, TS).',
    ),
    calculatedWaterRateMatchIndex: NetworkRatesStringAgentSchema.shape.calculatedWaterRateMatchIndex?.describe(
      'Water rate match index, calculated vs measured (0-1 scale, TS).',
    ),
    wellSolverEstimatedOilRate: NetworkRatesStringAgentSchema.shape.wellSolverEstimatedOilRate?.describe(
      'Well solver estimated oil rate input (stb/d, TS).',
    ),
    wellSolverMeasuredOilRate: NetworkRatesStringAgentSchema.shape.wellSolverMeasuredOilRate?.describe(
      'Well solver measured oil rate input (stb/d, TS).',
    ),
    wellSolverDifference: NetworkRatesStringAgentSchema.shape.wellSolverDifference?.describe(
      'Difference between well solver estimated and measured oil rates (TS).',
    ),
    calculatedWellFBHP: NetworkRatesStringAgentSchema.shape.calculatedWellFBHP?.describe(
      'Network-calculated flowing BHP (psi, TS).',
    ),
    gasLiftInjection: NetworkRatesStringAgentSchema.shape.gasLiftInjection?.describe(
      'Gas lift injection rate from network solve (MSCF/d, TS).',
    ),
    calculatedWellWaterRateWI: NetworkRatesStringAgentSchema.shape.calculatedWellWaterRateWI?.describe(
      'Water injection rate from network solve (stb/d, TS).',
    ),
    calculatedWellGasRateGI: NetworkRatesStringAgentSchema.shape.calculatedWellGasRateGI?.describe(
      'Gas injection rate from network solve (MSCF/d, TS).',
    ),
  })?.describe(
    'Current-state network model rates per well string from WF7 GAP simulation (WF7).\n\nCalculated oil, gas, and water production rates per string with match indices\nquantifying accuracy against measured rates. Use for current-state network\nproduction performance and model match assessment. Excludes optimization\nscenario rates (see OptimizedRates_Network_String_Agent) and the richer\nper-network matched outputs (see StringOutputs_Network_Agent).\n\nUse for: Network Surveillance (WF7).\n\n@name Network Model Rates - String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const NetworkRiskAgentView = parseView({
  view: { externalId: 'NetworkRisk_Agent' },
  model: NetworkRiskAgentSchema.extend({
    ...InstanceIdType.shape,
    entityName: NetworkRiskAgentSchema.shape.entityName?.describe('Network entity name.'),
    network: NetworkRiskAgentSchema.shape.network?.describe('Reference to parent network model.'),
    corrosionRateMax: NetworkRiskAgentSchema.shape.corrosionRateMax?.describe(
      'Maximum corrosion rate across entity (TS).',
    ),
    waxDTMax: NetworkRiskAgentSchema.shape.waxDTMax?.describe('Maximum wax deposition temperature delta (TS)'),
    asphalteneDTMax: NetworkRiskAgentSchema.shape.asphalteneDTMax?.describe(
      'Maximum asphaltene onset temperature delta (TS).',
    ),
    evrMax: NetworkRiskAgentSchema.shape.evrMax?.describe('Maximum erosion velocity ratio (TS)'),
    erosionMax: NetworkRiskAgentSchema.shape.erosionMax?.describe('Maximum erosion rate (TS).'),
    scaleSIMax: NetworkRiskAgentSchema.shape.scaleSIMax?.describe('Maximum scale saturation index (TS)'),
    hydrateDTMax: NetworkRiskAgentSchema.shape.hydrateDTMax?.describe('Maximum hydrate temperature delta (TS)'),
    corrosionRisk: NetworkRiskAgentSchema.shape.corrosionRisk?.describe('Corrosion risk level (TS).'),
    waxRisk: NetworkRiskAgentSchema.shape.waxRisk?.describe('Wax deposition risk level (TS).'),
    asphalteneRisk: NetworkRiskAgentSchema.shape.asphalteneRisk?.describe('Asphaltene risk level (TS).'),
    evrRisk: NetworkRiskAgentSchema.shape.evrRisk?.describe('Erosion velocity risk level (TS).'),
    erosionRisk: NetworkRiskAgentSchema.shape.erosionRisk?.describe('Erosion risk level (TS).'),
    scaleSIRisk: NetworkRiskAgentSchema.shape.scaleSIRisk?.describe('Scale risk level (TS).'),
    hydrateRisk: NetworkRiskAgentSchema.shape.hydrateRisk?.describe('Hydrate formation risk level (TS).'),
    aggregatedRisk: NetworkRiskAgentSchema.shape.aggregatedRisk?.describe(
      'Overall aggregated flow assurance risk level (TS).',
    ),
    pe5StabilityMax: NetworkRiskAgentSchema.shape.pe5StabilityMax?.describe('Maximum PE5 stability indicator (TS).'),
    pe5StabilityRisk: NetworkRiskAgentSchema.shape.pe5StabilityRisk?.describe('PE5 stability risk level (TS).'),
  })?.describe(
    'Network risk indicators for flow assurance and operational risk (WF20).\n\nRisk scores and categories for network components. Use to assess failure points\nand prioritize maintenance. Excludes financial or detailed performance metrics.\n\nUse for: Flow Assurance Detection and Mitigation (WF20).\n\n@name Network Risk (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const NetworkRiskOptimizationScenariosAgentView = parseView({
  view: { externalId: 'NetworkRisk_OptimizationScenarios_Agent' },
  model: NetworkRiskOptimizationScenariosAgentSchema.extend({
    ...InstanceIdType.shape,
    entityName: NetworkRiskOptimizationScenariosAgentSchema.shape.entityName?.describe('Network entity name.'),
    network: NetworkRiskOptimizationScenariosAgentSchema.shape.network?.describe('Reference to parent network model.'),
    corrosionRateMax: NetworkRiskOptimizationScenariosAgentSchema.shape.corrosionRateMax?.describe(
      'Maximum corrosion rate for this scenario (TS).',
    ),
    waxDTMax: NetworkRiskOptimizationScenariosAgentSchema.shape.waxDTMax?.describe(
      'Maximum wax delta-T for this scenario (TS).',
    ),
    asphalteneDTMax: NetworkRiskOptimizationScenariosAgentSchema.shape.asphalteneDTMax?.describe(
      'Maximum asphaltene delta-T for this scenario (TS).',
    ),
    evrMax: NetworkRiskOptimizationScenariosAgentSchema.shape.evrMax?.describe(
      'Maximum erosion velocity ratio for this scenario (TS).',
    ),
    erosionMax: NetworkRiskOptimizationScenariosAgentSchema.shape.erosionMax?.describe(
      'Maximum erosion rate for this scenario (TS).',
    ),
    scaleSIMax: NetworkRiskOptimizationScenariosAgentSchema.shape.scaleSIMax?.describe(
      'Maximum scale saturation index for this scenario (TS).',
    ),
    hydrateDTMax: NetworkRiskOptimizationScenariosAgentSchema.shape.hydrateDTMax?.describe(
      'Maximum hydrate delta-T for this scenario (TS).',
    ),
    corrosionRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.corrosionRisk?.describe(
      'Corrosion risk level for this scenario (TS).',
    ),
    waxRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.waxRisk?.describe(
      'Wax risk level for this scenario (TS).',
    ),
    asphalteneRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.asphalteneRisk?.describe(
      'Asphaltene risk level for this scenario (TS).',
    ),
    evrRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.evrRisk?.describe(
      'Erosion velocity risk level for this scenario (TS).',
    ),
    erosionRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.erosionRisk?.describe(
      'Erosion risk level for this scenario (TS).',
    ),
    scaleSIRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.scaleSIRisk?.describe(
      'Scale risk level for this scenario (TS).',
    ),
    hydrateRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.hydrateRisk?.describe(
      'Hydrate risk level for this scenario (TS).',
    ),
    aggregatedRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.aggregatedRisk?.describe(
      'Overall aggregated risk level for this scenario (TS).',
    ),
    scenarioName: NetworkRiskOptimizationScenariosAgentSchema.shape.scenarioName?.describe(
      'Name of the optimization scenario.',
    ),
    runID: NetworkRiskOptimizationScenariosAgentSchema.shape.runID?.describe(
      'Unique identifier for this optimization run.',
    ),
    pe5StabilityMax: NetworkRiskOptimizationScenariosAgentSchema.shape.pe5StabilityMax?.describe(
      'Maximum PE5 stability for this scenario (TS).',
    ),
    pe5StabilityRisk: NetworkRiskOptimizationScenariosAgentSchema.shape.pe5StabilityRisk?.describe(
      'PE5 stability risk level for this scenario (TS).',
    ),
  })?.describe(
    'Per-scenario network risk and mitigation comparison (WF11/WF20).\n\nRisk scores and mitigation recommendations for each optimization scenario,\nincluding asphaltene, wax, and hydrate risk assessments, evaluated against a\ncurrent-state baseline. Use to compare candidate optimization strategies,\nidentify the most critical risks, and prioritize mitigation actions. For\ncurrent-state risk see NetworkRisk_Agent. Excludes raw operational data and\nhistorical trends.\n\nUse for: Production Optimization Scenarios (WF11), Flow Assurance Detection and Mitigation (WF20).\n\n@name Network Risk - Optimization Scenarios (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const NetworkRiskOptimizationScenariosView = parseView({
  view: { externalId: 'NetworkRisk_OptimizationScenarios' },
  model: NetworkRiskOptimizationScenariosSchema.extend({
    ...InstanceIdType.shape,
    entityName: NetworkRiskOptimizationScenariosSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    network: NetworkRiskOptimizationScenariosSchema.shape.network?.describe(
      'Network attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    corrosionRateMax: NetworkRiskOptimizationScenariosSchema.shape.corrosionRateMax?.describe(
      'Time series signal representing corrosion rate max for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waxDTMax: NetworkRiskOptimizationScenariosSchema.shape.waxDTMax?.describe(
      'Time series signal representing wax dtmax for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    asphalteneDTMax: NetworkRiskOptimizationScenariosSchema.shape.asphalteneDTMax?.describe(
      'Time series signal representing asphaltene dtmax for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    evrMax: NetworkRiskOptimizationScenariosSchema.shape.evrMax?.describe(
      'Time series signal representing evr max for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    erosionMax: NetworkRiskOptimizationScenariosSchema.shape.erosionMax?.describe(
      'Time series signal representing erosion max for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    scaleSIMax: NetworkRiskOptimizationScenariosSchema.shape.scaleSIMax?.describe(
      'Time series signal representing scale simax for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    hydrateDTMax: NetworkRiskOptimizationScenariosSchema.shape.hydrateDTMax?.describe(
      'Time series signal representing hydrate dtmax for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    corrosionRisk: NetworkRiskOptimizationScenariosSchema.shape.corrosionRisk?.describe(
      'Time series signal representing corrosion risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waxRisk: NetworkRiskOptimizationScenariosSchema.shape.waxRisk?.describe(
      'Time series signal representing wax risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    asphalteneRisk: NetworkRiskOptimizationScenariosSchema.shape.asphalteneRisk?.describe(
      'Time series signal representing asphaltene risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    evrRisk: NetworkRiskOptimizationScenariosSchema.shape.evrRisk?.describe(
      'Time series signal representing evr risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    erosionRisk: NetworkRiskOptimizationScenariosSchema.shape.erosionRisk?.describe(
      'Time series signal representing erosion risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    scaleSIRisk: NetworkRiskOptimizationScenariosSchema.shape.scaleSIRisk?.describe(
      'Time series signal representing scale sirisk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    hydrateRisk: NetworkRiskOptimizationScenariosSchema.shape.hydrateRisk?.describe(
      'Time series signal representing hydrate risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    aggregatedRisk: NetworkRiskOptimizationScenariosSchema.shape.aggregatedRisk?.describe(
      'Time series signal representing aggregated risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    scenarioName: NetworkRiskOptimizationScenariosSchema.shape.scenarioName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    runID: NetworkRiskOptimizationScenariosSchema.shape.runID?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    pe5StabilityMax: NetworkRiskOptimizationScenariosSchema.shape.pe5StabilityMax?.describe(
      'Time series signal representing pe5 stability max for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pe5StabilityRisk: NetworkRiskOptimizationScenariosSchema.shape.pe5StabilityRisk?.describe(
      'Time series signal representing pe5 stability risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Network Risk Optimization Scenarios view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const NetworkView = parseView({
  view: { externalId: 'Network' },
  model: NetworkSchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const OpportunityAgentView = parseView({
  view: { externalId: 'Opportunity_Agent' },
  model: OpportunityAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: OpportunityAgentSchema.shape.wellString?.describe('Reference to well string'),
    summary: OpportunityAgentSchema.shape.summary?.describe('Brief summary of the production opportunity'),
    description: OpportunityAgentSchema.shape.description?.describe(
      'Detailed description of the opportunity, including technical rationale.',
    ),
    type: OpportunityAgentSchema.shape.type?.describe(
      'Type of opportunity (e.g., CHOKE_ADJUSTMENT, RECOMPLETION, GAS_LIFT_OPT).',
    ),
    source: OpportunityAgentSchema.shape.source?.describe(
      'Origin of opportunity identification (e.g., SURVEILLANCE, WORKFLOW, MANUAL).',
    ),
    status: OpportunityAgentSchema.shape.status?.describe(
      'Current opportunity status: OPEN, VALIDATED, PLANNED, EXECUTED, CLOSED.\nUse to track lifecycle progress.',
    ),
    wellName: OpportunityAgentSchema.shape.wellName?.describe('Name of the well this opportunity applies to'),
    wellType: OpportunityAgentSchema.shape.wellType?.describe('Well type classification (PRODUCER, INJECTOR, etc.).'),
    baselineOilRate: OpportunityAgentSchema.shape.baselineOilRate?.describe(
      'Current oil production rate before intervention (stb/d)',
    ),
    estimatedOilRate: OpportunityAgentSchema.shape.estimatedOilRate?.describe(
      'Predicted oil rate after intervention (stb/d)',
    ),
    baselineWaterRate: OpportunityAgentSchema.shape.baselineWaterRate?.describe(
      'Current water production rate before intervention (stb/d).',
    ),
    estimatedWaterRate: OpportunityAgentSchema.shape.estimatedWaterRate?.describe(
      'Predicted water rate after intervention (stb/d).',
    ),
    baselineGasRate: OpportunityAgentSchema.shape.baselineGasRate?.describe(
      'Current gas production rate before intervention (Mscf/d).',
    ),
    estimatedGasRate: OpportunityAgentSchema.shape.estimatedGasRate?.describe(
      'Predicted gas rate after intervention (Mscf/d).',
    ),
    plannedExecutionDate: OpportunityAgentSchema.shape.plannedExecutionDate?.describe(
      'Scheduled date for intervention execution.',
    ),
    actualExecutionDate: OpportunityAgentSchema.shape.actualExecutionDate?.describe(
      'Actual date when intervention was executed.',
    ),
    cumulativeOilGain: OpportunityAgentSchema.shape.cumulativeOilGain?.describe(
      'Cumulative oil production gained since execution (stb)',
    ),
    valueTrackingStatus: OpportunityAgentSchema.shape.valueTrackingStatus?.describe(
      'Status of value tracking: ACTIVE, COMPLETED, NOT_STARTED.',
    ),
    valueTrackingEndDate: OpportunityAgentSchema.shape.valueTrackingEndDate?.describe(
      'Date when value tracking ended for this opportunity.',
    ),
    valueTrackingEndReason: OpportunityAgentSchema.shape.valueTrackingEndReason?.describe(
      'Reason for ending value tracking (e.g., RATE_DECLINE, NEW_INTERVENTION).',
    ),
    validationStatus: OpportunityAgentSchema.shape.validationStatus?.describe(
      'Validation status: PENDING, VALIDATED, REJECTED',
    ),
    validationComments: OpportunityAgentSchema.shape.validationComments?.describe(
      'Comments from validation review, including technical justification.',
    ),
    owner: OpportunityAgentSchema.shape.owner?.describe(
      'Person responsible for driving this opportunity to execution.',
    ),
    createdDate: OpportunityAgentSchema.shape.createdDate?.describe(
      'Date when opportunity was identified and created.',
    ),
    interventionActivity: OpportunityAgentSchema.shape.interventionActivity?.describe(
      'Type of intervention required (e.g., WORKOVER, CHOKE_CHANGE, STIMULATION).',
    ),
    ticketExternalID: OpportunityAgentSchema.shape.ticketExternalID?.describe(
      'Link to associated ticket in TicketRegistry',
    ),
  })?.describe(
    'Production optimization opportunities tracking potential gains from well\ninterventions.\n\nContains data related to production optimization opportunities tracking\npotential gains from well interventions. This view aggregates information from\noperational databases and historical performance metrics, to analyze the\neffectiveness of various well interventions. It answers analytical questions\nsuch as the potential oil gain from specific opportunities, the status of open\nor closed interventions, and the validation status of pending opportunities.\nExcludes detailed financial metrics or external market conditions (see other\nrelated views focused on economic analysis).',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const OptimizedRatesNetworkStringAgentView = parseView({
  view: { externalId: 'OptimizedRates_Network_String_Agent' },
  model: OptimizedRatesNetworkStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: OptimizedRatesNetworkStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    systemOptimizedOilRate: OptimizedRatesNetworkStringAgentSchema.shape.systemOptimizedOilRate?.describe(
      'System-optimized oil rate (stb/d, TS)',
    ),
    systemOptimizedGasRate: OptimizedRatesNetworkStringAgentSchema.shape.systemOptimizedGasRate?.describe(
      'System-optimized gas rate (MSCF/d, TS).',
    ),
    systemOptimizedWaterRate: OptimizedRatesNetworkStringAgentSchema.shape.systemOptimizedWaterRate?.describe(
      'System-optimized water rate (stb/d, TS).',
    ),
    systemOptimizedGasLiftRate: OptimizedRatesNetworkStringAgentSchema.shape.systemOptimizedGasLiftRate?.describe(
      'Optimized gas lift injection rate (MSCF/d, TS).',
    ),
    technicalOilRate: OptimizedRatesNetworkStringAgentSchema.shape.technicalOilRate?.describe(
      'Technical operating point oil rate (stb/d, TS).',
    ),
    technicalWaterRate: OptimizedRatesNetworkStringAgentSchema.shape.technicalWaterRate?.describe(
      'Technical operating point water rate (stb/d, TS).',
    ),
    technicalGasRate: OptimizedRatesNetworkStringAgentSchema.shape.technicalGasRate?.describe(
      'Technical operating point gas rate (MSCF/d, TS).',
    ),
    hydraulicOilRate: OptimizedRatesNetworkStringAgentSchema.shape.hydraulicOilRate?.describe(
      'Hydraulic operating point oil rate (stb/d, TS).',
    ),
    hydraulicWaterRate: OptimizedRatesNetworkStringAgentSchema.shape.hydraulicWaterRate?.describe(
      'Hydraulic operating point water rate (stb/d, TS).',
    ),
    hydraulicGasRate: OptimizedRatesNetworkStringAgentSchema.shape.hydraulicGasRate?.describe(
      'Hydraulic operating point gas rate (MSCF/d, TS).',
    ),
    fsoprOilRate: OptimizedRatesNetworkStringAgentSchema.shape.fsoprOilRate?.describe(
      'FSOPR operating point oil rate (stb/d, TS).',
    ),
    fsoprWaterRate: OptimizedRatesNetworkStringAgentSchema.shape.fsoprWaterRate?.describe(
      'FSOPR operating point water rate (stb/d, TS).',
    ),
    fsoprGasRate: OptimizedRatesNetworkStringAgentSchema.shape.fsoprGasRate?.describe(
      'FSOPR operating point gas rate (MSCF/d, TS).',
    ),
    adHocOptimization1OilRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocOptimization1OilRate?.describe(
      'Ad-hoc optimization scenario 1 oil rate (stb/d, TS).',
    ),
    adHocOptimization1WaterRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocOptimization1WaterRate?.describe(
      'Ad-hoc optimization scenario 1 water rate (stb/d, TS).',
    ),
    adHocOptimization1GasRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocOptimization1GasRate?.describe(
      'Ad-hoc optimization scenario 1 gas rate (MSCF/d, TS).',
    ),
    adHocOptimization2OilRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocOptimization2OilRate?.describe(
      'Ad-hoc optimization scenario 2 oil rate (stb/d, TS).',
    ),
    adHocOptimization2WaterRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocOptimization2WaterRate?.describe(
      'Ad-hoc optimization scenario 2 water rate (stb/d, TS).',
    ),
    adHocOptimization2GasRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocOptimization2GasRate?.describe(
      'Ad-hoc optimization scenario 2 gas rate (MSCF/d, TS).',
    ),
    adHocSimulation1OilRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocSimulation1OilRate?.describe(
      'Ad-hoc simulation scenario 1 oil rate (stb/d, TS).',
    ),
    adHocSimulation1WaterRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocSimulation1WaterRate?.describe(
      'Ad-hoc simulation scenario 1 water rate (stb/d, TS).',
    ),
    adHocSimulation1GasRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocSimulation1GasRate?.describe(
      'Ad-hoc simulation scenario 1 gas rate (MSCF/d, TS).',
    ),
    adHocSimulation2OilRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocSimulation2OilRate?.describe(
      'Ad-hoc simulation scenario 2 oil rate (stb/d, TS).',
    ),
    adHocSimulation2GasRate: OptimizedRatesNetworkStringAgentSchema.shape.adHocSimulation2GasRate?.describe(
      'Ad-hoc simulation scenario 2 gas rate (MSCF/d, TS).',
    ),
  })?.describe(
    'Optimization scenario rates per well string from WF7 GAP network (WF7/WF11).\n\nPer-string oil/gas/water rates under each optimization scenario (technical,\nhydraulic, custom) produced by the GAP network optimizer. Use to compare\nscenario outcomes against the current-state baseline and quantify uplift.\nFor current-state rates see NetworkRates_String_Agent; for the richer\nper-network matched snapshot see StringOutputs_Network_Agent. Excludes\nhistorical production data.\n\nUse for: Network Surveillance (WF7), Production Optimization Scenarios (WF11).\n\n@name Optimized Rates - Network Scenarios (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const OptimizedRatesSrmStringAgentView = parseView({
  view: { externalId: 'OptimizedRates_SRM_String_Agent' },
  model: OptimizedRatesSrmStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: OptimizedRatesSrmStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    scenario: OptimizedRatesSrmStringAgentSchema.shape.scenario?.describe('Optimization scenario name/identifier (TS)'),
    executionDate: OptimizedRatesSrmStringAgentSchema.shape.executionDate?.describe(
      'When this optimization scenario was executed (TS).',
    ),
    isOfficial: OptimizedRatesSrmStringAgentSchema.shape.isOfficial?.describe(
      'Whether this is the official approved scenario (boolean flag).\n1 = approved for execution, 0 = exploratory/what-if scenario.',
    ),
    optimizedOilRateSRM: OptimizedRatesSrmStringAgentSchema.shape.optimizedOilRateSRM?.describe(
      'SRM-optimized oil production rate (stb/d, TS)',
    ),
    optimizeGasRateSRM: OptimizedRatesSrmStringAgentSchema.shape.optimizeGasRateSRM?.describe(
      'SRM-optimized gas production rate (MSCF/d, TS).',
    ),
    optimizeWaterRateSRM: OptimizedRatesSrmStringAgentSchema.shape.optimizeWaterRateSRM?.describe(
      'SRM-optimized water production rate (stb/d, TS).',
    ),
    optimizedWaterInjRateSRM: OptimizedRatesSrmStringAgentSchema.shape.optimizedWaterInjRateSRM?.describe(
      'SRM-optimized water injection rate (stb/d, TS)',
    ),
    optimizedGasInjRateSRM: OptimizedRatesSrmStringAgentSchema.shape.optimizedGasInjRateSRM?.describe(
      'SRM-optimized gas injection rate (MSCF/d, TS)',
    ),
    optimizedOilRateGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedOilRateGAP?.describe(
      'GAP network-optimized oil production rate (stb/d, TS)',
    ),
    optimizedGasRateGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedGasRateGAP?.describe(
      'GAP network-optimized gas production rate (MSCF/d, TS).',
    ),
    optimizedWaterRateGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedWaterRateGAP?.describe(
      'GAP network-optimized water production rate (stb/d, TS).',
    ),
    optimizedWaterInjRateGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedWaterInjRateGAP?.describe(
      'GAP network-optimized water injection rate (stb/d, TS).',
    ),
    optimizedGasInjRateGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedGasInjRateGAP?.describe(
      'GAP network-optimized gas injection rate (MSCF/d, TS).',
    ),
    optimizedChokeSizeGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedChokeSizeGAP?.describe(
      'GAP-optimized choke size setting (TS)',
    ),
    optimizedGasLiftRateGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedGasLiftRateGAP?.describe(
      'GAP-optimized gas lift injection rate (MSCF/d, TS)',
    ),
    optimizedESPFrequencyGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedESPFrequencyGAP?.describe(
      'GAP-optimized ESP pump frequency (Hz, TS)',
    ),
    optimizedBHFPGAP: OptimizedRatesSrmStringAgentSchema.shape.optimizedBHFPGAP?.describe(
      'GAP-optimized bottomhole flowing pressure (psia, TS)',
    ),
    optimizedWHP: OptimizedRatesSrmStringAgentSchema.shape.optimizedWHP?.describe(
      'Optimized wellhead pressure (psia, TS).',
    ),
    optimizedProdRateResCond: OptimizedRatesSrmStringAgentSchema.shape.optimizedProdRateResCond?.describe(
      'Optimized production rate at reservoir conditions (rb/d, TS).\nUsed for VRR calculation at reservoir conditions.',
    ),
    optimizedInjRateResCond: OptimizedRatesSrmStringAgentSchema.shape.optimizedInjRateResCond?.describe(
      'Optimized injection rate at reservoir conditions (rb/d, TS).\nUsed for VRR calculation at reservoir conditions.',
    ),
  })?.describe(
    'SRM/GAP optimization results per well string (WF17).\n\nOptimized rates and setpoints from Sector Reservoir Model and GAP; well-string\nperformance across optimization scenarios. Use for optimal production rates and gas lift optimization potential.\n\nUse for: VRR Optimization (WF17).\n\n@name Optimized Rates - SRM (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const PriorityRatesStringAgentView = parseView({
  view: { externalId: 'PriorityRates_String_Agent' },
  model: PriorityRatesStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: PriorityRatesStringAgentSchema.shape.wellString?.describe('Well string identifier'),
    priorityMethod: PriorityRatesStringAgentSchema.shape.priorityMethod?.describe(
      'Analysis method that produced the priority rates',
    ),
    priorityOilRateStd: PriorityRatesStringAgentSchema.shape.priorityOilRateStd?.describe(
      'Best-available estimated oil rate (stb/d, TS).',
    ),
    priorityGasRateStd: PriorityRatesStringAgentSchema.shape.priorityGasRateStd?.describe(
      'Best-available estimated gas rate (MSCF/d, TS).',
    ),
    priorityWaterRateStd: PriorityRatesStringAgentSchema.shape.priorityWaterRateStd?.describe(
      'Best-available estimated water rate (stb/d, TS).',
    ),
    priorityLiquidRateStd: PriorityRatesStringAgentSchema.shape.priorityLiquidRateStd?.describe(
      'Best-available estimated total liquid rate, oil + water (stb/d, TS).',
    ),
    priorityFbhp: PriorityRatesStringAgentSchema.shape.priorityFbhp?.describe(
      'Best-available flowing bottom-hole pressure (psi, TS).',
    ),
  })?.describe(
    'Best-available rate and pressure estimates per well string â€” default for simple rate lookups.\n\nPriority (best-available) oil, gas, water, liquid rates, flowing BHP, and\nsource method. Use for "what is the current rate for well X?" or "show\nproduction figures for field X". For method-comparison use EstimatedRates_String_Agent.\n\nUse for: Real-Time Well Rate and Pressure Estimation (WF10).\n\n@name Priority Rates - Best Available Estimates (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ProdplanStringReservoirSectorView = parseView({
  view: { externalId: 'Prodplan_String_Reservoir_Sector' },
  model: ProdplanStringReservoirSectorSchema.extend({
    ...InstanceIdType.shape,
    entityName: ProdplanStringReservoirSectorSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    reservoirName: ProdplanStringReservoirSectorSchema.shape.reservoirName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    sectorName: ProdplanStringReservoirSectorSchema.shape.sectorName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    giTechnicalRate: ProdplanStringReservoirSectorSchema.shape.giTechnicalRate?.describe(
      'Time series signal representing gi technical rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giAllowableRate: ProdplanStringReservoirSectorSchema.shape.giAllowableRate?.describe(
      'Time series signal representing gi allowable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giSustainableRate: ProdplanStringReservoirSectorSchema.shape.giSustainableRate?.describe(
      'Time series signal representing gi sustainable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giSubmittedMonth: ProdplanStringReservoirSectorSchema.shape.giSubmittedMonth?.describe(
      'Time series signal representing gi submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWprIntegrity: ProdplanStringReservoirSectorSchema.shape.opWprIntegrity?.describe(
      'Time series signal representing op wpr integrity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWprFlowAssurance: ProdplanStringReservoirSectorSchema.shape.opWprFlowAssurance?.describe(
      'Time series signal representing op wpr flow assurance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWprManPress: ProdplanStringReservoirSectorSchema.shape.opWprManPress?.describe(
      'Time series signal representing op wpr man press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWpr: ProdplanStringReservoirSectorSchema.shape.opWpr?.describe(
      'Time series signal representing op wpr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWtr: ProdplanStringReservoirSectorSchema.shape.opWtr?.describe(
      'Time series signal representing op wtr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWarVrr: ProdplanStringReservoirSectorSchema.shape.opWarVrr?.describe(
      'Time series signal representing op war vrr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWar: ProdplanStringReservoirSectorSchema.shape.opWar?.describe(
      'Time series signal representing op war for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opVrrAdjustment: ProdplanStringReservoirSectorSchema.shape.opVrrAdjustment?.describe(
      'Time series signal representing op vrr adjustment for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWsopr: ProdplanStringReservoirSectorSchema.shape.opWsopr?.describe(
      'Time series signal representing op wsopr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opRs: ProdplanStringReservoirSectorSchema.shape.opRs?.describe(
      'Time series signal representing op rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opBo: ProdplanStringReservoirSectorSchema.shape.opBo?.describe(
      'Time series signal representing op bo for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opBg: ProdplanStringReservoirSectorSchema.shape.opBg?.describe(
      'Time series signal representing op bg for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opBw: ProdplanStringReservoirSectorSchema.shape.opBw?.describe(
      'Time series signal representing op bw for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opSubmittedMonth: ProdplanStringReservoirSectorSchema.shape.opSubmittedMonth?.describe(
      'Time series signal representing op submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiTechnicalRate: ProdplanStringReservoirSectorSchema.shape.wiTechnicalRate?.describe(
      'Time series signal representing wi technical rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiAllowableRate: ProdplanStringReservoirSectorSchema.shape.wiAllowableRate?.describe(
      'Time series signal representing wi allowable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiSustainableRate: ProdplanStringReservoirSectorSchema.shape.wiSustainableRate?.describe(
      'Time series signal representing wi sustainable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiSubmittedMonth: ProdplanStringReservoirSectorSchema.shape.wiSubmittedMonth?.describe(
      'Time series signal representing wi submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    quotaContr: ProdplanStringReservoirSectorSchema.shape.quotaContr?.describe(
      'Time series signal representing quota contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fmoprContr: ProdplanStringReservoirSectorSchema.shape.fmoprContr?.describe(
      'Time series signal representing fmopr contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wsoprTotalGas: ProdplanStringReservoirSectorSchema.shape.wsoprTotalGas?.describe(
      'Time series signal representing wsopr total gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fmoprWater: ProdplanStringReservoirSectorSchema.shape.fmoprWater?.describe(
      'Time series signal representing fmopr water for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiWellAvailability: ProdplanStringReservoirSectorSchema.shape.wiWellAvailability?.describe(
      'Time series signal representing wi well availability for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiAvailableContr: ProdplanStringReservoirSectorSchema.shape.wiAvailableContr?.describe(
      'Time series signal representing wi available contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiSustainableContr: ProdplanStringReservoirSectorSchema.shape.wiSustainableContr?.describe(
      'Time series signal representing wi sustainable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiAllowableContr: ProdplanStringReservoirSectorSchema.shape.wiAllowableContr?.describe(
      'Time series signal representing wi allowable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giWellAvailability: ProdplanStringReservoirSectorSchema.shape.giWellAvailability?.describe(
      'Time series signal representing gi well availability for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giAvailableContr: ProdplanStringReservoirSectorSchema.shape.giAvailableContr?.describe(
      'Time series signal representing gi available contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giSustainableContr: ProdplanStringReservoirSectorSchema.shape.giSustainableContr?.describe(
      'Time series signal representing gi sustainable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giAllowableContr: ProdplanStringReservoirSectorSchema.shape.giAllowableContr?.describe(
      'Time series signal representing gi allowable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Production planning assumptions, constraints, and targets over time at the relevant aggregation level, used to compare actual performance versus plan and to steer optimization scenarios.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const ProdplanStringView = parseView({
  view: { externalId: 'Prodplan_String' },
  model: ProdplanStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: ProdplanStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    giTechnicalRate: ProdplanStringSchema.shape.giTechnicalRate?.describe(
      'Time series signal representing gi technical rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giAllowableRate: ProdplanStringSchema.shape.giAllowableRate?.describe(
      'Time series signal representing gi allowable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giSustainableRate: ProdplanStringSchema.shape.giSustainableRate?.describe(
      'Time series signal representing gi sustainable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giSubmittedMonth: ProdplanStringSchema.shape.giSubmittedMonth?.describe(
      'Time series signal representing gi submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWprIntegrity: ProdplanStringSchema.shape.opWprIntegrity?.describe(
      'Time series signal representing op wpr integrity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWprFlowAssurance: ProdplanStringSchema.shape.opWprFlowAssurance?.describe(
      'Time series signal representing op wpr flow assurance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWprManPress: ProdplanStringSchema.shape.opWprManPress?.describe(
      'Time series signal representing op wpr man press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWpr: ProdplanStringSchema.shape.opWpr?.describe(
      'Time series signal representing op wpr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWtr: ProdplanStringSchema.shape.opWtr?.describe(
      'Time series signal representing op wtr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWarVrr: ProdplanStringSchema.shape.opWarVrr?.describe(
      'Time series signal representing op war vrr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWar: ProdplanStringSchema.shape.opWar?.describe(
      'Time series signal representing op war for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opVrrAdjustment: ProdplanStringSchema.shape.opVrrAdjustment?.describe(
      'Time series signal representing op vrr adjustment for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opWsopr: ProdplanStringSchema.shape.opWsopr?.describe(
      'Time series signal representing op wsopr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opRs: ProdplanStringSchema.shape.opRs?.describe(
      'Time series signal representing op rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opBo: ProdplanStringSchema.shape.opBo?.describe(
      'Time series signal representing op bo for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opBg: ProdplanStringSchema.shape.opBg?.describe(
      'Time series signal representing op bg for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opBw: ProdplanStringSchema.shape.opBw?.describe(
      'Time series signal representing op bw for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    opSubmittedMonth: ProdplanStringSchema.shape.opSubmittedMonth?.describe(
      'Time series signal representing op submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiTechnicalRate: ProdplanStringSchema.shape.wiTechnicalRate?.describe(
      'Time series signal representing wi technical rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiAllowableRate: ProdplanStringSchema.shape.wiAllowableRate?.describe(
      'Time series signal representing wi allowable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiSustainableRate: ProdplanStringSchema.shape.wiSustainableRate?.describe(
      'Time series signal representing wi sustainable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiSubmittedMonth: ProdplanStringSchema.shape.wiSubmittedMonth?.describe(
      'Time series signal representing wi submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    quotaContr: ProdplanStringSchema.shape.quotaContr?.describe(
      'Time series signal representing quota contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fmoprContr: ProdplanStringSchema.shape.fmoprContr?.describe(
      'Time series signal representing fmopr contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wsoprTotalGas: ProdplanStringSchema.shape.wsoprTotalGas?.describe(
      'Time series signal representing wsopr total gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fmoprWater: ProdplanStringSchema.shape.fmoprWater?.describe(
      'Time series signal representing fmopr water for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiWellAvailability: ProdplanStringSchema.shape.wiWellAvailability?.describe(
      'Time series signal representing wi well availability for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiAvailableContr: ProdplanStringSchema.shape.wiAvailableContr?.describe(
      'Time series signal representing wi available contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiSustainableContr: ProdplanStringSchema.shape.wiSustainableContr?.describe(
      'Time series signal representing wi sustainable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiAllowableContr: ProdplanStringSchema.shape.wiAllowableContr?.describe(
      'Time series signal representing wi allowable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giWellAvailability: ProdplanStringSchema.shape.giWellAvailability?.describe(
      'Time series signal representing gi well availability for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giAvailableContr: ProdplanStringSchema.shape.giAvailableContr?.describe(
      'Time series signal representing gi available contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giSustainableContr: ProdplanStringSchema.shape.giSustainableContr?.describe(
      'Time series signal representing gi sustainable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giAllowableContr: ProdplanStringSchema.shape.giAllowableContr?.describe(
      'Time series signal representing gi allowable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Production planning assumptions, constraints, and targets over time at the relevant aggregation level, used to compare actual performance versus plan and to steer optimization scenarios.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const ProducerGuidelinesStringAgentView = parseView({
  view: { externalId: 'ProducerGuidelines_String_Agent' },
  model: ProducerGuidelinesStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: ProducerGuidelinesStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    maxGOR: ProducerGuidelinesStringAgentSchema.shape.maxGOR?.describe(
      'Maximum allowed Gas-Oil Ratio (scf/stb) from reservoir management guidelines.\nWells with GOR above this limit are violating guidelines and may need\nchoke adjustment or investigation.',
    ),
    minBHP: ProducerGuidelinesStringAgentSchema.shape.minBHP?.describe(
      'Minimum allowed Bottomhole Pressure (psia) from reservoir management guidelines.\nProduction wells operating below this BHP may be causing reservoir damage\nor excessive drawdown.',
    ),
    maxLiquidRate: ProducerGuidelinesStringAgentSchema.shape.maxLiquidRate?.describe(
      'Maximum allowed liquid production rate (stb/d) from reservoir management\nguidelines',
    ),
    maxOilRate: ProducerGuidelinesStringAgentSchema.shape.maxOilRate?.describe(
      'Maximum allowed oil production rate (stb/d) from reservoir management\nguidelines',
    ),
    minWHP: ProducerGuidelinesStringAgentSchema.shape.minWHP?.describe(
      'Minimum allowed Wellhead Pressure (psia) from reservoir management\nguidelines',
    ),
  })?.describe(
    'Reservoir management guidelines and operating limits for production strings (WF6).\n\nMax GOR, min BHP/WHP, max liquid/oil rates per string. Use to assess adherence\nto guidelines, identify wells outside limits, and flag reservoir damage risk.\nExcludes historical performance or detailed rates (see other views).\n\nUse for: Well Operating Envelope (WF6).',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ProductionAllocationAlarmsAgentView = parseView({
  view: { externalId: 'ProductionAllocationAlarms_Agent' },
  model: ProductionAllocationAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: ProductionAllocationAlarmsAgentSchema.shape.wellString?.describe('Reference to well string'),
    subCategory: ProductionAllocationAlarmsAgentSchema.shape.subCategory?.describe(
      'Alarm sub-category for domain filtering.',
    ),
    subWorkflowName: ProductionAllocationAlarmsAgentSchema.shape.subWorkflowName?.describe(
      'Sub-workflow that generated the alarm.',
    ),
    alarmCounter: ProductionAllocationAlarmsAgentSchema.shape.alarmCounter?.describe(
      'Number of consecutive occurrences of this alarm.',
    ),
    ticketId: ProductionAllocationAlarmsAgentSchema.shape.ticketId?.describe(
      'Associated ticket/action ID if alarm has been acknowledged.',
    ),
  })?.describe(
    'Production allocation alarms with medium or high priority.\n\nContains production allocation alarms, medium or high priority, derived from\nworkflows WF5 and WF13. Sourced from operational monitoring systems that track\nalarm events, allowing users to analyze alarm occurrences, their severity, and\nassociated workflows. It can answer questions regarding the frequency and\ntypes of alarms and impact on allocation. Excludes low-priority or non-WF5/WF13 alarms.\n\nUse for: Production Allocation (WF5), Gas Lift Estimation (WF13), Real-Time Surveillance (WF18).\n\n@name Production Allocation Alarms (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ProsperModelAgentView = parseView({
  view: { externalId: 'ProsperModel_Agent' },
  model: ProsperModelAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: ProsperModelAgentSchema.shape.wellString?.describe('Reference to wellString'),
    string_name: ProsperModelAgentSchema.shape.string_name?.describe('String name for display (e.g., LI001-L).'),
    field: ProsperModelAgentSchema.shape.field?.describe('Reference to Field'),
    modelStatus: ProsperModelAgentSchema.shape.modelStatus?.describe('Overall model status'),
    wf3ModelMatchedStatus: ProsperModelAgentSchema.shape.wf3ModelMatchedStatus?.describe('WF3 auto-calibration status'),
    wf2ModelMatchedStatus: ProsperModelAgentSchema.shape.wf2ModelMatchedStatus?.describe(
      'WF2 model matching status for rate estimation workflow.',
    ),
    reservoirPressure: ProsperModelAgentSchema.shape.reservoirPressure?.describe(
      'Reservoir pressure used in Prosper model (psi)',
    ),
    pi: ProsperModelAgentSchema.shape.pi?.describe('Productivity index from Prosper model (stb/d/psi).'),
    liftMethod: ProsperModelAgentSchema.shape.liftMethod?.describe('Artificial lift method'),
    vlpModel: ProsperModelAgentSchema.shape.vlpModel?.describe(
      'VLP correlation used (e.g., Beggs and Brill, Hagedorn Brown).',
    ),
    iprModel: ProsperModelAgentSchema.shape.iprModel?.describe('IPR model type (e.g., Vogel, Fetkovitch, Jones).'),
    modelUploadedTime: ProsperModelAgentSchema.shape.modelUploadedTime?.describe(
      'When the Prosper model file was uploaded to iPSO.',
    ),
    modelUpdatedTime: ProsperModelAgentSchema.shape.modelUpdatedTime?.describe(
      'When the model was last updated/recalibrated.',
    ),
    modelEffectiveTime: ProsperModelAgentSchema.shape.modelEffectiveTime?.describe(
      'When the model became the active/effective model for the string.',
    ),
    minStableRate: ProsperModelAgentSchema.shape.minStableRate?.describe(
      'Minimum stable flow rate from model (stb/d).',
    ),
    wearFactor: ProsperModelAgentSchema.shape.wearFactor?.describe('ESP wear factor (0-1)'),
    espPumpModel: ProsperModelAgentSchema.shape.espPumpModel?.describe(
      'ESP pump model/type from the Prosper model (e.g., manufacturer model code)',
    ),
    espCurrentMotor: ProsperModelAgentSchema.shape.espCurrentMotor?.describe(
      'Current motor identifier/model from the Prosper model (e.g., motor type or model code)',
    ),
    espCurrentCable: ProsperModelAgentSchema.shape.espCurrentCable?.describe(
      'Current cable identifier/type from the Prosper model (e.g., cable type or model code)',
    ),
  })?.describe(
    'Prosper well model repository with calibration status, version, and model\nmetadata.\n\nContains data on well models, including their calibration status, versioning,\nassociated metadata, and ESP equipment (pump model, current motor, current\ncable), sourced from the Prosper modeling system. This view is designed to\naddress analytical questions related to model availability, calibration\nsuccess, performance metrics, and equipment type across various wells, to\nassess the operational readiness of models in the field. Use cases: monitoring\nmodel compliance, identifying wells requiring immediate attention, evaluating\nthe overall health of the modeling infrastructure, and statistical summaries\nof efficiency or wear grouped by ESP type, pump model, motor, or cable.\n\n@name Prosper Model Status (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ProsperModelEventLogView = parseView({
  view: { externalId: 'ProsperModelEventLog' },
  model: ProsperModelEventLogSchema.extend({
    ...InstanceIdType.shape,
    prosperModel: ProsperModelEventLogSchema.shape.prosperModel?.describe(
      'Prosper Model attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelStatus: ProsperModelEventLogSchema.shape.modelStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    wf3ModelMatchedStatus: ProsperModelEventLogSchema.shape.wf3ModelMatchedStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    modelUpdatedTime: ProsperModelEventLogSchema.shape.modelUpdatedTime?.describe(
      'Attribute capturing model updated time for this entity in the production optimization context.',
    ),
    modelUpdatedBy: ProsperModelEventLogSchema.shape.modelUpdatedBy?.describe(
      'Model Updated By attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelAcceptedBy: ProsperModelEventLogSchema.shape.modelAcceptedBy?.describe(
      'Model Accepted By attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelAcceptedTime: ProsperModelEventLogSchema.shape.modelAcceptedTime?.describe(
      'Attribute capturing model accepted time for this entity in the production optimization context.',
    ),
  })?.describe(
    'Prosper Model Event Log view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const ProsperModelMetricsView = parseView({
  view: { externalId: 'ProsperModelMetrics' },
  model: ProsperModelMetricsSchema.extend({
    ...InstanceIdType.shape,
    entityName: ProsperModelMetricsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    field: ProsperModelMetricsSchema.shape.field?.describe(
      'Field attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelAvailability: ProsperModelMetricsSchema.shape.modelAvailability?.describe(
      'Time series signal representing model availability for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Prosper Model Metrics view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const ProsperModelView = parseView({
  view: { externalId: 'ProsperModel' },
  model: ProsperModelSchema.extend({
    ...InstanceIdType.shape,
    name: ProsperModelSchema.shape.name?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    description: ProsperModelSchema.shape.description?.describe(
      'Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting.',
    ),
    legacyFileExternalId: ProsperModelSchema.shape.legacyFileExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelUploadedBy: ProsperModelSchema.shape.modelUploadedBy?.describe(
      'Model Uploaded By attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelUploadedTime: ProsperModelSchema.shape.modelUploadedTime?.describe(
      'Attribute capturing model uploaded time for this entity in the production optimization context.',
    ),
    modelUpdatedBy: ProsperModelSchema.shape.modelUpdatedBy?.describe(
      'Model Updated By attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelUpdatedTime: ProsperModelSchema.shape.modelUpdatedTime?.describe(
      'Attribute capturing model updated time for this entity in the production optimization context.',
    ),
    modelEffectiveTime: ProsperModelSchema.shape.modelEffectiveTime?.describe(
      'Attribute capturing model effective time for this entity in the production optimization context.',
    ),
    modelAcceptedBy: ProsperModelSchema.shape.modelAcceptedBy?.describe(
      'Model Accepted By attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelAcceptedTime: ProsperModelSchema.shape.modelAcceptedTime?.describe(
      'Attribute capturing model accepted time for this entity in the production optimization context.',
    ),
    cCoefficient: ProsperModelSchema.shape.cCoefficient?.describe(
      'Numeric value storing c coefficient for this entity, used in calculations, reporting, or model configuration.',
    ),
    cCoefficientUnit: ProsperModelSchema.shape.cCoefficientUnit?.describe(
      'C Coefficient Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    calibrationWellTestRate: ProsperModelSchema.shape.calibrationWellTestRate?.describe(
      'Numeric value storing calibration well test rate for this entity, used in calculations, reporting, or model configuration.',
    ),
    calibrationWellTestTime: ProsperModelSchema.shape.calibrationWellTestTime?.describe(
      'Attribute capturing calibration well test time for this entity in the production optimization context.',
    ),
    executeStatus: ProsperModelSchema.shape.executeStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    fbhpAtMinStableRate: ProsperModelSchema.shape.fbhpAtMinStableRate?.describe(
      'Numeric value storing fbhp at min stable rate for this entity, used in calculations, reporting, or model configuration.',
    ),
    fluid: ProsperModelSchema.shape.fluid?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    iprModel: ProsperModelSchema.shape.iprModel?.describe(
      'Ipr Model attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    liftMethod: ProsperModelSchema.shape.liftMethod?.describe(
      'Numeric value storing lift method for this entity, used in calculations, reporting, or model configuration.',
    ),
    minStableRate: ProsperModelSchema.shape.minStableRate?.describe(
      'Numeric value storing min stable rate for this entity, used in calculations, reporting, or model configuration.',
    ),
    pE5Flag: ProsperModelSchema.shape.pE5Flag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    pi: ProsperModelSchema.shape.pi?.describe(
      'Numeric value storing pi for this entity, used in calculations, reporting, or model configuration.',
    ),
    piUnit: ProsperModelSchema.shape.piUnit?.describe(
      'Pi Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    pvt: ProsperModelSchema.shape.pvt?.describe(
      'Numeric value storing pvt for this entity, used in calculations, reporting, or model configuration.',
    ),
    pvtUnit: ProsperModelSchema.shape.pvtUnit?.describe(
      'Pvt Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    reservoirPressure: ProsperModelSchema.shape.reservoirPressure?.describe(
      'Numeric value storing reservoir pressure for this entity, used in calculations, reporting, or model configuration.',
    ),
    reservoirPressureUnit: ProsperModelSchema.shape.reservoirPressureUnit?.describe(
      'Reservoir Pressure Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    well: ProsperModelSchema.shape.well?.describe(
      'Well attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    rateDeviationPercentage: ProsperModelSchema.shape.rateDeviationPercentage?.describe(
      'Numeric value storing rate deviation percentage for this entity, used in calculations, reporting, or model configuration.',
    ),
    uVal: ProsperModelSchema.shape.uVal?.describe(
      'Numeric value storing u val for this entity, used in calculations, reporting, or model configuration.',
    ),
    uValUnit: ProsperModelSchema.shape.uValUnit?.describe(
      'U Val Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    vlpModel: ProsperModelSchema.shape.vlpModel?.describe(
      'Vlp Model attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    wearFactor: ProsperModelSchema.shape.wearFactor?.describe(
      'Numeric value storing wear factor for this entity, used in calculations, reporting, or model configuration.',
    ),
    wellType: ProsperModelSchema.shape.wellType?.describe(
      'Numeric value storing well type for this entity, used in calculations, reporting, or model configuration.',
    ),
    wf3EstimatedRate: ProsperModelSchema.shape.wf3EstimatedRate?.describe(
      'Numeric value storing wf3 estimated rate for this entity, used in calculations, reporting, or model configuration.',
    ),
    changeDetails: ProsperModelSchema.shape.changeDetails?.describe(
      'Change Details attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    espStages: ProsperModelSchema.shape.espStages?.describe(
      'Numeric value storing esp stages for this entity, used in calculations, reporting, or model configuration.',
    ),
    glInjectionDepth: ProsperModelSchema.shape.glInjectionDepth?.describe(
      'Numeric value storing gl injection depth for this entity, used in calculations, reporting, or model configuration.',
    ),
    glInjectionDepthUnit: ProsperModelSchema.shape.glInjectionDepthUnit?.describe(
      'Gl Injection Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    glOrificeSize: ProsperModelSchema.shape.glOrificeSize?.describe(
      'Numeric value storing gl orifice size for this entity, used in calculations, reporting, or model configuration.',
    ),
    glOrificeSizeUnit: ProsperModelSchema.shape.glOrificeSizeUnit?.describe(
      'Gl Orifice Size Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    modelStatus: ProsperModelSchema.shape.modelStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    flowExponent: ProsperModelSchema.shape.flowExponent?.describe(
      'Numeric value storing flow exponent for this entity, used in calculations, reporting, or model configuration.',
    ),
    originalProsperFileName: ProsperModelSchema.shape.originalProsperFileName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    string: ProsperModelSchema.shape.string?.describe(
      'String attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    wf3ModelMatchedStatus: ProsperModelSchema.shape.wf3ModelMatchedStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    simIntModelExternalId: ProsperModelSchema.shape.simIntModelExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionExternalId: ProsperModelSchema.shape.simIntModelRevisionExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    legacyFileId: ProsperModelSchema.shape.legacyFileId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    mimeType: ProsperModelSchema.shape.mimeType?.describe(
      'Mime Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    prosperWellName: ProsperModelSchema.shape.prosperWellName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    source: ProsperModelSchema.shape.source?.describe(
      'Source attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    sourceLocation: ProsperModelSchema.shape.sourceLocation?.describe(
      'Source Location attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    reservoir: ProsperModelSchema.shape.reservoir?.describe(
      'Attribute capturing reservoir for this entity in the production optimization context.',
    ),
    field: ProsperModelSchema.shape.field?.describe(
      'Field attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    wf2ModelMatchedStatus: ProsperModelSchema.shape.wf2ModelMatchedStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    wf2EstimatedRate: ProsperModelSchema.shape.wf2EstimatedRate?.describe(
      'Numeric value storing wf2 estimated rate for this entity, used in calculations, reporting, or model configuration.',
    ),
    wf2Processed: ProsperModelSchema.shape.wf2Processed?.describe(
      'Wf2 Processed attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    calibrationWellTestRateUnit: ProsperModelSchema.shape.calibrationWellTestRateUnit?.describe(
      'Calibration Well Test Rate Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    fbhpAtMinStableRateUnit: ProsperModelSchema.shape.fbhpAtMinStableRateUnit?.describe(
      'Fbhp At Min Stable Rate Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    minStableRateUnit: ProsperModelSchema.shape.minStableRateUnit?.describe(
      'Min Stable Rate Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    wf3EstimatedRateUnit: ProsperModelSchema.shape.wf3EstimatedRateUnit?.describe(
      'Wf3 Estimated Rate Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    fileSize: ProsperModelSchema.shape.fileSize?.describe(
      'Numeric value storing file size for this entity, used in calculations, reporting, or model configuration.',
    ),
    pendingModifications: ProsperModelSchema.shape.pendingModifications?.describe(
      'Attribute capturing pending modifications for this entity in the production optimization context.',
    ),
    string_name: ProsperModelSchema.shape.string_name?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    legacyDataSetId: ProsperModelSchema.shape.legacyDataSetId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionVersionId: ProsperModelSchema.shape.simIntModelRevisionVersionId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntExternalId: ProsperModelSchema.shape.simIntExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionId: ProsperModelSchema.shape.simIntModelRevisionId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionDescription: ProsperModelSchema.shape.simIntModelRevisionDescription?.describe(
      'Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting.',
    ),
    simIntModelRevisionStatus: ProsperModelSchema.shape.simIntModelRevisionStatus?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    simIntModelRevisionStatusMessage: ProsperModelSchema.shape.simIntModelRevisionStatusMessage?.describe(
      'Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    simIntModelRevisionLogId: ProsperModelSchema.shape.simIntModelRevisionLogId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    simIntModelRevisionCreatedTime: ProsperModelSchema.shape.simIntModelRevisionCreatedTime?.describe(
      'Attribute capturing sim int model revision created time for this entity in the production optimization context.',
    ),
    simIntModelRevisionUpdatedTime: ProsperModelSchema.shape.simIntModelRevisionUpdatedTime?.describe(
      'Attribute capturing sim int model revision updated time for this entity in the production optimization context.',
    ),
    reservoirTemperature: ProsperModelSchema.shape.reservoirTemperature?.describe(
      'Numeric value storing reservoir temperature for this entity, used in calculations, reporting, or model configuration.',
    ),
    reservoirTemperatureUnit: ProsperModelSchema.shape.reservoirTemperatureUnit?.describe(
      'Reservoir Temperature Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    platform: ProsperModelSchema.shape.platform?.describe(
      'Platform attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    maxMeasuredDepth: ProsperModelSchema.shape.maxMeasuredDepth?.describe(
      'Numeric value storing max measured depth for this entity, used in calculations, reporting, or model configuration.',
    ),
    maxMeasuredDepthUnit: ProsperModelSchema.shape.maxMeasuredDepthUnit?.describe(
      'Max Measured Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    maxTrueVerticalDepth: ProsperModelSchema.shape.maxTrueVerticalDepth?.describe(
      'Numeric value storing max true vertical depth for this entity, used in calculations, reporting, or model configuration.',
    ),
    maxTrueVerticalDepthUnit: ProsperModelSchema.shape.maxTrueVerticalDepthUnit?.describe(
      'Max True Vertical Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    topPerforationDepth: ProsperModelSchema.shape.topPerforationDepth?.describe(
      'Numeric value storing top perforation depth for this entity, used in calculations, reporting, or model configuration.',
    ),
    topPerforationDepthUnit: ProsperModelSchema.shape.topPerforationDepthUnit?.describe(
      'Top Perforation Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    bottomPerforationDepth: ProsperModelSchema.shape.bottomPerforationDepth?.describe(
      'Numeric value storing bottom perforation depth for this entity, used in calculations, reporting, or model configuration.',
    ),
    bottomPerforationDepthUnit: ProsperModelSchema.shape.bottomPerforationDepthUnit?.describe(
      'Bottom Perforation Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    bottomTubingId: ProsperModelSchema.shape.bottomTubingId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    bottomTubingIdUnit: ProsperModelSchema.shape.bottomTubingIdUnit?.describe(
      'Bottom Tubing Id Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    reservoirBubblePoint: ProsperModelSchema.shape.reservoirBubblePoint?.describe(
      'Numeric value storing reservoir bubble point for this entity, used in calculations, reporting, or model configuration.',
    ),
    reservoirBubblePointUnit: ProsperModelSchema.shape.reservoirBubblePointUnit?.describe(
      'Reservoir Bubble Point Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    espPumpDepth: ProsperModelSchema.shape.espPumpDepth?.describe(
      'Numeric value storing esp pump depth for this entity, used in calculations, reporting, or model configuration.',
    ),
    espPumpDepthUnit: ProsperModelSchema.shape.espPumpDepthUnit?.describe(
      'Esp Pump Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    glValveDepth: ProsperModelSchema.shape.glValveDepth?.describe(
      'Numeric value storing gl valve depth for this entity, used in calculations, reporting, or model configuration.',
    ),
    glValveDepthUnit: ProsperModelSchema.shape.glValveDepthUnit?.describe(
      'Gl Valve Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    espCurrentCable: ProsperModelSchema.shape.espCurrentCable?.describe(
      'Esp Current Cable attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    espCurrentMotor: ProsperModelSchema.shape.espCurrentMotor?.describe(
      'Esp Current Motor attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    espPumpModel: ProsperModelSchema.shape.espPumpModel?.describe(
      'Esp Pump Model attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    glMethod: ProsperModelSchema.shape.glMethod?.describe(
      'Numeric value storing gl method for this entity, used in calculations, reporting, or model configuration.',
    ),
    wellCompletionRecordCount: ProsperModelSchema.shape.wellCompletionRecordCount?.describe(
      'Numeric value storing well completion record count for this entity, used in calculations, reporting, or model configuration.',
    ),
    deviationSurveyRecordCount: ProsperModelSchema.shape.deviationSurveyRecordCount?.describe(
      'Numeric value storing deviation survey record count for this entity, used in calculations, reporting, or model configuration.',
    ),
    geoThermalGradientRecordCount: ProsperModelSchema.shape.geoThermalGradientRecordCount?.describe(
      'Numeric value storing geo thermal gradient record count for this entity, used in calculations, reporting, or model configuration.',
    ),
    prosperLocationName: ProsperModelSchema.shape.prosperLocationName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    phaseEnvelope: ProsperModelSchema.shape.phaseEnvelope?.describe(
      'Attribute capturing phase envelope for this entity in the production optimization context.',
    ),
    hydrateCurve: ProsperModelSchema.shape.hydrateCurve?.describe(
      'Attribute capturing hydrate curve for this entity in the production optimization context.',
    ),
    waxCurve: ProsperModelSchema.shape.waxCurve?.describe(
      'Attribute capturing wax curve for this entity in the production optimization context.',
    ),
    asphalteneCurve: ProsperModelSchema.shape.asphalteneCurve?.describe(
      'Attribute capturing asphaltene curve for this entity in the production optimization context.',
    ),
    criticalPoint: ProsperModelSchema.shape.criticalPoint?.describe(
      'Attribute capturing critical point for this entity in the production optimization context.',
    ),
    bubblePoint: ProsperModelSchema.shape.bubblePoint?.describe(
      'Attribute capturing bubble point for this entity in the production optimization context.',
    ),
  })?.describe(
    'Prosper Model view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const PseudoPressureTableView = parseView({
  view: { externalId: 'PseudoPressureTable' },
  model: PseudoPressureTableSchema.extend({
    ...InstanceIdType.shape,
    pressure: PseudoPressureTableSchema.shape.pressure?.describe(
      'Numeric value storing pressure for this entity, used in calculations, reporting, or model configuration.',
    ),
    pseudoPressure: PseudoPressureTableSchema.shape.pseudoPressure?.describe(
      'Numeric value storing pseudo pressure for this entity, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'Pseudo Pressure Table view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const PtsOutputsStringAgentView = parseView({
  view: { externalId: 'PtsOutputs_String_Agent' },
  model: PtsOutputsStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: PtsOutputsStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    calcWellTestTotalGOR: PtsOutputsStringAgentSchema.shape.calcWellTestTotalGOR?.describe(
      'Calculated total GOR based on vendor-reported rates (scf/stb, TS).\nCompare to wellTestGorPtsRef (WF01-transformed GOR at PTS reference conditions) to assess correction magnitude.',
    ),
    wellTestOilRatePtsRef: PtsOutputsStringAgentSchema.shape.wellTestOilRatePtsRef?.describe(
      'PTS-corrected oil rate at reference conditions (stb/d, TS).\nCompare to wellTestOilRateStd (vendor-reported standard rate) to assess PTS correction impact.',
    ),
    wellTestWaterCutPtsRef: PtsOutputsStringAgentSchema.shape.wellTestWaterCutPtsRef?.describe(
      'Water cut at PTS reference conditions (%, TS).\nUse to list wells above a water cut threshold or to track change between consecutive accepted well tests.',
    ),
    wellTestGorPtsRef: PtsOutputsStringAgentSchema.shape.wellTestGorPtsRef?.describe(
      'GOR transformed by WF01 to PTS reference conditions (scf/stb, TS).\nUse together with calcWellTestTotalGOR (measured GOR based on vendor-reported rates) for comparison.\nUse to list wells above/below a GOR limit or above maxGOR from producer guidelines.',
    ),
    wellTestOilRatePts2: PtsOutputsStringAgentSchema.shape.wellTestOilRatePts2?.describe(
      'Oil rate at PTS2 / standard conditions (stb/d, TS).',
    ),
    wellTestGasRatePts2: PtsOutputsStringAgentSchema.shape.wellTestGasRatePts2?.describe(
      'Gas rate at PTS2 / standard conditions (MMscfd, TS).',
    ),
    wellTestWaterRatePts2: PtsOutputsStringAgentSchema.shape.wellTestWaterRatePts2?.describe(
      'Water rate at PTS2 / standard conditions (stb/d, TS).',
    ),
    wellTestLiquidRatePts2: PtsOutputsStringAgentSchema.shape.wellTestLiquidRatePts2?.describe(
      'Liquid rate at PTS2 / standard conditions (stb/d, TS).',
    ),
    wellTestWaterCutPts2: PtsOutputsStringAgentSchema.shape.wellTestWaterCutPts2?.describe(
      'Water cut at PTS2 / standard conditions (%, TS).\nCompare to wellTestWaterCut (vendor-reported) to validate PTS calculation.',
    ),
    wellTestGorPts2: PtsOutputsStringAgentSchema.shape.wellTestGorPts2?.describe(
      'GOR at PTS2 / standard conditions (scf/stb, TS).\nCompare to wellTestTotalGorStd (vendor) and calcWellTestTotalGOR (calculated) for validation.',
    ),
    wellTestLiquidRatePtsRef: PtsOutputsStringAgentSchema.shape.wellTestLiquidRatePtsRef?.describe(
      'Total liquid rate at PTS reference conditions (stb/d, TS).',
    ),
    wellTestCGRPtsRef: PtsOutputsStringAgentSchema.shape.wellTestCGRPtsRef?.describe(
      'Condensate-gas ratio at PTS reference conditions (stb/MMscf, TS).',
    ),
    oilDensityPts1: PtsOutputsStringAgentSchema.shape.oilDensityPts1?.describe(
      'Oil density at PTS1 / line conditions (LC) (kg/m3, TS).',
    ),
    oilDensityPts2: PtsOutputsStringAgentSchema.shape.oilDensityPts2?.describe(
      'Oil density at PTS2 / standard conditions (SC) (kg/m3, TS).',
    ),
    waterDensityPts1: PtsOutputsStringAgentSchema.shape.waterDensityPts1?.describe(
      'Water density at PTS1 / line conditions (LC) (kg/m3, TS).',
    ),
    waterDensityPts2: PtsOutputsStringAgentSchema.shape.waterDensityPts2?.describe(
      'Water density at PTS2 / standard conditions (SC) (kg/m3, TS).',
    ),
    gasDensityPts1: PtsOutputsStringAgentSchema.shape.gasDensityPts1?.describe(
      'Gas density at PTS1 / line conditions (LC) (kg/m3, TS).',
    ),
    gasDensityPts2: PtsOutputsStringAgentSchema.shape.gasDensityPts2?.describe(
      'Gas density at PTS2 / standard conditions (SC) (kg/m3, TS).',
    ),
    gasGravity: PtsOutputsStringAgentSchema.shape.gasGravity?.describe(
      'Gas gravity at PTS reference conditions (relative to air, TS).',
    ),
    specificGravityGasPts1: PtsOutputsStringAgentSchema.shape.specificGravityGasPts1?.describe(
      'Specific gravity of gas at PTS1 / line conditions (LC) (TS).',
    ),
    specificGravityGasPts2: PtsOutputsStringAgentSchema.shape.specificGravityGasPts2?.describe(
      'Specific gravity of gas at PTS2 / standard conditions (SC) (TS).',
    ),
    boPts1: PtsOutputsStringAgentSchema.shape.boPts1?.describe(
      'Oil formation volume factor (Bo) from line conditions (PTS1/LC) to PTS reference conditions (res bbl/stb, TS).\n  Also referred to as oilShrinkageFactorPTS1toPTSRef.\n\n@name oilShrinkageFactorPTS1toPTSRef',
    ),
    boPts2: PtsOutputsStringAgentSchema.shape.boPts2?.describe(
      'Oil formation volume factor (Bo) from standard conditions (PTS2/SC) to PTS reference conditions (res bbl/stb, TS).\n  Also referred to as oilShrinkageFactorPTS2toPTSRef.\n\n@name oilShrinkageFactorPTS2toPTSRef',
    ),
    bgPts1: PtsOutputsStringAgentSchema.shape.bgPts1?.describe(
      'Gas formation volume factor (Bg) from line conditions (PTS1/LC) to PTS reference conditions (TS).\n  Also referred to as gasExpansionFactorPTS1toPTSRef.\n\n@name gasExpansionFactorPTS1toPTSRef',
    ),
    bgPts2: PtsOutputsStringAgentSchema.shape.bgPts2?.describe(
      'Gas formation volume factor (Bg) from standard conditions (PTS2/SC) to PTS reference conditions (TS).\n  Also referred to as gasExpansionFactorPTS2toPTSRef.\n\n@name gasExpansionFactorPTS2toPTSRef',
    ),
  })?.describe(
    'Path-to-surface corrected rates, GOR, water cut at stock-tank conditions (WF10/WF19).\n\nWell performance from calibrated models and wellhead measurements. Use for well\nefficiency, production optimization, reservoir performance, and production trends. Excludes historical or geological detail.\n\nUse for: Rate and Pressure Estimation (WF10), Reservoir Pressure and PI (WF19).\n\n@name PTS Outputs - String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const PtsOutputsStringView = parseView({
  view: { externalId: 'PtsOutputs_String' },
  model: PtsOutputsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: PtsOutputsStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    bgPts1: PtsOutputsStringSchema.shape.bgPts1?.describe(
      'Time series signal representing bg pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    boPts1: PtsOutputsStringSchema.shape.boPts1?.describe(
      'Time series signal representing bo pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    bwPts1: PtsOutputsStringSchema.shape.bwPts1?.describe(
      'Time series signal representing bw pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calcTotalGORPvtRsPts2: PtsOutputsStringSchema.shape.calcTotalGORPvtRsPts2?.describe(
      'Time series signal representing calc total gorpvt rs pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    composition: PtsOutputsStringSchema.shape.composition?.describe(
      'Time series signal representing composition for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fluidProperties: PtsOutputsStringSchema.shape.fluidProperties?.describe(
      'Time series signal representing fluid properties for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasDensityPts1: PtsOutputsStringSchema.shape.gasDensityPts1?.describe(
      'Time series signal representing gas density pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilAPIPts1: PtsOutputsStringSchema.shape.oilAPIPts1?.describe(
      'Time series signal representing oil apipts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilAPIPts2: PtsOutputsStringSchema.shape.oilAPIPts2?.describe(
      'Time series signal representing oil apipts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilDensityPts1: PtsOutputsStringSchema.shape.oilDensityPts1?.describe(
      'Time series signal representing oil density pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sampleDateTime: PtsOutputsStringSchema.shape.sampleDateTime?.describe(
      'Time series signal representing sample date time for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificGravityGasPts1: PtsOutputsStringSchema.shape.specificGravityGasPts1?.describe(
      'Time series signal representing specific gravity gas pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificGravityGasPts2: PtsOutputsStringSchema.shape.specificGravityGasPts2?.describe(
      'Time series signal representing specific gravity gas pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificGravityOilPts1: PtsOutputsStringSchema.shape.specificGravityOilPts1?.describe(
      'Time series signal representing specific gravity oil pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificGravityOilPts2: PtsOutputsStringSchema.shape.specificGravityOilPts2?.describe(
      'Time series signal representing specific gravity oil pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterDensityPts1: PtsOutputsStringSchema.shape.waterDensityPts1?.describe(
      'Time series signal representing water density pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCGRPts: PtsOutputsStringSchema.shape.wellTestCGRPts?.describe(
      'Time series signal representing well test cgrpts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCGRPts1: PtsOutputsStringSchema.shape.wellTestCGRPts1?.describe(
      'Time series signal representing well test cgrpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCGRPts2: PtsOutputsStringSchema.shape.wellTestCGRPts2?.describe(
      'Time series signal representing well test cgrpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasMassFlowRatePts1: PtsOutputsStringSchema.shape.wellTestGasMassFlowRatePts1?.describe(
      'Time series signal representing well test gas mass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasMassFlowRatePts2: PtsOutputsStringSchema.shape.wellTestGasMassFlowRatePts2?.describe(
      'Time series signal representing well test gas mass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasMassFlowRatePtsRef: PtsOutputsStringSchema.shape.wellTestGasMassFlowRatePtsRef?.describe(
      'Time series signal representing well test gas mass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRatePts2: PtsOutputsStringSchema.shape.wellTestGasRatePts2?.describe(
      'Time series signal representing well test gas rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGORPts1: PtsOutputsStringSchema.shape.wellTestGORPts1?.describe(
      'Time series signal representing well test gorpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGorPts2: PtsOutputsStringSchema.shape.wellTestGorPts2?.describe(
      'Time series signal representing well test gor pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestHCMassFlowRatePts1: PtsOutputsStringSchema.shape.wellTestHCMassFlowRatePts1?.describe(
      'Time series signal representing well test hcmass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestHCMassFlowRatePts2: PtsOutputsStringSchema.shape.wellTestHCMassFlowRatePts2?.describe(
      'Time series signal representing well test hcmass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestHCMassFlowRatePtsRef: PtsOutputsStringSchema.shape.wellTestHCMassFlowRatePtsRef?.describe(
      'Time series signal representing well test hcmass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestLiquidRatePts2: PtsOutputsStringSchema.shape.wellTestLiquidRatePts2?.describe(
      'Time series signal representing well test liquid rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilMassFlowRatePts1: PtsOutputsStringSchema.shape.wellTestOilMassFlowRatePts1?.describe(
      'Time series signal representing well test oil mass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilMassFlowRatePts2: PtsOutputsStringSchema.shape.wellTestOilMassFlowRatePts2?.describe(
      'Time series signal representing well test oil mass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilMassFlowRatePtsRef: PtsOutputsStringSchema.shape.wellTestOilMassFlowRatePtsRef?.describe(
      'Time series signal representing well test oil mass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRatePts2: PtsOutputsStringSchema.shape.wellTestOilRatePts2?.describe(
      'Time series signal representing well test oil rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRatePts1: PtsOutputsStringSchema.shape.wellTestTotalMassFlowRatePts1?.describe(
      'Time series signal representing well test total mass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRatePts2: PtsOutputsStringSchema.shape.wellTestTotalMassFlowRatePts2?.describe(
      'Time series signal representing well test total mass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRatePtsRef: PtsOutputsStringSchema.shape.wellTestTotalMassFlowRatePtsRef?.describe(
      'Time series signal representing well test total mass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCutPts2: PtsOutputsStringSchema.shape.wellTestWaterCutPts2?.describe(
      'Time series signal representing well test water cut pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterMassFlowRatePts1: PtsOutputsStringSchema.shape.wellTestWaterMassFlowRatePts1?.describe(
      'Time series signal representing well test water mass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterMassFlowRatePts2: PtsOutputsStringSchema.shape.wellTestWaterMassFlowRatePts2?.describe(
      'Time series signal representing well test water mass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterMassFlowRatePtsRef: PtsOutputsStringSchema.shape.wellTestWaterMassFlowRatePtsRef?.describe(
      'Time series signal representing well test water mass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRatePts2: PtsOutputsStringSchema.shape.wellTestWaterRatePts2?.describe(
      'Time series signal representing well test water rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWGRPts: PtsOutputsStringSchema.shape.wellTestWGRPts?.describe(
      'Time series signal representing well test wgrpts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWGRPts2: PtsOutputsStringSchema.shape.wellTestWGRPts2?.describe(
      'Time series signal representing well test wgrpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestSOVPts1: PtsOutputsStringSchema.shape.wellTestSOVPts1?.describe(
      'Time series signal representing well test sovpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestSGVPts1: PtsOutputsStringSchema.shape.wellTestSGVPts1?.describe(
      'Time series signal representing well test sgvpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestSOVPts2: PtsOutputsStringSchema.shape.wellTestSOVPts2?.describe(
      'Time series signal representing well test sovpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestSGVPts2: PtsOutputsStringSchema.shape.wellTestSGVPts2?.describe(
      'Time series signal representing well test sgvpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    totalCGRPts2: PtsOutputsStringSchema.shape.totalCGRPts2?.describe(
      'Time series signal representing total cgrpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCutPtsRef: PtsOutputsStringSchema.shape.wellTestWaterCutPtsRef?.describe(
      'Time series signal representing well test water cut pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRatePtsRef: PtsOutputsStringSchema.shape.wellTestOilRatePtsRef?.describe(
      'Time series signal representing well test oil rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRatePtsRef: PtsOutputsStringSchema.shape.wellTestGasRatePtsRef?.describe(
      'Time series signal representing well test gas rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRatePtsRef: PtsOutputsStringSchema.shape.wellTestWaterRatePtsRef?.describe(
      'Time series signal representing well test water rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGorPtsRef: PtsOutputsStringSchema.shape.wellTestGorPtsRef?.describe(
      'Time series signal representing well test gor pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    freeGORPtsRef: PtsOutputsStringSchema.shape.freeGORPtsRef?.describe(
      'Time series signal representing free gorpts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    estGasLiftInjectionRate: PtsOutputsStringSchema.shape.estGasLiftInjectionRate?.describe(
      'Time series signal representing est gas lift injection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    usedGasLiftInjectionRate: PtsOutputsStringSchema.shape.usedGasLiftInjectionRate?.describe(
      'Time series signal representing used gas lift injection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calcSaturationPress: PtsOutputsStringSchema.shape.calcSaturationPress?.describe(
      'Time series signal representing calc saturation press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestLiquidRatePtsRef: PtsOutputsStringSchema.shape.wellTestLiquidRatePtsRef?.describe(
      'Time series signal representing well test liquid rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWGRPtsRef: PtsOutputsStringSchema.shape.wellTestWGRPtsRef?.describe(
      'Time series signal representing well test wgrpts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCGRPtsRef: PtsOutputsStringSchema.shape.wellTestCGRPtsRef?.describe(
      'Time series signal representing well test cgrpts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phaseEnvelopeConditionsModelPtsRef: PtsOutputsStringSchema.shape.phaseEnvelopeConditionsModelPtsRef?.describe(
      'Time series signal representing phase envelope conditions model pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phaseEnvelopeRecordsModelPtsRef: PtsOutputsStringSchema.shape.phaseEnvelopeRecordsModelPtsRef?.describe(
      'Time series signal representing phase envelope records model pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phaseEnvelopeConditionsModelWellTest: PtsOutputsStringSchema.shape.phaseEnvelopeConditionsModelWellTest?.describe(
      'Time series signal representing phase envelope conditions model well test for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phaseEnvelopeRecordsModelWellTest: PtsOutputsStringSchema.shape.phaseEnvelopeRecordsModelWellTest?.describe(
      'Time series signal representing phase envelope records model well test for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phaseEnvelopeConditionsModelPtsRefResult:
      PtsOutputsStringSchema.shape.phaseEnvelopeConditionsModelPtsRefResult?.describe(
        'Time series signal representing phase envelope conditions model pts ref result for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    phaseEnvelopeRecordsModelPtsRefResult: PtsOutputsStringSchema.shape.phaseEnvelopeRecordsModelPtsRefResult?.describe(
      'Time series signal representing phase envelope records model pts ref result for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phaseEnvelopeConditionsModelPtsRefFreeGas:
      PtsOutputsStringSchema.shape.phaseEnvelopeConditionsModelPtsRefFreeGas?.describe(
        'Time series signal representing phase envelope conditions model pts ref free gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    phaseEnvelopeRecordsModelPtsRefFreeGas:
      PtsOutputsStringSchema.shape.phaseEnvelopeRecordsModelPtsRefFreeGas?.describe(
        'Time series signal representing phase envelope records model pts ref free gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    fluidCompModelPtsRef: PtsOutputsStringSchema.shape.fluidCompModelPtsRef?.describe(
      'Time series signal representing fluid comp model pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fluidCompModelWellTest: PtsOutputsStringSchema.shape.fluidCompModelWellTest?.describe(
      'Time series signal representing fluid comp model well test for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fluidCompModelPtsRefResult: PtsOutputsStringSchema.shape.fluidCompModelPtsRefResult?.describe(
      'Time series signal representing fluid comp model pts ref result for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fluidCompModelPtsRefFreeGas: PtsOutputsStringSchema.shape.fluidCompModelPtsRefFreeGas?.describe(
      'Time series signal representing fluid comp model pts ref free gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    saturationPressure: PtsOutputsStringSchema.shape.saturationPressure?.describe(
      'Time series signal representing saturation pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    solutionGOR: PtsOutputsStringSchema.shape.solutionGOR?.describe(
      'Time series signal representing solution gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    bOil: PtsOutputsStringSchema.shape.bOil?.describe(
      'Time series signal representing b oil for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilGravity: PtsOutputsStringSchema.shape.oilGravity?.describe(
      'Time series signal representing oil gravity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilViscosity: PtsOutputsStringSchema.shape.oilViscosity?.describe(
      'Time series signal representing oil viscosity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasGravity: PtsOutputsStringSchema.shape.gasGravity?.describe(
      'Time series signal representing gas gravity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    blackOilPropModel: PtsOutputsStringSchema.shape.blackOilPropModel?.describe(
      'Time series signal representing black oil prop model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fluidCompositionPts1: PtsOutputsStringSchema.shape.fluidCompositionPts1?.describe(
      'Time series signal representing fluid composition pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sampleComposition: PtsOutputsStringSchema.shape.sampleComposition?.describe(
      'Time series signal representing sample composition for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pvtInfo: PtsOutputsStringSchema.shape.pvtInfo?.describe(
      'Pvt Info attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    waterSalinity: PtsOutputsStringSchema.shape.waterSalinity?.describe(
      'Time series signal representing water salinity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    n2: PtsOutputsStringSchema.shape.n2?.describe(
      'Time series signal representing n2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    h2S: PtsOutputsStringSchema.shape.h2S?.describe(
      'Time series signal representing h2 s for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cO2: PtsOutputsStringSchema.shape.cO2?.describe(
      'Time series signal representing c o2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calcWellTestGORInSitu: PtsOutputsStringSchema.shape.calcWellTestGORInSitu?.describe(
      'Time series signal representing calc well test gorin situ for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    freeCGRPtsRef: PtsOutputsStringSchema.shape.freeCGRPtsRef?.describe(
      'Time series signal representing free cgrpts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calcWellTestTotalGOR: PtsOutputsStringSchema.shape.calcWellTestTotalGOR?.describe(
      'Time series signal representing calc well test total gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRatePts1: PtsOutputsStringSchema.shape.wellTestGasRatePts1?.describe(
      'Time series signal representing well test gas rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRatePts1: PtsOutputsStringSchema.shape.wellTestOilRatePts1?.describe(
      'Time series signal representing well test oil rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestLiquidRatePts1: PtsOutputsStringSchema.shape.wellTestLiquidRatePts1?.describe(
      'Time series signal representing well test liquid rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRatePts1: PtsOutputsStringSchema.shape.wellTestWaterRatePts1?.describe(
      'Time series signal representing well test water rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCutPts1: PtsOutputsStringSchema.shape.wellTestWaterCutPts1?.describe(
      'Time series signal representing well test water cut pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWGRPts1: PtsOutputsStringSchema.shape.wellTestWGRPts1?.describe(
      'Time series signal representing well test wgrpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    solutionGORPts1: PtsOutputsStringSchema.shape.solutionGORPts1?.describe(
      'Time series signal representing solution gorpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    solutionCGR: PtsOutputsStringSchema.shape.solutionCGR?.describe(
      'Time series signal representing solution cgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    solutionCGRPts1: PtsOutputsStringSchema.shape.solutionCGRPts1?.describe(
      'Time series signal representing solution cgrpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterDensityPts2: PtsOutputsStringSchema.shape.waterDensityPts2?.describe(
      'Time series signal representing water density pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cgrPts1: PtsOutputsStringSchema.shape.cgrPts1?.describe(
      'Time series signal representing cgr pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelRevisionId: PtsOutputsStringSchema.shape.modelRevisionId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelRevisionExternalId: PtsOutputsStringSchema.shape.modelRevisionExternalId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelRevisionModelExternalId: PtsOutputsStringSchema.shape.modelRevisionModelExternalId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelRevisionFileId: PtsOutputsStringSchema.shape.modelRevisionFileId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    wellTestEstimatedGLRate: PtsOutputsStringSchema.shape.wellTestEstimatedGLRate?.describe(
      'Time series signal representing well test estimated glrate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasRatePVTRsPts1: PtsOutputsStringSchema.shape.gasRatePVTRsPts1?.describe(
      'Time series signal representing gas rate pvtrs pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    bGLPts1: PtsOutputsStringSchema.shape.bGLPts1?.describe(
      'Time series signal representing b glpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calcWellTestGOR: PtsOutputsStringSchema.shape.calcWellTestGOR?.describe(
      'Time series signal representing calc well test gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    anchoringFluid: PtsOutputsStringSchema.shape.anchoringFluid?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    matchingMethod: PtsOutputsStringSchema.shape.matchingMethod?.describe(
      'Time series signal representing matching method for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    totalGORPvtRsPts2: PtsOutputsStringSchema.shape.totalGORPvtRsPts2?.describe(
      'Time series signal representing total gorpvt rs pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    freeGORSC: PtsOutputsStringSchema.shape.freeGORSC?.describe(
      'Time series signal representing free gorsc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    saturationPressureRs: PtsOutputsStringSchema.shape.saturationPressureRs?.describe(
      'Time series signal representing saturation pressure rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilViscosityRs: PtsOutputsStringSchema.shape.oilViscosityRs?.describe(
      'Time series signal representing oil viscosity rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    bOilRs: PtsOutputsStringSchema.shape.bOilRs?.describe(
      'Time series signal representing b oil rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    solutionGORRs: PtsOutputsStringSchema.shape.solutionGORRs?.describe(
      'Time series signal representing solution gorrs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificOilGravityRs: PtsOutputsStringSchema.shape.specificOilGravityRs?.describe(
      'Time series signal representing specific oil gravity rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificGasGravityRs: PtsOutputsStringSchema.shape.specificGasGravityRs?.describe(
      'Time series signal representing specific gas gravity rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fluidCompositionPts1FreeGas: PtsOutputsStringSchema.shape.fluidCompositionPts1FreeGas?.describe(
      'Time series signal representing fluid composition pts1 free gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGOR: PtsOutputsStringSchema.shape.wellTestGOR?.describe(
      'Time series signal representing well test gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phaseEnvelopeRecordsModelPtsRefRs: PtsOutputsStringSchema.shape.phaseEnvelopeRecordsModelPtsRefRs?.describe(
      'Time series signal representing phase envelope records model pts ref rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phaseEnvelopeConditionsModelPtsRs: PtsOutputsStringSchema.shape.phaseEnvelopeConditionsModelPtsRs?.describe(
      'Time series signal representing phase envelope conditions model pts rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilDensityPts2: PtsOutputsStringSchema.shape.oilDensityPts2?.describe(
      'Time series signal representing oil density pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasDensityPts2: PtsOutputsStringSchema.shape.gasDensityPts2?.describe(
      'Time series signal representing gas density pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestUsedGLRate: PtsOutputsStringSchema.shape.wellTestUsedGLRate?.describe(
      'Time series signal representing well test used glrate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    solutionGORRsPts1: PtsOutputsStringSchema.shape.solutionGORRsPts1?.describe(
      'Time series signal representing solution gorrs pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    h2SRs: PtsOutputsStringSchema.shape.h2SRs?.describe(
      'Time series signal representing h2 srs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    n2SRs: PtsOutputsStringSchema.shape.n2SRs?.describe(
      'Time series signal representing n2 srs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cO2Rs: PtsOutputsStringSchema.shape.cO2Rs?.describe(
      'Time series signal representing c o2 rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    n2Rs: PtsOutputsStringSchema.shape.n2Rs?.describe(
      'Time series signal representing n2 rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    solutionGORRsPts1scfbbl: PtsOutputsStringSchema.shape.solutionGORRsPts1scfbbl?.describe(
      'Time series signal representing solution gorrs pts1scfbbl for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    usedGasLiftInjectionRateLC: PtsOutputsStringSchema.shape.usedGasLiftInjectionRateLC?.describe(
      'Time series signal representing used gas lift injection rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGLMassFlowRatePts2: PtsOutputsStringSchema.shape.wellTestGLMassFlowRatePts2?.describe(
      'Time series signal representing well test glmass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGLMassFlowRatePts1: PtsOutputsStringSchema.shape.wellTestGLMassFlowRatePts1?.describe(
      'Time series signal representing well test glmass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fieldGLToleranceUpdate: PtsOutputsStringSchema.shape.fieldGLToleranceUpdate?.describe(
      'Time series signal representing field gltolerance update for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    hydrateCurveTotalFluidPtsRef: PtsOutputsStringSchema.shape.hydrateCurveTotalFluidPtsRef?.describe(
      'Time series signal representing hydrate curve total fluid pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Pts Outputs String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const PtsReferenceConditionsView = parseView({
  view: { externalId: 'PTS_Reference_Conditions' },
  model: PtsReferenceConditionsSchema.extend({
    ...InstanceIdType.shape,
    fieldName: PtsReferenceConditionsSchema.shape.fieldName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    fieldCode: PtsReferenceConditionsSchema.shape.fieldCode?.describe(
      'Field Code attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    date: PtsReferenceConditionsSchema.shape.date?.describe(
      'Attribute capturing date for this entity in the production optimization context.',
    ),
    refStgPress1: PtsReferenceConditionsSchema.shape.refStgPress1?.describe(
      'Numeric value storing ref stg press1 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgTemp1: PtsReferenceConditionsSchema.shape.refStgTemp1?.describe(
      'Numeric value storing ref stg temp1 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgPress2: PtsReferenceConditionsSchema.shape.refStgPress2?.describe(
      'Numeric value storing ref stg press2 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgTemp2: PtsReferenceConditionsSchema.shape.refStgTemp2?.describe(
      'Numeric value storing ref stg temp2 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgPress3: PtsReferenceConditionsSchema.shape.refStgPress3?.describe(
      'Numeric value storing ref stg press3 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgTemp3: PtsReferenceConditionsSchema.shape.refStgTemp3?.describe(
      'Numeric value storing ref stg temp3 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgPress4: PtsReferenceConditionsSchema.shape.refStgPress4?.describe(
      'Numeric value storing ref stg press4 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgTemp4: PtsReferenceConditionsSchema.shape.refStgTemp4?.describe(
      'Numeric value storing ref stg temp4 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgPress5: PtsReferenceConditionsSchema.shape.refStgPress5?.describe(
      'Numeric value storing ref stg press5 for this entity, used in calculations, reporting, or model configuration.',
    ),
    refStgTemp5: PtsReferenceConditionsSchema.shape.refStgTemp5?.describe(
      'Numeric value storing ref stg temp5 for this entity, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'Reference pressure, temperature, and spinner conditions for pressure–temperature–spinner (PTS) surveys, used to normalize, interpret, and compare wellbore survey data.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const PvtAnalysisStringAgentView = parseView({
  view: { externalId: 'PVTAnalysis_String_Agent' },
  model: PvtAnalysisStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: PvtAnalysisStringAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'PVT analysis results and fluid property measurements per well string.\n\nContains PVT sample analysis reference data, fluid type, sample date, and\nanalysis quality indicators for each well string. Sourced from laboratory\nanalyses of fluid samples collected from wells, to address analytical\nquestions regarding fluid characteristics and behavior under varying\nconditions. It excludes production data or reservoir performance metrics (see\nother views). Use cases: evaluating fluid properties for reservoir simulations\nand optimizing production strategies based on sample quality and composition.\n\n@name PVT Analysis - String (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const PvtAnalysisStringView = parseView({
  view: { externalId: 'PVTAnalysis_String' },
  model: PvtAnalysisStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: PvtAnalysisStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    sampleType: PvtAnalysisStringSchema.shape.sampleType?.describe(
      'Time series signal representing sample type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    salinity: PvtAnalysisStringSchema.shape.salinity?.describe(
      'Time series signal representing salinity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sampleDate: PvtAnalysisStringSchema.shape.sampleDate?.describe(
      'Time series signal representing sample date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterCut: PvtAnalysisStringSchema.shape.waterCut?.describe(
      'Time series signal representing water cut for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'PVT analysis results describing oil, gas, and water properties over pressure and temperature, supporting network modeling, wellbore hydraulics, allocation, and production forecasting.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const RateDiagnosticsStringAgentView = parseView({
  view: { externalId: 'RateDiagnostics_String_Agent' },
  model: RateDiagnosticsStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: RateDiagnosticsStringAgentSchema.shape.wellString?.describe('Reference to well string'),
    wellPerformance: RateDiagnosticsStringAgentSchema.shape.wellPerformance?.describe(
      'Well performance indicator (dimensionless)',
    ),
    qliqDelta: RateDiagnosticsStringAgentSchema.shape.qliqDelta?.describe(
      'Difference between current and reference liquid rate (stb/d, TS).\nPositive = above reference, negative = below',
    ),
    grdAnalysisStatus: RateDiagnosticsStringAgentSchema.shape.grdAnalysisStatus?.describe(
      'Status of Gas Rate Decline analysis',
    ),
    chokeSizeCalc: RateDiagnosticsStringAgentSchema.shape.chokeSizeCalc?.describe(
      'Calculated production choke size implied by current rate and pressure conditions (64ths inch, TS).',
    ),
    chokeCdCalc: RateDiagnosticsStringAgentSchema.shape.chokeCdCalc?.describe(
      'Calculated production choke discharge coefficient (Cd, TS)',
    ),
  })?.describe(
    'Well performance scores, rate-change metrics, analysis status, choke/GL parameters per string.\n\nDiagnostic metadata about the estimation process (not rate values). Use for:\nwell performance vs potential, ESP/GL/GRD analysis success, rate change, or\nimplied choke size. For rate estimates use EstimatedRates_String_Agent; for\ndata-driven rates use DataDrivenRates_String_Agent.\n\nUse for: performance scores and analysis status (WF10).\n\n@name Rate Diagnostics - Well Performance and Analysis Status (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ReservoirGuidelineView = parseView({
  view: { externalId: 'Reservoir_Guideline' },
  model: ReservoirGuidelineSchema.extend({
    ...InstanceIdType.shape,
    field: ReservoirGuidelineSchema.shape.field?.describe(
      "Reference to the related 'Field' entity for this 'Reservoir_Guideline' row.",
    ),
    reservoir: ReservoirGuidelineSchema.shape.reservoir?.describe(
      "Reference to the related 'Reservoir' entity for this 'Reservoir_Guideline' row.",
    ),
    sector: ReservoirGuidelineSchema.shape.sector?.describe(
      "Reference to the related 'Sector' entity for this 'Reservoir_Guideline' row.",
    ),
    vrrTarget: ReservoirGuidelineSchema.shape.vrrTarget?.describe(
      "Numeric value 'vrrTarget' (floating point) for this 'Reservoir_Guideline' row.",
    ),
    technicalOilRate: ReservoirGuidelineSchema.shape.technicalOilRate?.describe(
      "Numeric value 'technicalOilRate' (floating point) for this 'Reservoir_Guideline' row.",
    ),
    technicalGasRate: ReservoirGuidelineSchema.shape.technicalGasRate?.describe(
      "Numeric value 'technicalGasRate' (floating point) for this 'Reservoir_Guideline' row.",
    ),
    reservoirAllowableRate: ReservoirGuidelineSchema.shape.reservoirAllowableRate?.describe(
      "Numeric value 'reservoirAllowableRate' (floating point) for this 'Reservoir_Guideline' row.",
    ),
    vrrRequirement: ReservoirGuidelineSchema.shape.vrrRequirement?.describe(
      "Numeric value 'vrrRequirement' (floating point) for this 'Reservoir_Guideline' row.",
    ),
    expectedReservoirPressure: ReservoirGuidelineSchema.shape.expectedReservoirPressure?.describe(
      "Numeric value 'expectedReservoirPressure' (floating point) for this 'Reservoir_Guideline' row.",
    ),
    effectiveDate: ReservoirGuidelineSchema.shape.effectiveDate?.describe(
      "Timestamp 'effectiveDate' associated with this 'Reservoir_Guideline' row.",
    ),
  })?.describe("View 'Reservoir_Guideline' in the iPSO production optimization solution data model."),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ReservoirInputsAgentView = parseView({
  view: { externalId: 'ReservoirInputs_Agent' },
  model: ReservoirInputsAgentSchema.extend({
    ...InstanceIdType.shape,
    reservoir: ReservoirInputsAgentSchema.shape.reservoir?.describe('Reference to reservoir.'),
    reservoirProductionAllocationOilFactor:
      ReservoirInputsAgentSchema.shape.reservoirProductionAllocationOilFactor?.describe(
        'Oil production allocation factor for this reservoir (fraction, TS).\nShare of facility oil production attributed to this reservoir.',
      ),
    reservoirProductionAllocationGasFactor:
      ReservoirInputsAgentSchema.shape.reservoirProductionAllocationGasFactor?.describe(
        'Gas production allocation factor for this reservoir (fraction, TS).\nShare of facility gas production attributed to this reservoir.',
      ),
    reservoirProductionAllocationWaterFactor:
      ReservoirInputsAgentSchema.shape.reservoirProductionAllocationWaterFactor?.describe(
        'Water production allocation factor for this reservoir (fraction, TS).\nShare of facility water production attributed to this reservoir.',
      ),
    reservoirProductionAllocationFactor: ReservoirInputsAgentSchema.shape.reservoirProductionAllocationFactor?.describe(
      'Combined production allocation factor for this reservoir (fraction, TS).\nOverall share of total facility production attributed to this reservoir.',
    ),
    reservoirInjectionAllocationOilFactor:
      ReservoirInputsAgentSchema.shape.reservoirInjectionAllocationOilFactor?.describe(
        'Oil injection allocation factor for this reservoir (fraction, TS).\nUsed in WAG (Water-Alternating-Gas) injection schemes.',
      ),
    reservoirInjectionAllocationGasFactor:
      ReservoirInputsAgentSchema.shape.reservoirInjectionAllocationGasFactor?.describe(
        'Gas injection allocation factor for this reservoir (fraction, TS).\nShare of facility gas injection attributed to this reservoir.',
      ),
    reservoirInjectionAllocationWaterFactor:
      ReservoirInputsAgentSchema.shape.reservoirInjectionAllocationWaterFactor?.describe(
        'Water injection allocation factor for this reservoir (fraction, TS).\nShare of facility water injection attributed to this reservoir.',
      ),
    reservoirInjectionAllocationFactor: ReservoirInputsAgentSchema.shape.reservoirInjectionAllocationFactor?.describe(
      'Combined injection allocation factor for this reservoir (fraction, TS).\nOverall share of total facility injection attributed to this reservoir.',
    ),
  })?.describe(
    'Reservoir-level allocation factors for production and injection (WF16).\n\nHow production and injection from facilities are distributed among reservoirs.\nUse for allocation share per reservoir and which reservoir has highest allocation. Excludes well connectivity or performance detail.\n\nUse for: VRR Monitoring and Surveillance (WF16).\n\n@name Reservoir Inputs - Allocation Factors (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ReservoirInputsView = parseView({
  view: { externalId: 'ReservoirInputs' },
  model: ReservoirInputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: ReservoirInputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    reservoirProductionAllocationOilFactor:
      ReservoirInputsSchema.shape.reservoirProductionAllocationOilFactor?.describe(
        'Time series signal representing reservoir production allocation oil factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    reservoirProductionAllocationGasFactor:
      ReservoirInputsSchema.shape.reservoirProductionAllocationGasFactor?.describe(
        'Time series signal representing reservoir production allocation gas factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    reservoirProductionAllocationWaterFactor:
      ReservoirInputsSchema.shape.reservoirProductionAllocationWaterFactor?.describe(
        'Time series signal representing reservoir production allocation water factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    reservoirInjectionAllocationOilFactor: ReservoirInputsSchema.shape.reservoirInjectionAllocationOilFactor?.describe(
      'Time series signal representing reservoir injection allocation oil factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    reservoirInjectionAllocationGasFactor: ReservoirInputsSchema.shape.reservoirInjectionAllocationGasFactor?.describe(
      'Time series signal representing reservoir injection allocation gas factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    reservoirInjectionAllocationWaterFactor:
      ReservoirInputsSchema.shape.reservoirInjectionAllocationWaterFactor?.describe(
        'Time series signal representing reservoir injection allocation water factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    reservoirProductionAllocationFactor: ReservoirInputsSchema.shape.reservoirProductionAllocationFactor?.describe(
      'Time series signal representing reservoir production allocation factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    reservoirInjectionAllocationFactor: ReservoirInputsSchema.shape.reservoirInjectionAllocationFactor?.describe(
      'Time series signal representing reservoir injection allocation factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Reservoir Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const ReservoirOutputsAgentView = parseView({
  view: { externalId: 'ReservoirOutputs_Agent' },
  model: ReservoirOutputsAgentSchema.extend({
    ...InstanceIdType.shape,
    reservoir: ReservoirOutputsAgentSchema.shape.reservoir?.describe('Reference to reservoir.'),
    field: ReservoirOutputsAgentSchema.shape.field?.describe('Parent field containing this reservoir'),
    vrr: ReservoirOutputsAgentSchema.shape.vrr?.describe('Daily voidage replacement ratio (TS)'),
    mtdVRR: ReservoirOutputsAgentSchema.shape.mtdVRR?.describe('Month-to-date VRR (TS)'),
    ytdVRR: ReservoirOutputsAgentSchema.shape.ytdVRR?.describe('Year-to-date VRR (TS)'),
    vrrCompliance: ReservoirOutputsAgentSchema.shape.vrrCompliance?.describe('Daily VRR compliance flag (TS)'),
    mtdVRRCompliance: ReservoirOutputsAgentSchema.shape.mtdVRRCompliance?.describe(
      'Month-to-date VRR compliance flag (TS)',
    ),
    ytdVRRCompliance: ReservoirOutputsAgentSchema.shape.ytdVRRCompliance?.describe(
      'Year-to-date VRR compliance flag (TS)',
    ),
    pressureCompliance: ReservoirOutputsAgentSchema.shape.pressureCompliance?.describe(
      'Reservoir pressure compliance flag (TS)',
    ),
    regionPressure: ReservoirOutputsAgentSchema.shape.regionPressure?.describe(
      'Average reservoir region pressure (psi, TS)',
    ),
    giRate: ReservoirOutputsAgentSchema.shape.giRate?.describe(
      'Aggregated gas injection rate for the reservoir (MSCF/d, TS).',
    ),
    wiRate: ReservoirOutputsAgentSchema.shape.wiRate?.describe(
      'Aggregated water injection rate for the reservoir (stb/d, TS).',
    ),
    giTargetRate: ReservoirOutputsAgentSchema.shape.giTargetRate?.describe(
      'Gas injection target rate from planning/optimization (MSCF/d, TS).\nCompare to giRate for performance gap.',
    ),
    wiTargetRate: ReservoirOutputsAgentSchema.shape.wiTargetRate?.describe(
      'Water injection target rate from planning/optimization (stb/d, TS).\nCompare to wiRate for performance gap.',
    ),
    giTargetRateCompliance: ReservoirOutputsAgentSchema.shape.giTargetRateCompliance?.describe(
      'Gas injection target rate compliance flag (TS)',
    ),
    wiTargetRateCompliance: ReservoirOutputsAgentSchema.shape.wiTargetRateCompliance?.describe(
      'Water injection target rate compliance flag (TS)',
    ),
    downholeOilProductionVolume: ReservoirOutputsAgentSchema.shape.downholeOilProductionVolume?.describe(
      'Downhole oil production volume at reservoir conditions (rb, TS).\nUsed in VRR denominator calculation.',
    ),
    downholeGasProductionVolume: ReservoirOutputsAgentSchema.shape.downholeGasProductionVolume?.describe(
      'Downhole gas production volume at reservoir conditions (rb, TS).\nUsed in VRR denominator calculation.',
    ),
    downholeWaterProductionVolume: ReservoirOutputsAgentSchema.shape.downholeWaterProductionVolume?.describe(
      'Downhole water production volume at reservoir conditions (rb, TS).\nUsed in VRR denominator calculation.',
    ),
    downholeWaterInjectionVolume: ReservoirOutputsAgentSchema.shape.downholeWaterInjectionVolume?.describe(
      'Downhole water injection volume at reservoir conditions (rb, TS).\nUsed in VRR numerator calculation.',
    ),
    downholeGasInjectionVolume: ReservoirOutputsAgentSchema.shape.downholeGasInjectionVolume?.describe(
      'Downhole gas injection volume at reservoir conditions (rb, TS).\nUsed in VRR numerator calculation.',
    ),
    wellsActiveOpNf: ReservoirOutputsAgentSchema.shape.wellsActiveOpNf?.describe(
      'Count of active oil producer wells on natural flow (TS).',
    ),
    wellsActiveGpNf: ReservoirOutputsAgentSchema.shape.wellsActiveGpNf?.describe(
      'Count of active gas producer wells on natural flow (TS).',
    ),
    wellsActiveOpEsp: ReservoirOutputsAgentSchema.shape.wellsActiveOpEsp?.describe(
      'Count of active oil producer wells on ESP (TS).',
    ),
    wellsActiveOpGl: ReservoirOutputsAgentSchema.shape.wellsActiveOpGl?.describe(
      'Count of active oil producer wells on gas lift (TS).',
    ),
    wellsActiveGi: ReservoirOutputsAgentSchema.shape.wellsActiveGi?.describe(
      'Count of active gas injector wells (TS).',
    ),
    wellsActiveWi: ReservoirOutputsAgentSchema.shape.wellsActiveWi?.describe(
      'Count of active water injector wells (TS).',
    ),
    wellsInActiveOpNf: ReservoirOutputsAgentSchema.shape.wellsInActiveOpNf?.describe(
      'Count of inactive oil producer wells on natural flow (TS).',
    ),
    wellsInActiveGpNf: ReservoirOutputsAgentSchema.shape.wellsInActiveGpNf?.describe(
      'Count of inactive gas producer wells on natural flow (TS).',
    ),
    wellsInActiveOpEsp: ReservoirOutputsAgentSchema.shape.wellsInActiveOpEsp?.describe(
      'Count of inactive oil producer wells on ESP (TS).',
    ),
    wellsInActiveOpGl: ReservoirOutputsAgentSchema.shape.wellsInActiveOpGl?.describe(
      'Count of inactive oil producer wells on gas lift (TS).',
    ),
    wellsInActiveGi: ReservoirOutputsAgentSchema.shape.wellsInActiveGi?.describe(
      'Count of inactive gas injector wells (TS).',
    ),
    wellsInActiveWi: ReservoirOutputsAgentSchema.shape.wellsInActiveWi?.describe(
      'Count of inactive water injector wells (TS).',
    ),
  })?.describe(
    'Reservoir-level VRR metrics, compliance ratios, injection balance (WF16).\n\nReservoir output metrics for VRR compliance, injection strategies, well activity.\nUse to assess reservoir health and injection-related risks. Excludes geological or historical detail.\n\nUse for: VRR Monitoring and Surveillance (WF16).\n\n@name Reservoir Outputs (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ReservoirOutputsView = parseView({
  view: { externalId: 'ReservoirOutputs' },
  model: ReservoirOutputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: ReservoirOutputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellsActiveOpNf: ReservoirOutputsSchema.shape.wellsActiveOpNf?.describe(
      'Time series signal representing wells active op nf for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveGpNf: ReservoirOutputsSchema.shape.wellsActiveGpNf?.describe(
      'Time series signal representing wells active gp nf for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveOpEsp: ReservoirOutputsSchema.shape.wellsActiveOpEsp?.describe(
      'Time series signal representing wells active op esp for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveOpGl: ReservoirOutputsSchema.shape.wellsActiveOpGl?.describe(
      'Time series signal representing wells active op gl for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveGi: ReservoirOutputsSchema.shape.wellsActiveGi?.describe(
      'Time series signal representing wells active gi for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveWi: ReservoirOutputsSchema.shape.wellsActiveWi?.describe(
      'Time series signal representing wells active wi for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpNf: ReservoirOutputsSchema.shape.wellsInActiveOpNf?.describe(
      'Time series signal representing wells in active op nf for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveGpNf: ReservoirOutputsSchema.shape.wellsInActiveGpNf?.describe(
      'Time series signal representing wells in active gp nf for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpEsp: ReservoirOutputsSchema.shape.wellsInActiveOpEsp?.describe(
      'Time series signal representing wells in active op esp for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpGl: ReservoirOutputsSchema.shape.wellsInActiveOpGl?.describe(
      'Time series signal representing wells in active op gl for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveGi: ReservoirOutputsSchema.shape.wellsInActiveGi?.describe(
      'Time series signal representing wells in active gi for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveWi: ReservoirOutputsSchema.shape.wellsInActiveWi?.describe(
      'Time series signal representing wells in active wi for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giRate: ReservoirOutputsSchema.shape.giRate?.describe(
      'Time series signal representing gi rate for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiRate: ReservoirOutputsSchema.shape.wiRate?.describe(
      'Time series signal representing wi rate for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giTargetRate: ReservoirOutputsSchema.shape.giTargetRate?.describe(
      'Target production or injection rate setpoint for this reservoir, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance.',
    ),
    wiTargetRate: ReservoirOutputsSchema.shape.wiTargetRate?.describe(
      'Target production or injection rate setpoint for this reservoir, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance.',
    ),
    field: ReservoirOutputsSchema.shape.field?.describe(
      'Field attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
    giTargetRateCompliance: ReservoirOutputsSchema.shape.giTargetRateCompliance?.describe(
      'Target production or injection rate setpoint for this reservoir, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance.',
    ),
    wiTargetRateCompliance: ReservoirOutputsSchema.shape.wiTargetRateCompliance?.describe(
      'Target production or injection rate setpoint for this reservoir, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance.',
    ),
    downholeOilProductionVolume: ReservoirOutputsSchema.shape.downholeOilProductionVolume?.describe(
      'Time series signal representing downhole oil production volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    downholeGasProductionVolume: ReservoirOutputsSchema.shape.downholeGasProductionVolume?.describe(
      'Time series signal representing downhole gas production volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    downholeWaterProductionVolume: ReservoirOutputsSchema.shape.downholeWaterProductionVolume?.describe(
      'Time series signal representing downhole water production volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    downholeWaterInjectionVolume: ReservoirOutputsSchema.shape.downholeWaterInjectionVolume?.describe(
      'Time series signal representing downhole water injection volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    downholeGasInjectionVolume: ReservoirOutputsSchema.shape.downholeGasInjectionVolume?.describe(
      'Time series signal representing downhole gas injection volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vrrCompliance: ReservoirOutputsSchema.shape.vrrCompliance?.describe(
      'Time series signal representing vrr compliance for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pressureCompliance: ReservoirOutputsSchema.shape.pressureCompliance?.describe(
      'Time series signal representing pressure compliance for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mtdVRR: ReservoirOutputsSchema.shape.mtdVRR?.describe(
      'Time series signal representing mtd vrr for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    ytdVRR: ReservoirOutputsSchema.shape.ytdVRR?.describe(
      'Time series signal representing ytd vrr for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vrr: ReservoirOutputsSchema.shape.vrr?.describe(
      'Time series signal representing vrr for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    regionPressure: ReservoirOutputsSchema.shape.regionPressure?.describe(
      'Time series signal representing region pressure for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mtdVRRCompliance: ReservoirOutputsSchema.shape.mtdVRRCompliance?.describe(
      'Time series signal representing mtd vrrcompliance for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    ytdVRRCompliance: ReservoirOutputsSchema.shape.ytdVRRCompliance?.describe(
      'Time series signal representing ytd vrrcompliance for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Aggregated reservoir-level outputs including counts of active and inactive wells, injection rates and downhole production/injection volumes, as well as voidage replacement ratio (VRR) and pressure compliance metrics for reservoir management and optimization.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const ReservoirProdplanView = parseView({
  view: { externalId: 'Reservoir_Prodplan' },
  model: ReservoirProdplanSchema.extend({
    ...InstanceIdType.shape,
    reservoir: ReservoirProdplanSchema.shape.reservoir?.describe(
      'Reservoir attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
    vrrTarget: ReservoirProdplanSchema.shape.vrrTarget?.describe(
      'Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    prodTarget: ReservoirProdplanSchema.shape.prodTarget?.describe(
      'Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    effectiveDate: ReservoirProdplanSchema.shape.effectiveDate?.describe(
      'Attribute capturing effective date for this reservoir in the production optimization context.',
    ),
    submittedMonth: ReservoirProdplanSchema.shape.submittedMonth?.describe(
      'Attribute capturing submitted month for this reservoir in the production optimization context.',
    ),
    field: ReservoirProdplanSchema.shape.field?.describe(
      'Field attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
  })?.describe(
    'Production planning assumptions, constraints, and targets over time at the relevant aggregation level, used to compare actual performance versus plan and to steer optimization scenarios.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const ReservoirView = parseView({
  view: { externalId: 'Reservoir' },
  model: ReservoirSchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const SaturationPressureMappingView = parseView({
  view: { externalId: 'Saturation_Pressure_Mapping' },
  model: SaturationPressureMappingSchema.extend({
    ...InstanceIdType.shape,
    effectiveDate: SaturationPressureMappingSchema.shape.effectiveDate?.describe(
      'Attribute capturing effective date for this entity in the production optimization context.',
    ),
    entityName: SaturationPressureMappingSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    pvtRef: SaturationPressureMappingSchema.shape.pvtRef?.describe(
      'Pvt Ref attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    satPress: SaturationPressureMappingSchema.shape.satPress?.describe(
      'Numeric value storing sat press for this entity, used in calculations, reporting, or model configuration.',
    ),
    solutionGOR: SaturationPressureMappingSchema.shape.solutionGOR?.describe(
      'Numeric value storing solution gor for this entity, used in calculations, reporting, or model configuration.',
    ),
    resTemp: SaturationPressureMappingSchema.shape.resTemp?.describe(
      'Numeric value storing res temp for this entity, used in calculations, reporting, or model configuration.',
    ),
    pvtFile: SaturationPressureMappingSchema.shape.pvtFile?.describe(
      'Pvt File attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    prpFile: SaturationPressureMappingSchema.shape.prpFile?.describe(
      'Prp File attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    wat: SaturationPressureMappingSchema.shape.wat?.describe(
      'Numeric value storing wat for this entity, used in calculations, reporting, or model configuration.',
    ),
    asphTable: SaturationPressureMappingSchema.shape.asphTable?.describe(
      'Asph Table attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
  })?.describe(
    'Saturation Pressure Mapping view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const SectorHierarchyAgentView = parseView({
  view: { externalId: 'SectorHierarchy_Agent' },
  model: SectorHierarchyAgentSchema.extend({
    ...InstanceIdType.shape,
    reservoir: SectorHierarchyAgentSchema.shape.reservoir?.describe('Subsurface reservoir containing the sector.'),
    sector: SectorHierarchyAgentSchema.shape.sector?.describe('Subdivision of a reservoir used for flow allocation.'),
    well: SectorHierarchyAgentSchema.shape.well?.describe('Physical wellbore containing the string.'),
    string: SectorHierarchyAgentSchema.shape.string?.describe('Completion or producing interval'),
    allocationFactor: SectorHierarchyAgentSchema.shape.allocationFactor?.describe(
      'Fractional flow allocation for this string within its sector.',
    ),
    startDateTime: SectorHierarchyAgentSchema.shape.startDateTime?.describe(
      'Timestamp at which this sector assignment became effective.',
    ),
    endDateTime: SectorHierarchyAgentSchema.shape.endDateTime?.describe(
      'Timestamp at which this sector assignment ended.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Reservoir â†’ sector â†’ well â†’ string mapping with per-string allocation\nfactors, scoped to in-scope assets.\n\nLookup table linking each producing string to its sector within a reservoir,\ntogether with the flow allocation factor used in sector-based allocation,\nand the effective date range of the assignment. Complements\nFlatHierarchy_Agent, which carries the broader production hierarchy.\n\n@name SectorHierarchy (Agent Scoped)',
    ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const SectorHierarchyView = parseView({
  view: { externalId: 'SectorHierarchy' },
  model: SectorHierarchySchema.extend({
    ...InstanceIdType.shape,
    reservoir: SectorHierarchySchema.shape.reservoir?.describe('Subsurface reservoir formation containing the sector'),
    sector: SectorHierarchySchema.shape.sector?.describe(
      'Subdivision of a reservoir used for flow allocation and production management',
    ),
    well: SectorHierarchySchema.shape.well?.describe('Physical wellbore containing this string'),
    string: SectorHierarchySchema.shape.string?.describe('Completion/producing interval within the well'),
    startDateTime: SectorHierarchySchema.shape.startDateTime?.describe('When this sector assignment became effective'),
    endDateTime: SectorHierarchySchema.shape.endDateTime?.describe('When this sector assignment ended'),
    allocationFactor: SectorHierarchySchema.shape.allocationFactor?.describe(
      'Numeric factor (0-1) used to allocate production volumes from this string to the sector',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      "DENORMALIZED SECTOR LOOKUP TABLE - For sector-based flow allocation and reservoir analysis.\n\nSTRUCTURE: Each row = one String with its sector/reservoir assignment and allocation factor.\nHierarchy: Reservoir → Sector → Well → String\n\nWHY USE THIS: Navigate sector relationships and retrieve allocation factors for flow calculations.\n\nQUERY PATTERNS:\n- Find strings in a sector: Filter sector.name = 'X', select string\n- Find wells in a reservoir: Filter reservoir.name = 'Y', select DISTINCT well\n- Get allocation factors: Filter by sector or reservoir, select allocationFactor\n\nKEY BEHAVIORS:\n- One row per string means parent entities repeat (use DISTINCT for unique parents)\n- References return full entity objects - access .name, .externalId, etc.\n- Use startDateTime/endDateTime for historical sector assignments",
    ),
  dataModel: DataModel.IpsoSolution,
});

export const SectorOutputsView = parseView({
  view: { externalId: 'SectorOutputs' },
  model: SectorOutputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: SectorOutputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellsActiveOpNf: SectorOutputsSchema.shape.wellsActiveOpNf?.describe(
      'Time series signal representing wells active op nf for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveGpNf: SectorOutputsSchema.shape.wellsActiveGpNf?.describe(
      'Time series signal representing wells active gp nf for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveOpEsp: SectorOutputsSchema.shape.wellsActiveOpEsp?.describe(
      'Time series signal representing wells active op esp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveOpGl: SectorOutputsSchema.shape.wellsActiveOpGl?.describe(
      'Time series signal representing wells active op gl for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveGi: SectorOutputsSchema.shape.wellsActiveGi?.describe(
      'Time series signal representing wells active gi for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsActiveWi: SectorOutputsSchema.shape.wellsActiveWi?.describe(
      'Time series signal representing wells active wi for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpNf: SectorOutputsSchema.shape.wellsInActiveOpNf?.describe(
      'Time series signal representing wells in active op nf for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveGpNf: SectorOutputsSchema.shape.wellsInActiveGpNf?.describe(
      'Time series signal representing wells in active gp nf for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpEsp: SectorOutputsSchema.shape.wellsInActiveOpEsp?.describe(
      'Time series signal representing wells in active op esp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveOpGl: SectorOutputsSchema.shape.wellsInActiveOpGl?.describe(
      'Time series signal representing wells in active op gl for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveGi: SectorOutputsSchema.shape.wellsInActiveGi?.describe(
      'Time series signal representing wells in active gi for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellsInActiveWi: SectorOutputsSchema.shape.wellsInActiveWi?.describe(
      'Time series signal representing wells in active wi for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giRate: SectorOutputsSchema.shape.giRate?.describe(
      'Time series signal representing gi rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wiRate: SectorOutputsSchema.shape.wiRate?.describe(
      'Time series signal representing wi rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    giTargetRate: SectorOutputsSchema.shape.giTargetRate?.describe(
      'Target production or injection rate setpoint for this entity, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance.',
    ),
    wiTargetRate: SectorOutputsSchema.shape.wiTargetRate?.describe(
      'Target production or injection rate setpoint for this entity, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance.',
    ),
    field: SectorOutputsSchema.shape.field?.describe(
      'Field attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    reservoir: SectorOutputsSchema.shape.reservoir?.describe(
      'Reservoir attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    giTargetRateCompliance: SectorOutputsSchema.shape.giTargetRateCompliance?.describe(
      'Target production or injection rate setpoint for this entity, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance.',
    ),
    wiTargetRateCompliance: SectorOutputsSchema.shape.wiTargetRateCompliance?.describe(
      'Target production or injection rate setpoint for this entity, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance.',
    ),
    downholeOilProductionVolume: SectorOutputsSchema.shape.downholeOilProductionVolume?.describe(
      'Time series signal representing downhole oil production volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    downholeGasProductionVolume: SectorOutputsSchema.shape.downholeGasProductionVolume?.describe(
      'Time series signal representing downhole gas production volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    downholeWaterProductionVolume: SectorOutputsSchema.shape.downholeWaterProductionVolume?.describe(
      'Time series signal representing downhole water production volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    downholeWaterInjectionVolume: SectorOutputsSchema.shape.downholeWaterInjectionVolume?.describe(
      'Time series signal representing downhole water injection volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    downholeGasInjectionVolume: SectorOutputsSchema.shape.downholeGasInjectionVolume?.describe(
      'Time series signal representing downhole gas injection volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vrrCompliance: SectorOutputsSchema.shape.vrrCompliance?.describe(
      'Time series signal representing vrr compliance for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pressureCompliance: SectorOutputsSchema.shape.pressureCompliance?.describe(
      'Time series signal representing pressure compliance for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mtdVRR: SectorOutputsSchema.shape.mtdVRR?.describe(
      'Time series signal representing mtd vrr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    ytdVRR: SectorOutputsSchema.shape.ytdVRR?.describe(
      'Time series signal representing ytd vrr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vrr: SectorOutputsSchema.shape.vrr?.describe(
      'Time series signal representing vrr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    regionPressure: SectorOutputsSchema.shape.regionPressure?.describe(
      'Time series signal representing region pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mtdVRRCompliance: SectorOutputsSchema.shape.mtdVRRCompliance?.describe(
      'Time series signal representing mtd vrrcompliance for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    ytdVRRCompliance: SectorOutputsSchema.shape.ytdVRRCompliance?.describe(
      'Time series signal representing ytd vrrcompliance for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Aggregated sector-level outputs including counts of active and inactive wells, injection rates and downhole production/injection volumes, as well as voidage replacement ratio (VRR) and pressure compliance metrics for sector surveillance and optimization.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const SectorProdplanView = parseView({
  view: { externalId: 'Sector_Prodplan' },
  model: SectorProdplanSchema.extend({
    ...InstanceIdType.shape,
    sector: SectorProdplanSchema.shape.sector?.describe(
      'Sector attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    reservoir: SectorProdplanSchema.shape.reservoir?.describe(
      'Reservoir attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    field: SectorProdplanSchema.shape.field?.describe(
      'Field attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    vrrTarget: SectorProdplanSchema.shape.vrrTarget?.describe(
      'Target value for this entity defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    effectiveDate: SectorProdplanSchema.shape.effectiveDate?.describe(
      'Attribute capturing effective date for this entity in the production optimization context.',
    ),
    submittedMonth: SectorProdplanSchema.shape.submittedMonth?.describe(
      'Attribute capturing submitted month for this entity in the production optimization context.',
    ),
  })?.describe(
    'Production planning assumptions, constraints, and targets over time at the relevant aggregation level, used to compare actual performance versus plan and to steer optimization scenarios.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const SectorView = parseView({
  view: { externalId: 'Sector' },
  model: SectorSchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const SeparatorInputsView = parseView({
  view: { externalId: 'SeparatorInputs' },
  model: SeparatorInputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: SeparatorInputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    separatorOilRate: SeparatorInputsSchema.shape.separatorOilRate?.describe(
      'Time series signal representing separator oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorGasRate: SeparatorInputsSchema.shape.separatorGasRate?.describe(
      'Time series signal representing separator gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorWaterRate: SeparatorInputsSchema.shape.separatorWaterRate?.describe(
      'Time series signal representing separator water rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    separatorPressure: SeparatorInputsSchema.shape.separatorPressure?.describe(
      'Time series signal representing separator pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Separator Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const ShgProducerGuidelineView = parseView({
  view: { externalId: 'SHG_Producer_Guideline' },
  model: ShgProducerGuidelineSchema.extend({
    ...InstanceIdType.shape,
    entityName: ShgProducerGuidelineSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    minBHP: ShgProducerGuidelineSchema.shape.minBHP?.describe(
      'Numeric value storing min bhp for this entity, used in calculations, reporting, or model configuration.',
    ),
    minWHP: ShgProducerGuidelineSchema.shape.minWHP?.describe(
      'Numeric value storing min whp for this entity, used in calculations, reporting, or model configuration.',
    ),
    maxGOR: ShgProducerGuidelineSchema.shape.maxGOR?.describe(
      'Numeric value storing max gor for this entity, used in calculations, reporting, or model configuration.',
    ),
    maxLiquidRate: ShgProducerGuidelineSchema.shape.maxLiquidRate?.describe(
      'Numeric value storing max liquid rate for this entity, used in calculations, reporting, or model configuration.',
    ),
    maxOilRate: ShgProducerGuidelineSchema.shape.maxOilRate?.describe(
      'Numeric value storing max oil rate for this entity, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'SHG Producer Guideline view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const SPressSettingsView = parseView({
  view: { externalId: 'SPressSettings' },
  model: SPressSettingsSchema.extend({
    ...InstanceIdType.shape,
    entityName: SPressSettingsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    dateTime: SPressSettingsSchema.shape.dateTime?.describe(
      'Attribute capturing date time for this entity in the production optimization context.',
    ),
    minReservoirPressure: SPressSettingsSchema.shape.minReservoirPressure?.describe(
      'Numeric value storing min reservoir pressure for this entity, used in calculations, reporting, or model configuration.',
    ),
    maxReservoirPressure: SPressSettingsSchema.shape.maxReservoirPressure?.describe(
      'Numeric value storing max reservoir pressure for this entity, used in calculations, reporting, or model configuration.',
    ),
    minNumberShutInPressures: SPressSettingsSchema.shape.minNumberShutInPressures?.describe(
      'Numeric value storing min number shut in pressures for this entity, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'SPress Settings view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const SrmOutputsAllEntitiesView = parseView({
  view: { externalId: 'SRMOutputs_All_Entities' },
  model: SrmOutputsAllEntitiesSchema.extend({
    ...InstanceIdType.shape,
    entityName: SrmOutputsAllEntitiesSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    entityType: SrmOutputsAllEntitiesSchema.shape.entityType?.describe(
      'Time series signal representing entity type for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    executionBy: SrmOutputsAllEntitiesSchema.shape.executionBy?.describe(
      'Time series signal representing execution by for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    executionDate: SrmOutputsAllEntitiesSchema.shape.executionDate?.describe(
      'Time series signal representing execution date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    createdDate: SrmOutputsAllEntitiesSchema.shape.createdDate?.describe(
      'Time series signal representing created date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lastUpdatedDate: SrmOutputsAllEntitiesSchema.shape.lastUpdatedDate?.describe(
      'Time series signal representing last updated date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    scenario: SrmOutputsAllEntitiesSchema.shape.scenario?.describe(
      'Time series signal representing scenario for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    scenaroID: SrmOutputsAllEntitiesSchema.shape.scenaroID?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    vrrTarget: SrmOutputsAllEntitiesSchema.shape.vrrTarget?.describe(
      'Target value for this entity defined by planning or optimization processes, used to measure performance gaps and steer operations.',
    ),
    oilRateQuota: SrmOutputsAllEntitiesSchema.shape.oilRateQuota?.describe(
      'Time series signal representing oil rate quota for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasInjCapacity: SrmOutputsAllEntitiesSchema.shape.gasInjCapacity?.describe(
      'Time series signal representing gas inj capacity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterInjCapacity: SrmOutputsAllEntitiesSchema.shape.waterInjCapacity?.describe(
      'Time series signal representing water inj capacity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    isOfficial: SrmOutputsAllEntitiesSchema.shape.isOfficial?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    optimizedOilRateGAP: SrmOutputsAllEntitiesSchema.shape.optimizedOilRateGAP?.describe(
      'Time series signal representing optimized oil rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasRateGAP: SrmOutputsAllEntitiesSchema.shape.optimizedGasRateGAP?.describe(
      'Time series signal representing optimized gas rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterRateGAP: SrmOutputsAllEntitiesSchema.shape.optimizedWaterRateGAP?.describe(
      'Time series signal representing optimized water rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterInjRateGAP: SrmOutputsAllEntitiesSchema.shape.optimizedWaterInjRateGAP?.describe(
      'Time series signal representing optimized water inj rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasInjRateGAP: SrmOutputsAllEntitiesSchema.shape.optimizedGasInjRateGAP?.describe(
      'Time series signal representing optimized gas inj rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedOilRateSRM: SrmOutputsAllEntitiesSchema.shape.optimizedOilRateSRM?.describe(
      'Time series signal representing optimized oil rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasRateSRM: SrmOutputsAllEntitiesSchema.shape.optimizedGasRateSRM?.describe(
      'Time series signal representing optimized gas rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterRateSRM: SrmOutputsAllEntitiesSchema.shape.optimizedWaterRateSRM?.describe(
      'Time series signal representing optimized water rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterInjRateSRM: SrmOutputsAllEntitiesSchema.shape.optimizedWaterInjRateSRM?.describe(
      'Time series signal representing optimized water inj rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasInjRateSRM: SrmOutputsAllEntitiesSchema.shape.optimizedGasInjRateSRM?.describe(
      'Time series signal representing optimized gas inj rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedCO2InjRateSRM: SrmOutputsAllEntitiesSchema.shape.optimizedCO2InjRateSRM?.describe(
      'Time series signal representing optimized co2 inj rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedProdRateResCondSRM: SrmOutputsAllEntitiesSchema.shape.optimizedProdRateResCondSRM?.describe(
      'Time series signal representing optimized prod rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterInjRateResCondSRM: SrmOutputsAllEntitiesSchema.shape.optimizedWaterInjRateResCondSRM?.describe(
      'Time series signal representing optimized water inj rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasInjRateResCondSRM: SrmOutputsAllEntitiesSchema.shape.optimizedGasInjRateResCondSRM?.describe(
      'Time series signal representing optimized gas inj rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedCO2InjRateResCondSRM: SrmOutputsAllEntitiesSchema.shape.optimizedCO2InjRateResCondSRM?.describe(
      'Time series signal representing optimized co2 inj rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'SRMOutputs All Entities view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const SrmOutputsStringView = parseView({
  view: { externalId: 'SRMOutputs_String' },
  model: SrmOutputsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: SrmOutputsStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    executionBy: SrmOutputsStringSchema.shape.executionBy?.describe(
      'Time series signal representing execution by for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    executionDate: SrmOutputsStringSchema.shape.executionDate?.describe(
      'Time series signal representing execution date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    createdDate: SrmOutputsStringSchema.shape.createdDate?.describe(
      'Time series signal representing created date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lastUpdatedDate: SrmOutputsStringSchema.shape.lastUpdatedDate?.describe(
      'Time series signal representing last updated date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    scenario: SrmOutputsStringSchema.shape.scenario?.describe(
      'Time series signal representing scenario for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    scenaroID: SrmOutputsStringSchema.shape.scenaroID?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    optimizedOilRateSRM: SrmOutputsStringSchema.shape.optimizedOilRateSRM?.describe(
      'Time series signal representing optimized oil rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizeGasRateSRM: SrmOutputsStringSchema.shape.optimizeGasRateSRM?.describe(
      'Time series signal representing optimize gas rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizeWaterRateSRM: SrmOutputsStringSchema.shape.optimizeWaterRateSRM?.describe(
      'Time series signal representing optimize water rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterInjRateSRM: SrmOutputsStringSchema.shape.optimizedWaterInjRateSRM?.describe(
      'Time series signal representing optimized water inj rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasInjRateSRM: SrmOutputsStringSchema.shape.optimizedGasInjRateSRM?.describe(
      'Time series signal representing optimized gas inj rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedOilRateGAP: SrmOutputsStringSchema.shape.optimizedOilRateGAP?.describe(
      'Time series signal representing optimized oil rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasRateGAP: SrmOutputsStringSchema.shape.optimizedGasRateGAP?.describe(
      'Time series signal representing optimized gas rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterRateGAP: SrmOutputsStringSchema.shape.optimizedWaterRateGAP?.describe(
      'Time series signal representing optimized water rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterInjRateGAP: SrmOutputsStringSchema.shape.optimizedWaterInjRateGAP?.describe(
      'Time series signal representing optimized water inj rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasInjRateGAP: SrmOutputsStringSchema.shape.optimizedGasInjRateGAP?.describe(
      'Time series signal representing optimized gas inj rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedChokeSizeGAP: SrmOutputsStringSchema.shape.optimizedChokeSizeGAP?.describe(
      'Time series signal representing optimized choke size gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasLiftRateGAP: SrmOutputsStringSchema.shape.optimizedGasLiftRateGAP?.describe(
      'Time series signal representing optimized gas lift rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedESPFrequencyGAP: SrmOutputsStringSchema.shape.optimizedESPFrequencyGAP?.describe(
      'Time series signal representing optimized espfrequency gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedBHFPGAP: SrmOutputsStringSchema.shape.optimizedBHFPGAP?.describe(
      'Time series signal representing optimized bhfpgap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWHP: SrmOutputsStringSchema.shape.optimizedWHP?.describe(
      'Time series signal representing optimized whp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    isOfficial: SrmOutputsStringSchema.shape.isOfficial?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    optimizedInjRateResCond: SrmOutputsStringSchema.shape.optimizedInjRateResCond?.describe(
      'Time series signal representing optimized inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedProdRateResCond: SrmOutputsStringSchema.shape.optimizedProdRateResCond?.describe(
      'Time series signal representing optimized prod rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedWaterInjRateResCond: SrmOutputsStringSchema.shape.optimizedWaterInjRateResCond?.describe(
      'Time series signal representing optimized water inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedGasInjRateResCond: SrmOutputsStringSchema.shape.optimizedGasInjRateResCond?.describe(
      'Time series signal representing optimized gas inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellType: SrmOutputsStringSchema.shape.wellType?.describe(
      'Time series signal representing well type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedOilRateSRM: SrmOutputsStringSchema.shape.adHocOptimizedOilRateSRM?.describe(
      'Time series signal representing ad hoc optimized oil rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedGasRateSRM: SrmOutputsStringSchema.shape.adHocOptimizedGasRateSRM?.describe(
      'Time series signal representing ad hoc optimized gas rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedWaterRateSRM: SrmOutputsStringSchema.shape.adHocOptimizedWaterRateSRM?.describe(
      'Time series signal representing ad hoc optimized water rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedWaterInjRateSRM: SrmOutputsStringSchema.shape.adHocOptimizedWaterInjRateSRM?.describe(
      'Time series signal representing ad hoc optimized water inj rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedGasInjRateSRM: SrmOutputsStringSchema.shape.adHocOptimizedGasInjRateSRM?.describe(
      'Time series signal representing ad hoc optimized gas inj rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedInjRateResCond: SrmOutputsStringSchema.shape.adHocOptimizedInjRateResCond?.describe(
      'Time series signal representing ad hoc optimized inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedProdRateResCond: SrmOutputsStringSchema.shape.adHocOptimizedProdRateResCond?.describe(
      'Time series signal representing ad hoc optimized prod rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedWaterInjRateResCond: SrmOutputsStringSchema.shape.adHocOptimizedWaterInjRateResCond?.describe(
      'Time series signal representing ad hoc optimized water inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocOptimizedGasInjRateResCond: SrmOutputsStringSchema.shape.adHocOptimizedGasInjRateResCond?.describe(
      'Time series signal representing ad hoc optimized gas inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedOilRateGAP: SrmOutputsStringSchema.shape.adHocoptimizedOilRateGAP?.describe(
      'Time series signal representing ad hocoptimized oil rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedGasRateGAP: SrmOutputsStringSchema.shape.adHocoptimizedGasRateGAP?.describe(
      'Time series signal representing ad hocoptimized gas rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedWaterRateGAP: SrmOutputsStringSchema.shape.adHocoptimizedWaterRateGAP?.describe(
      'Time series signal representing ad hocoptimized water rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedWaterInjRateGAP: SrmOutputsStringSchema.shape.adHocoptimizedWaterInjRateGAP?.describe(
      'Time series signal representing ad hocoptimized water inj rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedGasInjRateGAP: SrmOutputsStringSchema.shape.adHocoptimizedGasInjRateGAP?.describe(
      'Time series signal representing ad hocoptimized gas inj rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedChokeSizeGAP: SrmOutputsStringSchema.shape.adHocoptimizedChokeSizeGAP?.describe(
      'Time series signal representing ad hocoptimized choke size gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedGasLiftRateGAP: SrmOutputsStringSchema.shape.adHocoptimizedGasLiftRateGAP?.describe(
      'Time series signal representing ad hocoptimized gas lift rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedESPFrequencyGAP: SrmOutputsStringSchema.shape.adHocoptimizedESPFrequencyGAP?.describe(
      'Time series signal representing ad hocoptimized espfrequency gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    adHocoptimizedBHFPGAP: SrmOutputsStringSchema.shape.adHocoptimizedBHFPGAP?.describe(
      'Time series signal representing ad hocoptimized bhfpgap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'SRMOutputs String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const SrmOutputView = parseView({
  view: { externalId: 'SRMOutput' },
  model: SrmOutputSchema.extend({
    ...InstanceIdType.shape,
    entityName: SrmOutputSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    executionBy: SrmOutputSchema.shape.executionBy?.describe(
      'Execution By attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    executionDate: SrmOutputSchema.shape.executionDate?.describe(
      'Attribute capturing execution date for this entity in the production optimization context.',
    ),
    scenario: SrmOutputSchema.shape.scenario?.describe(
      'Scenario attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    date: SrmOutputSchema.shape.date?.describe(
      'Attribute capturing date for this entity in the production optimization context.',
    ),
    optimizedOilRate: SrmOutputSchema.shape.optimizedOilRate?.describe(
      'Numeric value storing optimized oil rate for this entity, used in calculations, reporting, or model configuration.',
    ),
    optimizeGasRate: SrmOutputSchema.shape.optimizeGasRate?.describe(
      'Numeric value storing optimize gas rate for this entity, used in calculations, reporting, or model configuration.',
    ),
    optimizedCO2InjRateSRM: SrmOutputSchema.shape.optimizedCO2InjRateSRM?.describe(
      'Time series signal representing optimized co2 inj rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    optimizedCO2InjRateResCondSRM: SrmOutputSchema.shape.optimizedCO2InjRateResCondSRM?.describe(
      'Time series signal representing optimized co2 inj rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'SRMOutput view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const SrmSettingsView = parseView({
  view: { externalId: 'SRMSettings' },
  model: SrmSettingsSchema.extend({
    ...InstanceIdType.shape,
    entityName: SrmSettingsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    waterProductionWeight: SrmSettingsSchema.shape.waterProductionWeight?.describe(
      'Numeric value storing water production weight for this entity, used in calculations, reporting, or model configuration.',
    ),
    gasProductionWeight: SrmSettingsSchema.shape.gasProductionWeight?.describe(
      'Numeric value storing gas production weight for this entity, used in calculations, reporting, or model configuration.',
    ),
    waterInjectionWeight: SrmSettingsSchema.shape.waterInjectionWeight?.describe(
      'Numeric value storing water injection weight for this entity, used in calculations, reporting, or model configuration.',
    ),
    gasInjectionWeight: SrmSettingsSchema.shape.gasInjectionWeight?.describe(
      'Numeric value storing gas injection weight for this entity, used in calculations, reporting, or model configuration.',
    ),
    vrrWeight: SrmSettingsSchema.shape.vrrWeight?.describe(
      'Numeric value storing vrr weight for this entity, used in calculations, reporting, or model configuration.',
    ),
    maxIterations: SrmSettingsSchema.shape.maxIterations?.describe(
      'Numeric value storing max iterations for this entity, used in calculations, reporting, or model configuration.',
    ),
    allocationFactorType: SrmSettingsSchema.shape.allocationFactorType?.describe(
      'Allocation Factor Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    chokeCalculation: SrmSettingsSchema.shape.chokeCalculation?.describe(
      'Choke Calculation attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    minNumberWellTests: SrmSettingsSchema.shape.minNumberWellTests?.describe(
      'Numeric value storing min number well tests for this entity, used in calculations, reporting, or model configuration.',
    ),
    minRatio: SrmSettingsSchema.shape.minRatio?.describe(
      'Numeric value storing min ratio for this entity, used in calculations, reporting, or model configuration.',
    ),
    rateConstraintOption: SrmSettingsSchema.shape.rateConstraintOption?.describe(
      'Rate Constraint Option attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
  })?.describe(
    'SRMSettings view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const StringAssetView = parseView({
  view: { externalId: 'String_asset' },
  model: StringAssetSchema.extend({
    ...InstanceIdType.shape,
    name: StringAssetSchema.shape.name?.describe('String name'),
  }),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const StringFluidCompositionAgentView = parseView({
  view: { externalId: 'StringFluidComposition_Agent' },
  model: StringFluidCompositionAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: StringFluidCompositionAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'String-level fluid composition including oil, gas, and water fractions.\n\nContains detailed fluid composition data at the string level, including\nvarious gas and liquid fractions derived from well tests and production data.\nSourced from field measurements and laboratory analyses, enabling the\nresolution of analytical questions related to fluid behavior, phase\ninteractions, and reservoir performance. It excludes historical production\nrates or reservoir pressure data, which are available in other views. Use\ncases: optimizing production strategies, assessing flow assurance challenges,\nand conducting PVT studies for enhanced oil recovery.\n\n@name String Fluid Composition (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const StringFluidCompositionView = parseView({
  view: { externalId: 'StringFluidComposition' },
  model: StringFluidCompositionSchema.extend({
    ...InstanceIdType.shape,
    entityName: StringFluidCompositionSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    n2: StringFluidCompositionSchema.shape.n2?.describe(
      'Time series signal representing n2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    co2: StringFluidCompositionSchema.shape.co2?.describe(
      'Time series signal representing co2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    h2s: StringFluidCompositionSchema.shape.h2s?.describe(
      'Time series signal representing h2s for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c1: StringFluidCompositionSchema.shape.c1?.describe(
      'Time series signal representing c1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c2: StringFluidCompositionSchema.shape.c2?.describe(
      'Time series signal representing c2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c3: StringFluidCompositionSchema.shape.c3?.describe(
      'Time series signal representing c3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    iC4: StringFluidCompositionSchema.shape.iC4?.describe(
      'Time series signal representing i c4 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    nC4: StringFluidCompositionSchema.shape.nC4?.describe(
      'Time series signal representing n c4 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    iC5: StringFluidCompositionSchema.shape.iC5?.describe(
      'Time series signal representing i c5 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    nC5: StringFluidCompositionSchema.shape.nC5?.describe(
      'Time series signal representing n c5 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c6: StringFluidCompositionSchema.shape.c6?.describe(
      'Time series signal representing c6 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c7c14: StringFluidCompositionSchema.shape.c7c14?.describe(
      'Time series signal representing c7c14 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c15c25: StringFluidCompositionSchema.shape.c15c25?.describe(
      'Time series signal representing c15c25 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c26c80: StringFluidCompositionSchema.shape.c26c80?.describe(
      'Time series signal representing c26c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificGasGravity: StringFluidCompositionSchema.shape.specificGasGravity?.describe(
      'Time series signal representing specific gas gravity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wgr: StringFluidCompositionSchema.shape.wgr?.describe(
      'Time series signal representing wgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    condensateGravity: StringFluidCompositionSchema.shape.condensateGravity?.describe(
      'Time series signal representing condensate gravity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterSalinity: StringFluidCompositionSchema.shape.waterSalinity?.describe(
      'Time series signal representing water salinity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cgr: StringFluidCompositionSchema.shape.cgr?.describe(
      'Time series signal representing cgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fluidType: StringFluidCompositionSchema.shape.fluidType?.describe(
      'Time series signal representing fluid type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c7c13: StringFluidCompositionSchema.shape.c7c13?.describe(
      'Time series signal representing c7c13 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c14c23: StringFluidCompositionSchema.shape.c14c23?.describe(
      'Time series signal representing c14c23 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c24c73: StringFluidCompositionSchema.shape.c24c73?.describe(
      'Time series signal representing c24c73 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c7c15: StringFluidCompositionSchema.shape.c7c15?.describe(
      'Time series signal representing c7c15 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c7c10: StringFluidCompositionSchema.shape.c7c10?.describe(
      'Time series signal representing c7c10 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c25c80: StringFluidCompositionSchema.shape.c25c80?.describe(
      'Time series signal representing c25c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c16c25: StringFluidCompositionSchema.shape.c16c25?.describe(
      'Time series signal representing c16c25 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c14c28: StringFluidCompositionSchema.shape.c14c28?.describe(
      'Time series signal representing c14c28 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c11c16: StringFluidCompositionSchema.shape.c11c16?.describe(
      'Time series signal representing c11c16 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c17c24: StringFluidCompositionSchema.shape.c17c24?.describe(
      'Time series signal representing c17c24 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c17c25: StringFluidCompositionSchema.shape.c17c25?.describe(
      'Time series signal representing c17c25 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c7c18: StringFluidCompositionSchema.shape.c7c18?.describe(
      'Time series signal representing c7c18 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c7c16: StringFluidCompositionSchema.shape.c7c16?.describe(
      'Time series signal representing c7c16 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c17c29: StringFluidCompositionSchema.shape.c17c29?.describe(
      'Time series signal representing c17c29 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c30c18: StringFluidCompositionSchema.shape.c30c18?.describe(
      'Time series signal representing c30c18 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c30c80: StringFluidCompositionSchema.shape.c30c80?.describe(
      'Time series signal representing c30c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c16c26: StringFluidCompositionSchema.shape.c16c26?.describe(
      'Time series signal representing c16c26 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c27c80: StringFluidCompositionSchema.shape.c27c80?.describe(
      'Time series signal representing c27c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    iC4plusnC4: StringFluidCompositionSchema.shape.iC4plusnC4?.describe(
      'Time series signal representing i c4plusn c4 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    iC5plusnC5: StringFluidCompositionSchema.shape.iC5plusnC5?.describe(
      'Time series signal representing i c5plusn c5 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c17plus: StringFluidCompositionSchema.shape.c17plus?.describe(
      'Time series signal representing c17plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c25plus: StringFluidCompositionSchema.shape.c25plus?.describe(
      'Time series signal representing c25plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c28plus: StringFluidCompositionSchema.shape.c28plus?.describe(
      'Time series signal representing c28plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c14plus: StringFluidCompositionSchema.shape.c14plus?.describe(
      'Time series signal representing c14plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c74c80: StringFluidCompositionSchema.shape.c74c80?.describe(
      'Time series signal representing c74c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c80plus: StringFluidCompositionSchema.shape.c80plus?.describe(
      'Time series signal representing c80plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c81plus: StringFluidCompositionSchema.shape.c81plus?.describe(
      'Time series signal representing c81plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    c74plus: StringFluidCompositionSchema.shape.c74plus?.describe(
      'Time series signal representing c74plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'String Fluid Composition view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const StringFunctionView = parseView({
  view: { externalId: 'String_Function' },
  model: StringFunctionSchema.extend({
    ...InstanceIdType.shape,
    endDate: StringFunctionSchema.shape.endDate?.describe(
      'Attribute capturing end date for this production string in the production optimization context.',
    ),
    startDate: StringFunctionSchema.shape.startDate?.describe(
      'Attribute capturing start date for this production string in the production optimization context.',
    ),
    stringFunction: StringFunctionSchema.shape.stringFunction?.describe(
      'Text describing the functional role of the production string (for example main producer, backup, injector, idle), used in surveillance and planning.',
    ),
    string: StringFunctionSchema.shape.string?.describe(
      'String attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    stringCode: StringFunctionSchema.shape.stringCode?.describe(
      'String Code attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    primaryWellbore: StringFunctionSchema.shape.primaryWellbore?.describe(
      'Primary Wellbore attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    fieldCode: StringFunctionSchema.shape.fieldCode?.describe(
      'Field Code attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    well: StringFunctionSchema.shape.well?.describe(
      'Well attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
  })?.describe(
    'String Function view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const StringInputsStaticView = parseView({
  view: { externalId: 'StringInputs_Static' },
  model: StringInputsStaticSchema.extend({
    ...InstanceIdType.shape,
    entityName: StringInputsStaticSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellbore: StringInputsStaticSchema.shape.wellbore?.describe(
      'Wellbore attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    topDepth: StringInputsStaticSchema.shape.topDepth?.describe(
      'Numeric value storing top depth for this production string, used in calculations, reporting, or model configuration.',
    ),
    bottomDepth: StringInputsStaticSchema.shape.bottomDepth?.describe(
      'Numeric value storing bottom depth for this production string, used in calculations, reporting, or model configuration.',
    ),
    startDate: StringInputsStaticSchema.shape.startDate?.describe(
      'Attribute capturing start date for this production string in the production optimization context.',
    ),
    endDate: StringInputsStaticSchema.shape.endDate?.describe(
      'Attribute capturing end date for this production string in the production optimization context.',
    ),
    boreholeShape: StringInputsStaticSchema.shape.boreholeShape?.describe(
      'Borehole Shape attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    wellboreType: StringInputsStaticSchema.shape.wellboreType?.describe(
      'Wellbore Type attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    originalBaseX: StringInputsStaticSchema.shape.originalBaseX?.describe(
      'Numeric value storing original base x for this production string, used in calculations, reporting, or model configuration.',
    ),
    originalBaseY: StringInputsStaticSchema.shape.originalBaseY?.describe(
      'Numeric value storing original base y for this production string, used in calculations, reporting, or model configuration.',
    ),
    baseX: StringInputsStaticSchema.shape.baseX?.describe(
      'Numeric value storing base x for this production string, used in calculations, reporting, or model configuration.',
    ),
    baseY: StringInputsStaticSchema.shape.baseY?.describe(
      'Numeric value storing base y for this production string, used in calculations, reporting, or model configuration.',
    ),
    originalTopX: StringInputsStaticSchema.shape.originalTopX?.describe(
      'Numeric value storing original top x for this production string, used in calculations, reporting, or model configuration.',
    ),
    originalTopY: StringInputsStaticSchema.shape.originalTopY?.describe(
      'Numeric value storing original top y for this production string, used in calculations, reporting, or model configuration.',
    ),
    topX: StringInputsStaticSchema.shape.topX?.describe(
      'Numeric value storing top x for this production string, used in calculations, reporting, or model configuration.',
    ),
    topY: StringInputsStaticSchema.shape.topY?.describe(
      'Numeric value storing top y for this production string, used in calculations, reporting, or model configuration.',
    ),
    crs: StringInputsStaticSchema.shape.crs?.describe(
      'Crs attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    elevation: StringInputsStaticSchema.shape.elevation?.describe(
      'Numeric value storing elevation for this production string, used in calculations, reporting, or model configuration.',
    ),
    elevationRef: StringInputsStaticSchema.shape.elevationRef?.describe(
      'Elevation Ref attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    baseLongMidPerf: StringInputsStaticSchema.shape.baseLongMidPerf?.describe(
      'Numeric value storing base long mid perf for this production string, used in calculations, reporting, or model configuration.',
    ),
    baseLatMidPerf: StringInputsStaticSchema.shape.baseLatMidPerf?.describe(
      'Numeric value storing base lat mid perf for this production string, used in calculations, reporting, or model configuration.',
    ),
    baseXMidPerf: StringInputsStaticSchema.shape.baseXMidPerf?.describe(
      'Numeric value storing base xmid perf for this production string, used in calculations, reporting, or model configuration.',
    ),
    baseYMidPerf: StringInputsStaticSchema.shape.baseYMidPerf?.describe(
      'Numeric value storing base ymid perf for this production string, used in calculations, reporting, or model configuration.',
    ),
  })?.describe(
    'String Inputs Static view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const StringReservoirInputsView = parseView({
  view: { externalId: 'String_Reservoir_Inputs' },
  model: StringReservoirInputsSchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const SurveillanceAlarmsAgentView = parseView({
  view: { externalId: 'SurveillanceAlarms_Agent' },
  model: SurveillanceAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: SurveillanceAlarmsAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'Well surveillance alarms with medium or high priority.\n\nContains well surveillance alarms that are classified as medium or high\npriority, sourced from real-time monitoring systems and well status workflows.\nUse for frequency and types of alarms, wells affected, duration. Excludes low-priority or historical alarms.\n\nUse for: Real-Time Surveillance (WF18), Well Status (WF25).\n\n@name Well Surveillance Alarms (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const TicketRegistryAgentView = parseView({
  view: { externalId: 'TicketRegistry_Agent' },
  model: TicketRegistryAgentSchema.extend({
    ...InstanceIdType.shape,
    ticketId: TicketRegistryAgentSchema.shape.ticketId?.describe('Unique ticket identifier'),
    ticketSummary: TicketRegistryAgentSchema.shape.ticketSummary?.describe('Brief summary of the issue or action item'),
    ticketCategory: TicketRegistryAgentSchema.shape.ticketCategory?.describe(
      'Category classification (e.g., WELL_ISSUE, ESP_FAILURE, OPTIMIZATION).\nUse to filter tickets by problem type.',
    ),
    ticketSource: TicketRegistryAgentSchema.shape.ticketSource?.describe(
      'Origin of the ticket (e.g., ALARM, MANUAL, SURVEILLANCE, WORKFLOW).\nIndicates how the ticket was created.',
    ),
    entityType: TicketRegistryAgentSchema.shape.entityType?.describe(
      'Type of entity the ticket relates to: WELL, STRING, FIELD, RESERVOIR.\nUse to filter tickets by entity scope.',
    ),
    entityName: TicketRegistryAgentSchema.shape.entityName?.describe(
      'Name of the well, string, or field the ticket is associated with.\nPrimary filter for "show tickets for well X" queries.',
    ),
    status: TicketRegistryAgentSchema.shape.status?.describe(
      'Current ticket status: OPEN, IN_PROGRESS, CLOSED, CANCELLED.\nUse to filter active vs completed tickets.',
    ),
    priority: TicketRegistryAgentSchema.shape.priority?.describe(
      'Ticket priority level: LOW, MEDIUM, HIGH, URGENT.\nUse to filter critical issues that need immediate attention.',
    ),
    reportedDate: TicketRegistryAgentSchema.shape.reportedDate?.describe(
      'Date/time when the ticket was created or reported',
    ),
    dueDate: TicketRegistryAgentSchema.shape.dueDate?.describe('Target date for ticket resolution'),
    closedDate: TicketRegistryAgentSchema.shape.closedDate?.describe('Date/time when ticket was closed'),
    assignedTo: TicketRegistryAgentSchema.shape.assignedTo?.describe('Person or team assigned to resolve the ticket.'),
    description: TicketRegistryAgentSchema.shape.description?.describe(
      'Full description of the issue, including context and observations.',
    ),
    recommendation: TicketRegistryAgentSchema.shape.recommendation?.describe(
      'Recommended action or investigation steps to resolve the issue.',
    ),
    actionPlan: TicketRegistryAgentSchema.shape.actionPlan?.describe(
      'Detailed action plan with steps to remediate the issue.',
    ),
    isOpportunity: TicketRegistryAgentSchema.shape.isOpportunity?.describe(
      "Flag indicating if ticket represents a production optimization opportunity.\n'true' = opportunity for gain, 'false' = issue/problem.",
    ),
  })?.describe(
    'Troubleshooting ticket management for tracking open, closed, and assigned\noperations tickets.\n\nContains detailed records of troubleshooting tickets, including their\nlifecycle stages, statuses, and associated metadata such as priority and\nassignment. Sourced from operational ticketing systems, used to analyze ticket\ntrends, assess workload distribution, and identify areas requiring immediate\nattention. Typical analytical questions include tracking the status of tickets\nby category, evaluating response times, and determining the volume of tickets\nrelated to specific entities or opportunities. Excludes financial metrics or\nperformance indicators related to ticket resolution (see operational\nefficiency).',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const ValueTrackingAgentView = parseView({
  view: { externalId: 'ValueTracking_Agent' },
  model: ValueTrackingAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: ValueTrackingAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'Value realization tracking with production gain and cost saving records per\nopportunity.\n\nContains comprehensive data on value realization associated with production\ngains and cost savings in USD or barrel oil equivalent, derived from various\noptimization opportunities. Sourced from well performance metrics, ticketing\nsystems, and optimization records, allowing it to answer analytical questions\nregarding the effectiveness of specific interventions and their financial\nimpacts. It excludes raw production data or detailed operational metrics that\nmay be found in other views focused on real-time production tracking. Use\ncases: performance assessment of optimization strategies, financial\nforecasting, and operational efficiency analysis.\n\n@name Value Tracking (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const WaterAnalysisView = parseView({
  view: { externalId: 'Water_Analysis' },
  model: WaterAnalysisSchema.extend({
    ...InstanceIdType.shape,
    entityName: WaterAnalysisSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    analysisDate: WaterAnalysisSchema.shape.analysisDate?.describe(
      'Time series signal representing analysis date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sampleDate: WaterAnalysisSchema.shape.sampleDate?.describe(
      'Time series signal representing sample date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    barium: WaterAnalysisSchema.shape.barium?.describe(
      'Time series signal representing barium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    bicarbonate: WaterAnalysisSchema.shape.bicarbonate?.describe(
      'Time series signal representing bicarbonate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    boron: WaterAnalysisSchema.shape.boron?.describe(
      'Time series signal representing boron for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    bsw: WaterAnalysisSchema.shape.bsw?.describe(
      'Time series signal representing bsw for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calcium: WaterAnalysisSchema.shape.calcium?.describe(
      'Time series signal representing calcium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    calculatedTotalDisolvedSolids: WaterAnalysisSchema.shape.calculatedTotalDisolvedSolids?.describe(
      'Time series signal representing calculated total disolved solids for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    carbonate: WaterAnalysisSchema.shape.carbonate?.describe(
      'Time series signal representing carbonate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chloride: WaterAnalysisSchema.shape.chloride?.describe(
      'Time series signal representing chloride for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    dissolvedIron: WaterAnalysisSchema.shape.dissolvedIron?.describe(
      'Time series signal representing dissolved iron for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    h2s: WaterAnalysisSchema.shape.h2s?.describe(
      'Time series signal representing h2s for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    hydroxide: WaterAnalysisSchema.shape.hydroxide?.describe(
      'Time series signal representing hydroxide for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    iron: WaterAnalysisSchema.shape.iron?.describe(
      'Time series signal representing iron for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    magnesium: WaterAnalysisSchema.shape.magnesium?.describe(
      'Time series signal representing magnesium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    measuredTotalDisolvedSolids: WaterAnalysisSchema.shape.measuredTotalDisolvedSolids?.describe(
      'Time series signal representing measured total disolved solids for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilContentVol: WaterAnalysisSchema.shape.oilContentVol?.describe(
      'Time series signal representing oil content vol for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    ph: WaterAnalysisSchema.shape.ph?.describe(
      'Time series signal representing ph for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phosphorous: WaterAnalysisSchema.shape.phosphorous?.describe(
      'Time series signal representing phosphorous for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    phTemp: WaterAnalysisSchema.shape.phTemp?.describe(
      'Time series signal representing ph temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    potassium: WaterAnalysisSchema.shape.potassium?.describe(
      'Time series signal representing potassium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    resistivity: WaterAnalysisSchema.shape.resistivity?.describe(
      'Time series signal representing resistivity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    resistivityTemp: WaterAnalysisSchema.shape.resistivityTemp?.describe(
      'Time series signal representing resistivity temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    salinity: WaterAnalysisSchema.shape.salinity?.describe(
      'Time series signal representing salinity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sgTemp: WaterAnalysisSchema.shape.sgTemp?.describe(
      'Time series signal representing sg temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sodium: WaterAnalysisSchema.shape.sodium?.describe(
      'Time series signal representing sodium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    solubility: WaterAnalysisSchema.shape.solubility?.describe(
      'Time series signal representing solubility for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    specificGravity: WaterAnalysisSchema.shape.specificGravity?.describe(
      'Time series signal representing specific gravity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    strontium: WaterAnalysisSchema.shape.strontium?.describe(
      'Time series signal representing strontium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sulphate: WaterAnalysisSchema.shape.sulphate?.describe(
      'Time series signal representing sulphate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    temperature: WaterAnalysisSchema.shape.temperature?.describe(
      'Time series signal representing temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    totalIron: WaterAnalysisSchema.shape.totalIron?.describe(
      'Time series signal representing total iron for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    totalSuspendedSolids: WaterAnalysisSchema.shape.totalSuspendedSolids?.describe(
      'Time series signal representing total suspended solids for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    id: WaterAnalysisSchema.shape.id?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    remarks: WaterAnalysisSchema.shape.remarks?.describe(
      'Time series signal representing remarks for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    companyProgramRef: WaterAnalysisSchema.shape.companyProgramRef?.describe(
      'Time series signal representing company program ref for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    companySampleNo: WaterAnalysisSchema.shape.companySampleNo?.describe(
      'Time series signal representing company sample no for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    reportRef: WaterAnalysisSchema.shape.reportRef?.describe(
      'Time series signal representing report ref for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sampleType: WaterAnalysisSchema.shape.sampleType?.describe(
      'Time series signal representing sample type for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Water Analysis view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellBehaviourAlarmsAgentView = parseView({
  view: { externalId: 'WellBehaviourAlarms_Agent' },
  model: WellBehaviourAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: WellBehaviourAlarmsAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'Well behaviour and productivity alarms with medium or high priority.\n\nContains well behaviour and productivity alarms, alarms classified with medium\nor high priority. Sourced from workflows that monitor well operating\nenvelopes, real-time measurements of well rates and pressures, and reservoir\npressure estimations. Use for alarm frequency, duration, impact on well performance. Excludes low-priority alarms.\n\nUse for: Real-Time Surveillance (WF18), envelope (WF6), rate/pressure (WF10).\n\n@name Well Behaviour & Productivity Alarms (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const WellChokeMappingView = parseView({
  view: { externalId: 'Well_Choke_Mapping' },
  model: WellChokeMappingSchema.extend({
    ...InstanceIdType.shape,
    entityName: WellChokeMappingSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    choketype: WellChokeMappingSchema.shape.choketype?.describe(
      'Time series signal representing choketype for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasLiftChokeType: WellChokeMappingSchema.shape.gasLiftChokeType?.describe(
      'Time series signal representing gas lift choke type for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Well Choke Mapping view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellInputsStaticView = parseView({
  view: { externalId: 'WellInputs_Static' },
  model: WellInputsStaticSchema.extend({
    ...InstanceIdType.shape,
    entityName: WellInputsStaticSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    elevation: WellInputsStaticSchema.shape.elevation?.describe(
      'Numeric value storing elevation for this well, used in calculations, reporting, or model configuration.',
    ),
    originalCRS: WellInputsStaticSchema.shape.originalCRS?.describe(
      'Numeric value storing original crs for this well, used in calculations, reporting, or model configuration.',
    ),
    originalX: WellInputsStaticSchema.shape.originalX?.describe(
      'Numeric value storing original x for this well, used in calculations, reporting, or model configuration.',
    ),
    originalY: WellInputsStaticSchema.shape.originalY?.describe(
      'Numeric value storing original y for this well, used in calculations, reporting, or model configuration.',
    ),
    crs: WellInputsStaticSchema.shape.crs?.describe(
      'Numeric value storing crs for this well, used in calculations, reporting, or model configuration.',
    ),
    latitude: WellInputsStaticSchema.shape.latitude?.describe(
      'Numeric value storing latitude for this well, used in calculations, reporting, or model configuration.',
    ),
    longitude: WellInputsStaticSchema.shape.longitude?.describe(
      'Numeric value storing longitude for this well, used in calculations, reporting, or model configuration.',
    ),
    elevationRef: WellInputsStaticSchema.shape.elevationRef?.describe(
      'Elevation Ref attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    spudDate: WellInputsStaticSchema.shape.spudDate?.describe(
      'Attribute capturing spud date for this well in the production optimization context.',
    ),
  })?.describe(
    'Well Inputs Static view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellInputsStringView = parseView({
  view: { externalId: 'WellInputs_String' },
  model: WellInputsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: WellInputsStringSchema.shape.entityName?.describe('Reference to the String_asset entity'),
    pumpFrequency: WellInputsStringSchema.shape.pumpFrequency?.describe(
      'ESP motor frequency (Hz) from variable speed drive (VSD)',
    ),
    pumpIntakePress: WellInputsStringSchema.shape.pumpIntakePress?.describe(
      'ESP pump intake pressure (psia or bara) measured at the pump suction',
    ),
    pumpDischargePress: WellInputsStringSchema.shape.pumpDischargePress?.describe(
      'ESP pump discharge pressure (psia or bara) measured at pump outlet',
    ),
    pumpIntakeTemp: WellInputsStringSchema.shape.pumpIntakeTemp?.describe('Temperature (°F or °C) at ESP pump intake'),
    pumpDischargeTemp: WellInputsStringSchema.shape.pumpDischargeTemp?.describe(
      'Temperature (°F or °C) at ESP pump discharge',
    ),
    pumpMotorTemp: WellInputsStringSchema.shape.pumpMotorTemp?.describe('ESP motor winding temperature (°F or °C)'),
    pumpCurrent: WellInputsStringSchema.shape.pumpCurrent?.describe('ESP motor current draw (amps)'),
    pumpVoltage: WellInputsStringSchema.shape.pumpVoltage?.describe('ESP motor voltage (volts) from VSD'),
    pumpVibration: WellInputsStringSchema.shape.pumpVibration?.describe('ESP vibration level (g or mm/s)'),
    gasLiftInjRate: WellInputsStringSchema.shape.gasLiftInjRate?.describe(
      'Gas lift injection rate (MSCF/d) measured at the well',
    ),
    gasLiftFlowCVInletPress: WellInputsStringSchema.shape.gasLiftFlowCVInletPress?.describe(
      'Pressure (psia or bara) upstream of gas lift control valve',
    ),
    gasLiftInjTemp: WellInputsStringSchema.shape.gasLiftInjTemp?.describe(
      'Gas lift gas temperature (°F or °C) at injection point',
    ),
    gasLiftFlowCVSize: WellInputsStringSchema.shape.gasLiftFlowCVSize?.describe(
      'Gas lift control valve size or opening position (% or 64ths inch)',
    ),
    wellHeadPress: WellInputsStringSchema.shape.wellHeadPress?.describe(
      'Tubing head pressure (THP) or wellhead pressure (WHP) in psia or bara',
    ),
    wellHeadTemp: WellInputsStringSchema.shape.wellHeadTemp?.describe('Wellhead temperature (°F or °C)'),
    chokeSize: WellInputsStringSchema.shape.chokeSize?.describe('Production choke bean size (64ths inch) or trim size'),
    flowLinePress: WellInputsStringSchema.shape.flowLinePress?.describe(
      'Flowline pressure (psia or bara) downstream of choke, typically at pipeline\nconnection',
    ),
    flowLineTemp: WellInputsStringSchema.shape.flowLineTemp?.describe(
      'Flowline temperature (°F or °C) downstream of choke',
    ),
    casingHeadPress: WellInputsStringSchema.shape.casingHeadPress?.describe(
      'Casing head pressure (psia or bara) at surface',
    ),
    bottomHolePress: WellInputsStringSchema.shape.bottomHolePress?.describe(
      'Flowing bottomhole pressure (FBHP) in psia or bara from permanent downhole gauge.\nDirect measurement of reservoir-wellbore interface pressure',
    ),
    bottomHoleTemp: WellInputsStringSchema.shape.bottomHoleTemp?.describe(
      'Bottomhole temperature (°F or °C) from permanent downhole gauge',
    ),
    liftType: WellInputsStringSchema.shape.liftType?.describe(
      "Current artificial lift method: 'NATURAL_FLOW', 'ESP', 'GAS_LIFT', 'ROD_PUMP',\n'JET_PUMP', 'PCP'",
    ),
    annulusPress: WellInputsStringSchema.shape.annulusPress?.describe(
      'Annulus pressure (psia or bara) between tubing and casing',
    ),
    wingValve: WellInputsStringSchema.shape.wingValve?.describe('Wing valve status: 1 = OPEN, 0 = CLOSED'),
    controlValve: WellInputsStringSchema.shape.controlValve?.describe('Control valve position or status'),
    downstreamPressure: WellInputsStringSchema.shape.downstreamPressure?.describe(
      'Pressure (psia or bara) downstream of production choke',
    ),
    gasRateFlow: WellInputsStringSchema.shape.gasRateFlow?.describe(
      'Measured gas flow rate (MSCF/d) from wellhead or separator meter',
    ),
    gasInjRate: WellInputsStringSchema.shape.gasInjRate?.describe('Gas injection rate (MSCF/d) for gas injector wells'),
    waterInjRate: WellInputsStringSchema.shape.waterInjRate?.describe(
      'Water injection rate (stb/d or m³/d) for water injector wells',
    ),
    sPress: WellInputsStringSchema.shape.sPress?.describe('Separator or station pressure (psia or bara)'),
    potentialOilProduction: WellInputsStringSchema.shape.potentialOilProduction?.describe(
      'Unconstrained oil production potential (stb/d) - maximum rate achievable with\nno surface constraints (choke fully open, unlimited processing capacity).\nUsed as upper bound for optimization and gap analysis.',
    ),
    targetOilProduction: WellInputsStringSchema.shape.targetOilProduction?.describe(
      'Target oil production rate (stb/d) from production plan',
    ),
    depthSensor: WellInputsStringSchema.shape.depthSensor?.describe(
      'Depth (ft or m) of the downhole pressure/temperature sensor',
    ),
    chokeDownstreamPressure1: WellInputsStringSchema.shape.chokeDownstreamPressure1?.describe(
      'First downstream pressure measurement point after choke (psia or bara).\nMay be used when multiple pressure taps exist downstream of choke.',
    ),
    chokeDownstreamPressure2: WellInputsStringSchema.shape.chokeDownstreamPressure2?.describe(
      'Second downstream pressure measurement point after choke (psia or bara).\nAdditional tap for redundancy or different location in manifold.',
    ),
    gasInjWellheadPress: WellInputsStringSchema.shape.gasInjWellheadPress?.describe(
      'Wellhead pressure (psia or bara) for gas injection wells',
    ),
    waterInjWellheadPress: WellInputsStringSchema.shape.waterInjWellheadPress?.describe(
      'Wellhead pressure (psia or bara) for water injection wells',
    ),
    gasInjChokeOpening: WellInputsStringSchema.shape.gasInjChokeOpening?.describe(
      'Gas injection choke opening position (% open)',
    ),
    waterInjChokeOpening: WellInputsStringSchema.shape.waterInjChokeOpening?.describe(
      'Water injection choke opening position (% open)',
    ),
    giHeaderPressure: WellInputsStringSchema.shape.giHeaderPressure?.describe(
      'Gas injection header pressure (psia or bara)',
    ),
    giHeaderTemperature: WellInputsStringSchema.shape.giHeaderTemperature?.describe(
      'Gas injection header temperature (°F or °C)',
    ),
    waterHeaderPressure: WellInputsStringSchema.shape.waterHeaderPressure?.describe(
      'Water injection header pressure (psia or bara)',
    ),
    potentialGasProduction: WellInputsStringSchema.shape.potentialGasProduction?.describe(
      'Unconstrained gas production potential (MSCF/d) - maximum rate achievable\nwith no surface constraints.',
    ),
    targetGasProduction: WellInputsStringSchema.shape.targetGasProduction?.describe(
      'Target gas production rate (MSCF/d) from production plan.',
    ),
    potentialWaterProduction: WellInputsStringSchema.shape.potentialWaterProduction?.describe(
      'Unconstrained water production potential (stb/d) - maximum water rate at\nunconstrained oil/liquid rate',
    ),
    targetWaterProduction: WellInputsStringSchema.shape.targetWaterProduction?.describe(
      'Target water production rate (stb/d) from production plan',
    ),
    potentialWaterInjection: WellInputsStringSchema.shape.potentialWaterInjection?.describe(
      'Unconstrained water injection potential (stb/d) - maximum injection rate\nachievable with unlimited supply and pressure',
    ),
    targetWaterInjection: WellInputsStringSchema.shape.targetWaterInjection?.describe(
      'Target water injection rate (stb/d) from injection plan',
    ),
    potentialGasInjection: WellInputsStringSchema.shape.potentialGasInjection?.describe(
      'Unconstrained gas injection potential (MSCF/d) - maximum injection rate\nachievable with unlimited supply and pressure.',
    ),
    targetGasInjection: WellInputsStringSchema.shape.targetGasInjection?.describe(
      'Target gas injection rate (MSCF/d) from injection plan',
    ),
    modelComposition: WellInputsStringSchema.shape.modelComposition?.describe(
      'Reference to fluid composition or PVT model used for well calculations.\nMay be a composition ID or direct reference to composition table.',
    ),
    gasLiftFlowCVInletTemp: WellInputsStringSchema.shape.gasLiftFlowCVInletTemp?.describe(
      'Temperature (°F or °C) upstream of gas lift control valve',
    ),
    surfaceSafetyValve: WellInputsStringSchema.shape.surfaceSafetyValve?.describe(
      'Surface safety valve (SSV) status: 1 = OPEN, 0 = CLOSED',
    ),
    toProdHeader: WellInputsStringSchema.shape.toProdHeader?.describe(
      'Valve status or flag indicating well is routed to production header: 1 = routed\nto production, 0 = not routed',
    ),
    toTestHeader: WellInputsStringSchema.shape.toTestHeader?.describe(
      'Valve status or flag indicating well is routed to test separator: 1 = on test,\n0 = not on test',
    ),
    subSurfaceSafetyValve: WellInputsStringSchema.shape.subSurfaceSafetyValve?.describe(
      'Subsurface safety valve (SSSV) status: 1 = OPEN, 0 = CLOSED',
    ),
    chokeOpening: WellInputsStringSchema.shape.chokeOpening?.describe(
      'Production choke opening position (% open) for adjustable chokes',
    ),
  })?.describe(
    'REAL-TIME SENSOR AND MEASUREMENT DATA for well strings. Contains high-frequency\ntime series from SCADA, historians, and downhole gauges used as inputs for\nwell models, surveillance calculations, and optimization.\n\nKEY DATA CATEGORIES:\n- ESP parameters: pump frequency, pressures, temperatures, current, voltage, vibration\n- Gas lift parameters: injection rate, CV pressure/temperature, choke settings\n- Wellhead/flowline: pressures, temperatures, choke size/opening\n- Downhole: BHP, BHT, annulus pressure (if instrumented)\n- Valve status: SSV, SSSV, wing valve, control valve positions\n- Targets/potentials: planned rates and unconstrained capacities\n\nDATA SOURCES:\n- SCADA/DCS for real-time surface measurements\n- Historians for time series storage\n- Downhole gauges for BHP/BHT (if instrumented)\n- Planning systems for targets and potentials',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellMovementAgentView = parseView({
  view: { externalId: 'WellMovement_Agent' },
  model: WellMovementAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: WellMovementAgentSchema.shape.wellString?.describe('Reference to well string'),
  })?.describe(
    'Well movement records including choke adjustments, ESP frequency changes, and\nGL optimization.\n\nContains detailed records of operational changes made to wells, choke\nadjustments, ESP frequency changes, GL rate optimization, and injection rate\nmodifications. Sourced from well management systems and operational logs,\nallowing for analysis of optimization recommendations and their execution\nstatus. Answers questions on the impact of specific adjustments on well\nperformance and efficiency, as well as track the timeline of changes made.\nExcludes historical production data or reservoir characteristics (see other\nrelated views).\n\n@name Well Movement (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const WellOutputsStringView = parseView({
  view: { externalId: 'WellOutputs_String' },
  model: WellOutputsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: WellOutputsStringSchema.shape.entityName?.describe('Reference to the String_asset entity'),
    onlineStatus: WellOutputsStringSchema.shape.onlineStatus?.describe(
      "Current operational status of the string: 'ONLINE' (producing/injecting),\n'OFFLINE' (shut-in), 'TEST' (on well test), 'UNSTABLE' (transient conditions).\nPrimary flag for filtering active strings in surveillance dashboards.",
    ),
    steadyStateStatus: WellOutputsStringSchema.shape.steadyStateStatus?.describe(
      "Indicates whether the string is in steady-state flow conditions: 'STEADY' or\n'TRANSIENT'",
    ),
    systemAnalysisLiquidRateStd: WellOutputsStringSchema.shape.systemAnalysisLiquidRateStd?.describe(
      'Total liquid rate at stock-tank conditions (stb/d) from nodal analysis\n(IPR-VLP intersection)',
    ),
    systemAnalysisOilRateStd: WellOutputsStringSchema.shape.systemAnalysisOilRateStd?.describe(
      'Oil rate at stock-tank conditions (stb/d) from nodal analysis',
    ),
    systemAnalysisGasRateStd: WellOutputsStringSchema.shape.systemAnalysisGasRateStd?.describe(
      'Gas rate at standard conditions (MSCF/d) from nodal analysis',
    ),
    systemAnalysisWaterRateStd: WellOutputsStringSchema.shape.systemAnalysisWaterRateStd?.describe(
      'Water rate at stock-tank conditions (stb/d) from nodal analysis.\nCalculated from liquid rate using water cut.',
    ),
    systemAnalysisFbhp: WellOutputsStringSchema.shape.systemAnalysisFbhp?.describe(
      'Flowing bottomhole pressure (psia or bara) at the operating point from\nnodal analysis',
    ),
    chokeAnalysisLiquidRateStd: WellOutputsStringSchema.shape.chokeAnalysisLiquidRateStd?.describe(
      'Total liquid rate (stb/d) calculated from choke equation using upstream\npressure, choke size, and fluid properties',
    ),
    chokeAnalysisOilRateStd: WellOutputsStringSchema.shape.chokeAnalysisOilRateStd?.describe(
      'Oil rate (stb/d) from choke analysis, derived from liquid rate and water cut.',
    ),
    chokeAnalysisGasRateStd: WellOutputsStringSchema.shape.chokeAnalysisGasRateStd?.describe(
      'Gas rate (MSCF/d) from choke analysis, calculated from choke equation\nor derived from liquid rate and GOR.',
    ),
    chokeAnalysisWaterRateStd: WellOutputsStringSchema.shape.chokeAnalysisWaterRateStd?.describe(
      'Water rate (stb/d) from choke analysis, derived from liquid rate and water cut.',
    ),
    chokeAnalysisFbhp: WellOutputsStringSchema.shape.chokeAnalysisFbhp?.describe(
      'Estimated flowing BHP (psia or bara) from choke analysis, typically\nback-calculated from WHP using VLP or pressure traverse.',
    ),
    iprAnalysisLiquidRateStd: WellOutputsStringSchema.shape.iprAnalysisLiquidRateStd?.describe(
      'Liquid rate (stb/d) from IPR curve at current reservoir and flowing\nconditions',
    ),
    iprAnalysisOilRateStd: WellOutputsStringSchema.shape.iprAnalysisOilRateStd?.describe(
      'Oil rate (stb/d) from IPR curve analysis.',
    ),
    iprAnalysisGasRateStd: WellOutputsStringSchema.shape.iprAnalysisGasRateStd?.describe(
      'Gas rate (MSCF/d) from IPR curve analysis.',
    ),
    iprAnalysisWaterRateStd: WellOutputsStringSchema.shape.iprAnalysisWaterRateStd?.describe(
      'Water rate (stb/d) from IPR curve analysis.',
    ),
    iprAnalysisFbhp: WellOutputsStringSchema.shape.iprAnalysisFbhp?.describe(
      'Flowing BHP (psia or bara) used for IPR curve lookup or the result\nof IPR analysis at current rate.',
    ),
    hoursOnline: WellOutputsStringSchema.shape.hoursOnline?.describe(
      'Cumulative hours the string has been online (producing/injecting) since\nlast reset or start of tracking period',
    ),
    curveAnalysisLiquidRateStd: WellOutputsStringSchema.shape.curveAnalysisLiquidRateStd?.describe(
      'Liquid rate (stb/d) from performance curve lookup, typically a rate vs\npressure or rate vs time curve derived from historical data.',
    ),
    curveAnalysisOilRateStd: WellOutputsStringSchema.shape.curveAnalysisOilRateStd?.describe(
      'Oil rate (stb/d) from performance curve analysis.',
    ),
    curveAnalysisGasRateStd: WellOutputsStringSchema.shape.curveAnalysisGasRateStd?.describe(
      'Gas rate (MSCF/d) from performance curve analysis.',
    ),
    curveAnalysisWaterRateStd: WellOutputsStringSchema.shape.curveAnalysisWaterRateStd?.describe(
      'Water rate (stb/d) from performance curve analysis.',
    ),
    curveAnalysisFbhp: WellOutputsStringSchema.shape.curveAnalysisFbhp?.describe(
      'Flowing BHP (psia or bara) from performance curve analysis.',
    ),
    wellType: WellOutputsStringSchema.shape.wellType?.describe(
      "Classification of the well type: 'PRODUCTION', 'INJECTION', 'OBSERVATION',\n'DISPOSAL', 'WAG'",
    ),
    product: WellOutputsStringSchema.shape.product?.describe(
      "Primary product type: 'OIL', 'GAS', 'CONDENSATE', 'WATER'",
    ),
    wag: WellOutputsStringSchema.shape.wag?.describe(
      "Water-Alternating-Gas (WAG) status: 'YES' if string alternates between water\nand gas injection, 'NO' otherwise",
    ),
    liftType: WellOutputsStringSchema.shape.liftType?.describe(
      "Current artificial lift method: 'NATURAL_FLOW', 'ESP', 'GAS_LIFT', 'ROD_PUMP',\n'JET_PUMP', 'PCP'",
    ),
    cumulativeWaterInjVol: WellOutputsStringSchema.shape.cumulativeWaterInjVol?.describe(
      'Cumulative water injection volume (stb or m³) since start of injection\nor last reset',
    ),
    cumulativeWaterInjPress: WellOutputsStringSchema.shape.cumulativeWaterInjPress?.describe(
      'Average or reference wellhead pressure (psia or bara) during cumulative\nwater injection period',
    ),
    cumulativeGasInjVol: WellOutputsStringSchema.shape.cumulativeGasInjVol?.describe(
      'Cumulative gas injection volume (MSCF or km³) since start of injection\nor last reset',
    ),
    cumulativeGasInjPress: WellOutputsStringSchema.shape.cumulativeGasInjPress?.describe(
      'Average or reference wellhead pressure (psia or bara) during cumulative\ngas injection period',
    ),
    wellTestValidation: WellOutputsStringSchema.shape.wellTestValidation?.describe(
      "Validation status of the most recent well test: 'VALID', 'INVALID',\n'PENDING_REVIEW'",
    ),
    instrumented: WellOutputsStringSchema.shape.instrumented?.describe(
      'Flag indicating whether the string has downhole instrumentation (gauges):\n1 = instrumented with real-time pressure/temperature, 0 = not instrumented.\nAffects data quality and available analysis methods.',
    ),
    glirMeasured: WellOutputsStringSchema.shape.glirMeasured?.describe(
      'Measured gas lift injection rate (MSCF/d) from flow meter',
    ),
    glirNetworkSimulation: WellOutputsStringSchema.shape.glirNetworkSimulation?.describe(
      'Gas lift injection rate (MSCF/d) from network simulation',
    ),
    glirChokeEquation: WellOutputsStringSchema.shape.glirChokeEquation?.describe(
      'Gas lift injection rate (MSCF/d) calculated from GL choke equation\nusing upstream pressure and choke setting.',
    ),
    glirAllocated: WellOutputsStringSchema.shape.glirAllocated?.describe(
      'Allocated gas lift injection rate (MSCF/d) from daily allocation.\nMay differ from measured if metering is at a header level.',
    ),
    glirSelected: WellOutputsStringSchema.shape.glirSelected?.describe(
      'Selected/priority gas lift rate (MSCF/d) used for optimization and\nsurveillance',
    ),
    glirSelectedType: WellOutputsStringSchema.shape.glirSelectedType?.describe(
      "Source of the selected GLIR: 'MEASURED', 'NETWORK_SIMULATION',\n'CHOKE_EQUATION', 'ALLOCATED'",
    ),
    wellPerformance: WellOutputsStringSchema.shape.wellPerformance?.describe(
      'Well performance indicator or score (dimensionless)',
    ),
    priorityLiquidRateStd: WellOutputsStringSchema.shape.priorityLiquidRateStd?.describe(
      'Selected best-available liquid rate (stb/d) for surveillance',
    ),
    priorityOilRateStd: WellOutputsStringSchema.shape.priorityOilRateStd?.describe(
      'Selected best-available oil rate (stb/d) for surveillance',
    ),
    priorityGasRateStd: WellOutputsStringSchema.shape.priorityGasRateStd?.describe(
      'Selected best-available gas rate (MSCF/d) for surveillance',
    ),
    priotiryWaterRateStd: WellOutputsStringSchema.shape.priotiryWaterRateStd?.describe(
      '[DEPRECATED - use priorityWaterRateStd] Legacy field with typo in name.',
    ),
    priorityFbhp: WellOutputsStringSchema.shape.priorityFbhp?.describe(
      'Selected best-available flowing BHP (psia or bara) for surveillance.\nUse this as the primary BHP when a single value is needed.',
    ),
    qliqDelta: WellOutputsStringSchema.shape.qliqDelta?.describe(
      'Difference between current liquid rate and a reference rate (stb/d).\nPositive = producing above reference; negative = below reference.\nUsed for rate change monitoring and alarm triggering.',
    ),
    productivityIndex: WellOutputsStringSchema.shape.productivityIndex?.describe(
      'Productivity index (PI) for producers, in stb/d/psi or m³/d/bar.\nMeasures reservoir-to-wellbore flow efficiency',
    ),
    injectivityIndex: WellOutputsStringSchema.shape.injectivityIndex?.describe(
      'Injectivity index (II) for injectors, in stb/d/psi or m³/d/bar.\nMeasures wellbore-to-reservoir flow efficiency for injection wells.',
    ),
    reservoirPressureDatum: WellOutputsStringSchema.shape.reservoirPressureDatum?.describe(
      'Current reservoir pressure (psia or bara) at the datum depth for this string.\nMay be updated from pressure surveys, material balance, or simulation.',
    ),
    reservoirPressureMidPerforation: WellOutputsStringSchema.shape.reservoirPressureMidPerforation?.describe(
      'Reservoir pressure (psia or bara) corrected to mid-perforation depth.\nUsed directly in IPR calculations and nodal analysis.',
    ),
    prosperWellType: WellOutputsStringSchema.shape.prosperWellType?.describe(
      "Well type as configured in the PROSPER well model: 'CASED_HOLE', 'OPEN_HOLE',\n'MULTILATERAL', etc",
    ),
    prosperProduct: WellOutputsStringSchema.shape.prosperProduct?.describe(
      "Product type as configured in PROSPER model: 'OIL', 'GAS', 'CONDENSATE'.\nDetermines PVT correlations and flow regime calculations in the model.",
    ),
    prosperWag: WellOutputsStringSchema.shape.prosperWag?.describe('WAG configuration in PROSPER model'),
    prosperLiftType: WellOutputsStringSchema.shape.prosperLiftType?.describe(
      'Lift type as configured in PROSPER model',
    ),
    sluggingStatus: WellOutputsStringSchema.shape.sluggingStatus?.describe(
      "Indicates whether the string is experiencing slugging flow: 'SLUGGING',\n'STABLE', 'SEVERE_SLUGGING'",
    ),
    systemAnalysisStatus: WellOutputsStringSchema.shape.systemAnalysisStatus?.describe(
      "Status of system analysis calculation: 'SUCCESS', 'FAILED', 'NO_INTERSECTION',\n'INVALID_INPUT'",
    ),
    espqlAnalysisStatus: WellOutputsStringSchema.shape.espqlAnalysisStatus?.describe(
      "Status of ESP rate calculation (ESP Q-Liquid analysis): 'SUCCESS',\n'FAILED', 'NO_DATA'",
    ),
    glqlAnalysisStatus: WellOutputsStringSchema.shape.glqlAnalysisStatus?.describe(
      "Status of gas lift rate calculation: 'SUCCESS', 'FAILED', 'NO_DATA'.\nCheck before using gas lift-derived rates.",
    ),
    grdAnalysisStatus: WellOutputsStringSchema.shape.grdAnalysisStatus?.describe(
      "Status of Gas Rate Decline analysis: 'SUCCESS', 'FAILED', 'INSUFFICIENT_DATA'.\nCheck before using GRD-derived forecasts.",
    ),
    chokeAnalysisStatus: WellOutputsStringSchema.shape.chokeAnalysisStatus?.describe(
      "Status of choke analysis calculation: 'SUCCESS', 'FAILED', 'CRITICAL_FLOW',\n'SUBCRITICAL_FLOW'",
    ),
    priorityMethod: WellOutputsStringSchema.shape.priorityMethod?.describe(
      "Analysis method selected as the priority/best source for rates:\n'SYSTEM_ANALYSIS', 'CHOKE_ANALYSIS', 'ALLOCATION', 'WELL_TEST', 'DATA_ANALYSIS'.\nIndicates which method's rates populate the priority* fields.",
    ),
    simulationId: WellOutputsStringSchema.shape.simulationId?.describe(
      'Unique identifier linking this string to its representation in the network\nsimulation model',
    ),
    vlpAnalysisLiquidRateStd: WellOutputsStringSchema.shape.vlpAnalysisLiquidRateStd?.describe(
      'Liquid rate (stb/d) from VLP curve at current tubing and separator\nconditions',
    ),
    vlpAnalysisOilRateStd: WellOutputsStringSchema.shape.vlpAnalysisOilRateStd?.describe(
      'Oil rate (stb/d) from VLP curve analysis.',
    ),
    vlpAnalysisGasRateStd: WellOutputsStringSchema.shape.vlpAnalysisGasRateStd?.describe(
      'Gas rate (MSCF/d) from VLP curve analysis.',
    ),
    vlpAnalysisWaterRateStd: WellOutputsStringSchema.shape.vlpAnalysisWaterRateStd?.describe(
      'Water rate (stb/d) from VLP curve analysis.',
    ),
    vlpAnalysisFbhp: WellOutputsStringSchema.shape.vlpAnalysisFbhp?.describe(
      'Flowing BHP (psia or bara) from VLP curve at current rate and WHP conditions.',
    ),
    simulationChokeId: WellOutputsStringSchema.shape.simulationChokeId?.describe(
      'Identifier for the choke node associated with this string in the network\nsimulation',
    ),
    simulationIprInput: WellOutputsStringSchema.shape.simulationIprInput?.describe(
      'IPR curve or parameters used as input to the network simulation for this\nstring',
    ),
    simulationCurveInput: WellOutputsStringSchema.shape.simulationCurveInput?.describe(
      'Performance curve input for network simulation, typically combining IPR\nand VLP curves for nodal analysis.',
    ),
    simulationVlpInput: WellOutputsStringSchema.shape.simulationVlpInput?.describe(
      'VLP curve or parameters used as input to the network simulation for this\nstring',
    ),
    hallLine: WellOutputsStringSchema.shape.hallLine?.describe(
      'Hall plot cumulative value or slope for injection performance analysis.\nTrend changes indicate injectivity changes over time.',
    ),
    hallInterpretation: WellOutputsStringSchema.shape.hallInterpretation?.describe(
      "Interpretation of Hall plot trend: 'STABLE', 'IMPROVING', 'DECLINING',\n'STIMULATION_NEEDED'",
    ),
    motorEfficiency: WellOutputsStringSchema.shape.motorEfficiency?.describe(
      'ESP motor efficiency (%) - ratio of hydraulic power output to electrical\npower input',
    ),
    motorLoad: WellOutputsStringSchema.shape.motorLoad?.describe(
      'ESP motor load (%) - current electrical load as percentage of rated\ncapacity',
    ),
    priorityWaterRateStd: WellOutputsStringSchema.shape.priorityWaterRateStd?.describe(
      'Selected best-available water rate (stb/d) for surveillance.',
    ),
    giWHP: WellOutputsStringSchema.shape.giWHP?.describe(
      'Current wellhead pressure (psia or bara) during gas injection',
    ),
    wiWHP: WellOutputsStringSchema.shape.wiWHP?.describe(
      'Current wellhead pressure (psia or bara) during water injection.',
    ),
    giBHP: WellOutputsStringSchema.shape.giBHP?.describe('Bottomhole pressure (psia or bara) during gas injection'),
    wiBHP: WellOutputsStringSchema.shape.wiBHP?.describe('Bottomhole pressure (psia or bara) during water injection'),
    giRate: WellOutputsStringSchema.shape.giRate?.describe('Current gas injection rate (MSCF/d)'),
    wiRate: WellOutputsStringSchema.shape.wiRate?.describe('Current water injection rate (stb/d or m³/d)'),
    giTargetRate: WellOutputsStringSchema.shape.giTargetRate?.describe(
      'Target gas injection rate (MSCF/d) from production plan or optimization.\nCompare to giRate to assess injection compliance.',
    ),
    wiTargetRate: WellOutputsStringSchema.shape.wiTargetRate?.describe(
      'Target water injection rate (stb/d) from production plan or optimization.',
    ),
    giTechnicalRate: WellOutputsStringSchema.shape.giTechnicalRate?.describe(
      'Maximum technically achievable gas injection rate (MSCF/d) given current\nwell and facility constraints',
    ),
    wiTechnicalRate: WellOutputsStringSchema.shape.wiTechnicalRate?.describe(
      'Maximum technically achievable water injection rate (stb/d) given\ncurrent well and facility constraints.',
    ),
    surfaceSafetyValveCloseState: WellOutputsStringSchema.shape.surfaceSafetyValveCloseState?.describe(
      'Surface safety valve (SSV) state: 1 = CLOSED, 0 = OPEN',
    ),
    subSurfaceSafetyValveCloseState: WellOutputsStringSchema.shape.subSurfaceSafetyValveCloseState?.describe(
      'Subsurface safety valve (SSSV) state: 1 = CLOSED, 0 = OPEN',
    ),
    chokeSizeCalc: WellOutputsStringSchema.shape.chokeSizeCalc?.describe(
      'Calculated production choke size (64ths inch or mm) required to achieve\ncurrent rate given pressure conditions',
    ),
    dataAnalysisLiquidRateStd: WellOutputsStringSchema.shape.dataAnalysisLiquidRateStd?.describe(
      'Liquid rate (stb/d) from data-driven analysis, typically ML models or\nstatistical methods applied to real-time sensor data.',
    ),
    dataAnalysisOilRateStd: WellOutputsStringSchema.shape.dataAnalysisOilRateStd?.describe(
      'Oil rate (stb/d) from data analysis models.',
    ),
    dataAnalysisGasRateStd: WellOutputsStringSchema.shape.dataAnalysisGasRateStd?.describe(
      'Gas rate (MSCF/d) from data analysis models.',
    ),
    dataAnalysisWaterRateStd: WellOutputsStringSchema.shape.dataAnalysisWaterRateStd?.describe(
      'Water rate (stb/d) from data analysis models.',
    ),
    dataAnalysisFbhp: WellOutputsStringSchema.shape.dataAnalysisFbhp?.describe(
      'Flowing BHP (psia or bara) from data analysis models.',
    ),
    pumpHead: WellOutputsStringSchema.shape.pumpHead?.describe(
      'ESP pump head (ft or m) - pressure increase provided by the pump.\nCompare to pump curve to assess operating point and efficiency.',
    ),
    pumpAvgRate: WellOutputsStringSchema.shape.pumpAvgRate?.describe(
      'Average pump rate (stb/d) over the calculation period',
    ),
    chokeCdCalc: WellOutputsStringSchema.shape.chokeCdCalc?.describe(
      'Calculated discharge coefficient (Cd) for production choke',
    ),
    pvt_AlarmCode: WellOutputsStringSchema.shape.pvt_AlarmCode?.describe(
      'Alarm code from PVT calculations indicating data quality or calculation\nissues: 0 = OK, non-zero = specific issue code.',
    ),
    injectionEfficiency: WellOutputsStringSchema.shape.injectionEfficiency?.describe(
      'Injection efficiency metric (%) comparing actual injection rate to\ntarget or potential',
    ),
    onlineStatusReason: WellOutputsStringSchema.shape.onlineStatusReason?.describe(
      "Reason code or description explaining the current onlineStatus, e.g.,\n'SCHEDULED_MAINTENANCE', 'ESP_FAILURE', 'LOW_PRESSURE', 'WELL_TEST'.\nUseful for downtime analysis and root cause tracking.",
    ),
    injectionEfficiencyRank: WellOutputsStringSchema.shape.injectionEfficiencyRank?.describe(
      "Rank of this string's injection efficiency among all injectors (1 = best).\nUsed for prioritization and identification of underperformers.",
    ),
    injectionEfficiencyFlag: WellOutputsStringSchema.shape.injectionEfficiencyFlag?.describe(
      'Flag indicating injection efficiency status: 1 = below threshold (needs\nattention), 0 = acceptable',
    ),
    glChokeSizeCalc: WellOutputsStringSchema.shape.glChokeSizeCalc?.describe(
      'Calculated gas lift choke size (64ths inch or mm) required to achieve\ncurrent GLIR given upstream pressure conditions.',
    ),
    glChokeCdCalc: WellOutputsStringSchema.shape.glChokeCdCalc?.describe(
      'Calculated discharge coefficient (Cd) for gas lift choke',
    ),
    calcFVF: WellOutputsStringSchema.shape.calcFVF?.describe(
      'Calculated oil formation volume factor (Bo) at current conditions (rb/stb).\nUsed to convert surface volumes to reservoir volumes.',
    ),
    calcGasFVF: WellOutputsStringSchema.shape.calcGasFVF?.describe(
      'Calculated gas formation volume factor (Bg) at current conditions (rb/scf\nor m³/sm³)',
    ),
    calcGasViscosity: WellOutputsStringSchema.shape.calcGasViscosity?.describe(
      'Calculated gas viscosity (cp) at current pressure and temperature.\nUsed in pressure drop and flow calculations.',
    ),
    downholeOilProductionVolume: WellOutputsStringSchema.shape.downholeOilProductionVolume?.describe(
      'Oil production volume (rb/d) at downhole conditions',
    ),
    downholeGasProductionVolume: WellOutputsStringSchema.shape.downholeGasProductionVolume?.describe(
      'Gas production volume at downhole conditions',
    ),
    downholeWaterProductionVolume: WellOutputsStringSchema.shape.downholeWaterProductionVolume?.describe(
      'Water production volume (rb/d) at downhole conditions',
    ),
    downholeWaterInjectionVolume: WellOutputsStringSchema.shape.downholeWaterInjectionVolume?.describe(
      'Water injection volume at downhole conditions',
    ),
    downholeGasInjectionVolume: WellOutputsStringSchema.shape.downholeGasInjectionVolume?.describe(
      'Gas injection volume at downhole conditions',
    ),
    pressureCompliance: WellOutputsStringSchema.shape.pressureCompliance?.describe(
      'Pressure compliance status: indicates whether current operating pressure\nis within guidelines',
    ),
    pressureSource: WellOutputsStringSchema.shape.pressureSource?.describe(
      "Source of the BHP value: 'MEASURED' (downhole gauge), 'CALCULATED' (from\nWHP traverse), 'ESTIMATED' (correlation)",
    ),
    wingValveCloseState: WellOutputsStringSchema.shape.wingValveCloseState?.describe(
      'Wing valve state: 1 = CLOSED, 0 = OPEN',
    ),
  })?.describe(
    'OPERATIONAL AND ENGINEERING DATA for well strings. Contains real-time measurements,\ncalculated rates from various analysis methods, and well status indicators.\n\nKEY DIFFERENCES FROM AllocatedProperties_String:\n- This view has OPERATIONAL/ENGINEERING data (pressures, rates, status flags)\n- AllocatedProperties has ACCOUNTING data (allocated volumes for booking)\n\nANALYSIS METHOD PREFIXES:\n- systemAnalysis*: Rates from nodal analysis (IPR+VLP intersection)\n- chokeAnalysis*: Rates calculated from choke equation\n- iprAnalysis*: Rates from IPR curve only\n- vlpAnalysis*: Rates from VLP curve only\n- curveAnalysis*: Rates from performance curves\n- dataAnalysis*: Rates from data-driven models\n- priority*: Selected "best" rates for surveillance\n\nCOMMON QUERIES:\n- Is string online? onlineStatus\n- Current flowing BHP? systemAnalysisFbhp or priorityFbhp\n- Production rates? priorityOilRateStd, priorityGasRateStd, priorityWaterRateStd',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellStatusStringAgentView = parseView({
  view: { externalId: 'WellStatus_String_Agent' },
  model: WellStatusStringAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: WellStatusStringAgentSchema.shape.wellString?.describe('Reference to the well string entity.'),
    onlineStatus: WellStatusStringAgentSchema.shape.onlineStatus?.describe('Online state, numeric'),
    onlineStatusReason: WellStatusStringAgentSchema.shape.onlineStatusReason?.describe(
      'Reasons recorded at shut-in start that triggered the shut-in detection',
    ),
    steadyStateStatus: WellStatusStringAgentSchema.shape.steadyStateStatus?.describe('Flow stability, numeric'),
    sluggingStatus: WellStatusStringAgentSchema.shape.sluggingStatus?.describe(
      'Hydrodynamic slug-flow indicator, numeric',
    ),
    hoursOnline: WellStatusStringAgentSchema.shape.hoursOnline?.describe(
      'Hours online since midnight UTC+04:00, derived from onlineStatus (max 24).',
    ),
    liftType: WellStatusStringAgentSchema.shape.liftType?.describe('Artificial lift method'),
    wellType: WellStatusStringAgentSchema.shape.wellType?.describe('Well classification'),
    product: WellStatusStringAgentSchema.shape.product?.describe('Primary product type'),
    wag: WellStatusStringAgentSchema.shape.wag?.describe('Water-alternating-gas injection flag'),
    instrumented: WellStatusStringAgentSchema.shape.instrumented?.describe('Downhole instrumentation flag, numeric'),
    surfaceSafetyValveCloseState: WellStatusStringAgentSchema.shape.surfaceSafetyValveCloseState?.describe(
      'Surface safety valve (SSV) state, numeric',
    ),
    subSurfaceSafetyValveCloseState: WellStatusStringAgentSchema.shape.subSurfaceSafetyValveCloseState?.describe(
      'Subsurface safety valve (SSSV) state, numeric',
    ),
    wingValveCloseState: WellStatusStringAgentSchema.shape.wingValveCloseState?.describe('Wing valve state, numeric'),
    wellTestValidation: WellStatusStringAgentSchema.shape.wellTestValidation?.describe(
      'Validation status of the most recent well test',
    ),
    pressureCompliance: WellStatusStringAgentSchema.shape.pressureCompliance?.describe('Pressure compliance status'),
    pressureSource: WellStatusStringAgentSchema.shape.pressureSource?.describe(
      'Source method used to derive reservoir pressure',
    ),
    reservoirPressureDatum: WellStatusStringAgentSchema.shape.reservoirPressureDatum?.describe(
      'Estimated reservoir pressure at datum depth (psi).',
    ),
    reservoirPressureMidPerforation: WellStatusStringAgentSchema.shape.reservoirPressureMidPerforation?.describe(
      'Estimated reservoir pressure at mid-perforation depth (psi).',
    ),
  })?.describe(
    'Per-string operational status â€” lift type, well type, online state, valve\nstates, and reservoir pressure estimates.\n\nString-level state attributes sourced from field sensors and monitoring\nsystems, covering online, flow stability, and slugging indicators, surface\nand subsurface valve positions, well classification (lift type, product,\nWAG), and current reservoir pressure estimates. Distinct from\nInactiveString_Agent, which classifies long-term inactivity. Excludes\nhistorical performance and detailed production rates.\n\nUse for: Well Status Detection (WF25), Real-Time Surveillance (WF18).',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const WellTestAnalysisAgentView = parseView({
  view: { externalId: 'WellTestAnalysis_Agent' },
  model: WellTestAnalysisAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: WellTestAnalysisAgentSchema.shape.wellString?.describe('Reference to the well string entity.'),
    modelProductivityIndex: WellTestAnalysisAgentSchema.shape.modelProductivityIndex?.describe(
      'Productivity Index from the well test model (stb/d/psi).',
    ),
    modelProductivityIndexPercentChange:
      WellTestAnalysisAgentSchema.shape.modelProductivityIndexPercentChange?.describe(
        'Percent change in productivity index versus the previous accepted well test (%).',
      ),
    modelInjectivityIndex: WellTestAnalysisAgentSchema.shape.modelInjectivityIndex?.describe(
      'Injectivity Index for injection wells from the well test model (stb/d/psi).',
    ),
    modelInjectivityIndexPercentChange: WellTestAnalysisAgentSchema.shape.modelInjectivityIndexPercentChange?.describe(
      'Percent change in injectivity index versus the previous accepted well test (%).',
    ),
    modelReservoirPressure: WellTestAnalysisAgentSchema.shape.modelReservoirPressure?.describe(
      'Reservoir pressure from the well test model (psia).',
    ),
    modelReservoirPressurePercentChange:
      WellTestAnalysisAgentSchema.shape.modelReservoirPressurePercentChange?.describe(
        'Percent change in reservoir pressure versus the previous accepted well test (%).',
      ),
    modelWellTestTimestamp: WellTestAnalysisAgentSchema.shape.modelWellTestTimestamp?.describe(
      'Timestamp of the last accepted well test.',
    ),
    modelWellTestLiquidRate: WellTestAnalysisAgentSchema.shape.modelWellTestLiquidRate?.describe(
      'Total liquid rate (oil + water) measured at the last accepted well test (stb/d).',
    ),
    modelWellTestGasRate: WellTestAnalysisAgentSchema.shape.modelWellTestGasRate?.describe(
      'Gas rate measured at the last accepted well test (Mscf/d).',
    ),
    modelWellTestGor: WellTestAnalysisAgentSchema.shape.modelWellTestGor?.describe(
      'Gas-Oil Ratio measured at the last accepted well test (scf/stb).',
    ),
    modelWellTestWc: WellTestAnalysisAgentSchema.shape.modelWellTestWc?.describe(
      'Water cut (water / total liquid) measured at the last accepted well test (%).',
    ),
    modelWellTestWhp: WellTestAnalysisAgentSchema.shape.modelWellTestWhp?.describe(
      'Wellhead pressure during the last accepted well test (psia).',
    ),
    modelWellTestPdgPress: WellTestAnalysisAgentSchema.shape.modelWellTestPdgPress?.describe(
      'Permanent downhole gauge pressure during the last accepted well test (psia).',
    ),
    modelWellTestChp: WellTestAnalysisAgentSchema.shape.modelWellTestChp?.describe(
      'Casing head pressure during the last accepted well test (psia).',
    ),
    modelEstimatedOilRate: WellTestAnalysisAgentSchema.shape.modelEstimatedOilRate?.describe(
      'Current model-estimated oil rate (stb/d).',
    ),
    modelEstimatedLiquidRate: WellTestAnalysisAgentSchema.shape.modelEstimatedLiquidRate?.describe(
      'Current model-estimated total liquid rate (oil + water) (stb/d).',
    ),
    modelEstimatedGasRate: WellTestAnalysisAgentSchema.shape.modelEstimatedGasRate?.describe(
      'Current model-estimated gas rate (Mscf/d).',
    ),
    modelEstimatedWaterRate: WellTestAnalysisAgentSchema.shape.modelEstimatedWaterRate?.describe(
      'Current model-estimated water rate (stb/d).',
    ),
    modelEstimatedFbhp: WellTestAnalysisAgentSchema.shape.modelEstimatedFbhp?.describe(
      'Current model-estimated flowing bottomhole pressure (psia).',
    ),
  })?.describe(
    'Per-string well test analysis outputs â€” productivity and injectivity\nindices, reservoir pressure, last-test rates and pressures, and current\nmodel estimates.\n\nString-level outputs from the well test analysis workflow (WF03).\nProductivity and injectivity indices with percent change versus the\nprevious accepted test, reservoir pressure with percent change, timestamp\nand measured rates and pressures from the last accepted test, and current\nreal-time model estimates of rates and flowing bottomhole pressure.\nExcludes raw measurement curves and detailed completion or geological\ncontext.\n\nUse for: Well Test Analysis (WF03), Real-Time Surveillance (WF18).\n\n@name Well Test Analysis (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const WellTestGaugeStringView = parseView({
  view: { externalId: 'WellTestGauge_String' },
  model: WellTestGaugeStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: WellTestGaugeStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    lowerTestType: WellTestGaugeStringSchema.shape.lowerTestType?.describe(
      'Time series signal representing lower test type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lowerGaugePosition: WellTestGaugeStringSchema.shape.lowerGaugePosition?.describe(
      'Time series signal representing lower gauge position for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lowerGaugeDepth: WellTestGaugeStringSchema.shape.lowerGaugeDepth?.describe(
      'Time series signal representing lower gauge depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lowerResPressAtDatum: WellTestGaugeStringSchema.shape.lowerResPressAtDatum?.describe(
      'Time series signal representing lower res press at datum for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lowerDatumDepth: WellTestGaugeStringSchema.shape.lowerDatumDepth?.describe(
      'Time series signal representing lower datum depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lowerResPressAtGauge: WellTestGaugeStringSchema.shape.lowerResPressAtGauge?.describe(
      'Time series signal representing lower res press at gauge for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lowerSelectedGradient: WellTestGaugeStringSchema.shape.lowerSelectedGradient?.describe(
      'Time series signal representing lower selected gradient for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lowerProductivityIndex: WellTestGaugeStringSchema.shape.lowerProductivityIndex?.describe(
      'Time series signal representing lower productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lowerProductivityIndexSS: WellTestGaugeStringSchema.shape.lowerProductivityIndexSS?.describe(
      'Time series signal representing lower productivity index ss for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperTestType: WellTestGaugeStringSchema.shape.upperTestType?.describe(
      'Time series signal representing upper test type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperGaugePosition: WellTestGaugeStringSchema.shape.upperGaugePosition?.describe(
      'Time series signal representing upper gauge position for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperGaugeDepth: WellTestGaugeStringSchema.shape.upperGaugeDepth?.describe(
      'Time series signal representing upper gauge depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperResPressAtDatum: WellTestGaugeStringSchema.shape.upperResPressAtDatum?.describe(
      'Time series signal representing upper res press at datum for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperDatumDepth: WellTestGaugeStringSchema.shape.upperDatumDepth?.describe(
      'Time series signal representing upper datum depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperResPressAtGauge: WellTestGaugeStringSchema.shape.upperResPressAtGauge?.describe(
      'Time series signal representing upper res press at gauge for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperSelectedGradient: WellTestGaugeStringSchema.shape.upperSelectedGradient?.describe(
      'Time series signal representing upper selected gradient for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperProductivityIndex: WellTestGaugeStringSchema.shape.upperProductivityIndex?.describe(
      'Time series signal representing upper productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    upperProductivityIndexSS: WellTestGaugeStringSchema.shape.upperProductivityIndexSS?.describe(
      'Time series signal representing upper productivity index ss for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naTestType: WellTestGaugeStringSchema.shape.naTestType?.describe(
      'Time series signal representing na test type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naGaugePosition: WellTestGaugeStringSchema.shape.naGaugePosition?.describe(
      'Time series signal representing na gauge position for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naGaugeDepth: WellTestGaugeStringSchema.shape.naGaugeDepth?.describe(
      'Time series signal representing na gauge depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naResPressAtDatum: WellTestGaugeStringSchema.shape.naResPressAtDatum?.describe(
      'Time series signal representing na res press at datum for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naDatumDepth: WellTestGaugeStringSchema.shape.naDatumDepth?.describe(
      'Time series signal representing na datum depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naResPressAtGauge: WellTestGaugeStringSchema.shape.naResPressAtGauge?.describe(
      'Time series signal representing na res press at gauge for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naSelectedGradient: WellTestGaugeStringSchema.shape.naSelectedGradient?.describe(
      'Time series signal representing na selected gradient for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naProductivityIndex: WellTestGaugeStringSchema.shape.naProductivityIndex?.describe(
      'Time series signal representing na productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    naProductivityIndexSS: WellTestGaugeStringSchema.shape.naProductivityIndexSS?.describe(
      'Time series signal representing na productivity index ss for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Well Test Gauge String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellTestInputsStringView = parseView({
  view: { externalId: 'WellTestInputs_String' },
  model: WellTestInputsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: WellTestInputsStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellTestStartDate: WellTestInputsStringSchema.shape.wellTestStartDate?.describe(
      'Time series signal representing well test start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEndDate: WellTestInputsStringSchema.shape.wellTestEndDate?.describe(
      'Time series signal representing well test end date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspMotorVoltage: WellTestInputsStringSchema.shape.wellTestEspMotorVoltage?.describe(
      'Time series signal representing well test esp motor voltage for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspPumpDischargePressure: WellTestInputsStringSchema.shape.wellTestEspPumpDischargePressure?.describe(
      'Time series signal representing well test esp pump discharge pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspPumpFrequency: WellTestInputsStringSchema.shape.wellTestEspPumpFrequency?.describe(
      'Time series signal representing well test esp pump frequency for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspPumpIntakePressure: WellTestInputsStringSchema.shape.wellTestEspPumpIntakePressure?.describe(
      'Time series signal representing well test esp pump intake pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspPumpIntakeTemperature: WellTestInputsStringSchema.shape.wellTestEspPumpIntakeTemperature?.describe(
      'Time series signal representing well test esp pump intake temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlFlControlValveInletTemp: WellTestInputsStringSchema.shape.wellTestGlFlControlValveInletTemp?.describe(
      'Time series signal representing well test gl fl control valve inlet temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlInjectionChokeOpening: WellTestInputsStringSchema.shape.wellTestGlInjectionChokeOpening?.describe(
      'Time series signal representing well test gl injection choke opening for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlFlControlValveInletPres: WellTestInputsStringSchema.shape.wellTestGlFlControlValveInletPres?.describe(
      'Time series signal representing well test gl fl control valve inlet pres for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasLiftVolume: WellTestInputsStringSchema.shape.wellTestGasLiftVolume?.describe(
      'Time series signal representing well test gas lift volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlFlControlValvOutletPres: WellTestInputsStringSchema.shape.wellTestGlFlControlValvOutletPres?.describe(
      'Time series signal representing well test gl fl control valv outlet pres for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTestSeparatorLinePressure: WellTestInputsStringSchema.shape.wellTestTestSeparatorLinePressure?.describe(
      'Time series signal representing well test test separator line pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTestSeparatorLineTemperature:
      WellTestInputsStringSchema.shape.wellTestTestSeparatorLineTemperature?.describe(
        'Time series signal representing well test test separator line temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    wellTestWGR: WellTestInputsStringSchema.shape.wellTestWGR?.describe(
      'Time series signal representing well test wgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCGR: WellTestInputsStringSchema.shape.wellTestCGR?.describe(
      'Time series signal representing well test cgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWellheadPressure: WellTestInputsStringSchema.shape.wellTestWellheadPressure?.describe(
      'Time series signal representing well test wellhead pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWellheadTemperature: WellTestInputsStringSchema.shape.wellTestWellheadTemperature?.describe(
      'Time series signal representing well test wellhead temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRateStd: WellTestInputsStringSchema.shape.wellTestGasRateStd?.describe(
      'Time series signal representing well test gas rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRateInsitu: WellTestInputsStringSchema.shape.wellTestGasRateInsitu?.describe(
      'Time series signal representing well test gas rate insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRatePts: WellTestInputsStringSchema.shape.wellTestGasRatePts?.describe(
      'Time series signal representing well test gas rate pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEgorVendorStdGasRate: WellTestInputsStringSchema.shape.wellTestEgorVendorStdGasRate?.describe(
      'Time series signal representing well test egor vendor std gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRateStd: WellTestInputsStringSchema.shape.wellTestOilRateStd?.describe(
      'Time series signal representing well test oil rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRateInsitu: WellTestInputsStringSchema.shape.wellTestOilRateInsitu?.describe(
      'Time series signal representing well test oil rate insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRatePts: WellTestInputsStringSchema.shape.wellTestOilRatePts?.describe(
      'Time series signal representing well test oil rate pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEgorVendorStdOilRate: WellTestInputsStringSchema.shape.wellTestEgorVendorStdOilRate?.describe(
      'Time series signal representing well test egor vendor std oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRateStd: WellTestInputsStringSchema.shape.wellTestWaterRateStd?.describe(
      'Time series signal representing well test water rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRateInsitu: WellTestInputsStringSchema.shape.wellTestWaterRateInsitu?.describe(
      'Time series signal representing well test water rate insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRatePts: WellTestInputsStringSchema.shape.wellTestWaterRatePts?.describe(
      'Time series signal representing well test water rate pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEgorVendorStdWaterRate: WellTestInputsStringSchema.shape.wellTestEgorVendorStdWaterRate?.describe(
      'Time series signal representing well test egor vendor std water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGorInsitu: WellTestInputsStringSchema.shape.wellTestGorInsitu?.describe(
      'Time series signal representing well test gor insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGorPts: WellTestInputsStringSchema.shape.wellTestGorPts?.describe(
      'Time series signal representing well test gor pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalGorStd: WellTestInputsStringSchema.shape.wellTestTotalGorStd?.describe(
      'Time series signal representing well test total gor std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCut: WellTestInputsStringSchema.shape.wellTestWaterCut?.describe(
      'Time series signal representing well test water cut for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCutPts: WellTestInputsStringSchema.shape.wellTestWaterCutPts?.describe(
      'Time series signal representing well test water cut pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCutInsitu: WellTestInputsStringSchema.shape.wellTestWaterCutInsitu?.describe(
      'Time series signal representing well test water cut insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestLiquidRatePts: WellTestInputsStringSchema.shape.wellTestLiquidRatePts?.describe(
      'Time series signal representing well test liquid rate pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestChokeSize: WellTestInputsStringSchema.shape.wellTestChokeSize?.describe(
      'Time series signal representing well test choke size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCasingHeadPressure: WellTestInputsStringSchema.shape.wellTestCasingHeadPressure?.describe(
      'Time series signal representing well test casing head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCasingHeadTemperature: WellTestInputsStringSchema.shape.wellTestCasingHeadTemperature?.describe(
      'Time series signal representing well test casing head temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestBottomHolePressure: WellTestInputsStringSchema.shape.wellTestBottomHolePressure?.describe(
      'Time series signal representing well test bottom hole pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestBottomHoleTemperature: WellTestInputsStringSchema.shape.wellTestBottomHoleTemperature?.describe(
      'Time series signal representing well test bottom hole temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestFlowlineTemperature: WellTestInputsStringSchema.shape.wellTestFlowlineTemperature?.describe(
      'Time series signal representing well test flowline temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestFlowlinePressure: WellTestInputsStringSchema.shape.wellTestFlowlinePressure?.describe(
      'Time series signal representing well test flowline pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspMotorCurrent: WellTestInputsStringSchema.shape.wellTestEspMotorCurrent?.describe(
      'Time series signal representing well test esp motor current for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspMotorPower: WellTestInputsStringSchema.shape.wellTestEspMotorPower?.describe(
      'Time series signal representing well test esp motor power for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestDuration: WellTestInputsStringSchema.shape.wellTestDuration?.describe(
      'Time series signal representing well test duration for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestStringFunction: WellTestInputsStringSchema.shape.wellTestStringFunction?.describe(
      'Text describing the functional role of the production string (for example main producer, backup, injector, idle), used in surveillance and planning.',
    ),
    wellTestApprovedAllocationFlag: WellTestInputsStringSchema.shape.wellTestApprovedAllocationFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    wellTestTestTypeDesc: WellTestInputsStringSchema.shape.wellTestTestTypeDesc?.describe(
      'Time series signal representing well test test type desc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestMpfmName: WellTestInputsStringSchema.shape.wellTestMpfmName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    wellTestTestMethod: WellTestInputsStringSchema.shape.wellTestTestMethod?.describe(
      'Time series signal representing well test test method for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestArtificialLiftType: WellTestInputsStringSchema.shape.wellTestArtificialLiftType?.describe(
      'Time series signal representing well test artificial lift type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestValidationFlag: WellTestInputsStringSchema.shape.wellTestValidationFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    wellTestTestType: WellTestInputsStringSchema.shape.wellTestTestType?.describe(
      'Time series signal representing well test test type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    ptsDateTime: WellTestInputsStringSchema.shape.ptsDateTime?.describe(
      'Time series signal representing pts date time for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    composition: WellTestInputsStringSchema.shape.composition?.describe(
      'Time series signal representing composition for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelComposition: WellTestInputsStringSchema.shape.modelComposition?.describe(
      'Time series signal representing model composition for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sampleDateTime: WellTestInputsStringSchema.shape.sampleDateTime?.describe(
      'Time series signal representing sample date time for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    validatedBy: WellTestInputsStringSchema.shape.validatedBy?.describe(
      'Time series signal representing validated by for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    comments: WellTestInputsStringSchema.shape.comments?.describe(
      'Free-text comments field capturing operator or engineer notes related to this measurement, configuration, or event.',
    ),
    fluidProperties: WellTestInputsStringSchema.shape.fluidProperties?.describe(
      'Time series signal representing fluid properties for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGOR: WellTestInputsStringSchema.shape.wellTestGOR?.describe(
      'Time series signal representing well test gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRateOil: WellTestInputsStringSchema.shape.wellTestTotalMassFlowRateOil?.describe(
      'Time series signal representing well test total mass flow rate oil for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRateWater: WellTestInputsStringSchema.shape.wellTestTotalMassFlowRateWater?.describe(
      'Time series signal representing well test total mass flow rate water for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRateGas: WellTestInputsStringSchema.shape.wellTestTotalMassFlowRateGas?.describe(
      'Time series signal representing well test total mass flow rate gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasDensityInSitu: WellTestInputsStringSchema.shape.wellTestGasDensityInSitu?.describe(
      'Time series signal representing well test gas density in situ for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilDensityInSitu: WellTestInputsStringSchema.shape.wellTestOilDensityInSitu?.describe(
      'Time series signal representing well test oil density in situ for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    stablePeriodStartDate: WellTestInputsStringSchema.shape.stablePeriodStartDate?.describe(
      'Time series signal representing stable period start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    stablePeriodEndDate: WellTestInputsStringSchema.shape.stablePeriodEndDate?.describe(
      'Time series signal representing stable period end date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cgrLC: WellTestInputsStringSchema.shape.cgrLC?.describe(
      'Time series signal representing cgr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wgrLC: WellTestInputsStringSchema.shape.wgrLC?.describe(
      'Time series signal representing wgr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpMotorTemp: WellTestInputsStringSchema.shape.pumpMotorTemp?.describe(
      'Time series signal representing pump motor temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpVibration: WellTestInputsStringSchema.shape.pumpVibration?.describe(
      'Time series signal representing pump vibration for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpPower: WellTestInputsStringSchema.shape.pumpPower?.describe(
      'Time series signal representing pump power for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmDifferentialPressure: WellTestInputsStringSchema.shape.mpfmDifferentialPressure?.describe(
      'Time series signal representing mpfm differential pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLinePressure: WellTestInputsStringSchema.shape.mpfmLinePressure?.describe(
      'Time series signal representing mpfm line pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLineTemperature: WellTestInputsStringSchema.shape.mpfmLineTemperature?.describe(
      'Time series signal representing mpfm line temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    liquidRateSc: WellTestInputsStringSchema.shape.liquidRateSc?.describe(
      'Time series signal representing liquid rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    liquidRateLc: WellTestInputsStringSchema.shape.liquidRateLc?.describe(
      'Time series signal representing liquid rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilVolumeFractionLC: WellTestInputsStringSchema.shape.oilVolumeFractionLC?.describe(
      'Time series signal representing oil volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasVolumeFractionLC: WellTestInputsStringSchema.shape.gasVolumeFractionLC?.describe(
      'Time series signal representing gas volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterVolumeFractionLC: WellTestInputsStringSchema.shape.waterVolumeFractionLC?.describe(
      'Time series signal representing water volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterMassFlowRateSC: WellTestInputsStringSchema.shape.waterMassFlowRateSC?.describe(
      'Time series signal representing water mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilMassFlowRateSC: WellTestInputsStringSchema.shape.oilMassFlowRateSC?.describe(
      'Time series signal representing oil mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasMassFlowRateSC: WellTestInputsStringSchema.shape.gasMassFlowRateSC?.describe(
      'Time series signal representing gas mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterMassFlowRateLC: WellTestInputsStringSchema.shape.waterMassFlowRateLC?.describe(
      'Time series signal representing water mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilMassFlowRateLC: WellTestInputsStringSchema.shape.oilMassFlowRateLC?.describe(
      'Time series signal representing oil mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasMassFlowRateLC: WellTestInputsStringSchema.shape.gasMassFlowRateLC?.describe(
      'Time series signal representing gas mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilDensitySC: WellTestInputsStringSchema.shape.oilDensitySC?.describe(
      'Time series signal representing oil density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasDensitySC: WellTestInputsStringSchema.shape.gasDensitySC?.describe(
      'Time series signal representing gas density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterDensitySC: WellTestInputsStringSchema.shape.waterDensitySC?.describe(
      'Time series signal representing water density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilDensityLC: WellTestInputsStringSchema.shape.oilDensityLC?.describe(
      'Time series signal representing oil density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasDensityLC: WellTestInputsStringSchema.shape.gasDensityLC?.describe(
      'Time series signal representing gas density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterDensityLC: WellTestInputsStringSchema.shape.waterDensityLC?.describe(
      'Time series signal representing water density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glinjectionRate: WellTestInputsStringSchema.shape.glinjectionRate?.describe(
      'Time series signal representing glinjection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glFcvOutletTemp: WellTestInputsStringSchema.shape.glFcvOutletTemp?.describe(
      'Time series signal representing gl fcv outlet temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpDischargeTemp: WellTestInputsStringSchema.shape.pumpDischargeTemp?.describe(
      'Time series signal representing pump discharge temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmAlarms: WellTestInputsStringSchema.shape.mpfmAlarms?.describe(
      'Time series signal representing mpfm alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pvtAlarms: WellTestInputsStringSchema.shape.pvtAlarms?.describe(
      'Time series signal representing pvt alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    historicalAlarms: WellTestInputsStringSchema.shape.historicalAlarms?.describe(
      'Time series signal representing historical alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelAlarms: WellTestInputsStringSchema.shape.modelAlarms?.describe(
      'Time series signal representing model alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeAlarms: WellTestInputsStringSchema.shape.chokeAlarms?.describe(
      'Time series signal representing choke alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espwear: WellTestInputsStringSchema.shape.espwear?.describe(
      'Time series signal representing espwear for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelProductivityIndex: WellTestInputsStringSchema.shape.modelProductivityIndex?.describe(
      'Time series signal representing model productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelReservoirPressure: WellTestInputsStringSchema.shape.modelReservoirPressure?.describe(
      'Time series signal representing model reservoir pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelStabilityFlag: WellTestInputsStringSchema.shape.modelStabilityFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    modelMinStableRate: WellTestInputsStringSchema.shape.modelMinStableRate?.describe(
      'Time series signal representing model min stable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelReservoirModel: WellTestInputsStringSchema.shape.modelReservoirModel?.describe(
      'Time series signal representing model reservoir model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelVlpModel: WellTestInputsStringSchema.shape.modelVlpModel?.describe(
      'Time series signal representing model vlp model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestTimestamp: WellTestInputsStringSchema.shape.modelWellTestTimestamp?.describe(
      'Time series signal representing model well test timestamp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedoilRate: WellTestInputsStringSchema.shape.modelMatchedoilRate?.describe(
      'Time series signal representing model matchedoil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedliquidRate: WellTestInputsStringSchema.shape.modelMatchedliquidRate?.describe(
      'Time series signal representing model matchedliquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedgasRate: WellTestInputsStringSchema.shape.modelMatchedgasRate?.describe(
      'Time series signal representing model matchedgas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedwaterRate: WellTestInputsStringSchema.shape.modelMatchedwaterRate?.describe(
      'Time series signal representing model matchedwater rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeMatchedliquidRate: WellTestInputsStringSchema.shape.chokeMatchedliquidRate?.describe(
      'Time series signal representing choke matchedliquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedBHP: WellTestInputsStringSchema.shape.modelMatchedBHP?.describe(
      'Time series signal representing model matched bhp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestStartDateDH: WellTestInputsStringSchema.shape.wellTestStartDateDH?.describe(
      'Time series signal representing well test start date dh for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    historicalAlarmsCode: WellTestInputsStringSchema.shape.historicalAlarmsCode?.describe(
      'Time series signal representing historical alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelAlarmsCode: WellTestInputsStringSchema.shape.modelAlarmsCode?.describe(
      'Time series signal representing model alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeAlarmsCode: WellTestInputsStringSchema.shape.chokeAlarmsCode?.describe(
      'Time series signal representing choke alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    formationGOR: WellTestInputsStringSchema.shape.formationGOR?.describe(
      'Time series signal representing formation gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestLiquidRateLC: WellTestInputsStringSchema.shape.wellTestLiquidRateLC?.describe(
      'Time series signal representing well test liquid rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestLiquidRateSC: WellTestInputsStringSchema.shape.wellTestLiquidRateSC?.describe(
      'Time series signal representing well test liquid rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wlrLC: WellTestInputsStringSchema.shape.wlrLC?.describe(
      'Time series signal representing wlr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlInjectionChokeSize: WellTestInputsStringSchema.shape.wellTestGlInjectionChokeSize?.describe(
      'Time series signal representing well test gl injection choke size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestChokeOpening: WellTestInputsStringSchema.shape.wellTestChokeOpening?.describe(
      'Time series signal representing well test choke opening for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lastUpdatedByWellTest: WellTestInputsStringSchema.shape.lastUpdatedByWellTest?.describe(
      'Time series signal representing last updated by well test for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    lastUpdatedByStablePeriod: WellTestInputsStringSchema.shape.lastUpdatedByStablePeriod?.describe(
      'Time series signal representing last updated by stable period for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Well Test Inputs String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellTestModelParametersAgentView = parseView({
  view: { externalId: 'WellTest_ModelParameters_Agent' },
  model: WellTestModelParametersAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: WellTestModelParametersAgentSchema.shape.wellString?.describe('Reference to well string'),
    modelVlpCorrelation:
      WellTestModelParametersAgentSchema.shape.modelVlpCorrelation?.describe('VLP correlation used (TS)'),
    modelVlpParameter1:
      WellTestModelParametersAgentSchema.shape.modelVlpParameter1?.describe('VLP tuning parameter 1 (TS)'),
    modelVlpParameter2:
      WellTestModelParametersAgentSchema.shape.modelVlpParameter2?.describe('VLP tuning parameter 2 (TS)'),
    modelVlpParameter1PercentChange: WellTestModelParametersAgentSchema.shape.modelVlpParameter1PercentChange?.describe(
      'Percent change in VLP parameter 1 (%, TS)',
    ),
    modelVlpParameter2PercentChange: WellTestModelParametersAgentSchema.shape.modelVlpParameter2PercentChange?.describe(
      'Percent change in VLP parameter 2 (%, TS).\n\n@name vlpParam2Change',
    ),
    modelIprC: WellTestModelParametersAgentSchema.shape.modelIprC?.describe('IPR C coefficient (TS)'),
    modelIprN: WellTestModelParametersAgentSchema.shape.modelIprN?.describe('IPR n exponent (TS)'),
    modelReservoirModel: WellTestModelParametersAgentSchema.shape.modelReservoirModel?.describe(
      'Reservoir model type used (TS)',
    ),
    modelEspWf: WellTestModelParametersAgentSchema.shape.modelEspWf?.describe('ESP pump wear factor (TS)'),
    modelEspWfPercentChange: WellTestModelParametersAgentSchema.shape.modelEspWfPercentChange?.describe(
      'Percent change in ESP wear factor (%, TS)',
    ),
    modelWellTestEspFrequency: WellTestModelParametersAgentSchema.shape.modelWellTestEspFrequency?.describe(
      'ESP frequency during model match (Hz, TS)',
    ),
    modelGlOrificeSize: WellTestModelParametersAgentSchema.shape.modelGlOrificeSize?.describe(
      'Gas lift orifice size from model (inches, TS)',
    ),
    modelGlOrificeSizePercentChange: WellTestModelParametersAgentSchema.shape.modelGlOrificeSizePercentChange?.describe(
      'Percent change in orifice size (%, TS)',
    ),
    modelWellTestGlInjection: WellTestModelParametersAgentSchema.shape.modelWellTestGlInjection?.describe(
      'Gas lift injection rate used in model (MMscfd, TS).\n\n@name glInjectionRate',
    ),
    modelUval: WellTestModelParametersAgentSchema.shape.modelUval?.describe(
      'Overall heat transfer coefficient U-value (BTU/hr/ft2/degF, TS)',
    ),
    hasProsperModel: WellTestModelParametersAgentSchema.shape.hasProsperModel?.describe(
      'Flag indicating this string has an active Prosper model',
    ),
    prosperModelExternalId: WellTestModelParametersAgentSchema.shape.prosperModelExternalId?.describe(
      'External ID of the associated ProsperModel instance',
    ),
    modelMatchStatus: WellTestModelParametersAgentSchema.shape.modelMatchStatus?.describe(
      'Indicates whether the well test rate was matched during the WF03 calibration process (TS).\n  Values: MATCHED, FAILED, MANUAL',
    ),
    modelRevisionNumber: WellTestModelParametersAgentSchema.shape.modelRevisionNumber?.describe(
      'Prosper model revision number (TS)',
    ),
  })?.describe(
    'Prosper model tuning parameters from well test analysis including VLP, IPR,\nand ESP wear.\n\nContains detailed parameters derived from well test analysis, focusing on the\ntuning of Prosper models for various well types, including vertical lift\nperformance (VLP), inflow performance relationship (IPR), and electrical\nsubmersible pump (ESP) wear factors. Sourced from well test results and model\ncalibration processes, enabling production specialists to assess and optimize\nwell performance. It answers specific questions regarding the correlations and\nparameters used in VLP and IPR models, as well as the wear factors for ESP\nsystems, while it excludes raw test data or historical performance metrics\nfound in other views. Use cases: quality control of models, trend analysis for\nperformance optimization, and tracking pump degradation over time.\n\n@name Well Test Model Parameters (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const WellTestOutputsStringView = parseView({
  view: { externalId: 'WellTestOutputs_String' },
  model: WellTestOutputsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: WellTestOutputsStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellTestStartDate: WellTestOutputsStringSchema.shape.wellTestStartDate?.describe(
      'Time series signal representing well test start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfm: WellTestOutputsStringSchema.shape.mpfm?.describe(
      'Time series signal representing mpfm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEndDate: WellTestOutputsStringSchema.shape.wellTestEndDate?.describe(
      'Time series signal representing well test end date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    stablePeriodStartDate: WellTestOutputsStringSchema.shape.stablePeriodStartDate?.describe(
      'Time series signal representing stable period start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    stablePeriodEndDate: WellTestOutputsStringSchema.shape.stablePeriodEndDate?.describe(
      'Time series signal representing stable period end date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilRateSC: WellTestOutputsStringSchema.shape.oilRateSC?.describe(
      'Time series signal representing oil rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasRateSC: WellTestOutputsStringSchema.shape.gasRateSC?.describe(
      'Time series signal representing gas rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterRateSC: WellTestOutputsStringSchema.shape.waterRateSC?.describe(
      'Time series signal representing water rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterCutSC: WellTestOutputsStringSchema.shape.waterCutSC?.describe(
      'Time series signal representing water cut sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    totalGorSC: WellTestOutputsStringSchema.shape.totalGorSC?.describe(
      'Time series signal representing total gor sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cgrSC: WellTestOutputsStringSchema.shape.cgrSC?.describe(
      'Time series signal representing cgr sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wgrSC: WellTestOutputsStringSchema.shape.wgrSC?.describe(
      'Time series signal representing wgr sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterMassFlowRateSC: WellTestOutputsStringSchema.shape.waterMassFlowRateSC?.describe(
      'Time series signal representing water mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilMassFlowRateSC: WellTestOutputsStringSchema.shape.oilMassFlowRateSC?.describe(
      'Time series signal representing oil mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasMassFlowRateSC: WellTestOutputsStringSchema.shape.gasMassFlowRateSC?.describe(
      'Time series signal representing gas mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilDensitySC: WellTestOutputsStringSchema.shape.oilDensitySC?.describe(
      'Time series signal representing oil density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasDensitySC: WellTestOutputsStringSchema.shape.gasDensitySC?.describe(
      'Time series signal representing gas density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterDensitySC: WellTestOutputsStringSchema.shape.waterDensitySC?.describe(
      'Time series signal representing water density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilRateLC: WellTestOutputsStringSchema.shape.oilRateLC?.describe(
      'Time series signal representing oil rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasRateLC: WellTestOutputsStringSchema.shape.gasRateLC?.describe(
      'Time series signal representing gas rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterRateLC: WellTestOutputsStringSchema.shape.waterRateLC?.describe(
      'Time series signal representing water rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterCutLC: WellTestOutputsStringSchema.shape.waterCutLC?.describe(
      'Time series signal representing water cut lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterMassFlowRateLC: WellTestOutputsStringSchema.shape.waterMassFlowRateLC?.describe(
      'Time series signal representing water mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilMassFlowRateLC: WellTestOutputsStringSchema.shape.oilMassFlowRateLC?.describe(
      'Time series signal representing oil mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasMassFlowRateLC: WellTestOutputsStringSchema.shape.gasMassFlowRateLC?.describe(
      'Time series signal representing gas mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilDensityLC: WellTestOutputsStringSchema.shape.oilDensityLC?.describe(
      'Time series signal representing oil density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasDensityLC: WellTestOutputsStringSchema.shape.gasDensityLC?.describe(
      'Time series signal representing gas density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterDensityLC: WellTestOutputsStringSchema.shape.waterDensityLC?.describe(
      'Time series signal representing water density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gorLC: WellTestOutputsStringSchema.shape.gorLC?.describe(
      'Time series signal representing gor lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cgrLC: WellTestOutputsStringSchema.shape.cgrLC?.describe(
      'Time series signal representing cgr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wgrLC: WellTestOutputsStringSchema.shape.wgrLC?.describe(
      'Time series signal representing wgr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeSize: WellTestOutputsStringSchema.shape.chokeSize?.describe(
      'Time series signal representing choke size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    whp: WellTestOutputsStringSchema.shape.whp?.describe(
      'Time series signal representing whp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wht: WellTestOutputsStringSchema.shape.wht?.describe(
      'Time series signal representing wht for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    flp: WellTestOutputsStringSchema.shape.flp?.describe(
      'Time series signal representing flp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    flt: WellTestOutputsStringSchema.shape.flt?.describe(
      'Time series signal representing flt for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chp: WellTestOutputsStringSchema.shape.chp?.describe(
      'Time series signal representing chp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    dhgp: WellTestOutputsStringSchema.shape.dhgp?.describe(
      'Time series signal representing dhgp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    dhgt: WellTestOutputsStringSchema.shape.dhgt?.describe(
      'Time series signal representing dhgt for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glinjectionRate: WellTestOutputsStringSchema.shape.glinjectionRate?.describe(
      'Time series signal representing glinjection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glFcvChokeSize: WellTestOutputsStringSchema.shape.glFcvChokeSize?.describe(
      'Time series signal representing gl fcv choke size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glFcvInletTemp: WellTestOutputsStringSchema.shape.glFcvInletTemp?.describe(
      'Time series signal representing gl fcv inlet temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glFcvOutletTemp: WellTestOutputsStringSchema.shape.glFcvOutletTemp?.describe(
      'Time series signal representing gl fcv outlet temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glFcvInletPress: WellTestOutputsStringSchema.shape.glFcvInletPress?.describe(
      'Time series signal representing gl fcv inlet press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    glFcvOutletPress: WellTestOutputsStringSchema.shape.glFcvOutletPress?.describe(
      'Time series signal representing gl fcv outlet press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpFrequency: WellTestOutputsStringSchema.shape.pumpFrequency?.describe(
      'Time series signal representing pump frequency for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpIntakePress: WellTestOutputsStringSchema.shape.pumpIntakePress?.describe(
      'Time series signal representing pump intake press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpIntakeTemp: WellTestOutputsStringSchema.shape.pumpIntakeTemp?.describe(
      'Time series signal representing pump intake temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpDischargePress: WellTestOutputsStringSchema.shape.pumpDischargePress?.describe(
      'Time series signal representing pump discharge press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpDischargeTemp: WellTestOutputsStringSchema.shape.pumpDischargeTemp?.describe(
      'Time series signal representing pump discharge temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpMotorTemp: WellTestOutputsStringSchema.shape.pumpMotorTemp?.describe(
      'Time series signal representing pump motor temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpVibration: WellTestOutputsStringSchema.shape.pumpVibration?.describe(
      'Time series signal representing pump vibration for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpCurrent: WellTestOutputsStringSchema.shape.pumpCurrent?.describe(
      'Time series signal representing pump current for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpVoltage: WellTestOutputsStringSchema.shape.pumpVoltage?.describe(
      'Time series signal representing pump voltage for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pumpPower: WellTestOutputsStringSchema.shape.pumpPower?.describe(
      'Time series signal representing pump power for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmDifferentialPressure: WellTestOutputsStringSchema.shape.mpfmDifferentialPressure?.describe(
      'Time series signal representing mpfm differential pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLinePressure: WellTestOutputsStringSchema.shape.mpfmLinePressure?.describe(
      'Time series signal representing mpfm line pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmLineTemperature: WellTestOutputsStringSchema.shape.mpfmLineTemperature?.describe(
      'Time series signal representing mpfm line temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    liquidRateSc: WellTestOutputsStringSchema.shape.liquidRateSc?.describe(
      'Time series signal representing liquid rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    liquidRateLc: WellTestOutputsStringSchema.shape.liquidRateLc?.describe(
      'Time series signal representing liquid rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilVolumeFractionLC: WellTestOutputsStringSchema.shape.oilVolumeFractionLC?.describe(
      'Time series signal representing oil volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasVolumeFractionLC: WellTestOutputsStringSchema.shape.gasVolumeFractionLC?.describe(
      'Time series signal representing gas volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterVolumeFractionLC: WellTestOutputsStringSchema.shape.waterVolumeFractionLC?.describe(
      'Time series signal representing water volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    mpfmAlarms: WellTestOutputsStringSchema.shape.mpfmAlarms?.describe(
      'Time series signal representing mpfm alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pvtAlarms: WellTestOutputsStringSchema.shape.pvtAlarms?.describe(
      'Time series signal representing pvt alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    historicalAlarms: WellTestOutputsStringSchema.shape.historicalAlarms?.describe(
      'Time series signal representing historical alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelAlarms: WellTestOutputsStringSchema.shape.modelAlarms?.describe(
      'Time series signal representing model alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeAlarms: WellTestOutputsStringSchema.shape.chokeAlarms?.describe(
      'Time series signal representing choke alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    espwear: WellTestOutputsStringSchema.shape.espwear?.describe(
      'Time series signal representing espwear for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelProductivityIndex: WellTestOutputsStringSchema.shape.modelProductivityIndex?.describe(
      'Time series signal representing model productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelReservoirPressure: WellTestOutputsStringSchema.shape.modelReservoirPressure?.describe(
      'Time series signal representing model reservoir pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelStabilityFlag: WellTestOutputsStringSchema.shape.modelStabilityFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    modelMinStableRate: WellTestOutputsStringSchema.shape.modelMinStableRate?.describe(
      'Time series signal representing model min stable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelReservoirModel: WellTestOutputsStringSchema.shape.modelReservoirModel?.describe(
      'Time series signal representing model reservoir model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelVlpModel: WellTestOutputsStringSchema.shape.modelVlpModel?.describe(
      'Attribute capturing model vlp model for this production string in the production optimization context.',
    ),
    modelWellTestTimestamp: WellTestOutputsStringSchema.shape.modelWellTestTimestamp?.describe(
      'Time series signal representing model well test timestamp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedoilRate: WellTestOutputsStringSchema.shape.modelMatchedoilRate?.describe(
      'Time series signal representing model matchedoil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedliquidRate: WellTestOutputsStringSchema.shape.modelMatchedliquidRate?.describe(
      'Time series signal representing model matchedliquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedgasRate: WellTestOutputsStringSchema.shape.modelMatchedgasRate?.describe(
      'Time series signal representing model matchedgas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedwaterRate: WellTestOutputsStringSchema.shape.modelMatchedwaterRate?.describe(
      'Time series signal representing model matchedwater rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeMatchedliquidRate: WellTestOutputsStringSchema.shape.chokeMatchedliquidRate?.describe(
      'Time series signal representing choke matchedliquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchedBHP: WellTestOutputsStringSchema.shape.modelMatchedBHP?.describe(
      'Time series signal representing model matched bhp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestStartDateDH: WellTestOutputsStringSchema.shape.wellTestStartDateDH?.describe(
      'Time series signal representing well test start date dh for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    historicalAlarmsCode: WellTestOutputsStringSchema.shape.historicalAlarmsCode?.describe(
      'Time series signal representing historical alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelAlarmsCode: WellTestOutputsStringSchema.shape.modelAlarmsCode?.describe(
      'Time series signal representing model alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeAlarmsCode: WellTestOutputsStringSchema.shape.chokeAlarmsCode?.describe(
      'Time series signal representing choke alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    pvtAlarmsCode: WellTestOutputsStringSchema.shape.pvtAlarmsCode?.describe(
      'Time series signal representing pvt alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeMatchedgasRate: WellTestOutputsStringSchema.shape.chokeMatchedgasRate?.describe(
      'Time series signal representing choke matchedgas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    cdValue: WellTestOutputsStringSchema.shape.cdValue?.describe(
      'Time series signal representing cd value for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeSizeInch: WellTestOutputsStringSchema.shape.chokeSizeInch?.describe(
      'Time series signal representing choke size inch for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Aggregated outputs from individual well tests for each well string, including test timing, multiphase rates at standard and line conditions, derived ratios (GOR, WCT), phase densities and mass flow rates used for well performance and model calibration.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellTestRawView = parseView({
  view: { externalId: 'WellTest_Raw' },
  model: WellTestRawSchema.extend({
    ...InstanceIdType.shape,
    entityName: WellTestRawSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    wellTestStartDate: WellTestRawSchema.shape.wellTestStartDate?.describe(
      'Time series signal representing well test start date for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEndDate: WellTestRawSchema.shape.wellTestEndDate?.describe(
      'Time series signal representing well test end date for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspMotorVoltage: WellTestRawSchema.shape.wellTestEspMotorVoltage?.describe(
      'Time series signal representing well test esp motor voltage for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspPumpDischargePressure: WellTestRawSchema.shape.wellTestEspPumpDischargePressure?.describe(
      'Time series signal representing well test esp pump discharge pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspPumpFrequency: WellTestRawSchema.shape.wellTestEspPumpFrequency?.describe(
      'Time series signal representing well test esp pump frequency for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspPumpIntakePressure: WellTestRawSchema.shape.wellTestEspPumpIntakePressure?.describe(
      'Time series signal representing well test esp pump intake pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspPumpIntakeTemperature: WellTestRawSchema.shape.wellTestEspPumpIntakeTemperature?.describe(
      'Time series signal representing well test esp pump intake temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlFlControlValveInletTemp: WellTestRawSchema.shape.wellTestGlFlControlValveInletTemp?.describe(
      'Time series signal representing well test gl fl control valve inlet temp for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlInjectionChokeOpening: WellTestRawSchema.shape.wellTestGlInjectionChokeOpening?.describe(
      'Time series signal representing well test gl injection choke opening for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlFlControlValveInletPres: WellTestRawSchema.shape.wellTestGlFlControlValveInletPres?.describe(
      'Time series signal representing well test gl fl control valve inlet pres for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasLiftVolume: WellTestRawSchema.shape.wellTestGasLiftVolume?.describe(
      'Time series signal representing well test gas lift volume for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGlFlControlValvOutletPres: WellTestRawSchema.shape.wellTestGlFlControlValvOutletPres?.describe(
      'Time series signal representing well test gl fl control valv outlet pres for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTestSeparatorLinePressure: WellTestRawSchema.shape.wellTestTestSeparatorLinePressure?.describe(
      'Time series signal representing well test test separator line pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTestSeparatorLineTemperature: WellTestRawSchema.shape.wellTestTestSeparatorLineTemperature?.describe(
      'Time series signal representing well test test separator line temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWGR: WellTestRawSchema.shape.wellTestWGR?.describe(
      'Time series signal representing well test wgr for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCGR: WellTestRawSchema.shape.wellTestCGR?.describe(
      'Time series signal representing well test cgr for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWellheadPressure: WellTestRawSchema.shape.wellTestWellheadPressure?.describe(
      'Time series signal representing well test wellhead pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWellheadTemperature: WellTestRawSchema.shape.wellTestWellheadTemperature?.describe(
      'Time series signal representing well test wellhead temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRateStd: WellTestRawSchema.shape.wellTestGasRateStd?.describe(
      'Time series signal representing well test gas rate std for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRateInsitu: WellTestRawSchema.shape.wellTestGasRateInsitu?.describe(
      'Time series signal representing well test gas rate insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasRatePts: WellTestRawSchema.shape.wellTestGasRatePts?.describe(
      'Time series signal representing well test gas rate pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEgorVendorStdGasRate: WellTestRawSchema.shape.wellTestEgorVendorStdGasRate?.describe(
      'Time series signal representing well test egor vendor std gas rate for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRateStd: WellTestRawSchema.shape.wellTestOilRateStd?.describe(
      'Time series signal representing well test oil rate std for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRateInsitu: WellTestRawSchema.shape.wellTestOilRateInsitu?.describe(
      'Time series signal representing well test oil rate insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilRatePts: WellTestRawSchema.shape.wellTestOilRatePts?.describe(
      'Time series signal representing well test oil rate pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEgorVendorStdOilRate: WellTestRawSchema.shape.wellTestEgorVendorStdOilRate?.describe(
      'Time series signal representing well test egor vendor std oil rate for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRateStd: WellTestRawSchema.shape.wellTestWaterRateStd?.describe(
      'Time series signal representing well test water rate std for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRateInsitu: WellTestRawSchema.shape.wellTestWaterRateInsitu?.describe(
      'Time series signal representing well test water rate insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterRatePts: WellTestRawSchema.shape.wellTestWaterRatePts?.describe(
      'Time series signal representing well test water rate pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEgorVendorStdWaterRate: WellTestRawSchema.shape.wellTestEgorVendorStdWaterRate?.describe(
      'Time series signal representing well test egor vendor std water rate for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGorInsitu: WellTestRawSchema.shape.wellTestGorInsitu?.describe(
      'Time series signal representing well test gor insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGorPts: WellTestRawSchema.shape.wellTestGorPts?.describe(
      'Time series signal representing well test gor pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalGorStd: WellTestRawSchema.shape.wellTestTotalGorStd?.describe(
      'Time series signal representing well test total gor std for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCut: WellTestRawSchema.shape.wellTestWaterCut?.describe(
      'Time series signal representing well test water cut for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCutPts: WellTestRawSchema.shape.wellTestWaterCutPts?.describe(
      'Time series signal representing well test water cut pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestWaterCutInsitu: WellTestRawSchema.shape.wellTestWaterCutInsitu?.describe(
      'Time series signal representing well test water cut insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestLiquidRatePts: WellTestRawSchema.shape.wellTestLiquidRatePts?.describe(
      'Time series signal representing well test liquid rate pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestChokeSize: WellTestRawSchema.shape.wellTestChokeSize?.describe(
      'Time series signal representing well test choke size for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCasingHeadPressure: WellTestRawSchema.shape.wellTestCasingHeadPressure?.describe(
      'Time series signal representing well test casing head pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestCasingHeadTemperature: WellTestRawSchema.shape.wellTestCasingHeadTemperature?.describe(
      'Time series signal representing well test casing head temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestBottomHolePressure: WellTestRawSchema.shape.wellTestBottomHolePressure?.describe(
      'Time series signal representing well test bottom hole pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestBottomHoleTemperature: WellTestRawSchema.shape.wellTestBottomHoleTemperature?.describe(
      'Time series signal representing well test bottom hole temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestFlowlineTemperature: WellTestRawSchema.shape.wellTestFlowlineTemperature?.describe(
      'Time series signal representing well test flowline temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestFlowlinePressure: WellTestRawSchema.shape.wellTestFlowlinePressure?.describe(
      'Time series signal representing well test flowline pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspMotorCurrent: WellTestRawSchema.shape.wellTestEspMotorCurrent?.describe(
      'Time series signal representing well test esp motor current for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestEspMotorPower: WellTestRawSchema.shape.wellTestEspMotorPower?.describe(
      'Time series signal representing well test esp motor power for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestDuration: WellTestRawSchema.shape.wellTestDuration?.describe(
      'Time series signal representing well test duration for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestStringFunction: WellTestRawSchema.shape.wellTestStringFunction?.describe(
      'Text describing the functional role of the production string (for example main producer, backup, injector, idle), used in surveillance and planning.',
    ),
    wellTestApprovedAllocationFlag: WellTestRawSchema.shape.wellTestApprovedAllocationFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    wellTestTestTypeDesc: WellTestRawSchema.shape.wellTestTestTypeDesc?.describe(
      'Time series signal representing well test test type desc for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestMpfmName: WellTestRawSchema.shape.wellTestMpfmName?.describe(
      'Name or label for this well, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    wellTestTestMethod: WellTestRawSchema.shape.wellTestTestMethod?.describe(
      'Time series signal representing well test test method for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestArtificialLiftType: WellTestRawSchema.shape.wellTestArtificialLiftType?.describe(
      'Time series signal representing well test artificial lift type for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestValidationFlag: WellTestRawSchema.shape.wellTestValidationFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    wellTestTestType: WellTestRawSchema.shape.wellTestTestType?.describe(
      'Time series signal representing well test test type for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    ptsDateTime: WellTestRawSchema.shape.ptsDateTime?.describe(
      'Time series signal representing pts date time for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    composition: WellTestRawSchema.shape.composition?.describe(
      'Time series signal representing composition for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelComposition: WellTestRawSchema.shape.modelComposition?.describe(
      'Time series signal representing model composition for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    sampleDateTime: WellTestRawSchema.shape.sampleDateTime?.describe(
      'Time series signal representing sample date time for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    validatedBy: WellTestRawSchema.shape.validatedBy?.describe(
      'Time series signal representing validated by for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    comments: WellTestRawSchema.shape.comments?.describe(
      'Free-text comments field capturing operator or engineer notes related to this measurement, configuration, or event.',
    ),
    fluidProperties: WellTestRawSchema.shape.fluidProperties?.describe(
      'Time series signal representing fluid properties for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGOR: WellTestRawSchema.shape.wellTestGOR?.describe(
      'Time series signal representing well test gor for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRateOil: WellTestRawSchema.shape.wellTestTotalMassFlowRateOil?.describe(
      'Time series signal representing well test total mass flow rate oil for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRateWater: WellTestRawSchema.shape.wellTestTotalMassFlowRateWater?.describe(
      'Time series signal representing well test total mass flow rate water for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestTotalMassFlowRateGas: WellTestRawSchema.shape.wellTestTotalMassFlowRateGas?.describe(
      'Time series signal representing well test total mass flow rate gas for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestGasDensityInSitu: WellTestRawSchema.shape.wellTestGasDensityInSitu?.describe(
      'Time series signal representing well test gas density in situ for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestOilDensityInSitu: WellTestRawSchema.shape.wellTestOilDensityInSitu?.describe(
      'Time series signal representing well test oil density in situ for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    stablePeriodStartDate: WellTestRawSchema.shape.stablePeriodStartDate?.describe(
      'Time series signal representing stable period start date for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    stablePeriodEndDate: WellTestRawSchema.shape.stablePeriodEndDate?.describe(
      'Time series signal representing stable period end date for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellTestChokeOpening: WellTestRawSchema.shape.wellTestChokeOpening?.describe(
      'Time series signal representing well test choke opening for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Well Test Raw view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WellTestReservoirAnalysisAgentView = parseView({
  view: { externalId: 'WellTest_ReservoirAnalysis_Agent' },
  model: WellTestReservoirAnalysisAgentSchema.extend({
    ...InstanceIdType.shape,
    wellString: WellTestReservoirAnalysisAgentSchema.shape.wellString?.describe('Reference to well string'),
    modelProductivityIndex: WellTestReservoirAnalysisAgentSchema.shape.modelProductivityIndex?.describe(
      'Productivity Index - PI (stb/d/psi, TS)',
    ),
    modelProductivityIndexPercentChange:
      WellTestReservoirAnalysisAgentSchema.shape.modelProductivityIndexPercentChange?.describe(
        'Percent change in PI from previous accepted test (%, TS).\n  NEGATIVE = PI declined (possible causes: scale, skin, depletion).\n  > -20% decline warrants investigation.\n\n@name piPercentChange',
      ),
    modelInjectivityIndex: WellTestReservoirAnalysisAgentSchema.shape.modelInjectivityIndex?.describe(
      'Injectivity Index - II (bbl/d/psi, TS)',
    ),
    modelInjectivityIndexPercentChange:
      WellTestReservoirAnalysisAgentSchema.shape.modelInjectivityIndexPercentChange?.describe(
        'Percent change in II from previous test (%, TS).\n  Declining II may indicate: formation damage, scale, or plugging.\n\n@name iiPercentChange',
      ),
    modelReservoirPressure: WellTestReservoirAnalysisAgentSchema.shape.modelReservoirPressure?.describe(
      'Static reservoir pressure from analysis (psia, TS).\n  Declining Pres = depletion',
    ),
    modelReservoirPressurePercentChange:
      WellTestReservoirAnalysisAgentSchema.shape.modelReservoirPressurePercentChange?.describe(
        'Percent change in reservoir pressure (%, TS).\n  Rapid decline may indicate: poor sweep, inadequate injection support.\n\n@name reservoirPressureChange',
      ),
    modelStabilityFlag: WellTestReservoirAnalysisAgentSchema.shape.modelStabilityFlag?.describe(
      'Is well operating in stable regime? (TS)',
    ),
    modelMinStableRate: WellTestReservoirAnalysisAgentSchema.shape.modelMinStableRate?.describe(
      'Minimum rate for stable flow (stb/d, TS)',
    ),
    modelWellTestTimestamp: WellTestReservoirAnalysisAgentSchema.shape.modelWellTestTimestamp?.describe(
      'When this analysis was performed (TS)',
    ),
    modelStatus: WellTestReservoirAnalysisAgentSchema.shape.modelStatus?.describe('Status of analysis result (TS)'),
  })?.describe(
    'Reservoir performance from well test analysis including PI, II, and reservoir\npressure.\n\nContains data derived from well test analyses, focusing on key performance\nindicators such as the Productivity Index (PI), Injectivity Index (II), and\nreservoir pressure metrics. Sourced from field tests conducted on production\nand injection wells, allowing for the assessment of reservoir deliverability\nand performance over time. It answers critical questions regarding changes in\nPI, reservoir pressure trends, and the efficiency of reservoir depletion, but\nexcludes detailed geological data or historical production rates found in\nother views. Use cases: monitoring reservoir performance, identifying wells\nwith declining efficiency, and comparing performance across different fields.\n\n@name Well Test Reservoir Analysis (Agent)',
  ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const WellView = parseView({
  view: { externalId: 'Well' },
  model: WellSchema.extend(InstanceIdType.shape),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const Wf05FieldOutputsView = parseView({
  view: { externalId: 'WF05_Field_Outputs' },
  model: Wf05FieldOutputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: Wf05FieldOutputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    executionType: Wf05FieldOutputsSchema.shape.executionType?.describe(
      'Time series signal representing execution type for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fieldAllocationVolumeSource: Wf05FieldOutputsSchema.shape.fieldAllocationVolumeSource?.describe(
      'Time series signal representing field allocation volume source for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMTotalWellsEstimatedNonAssociatedGasVolume:
      Wf05FieldOutputsSchema.shape.preferredVFMTotalWellsEstimatedNonAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmtotal wells estimated non associated gas volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMTotalWellsEstimatedWaterVolume:
      Wf05FieldOutputsSchema.shape.preferredVFMTotalWellsEstimatedWaterVolume?.describe(
        'Time series signal representing preferred vfmtotal wells estimated water volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMTotalWellsEstimatedOilVolume:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMTotalWellsEstimatedOilVolume?.describe(
        'Time series signal representing weighted average vfmtotal wells estimated oil volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMTotalWellsEstimatedAssociatedGasVolume:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMTotalWellsEstimatedAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmtotal wells estimated associated gas volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMTotalWellsEstimatedNonAssociatedGasVolume:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMTotalWellsEstimatedNonAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmtotal wells estimated non associated gas volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMTotalWellsEstimatedWaterVolume:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMTotalWellsEstimatedWaterVolume?.describe(
        'Time series signal representing weighted average vfmtotal wells estimated water volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    dailyActualOilProduction: Wf05FieldOutputsSchema.shape.dailyActualOilProduction?.describe(
      'Time series signal representing daily actual oil production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    dailyAssociatedGasProduction: Wf05FieldOutputsSchema.shape.dailyAssociatedGasProduction?.describe(
      'Time series signal representing daily associated gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    dailyActualWaterProduction: Wf05FieldOutputsSchema.shape.dailyActualWaterProduction?.describe(
      'Time series signal representing daily actual water production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    dailyNonAssociatedGasProduction: Wf05FieldOutputsSchema.shape.dailyNonAssociatedGasProduction?.describe(
      'Time series signal representing daily non associated gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMTotalWellsEstimatedAssociatedGasVolume:
      Wf05FieldOutputsSchema.shape.preferredVFMTotalWellsEstimatedAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmtotal wells estimated associated gas volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMTotalWellsEstimatedOilVolume:
      Wf05FieldOutputsSchema.shape.preferredVFMTotalWellsEstimatedOilVolume?.describe(
        'Time series signal representing preferred vfmtotal wells estimated oil volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMRelativeFieldOilVolumeError:
      Wf05FieldOutputsSchema.shape.preferredVFMRelativeFieldOilVolumeError?.describe(
        'Time series signal representing preferred vfmrelative field oil volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMRelativeFieldAssociatedGasVolumeError:
      Wf05FieldOutputsSchema.shape.preferredVFMRelativeFieldAssociatedGasVolumeError?.describe(
        'Time series signal representing preferred vfmrelative field associated gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMRelativeFieldNonAssociatedGasVolumeError:
      Wf05FieldOutputsSchema.shape.preferredVFMRelativeFieldNonAssociatedGasVolumeError?.describe(
        'Time series signal representing preferred vfmrelative field non associated gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMRelativeFieldWaterVolumeError:
      Wf05FieldOutputsSchema.shape.preferredVFMRelativeFieldWaterVolumeError?.describe(
        'Time series signal representing preferred vfmrelative field water volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMRelativeFieldOilVolumeError:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMRelativeFieldOilVolumeError?.describe(
        'Time series signal representing weighted average vfmrelative field oil volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMRelativeFieldAssociatedGasVolumeError:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMRelativeFieldAssociatedGasVolumeError?.describe(
        'Time series signal representing weighted average vfmrelative field associated gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMRelativeFieldNonAssociatedGasVolumeError:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMRelativeFieldNonAssociatedGasVolumeError?.describe(
        'Time series signal representing weighted average vfmrelative field non associated gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMRelativeFieldWaterVolumeError:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMRelativeFieldWaterVolumeError?.describe(
        'Time series signal representing weighted average vfmrelative field water volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    totalWellsWaterInjectionVolume: Wf05FieldOutputsSchema.shape.totalWellsWaterInjectionVolume?.describe(
      'Time series signal representing total wells water injection volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    totalWellsGasInjectionVolume: Wf05FieldOutputsSchema.shape.totalWellsGasInjectionVolume?.describe(
      'Time series signal representing total wells gas injection volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMOilAllocationFactor: Wf05FieldOutputsSchema.shape.preferredVFMOilAllocationFactor?.describe(
      'Time series signal representing preferred vfmoil allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMAssociatedGasAllocationFactor:
      Wf05FieldOutputsSchema.shape.preferredVFMAssociatedGasAllocationFactor?.describe(
        'Time series signal representing preferred vfmassociated gas allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMNonAssociatedGasAllocationFactor:
      Wf05FieldOutputsSchema.shape.preferredVFMNonAssociatedGasAllocationFactor?.describe(
        'Time series signal representing preferred vfmnon associated gas allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMWaterAllocationFactor: Wf05FieldOutputsSchema.shape.preferredVFMWaterAllocationFactor?.describe(
      'Time series signal representing preferred vfmwater allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMOilAllocationFactor: Wf05FieldOutputsSchema.shape.weightedAverageVFMOilAllocationFactor?.describe(
      'Time series signal representing weighted average vfmoil allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMAssociatedGasAllocationFactor:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMAssociatedGasAllocationFactor?.describe(
        'Time series signal representing weighted average vfmassociated gas allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMNonAssociatedGasAllocationFactor:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMNonAssociatedGasAllocationFactor?.describe(
        'Time series signal representing weighted average vfmnon associated gas allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMWaterAllocationFactor:
      Wf05FieldOutputsSchema.shape.weightedAverageVFMWaterAllocationFactor?.describe(
        'Time series signal representing weighted average vfmwater allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    injectionWFExecutionType: Wf05FieldOutputsSchema.shape.injectionWFExecutionType?.describe(
      'Time series signal representing injection wfexecution type for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    oilProductionAllocationStatus: Wf05FieldOutputsSchema.shape.oilProductionAllocationStatus?.describe(
      'Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    agProductionAllocationStatus: Wf05FieldOutputsSchema.shape.agProductionAllocationStatus?.describe(
      'Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    nagProductionAllocationStatus: Wf05FieldOutputsSchema.shape.nagProductionAllocationStatus?.describe(
      'Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    waterProductionAllocationStatus: Wf05FieldOutputsSchema.shape.waterProductionAllocationStatus?.describe(
      'Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    gasProductionAllocationStatus: Wf05FieldOutputsSchema.shape.gasProductionAllocationStatus?.describe(
      'Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    gasInjectioAllocationStatus: Wf05FieldOutputsSchema.shape.gasInjectioAllocationStatus?.describe(
      'Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    waterInjectionAllocationStatus: Wf05FieldOutputsSchema.shape.waterInjectionAllocationStatus?.describe(
      'Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    relativeFieldGasVolumeError: Wf05FieldOutputsSchema.shape.relativeFieldGasVolumeError?.describe(
      'Time series signal representing relative field gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    relativeFieldWaterVolumeError: Wf05FieldOutputsSchema.shape.relativeFieldWaterVolumeError?.describe(
      'Time series signal representing relative field water volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    waterInjectionAllocationFactor: Wf05FieldOutputsSchema.shape.waterInjectionAllocationFactor?.describe(
      'Time series signal representing water injection allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    gasInjectionAllocationFactor: Wf05FieldOutputsSchema.shape.gasInjectionAllocationFactor?.describe(
      'Time series signal representing gas injection allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    fieldInjectionAllocationVolumeSource: Wf05FieldOutputsSchema.shape.fieldInjectionAllocationVolumeSource?.describe(
      'Time series signal representing field injection allocation volume source for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    dailyActualGasInjection: Wf05FieldOutputsSchema.shape.dailyActualGasInjection?.describe(
      'Time series signal representing daily actual gas injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    dailyActualWaterInjection: Wf05FieldOutputsSchema.shape.dailyActualWaterInjection?.describe(
      'Time series signal representing daily actual water injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'Field-level outputs from the WF05 workflow, summarizing virtual flow meter (VFM) estimates, actual daily production, allocation errors and allocation factors for oil, gas and water across all wells in the field.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const Wf05StringOutputsView = parseView({
  view: { externalId: 'WF05_String_Outputs' },
  model: Wf05StringOutputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: Wf05StringOutputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    executionType: Wf05StringOutputsSchema.shape.executionType?.describe(
      'Time series signal representing execution type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMAverageOilRate: Wf05StringOutputsSchema.shape.preferredVFMAverageOilRate?.describe(
      'Time series signal representing preferred vfmaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMAverageAssociatedGasRate: Wf05StringOutputsSchema.shape.preferredVFMAverageAssociatedGasRate?.describe(
      'Time series signal representing preferred vfmaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMAverageNonAssociatedGasRate:
      Wf05StringOutputsSchema.shape.preferredVFMAverageNonAssociatedGasRate?.describe(
        'Time series signal representing preferred vfmaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMAverageWaterRate: Wf05StringOutputsSchema.shape.preferredVFMAverageWaterRate?.describe(
      'Time series signal representing preferred vfmaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMEstimatedWellOilVolume: Wf05StringOutputsSchema.shape.preferredVFMEstimatedWellOilVolume?.describe(
      'Time series signal representing preferred vfmestimated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMEstimatedWellAssociatedGasVolume:
      Wf05StringOutputsSchema.shape.preferredVFMEstimatedWellAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmestimated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMEstimatedWellNonAssociatedGasVolume:
      Wf05StringOutputsSchema.shape.preferredVFMEstimatedWellNonAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmestimated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    wellUptime: Wf05StringOutputsSchema.shape.wellUptime?.describe(
      'Time series signal representing well uptime for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMDataSourceFlag: Wf05StringOutputsSchema.shape.preferredVFMDataSourceFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    vfmSystemAnalysisAverageOilRate: Wf05StringOutputsSchema.shape.vfmSystemAnalysisAverageOilRate?.describe(
      'Time series signal representing vfm system analysis average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmIPRAverageOilRate: Wf05StringOutputsSchema.shape.vfmIPRAverageOilRate?.describe(
      'Time series signal representing vfm ipraverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmVLPAverageOilRate: Wf05StringOutputsSchema.shape.vfmVLPAverageOilRate?.describe(
      'Time series signal representing vfm vlpaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmChokeAverageOilRate: Wf05StringOutputsSchema.shape.vfmChokeAverageOilRate?.describe(
      'Time series signal representing vfm choke average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmESPAverageOilRate: Wf05StringOutputsSchema.shape.vfmESPAverageOilRate?.describe(
      'Time series signal representing vfm espaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmDataDrivenAverageOilRate: Wf05StringOutputsSchema.shape.vfmDataDrivenAverageOilRate?.describe(
      'Time series signal representing vfm data driven average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmSystemAnalysisAverageAssociatedGasRate:
      Wf05StringOutputsSchema.shape.vfmSystemAnalysisAverageAssociatedGasRate?.describe(
        'Time series signal representing vfm system analysis average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmIPRAverageAssociatedGasRate: Wf05StringOutputsSchema.shape.vfmIPRAverageAssociatedGasRate?.describe(
      'Time series signal representing vfm ipraverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmVLPAverageAssociatedGasRate: Wf05StringOutputsSchema.shape.vfmVLPAverageAssociatedGasRate?.describe(
      'Time series signal representing vfm vlpaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmChokeAverageAssociatedGasRate: Wf05StringOutputsSchema.shape.vfmChokeAverageAssociatedGasRate?.describe(
      'Time series signal representing vfm choke average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmESPAverageAssociatedGasRate: Wf05StringOutputsSchema.shape.vfmESPAverageAssociatedGasRate?.describe(
      'Time series signal representing vfm espaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmDataDrivenAverageAssociatedGasRate:
      Wf05StringOutputsSchema.shape.vfmDataDrivenAverageAssociatedGasRate?.describe(
        'Time series signal representing vfm data driven average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate:
      Wf05StringOutputsSchema.shape.vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate?.describe(
        'Time series signal representing vfm system analysis average associated non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmIPRAverageNonAssociatedGasRate: Wf05StringOutputsSchema.shape.vfmIPRAverageNonAssociatedGasRate?.describe(
      'Time series signal representing vfm ipraverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmVLPAverageNonAssociatedGasRate: Wf05StringOutputsSchema.shape.vfmVLPAverageNonAssociatedGasRate?.describe(
      'Time series signal representing vfm vlpaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmChokeAverageNonAssociatedGasRate: Wf05StringOutputsSchema.shape.vfmChokeAverageNonAssociatedGasRate?.describe(
      'Time series signal representing vfm choke average non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmESPAverageNonAssociatedGasRate: Wf05StringOutputsSchema.shape.vfmESPAverageNonAssociatedGasRate?.describe(
      'Time series signal representing vfm espaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmDataDrivenAverageNonAssociatedGasRate:
      Wf05StringOutputsSchema.shape.vfmDataDrivenAverageNonAssociatedGasRate?.describe(
        'Time series signal representing vfm data driven average non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmSystemAnalysisAverageWaterRate: Wf05StringOutputsSchema.shape.vfmSystemAnalysisAverageWaterRate?.describe(
      'Time series signal representing vfm system analysis average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmIPRAverageWaterRate: Wf05StringOutputsSchema.shape.vfmIPRAverageWaterRate?.describe(
      'Time series signal representing vfm ipraverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmVLPAverageWaterRate: Wf05StringOutputsSchema.shape.vfmVLPAverageWaterRate?.describe(
      'Time series signal representing vfm vlpaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmChokeAverageWaterRate: Wf05StringOutputsSchema.shape.vfmChokeAverageWaterRate?.describe(
      'Time series signal representing vfm choke average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmESPAverageWaterRate: Wf05StringOutputsSchema.shape.vfmESPAverageWaterRate?.describe(
      'Time series signal representing vfm espaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmDataDrivenAverageWaterRate: Wf05StringOutputsSchema.shape.vfmDataDrivenAverageWaterRate?.describe(
      'Time series signal representing vfm data driven average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorSystemAnalysis: Wf05StringOutputsSchema.shape.normalizedWeightFactorSystemAnalysis?.describe(
      'Time series signal representing normalized weight factor system analysis for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorIPR: Wf05StringOutputsSchema.shape.normalizedWeightFactorIPR?.describe(
      'Time series signal representing normalized weight factor ipr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorVLP: Wf05StringOutputsSchema.shape.normalizedWeightFactorVLP?.describe(
      'Time series signal representing normalized weight factor vlp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorChoke: Wf05StringOutputsSchema.shape.normalizedWeightFactorChoke?.describe(
      'Time series signal representing normalized weight factor choke for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorESP: Wf05StringOutputsSchema.shape.normalizedWeightFactorESP?.describe(
      'Time series signal representing normalized weight factor esp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorDataDriven: Wf05StringOutputsSchema.shape.normalizedWeightFactorDataDriven?.describe(
      'Time series signal representing normalized weight factor data driven for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMOilRate: Wf05StringOutputsSchema.shape.weightedAverageVFMOilRate?.describe(
      'Time series signal representing weighted average vfmoil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMAssociatedGasRate: Wf05StringOutputsSchema.shape.weightedAverageVFMAssociatedGasRate?.describe(
      'Time series signal representing weighted average vfmassociated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMNonAssociatedGasRate:
      Wf05StringOutputsSchema.shape.weightedAverageVFMNonAssociatedGasRate?.describe(
        'Time series signal representing weighted average vfmnon associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMWaterRate: Wf05StringOutputsSchema.shape.weightedAverageVFMWaterRate?.describe(
      'Time series signal representing weighted average vfmwater rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMEstimatedWellOilVolume:
      Wf05StringOutputsSchema.shape.weightedAverageVFMEstimatedWellOilVolume?.describe(
        'Time series signal representing weighted average vfmestimated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMEstimatedWellAssociatedGasVolume:
      Wf05StringOutputsSchema.shape.weightedAverageVFMEstimatedWellAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmestimated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMEstimatedWellNonAssociatedGasVolume:
      Wf05StringOutputsSchema.shape.weightedAverageVFMEstimatedWellNonAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmestimated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMEstimatedWellWaterVolume:
      Wf05StringOutputsSchema.shape.weightedAverageVFMEstimatedWellWaterVolume?.describe(
        'Time series signal representing weighted average vfmestimated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageDataSourceFlag: Wf05StringOutputsSchema.shape.weightedAverageDataSourceFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    preferredVFMEstimatedWellWaterVolume: Wf05StringOutputsSchema.shape.preferredVFMEstimatedWellWaterVolume?.describe(
      'Time series signal representing preferred vfmestimated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    averageWaterInjectionRate: Wf05StringOutputsSchema.shape.averageWaterInjectionRate?.describe(
      'Time series signal representing average water injection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    averageGasInjectionRate: Wf05StringOutputsSchema.shape.averageGasInjectionRate?.describe(
      'Time series signal representing average gas injection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellWaterInjectionVolume: Wf05StringOutputsSchema.shape.wellWaterInjectionVolume?.describe(
      'Time series signal representing well water injection volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellGasInjectionVolume: Wf05StringOutputsSchema.shape.wellGasInjectionVolume?.describe(
      'Time series signal representing well gas injection volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    injectionRateDataSourceFlag: Wf05StringOutputsSchema.shape.injectionRateDataSourceFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    preferredVFMAllocatedWellOilVolume: Wf05StringOutputsSchema.shape.preferredVFMAllocatedWellOilVolume?.describe(
      'Time series signal representing preferred vfmallocated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMAllocatedWellAssociatedGasVolume:
      Wf05StringOutputsSchema.shape.preferredVFMAllocatedWellAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmallocated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMAllocatedWellNonAssociatedGasVolume:
      Wf05StringOutputsSchema.shape.preferredVFMAllocatedWellNonAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmallocated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMAllocatedWellWaterVolume: Wf05StringOutputsSchema.shape.preferredVFMAllocatedWellWaterVolume?.describe(
      'Time series signal representing preferred vfmallocated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMAllocatedWellOilVolume:
      Wf05StringOutputsSchema.shape.weightedAverageVFMAllocatedWellOilVolume?.describe(
        'Time series signal representing weighted average vfmallocated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMAllocatedWellAssociatedGasVolume:
      Wf05StringOutputsSchema.shape.weightedAverageVFMAllocatedWellAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmallocated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMAllocatedWellNonAssociatedGasVolume:
      Wf05StringOutputsSchema.shape.weightedAverageVFMAllocatedWellNonAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmallocated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMAllocatedWellWaterVolume:
      Wf05StringOutputsSchema.shape.weightedAverageVFMAllocatedWellWaterVolume?.describe(
        'Time series signal representing weighted average vfmallocated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    oilProductionAllocationStatus: Wf05StringOutputsSchema.shape.oilProductionAllocationStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    agProductionAllocationStatus: Wf05StringOutputsSchema.shape.agProductionAllocationStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    nagProductionAllocationStatus: Wf05StringOutputsSchema.shape.nagProductionAllocationStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    waterProductionAllocationStatus: Wf05StringOutputsSchema.shape.waterProductionAllocationStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    gasProductionAllocationStatus: Wf05StringOutputsSchema.shape.gasProductionAllocationStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    gasInjectioAllocationStatus: Wf05StringOutputsSchema.shape.gasInjectioAllocationStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    waterInjectionAllocationStatus: Wf05StringOutputsSchema.shape.waterInjectionAllocationStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    allocatedWellInjectionGasVolume: Wf05StringOutputsSchema.shape.allocatedWellInjectionGasVolume?.describe(
      'Time series signal representing allocated well injection gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    allocatedWellInjectionWaterVolume: Wf05StringOutputsSchema.shape.allocatedWellInjectionWaterVolume?.describe(
      'Time series signal representing allocated well injection water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    wellType: Wf05StringOutputsSchema.shape.wellType?.describe(
      'Time series signal representing well type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmPreferredMethodOilAllocationRate: Wf05StringOutputsSchema.shape.vfmPreferredMethodOilAllocationRate?.describe(
      'Time series signal representing vfm preferred method oil allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmPreferredMethodAssociatedGasAllocationRate:
      Wf05StringOutputsSchema.shape.vfmPreferredMethodAssociatedGasAllocationRate?.describe(
        'Time series signal representing vfm preferred method associated gas allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmPreferredMethodNonAssociatedGasAllocationRate:
      Wf05StringOutputsSchema.shape.vfmPreferredMethodNonAssociatedGasAllocationRate?.describe(
        'Time series signal representing vfm preferred method non associated gas allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmPreferredMethodWaterAllocationRate:
      Wf05StringOutputsSchema.shape.vfmPreferredMethodWaterAllocationRate?.describe(
        'Time series signal representing vfm preferred method water allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmWeightedAverageMethodOilAllocationRate:
      Wf05StringOutputsSchema.shape.vfmWeightedAverageMethodOilAllocationRate?.describe(
        'Time series signal representing vfm weighted average method oil allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmWeightedAverageAssociatedGasAllocationRate:
      Wf05StringOutputsSchema.shape.vfmWeightedAverageAssociatedGasAllocationRate?.describe(
        'Time series signal representing vfm weighted average associated gas allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmWeightedAverageNonAssociatedGasAllocationRate:
      Wf05StringOutputsSchema.shape.vfmWeightedAverageNonAssociatedGasAllocationRate?.describe(
        'Time series signal representing vfm weighted average non associated gas allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmWeightedAverageWaterAllocationRate:
      Wf05StringOutputsSchema.shape.vfmWeightedAverageWaterAllocationRate?.describe(
        'Time series signal representing vfm weighted average water allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    allocatedWellInjectionWaterRate: Wf05StringOutputsSchema.shape.allocatedWellInjectionWaterRate?.describe(
      'Time series signal representing allocated well injection water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    allocatedWellInjectionGasRate: Wf05StringOutputsSchema.shape.allocatedWellInjectionGasRate?.describe(
      'Time series signal representing allocated well injection gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    isWag: Wf05StringOutputsSchema.shape.isWag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
  })?.describe(
    'String level outputs from the WF05 workflow, providing virtual flow meter (VFM) based oil, gas and water rates, estimated well volumes, method-specific VFM rates and diagnostics used for allocation and well performance evaluation.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const Wf05StringReservoirOutputsView = parseView({
  view: { externalId: 'WF05_String_Reservoir_Outputs' },
  model: Wf05StringReservoirOutputsSchema.extend({
    ...InstanceIdType.shape,
    entityName: Wf05StringReservoirOutputsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    reservoirName: Wf05StringReservoirOutputsSchema.shape.reservoirName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    fieldName: Wf05StringReservoirOutputsSchema.shape.fieldName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    executionType: Wf05StringReservoirOutputsSchema.shape.executionType?.describe(
      'Time series signal representing execution type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMAverageOilRate: Wf05StringReservoirOutputsSchema.shape.preferredVFMAverageOilRate?.describe(
      'Time series signal representing preferred vfmaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMAverageAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMAverageAssociatedGasRate?.describe(
        'Time series signal representing preferred vfmaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMAverageNonAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMAverageNonAssociatedGasRate?.describe(
        'Time series signal representing preferred vfmaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMAverageWaterRate: Wf05StringReservoirOutputsSchema.shape.preferredVFMAverageWaterRate?.describe(
      'Time series signal representing preferred vfmaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMEstimatedWellOilVolume:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMEstimatedWellOilVolume?.describe(
        'Time series signal representing preferred vfmestimated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMEstimatedWellAssociatedGasVolume:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMEstimatedWellAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmestimated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMEstimatedWellNonAssociatedGasVolume:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMEstimatedWellNonAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmestimated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    wellUptime: Wf05StringReservoirOutputsSchema.shape.wellUptime?.describe(
      'Time series signal representing well uptime for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    preferredVFMDataSourceFlag: Wf05StringReservoirOutputsSchema.shape.preferredVFMDataSourceFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    vfmSystemAnalysisAverageOilRate: Wf05StringReservoirOutputsSchema.shape.vfmSystemAnalysisAverageOilRate?.describe(
      'Time series signal representing vfm system analysis average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmIPRAverageOilRate: Wf05StringReservoirOutputsSchema.shape.vfmIPRAverageOilRate?.describe(
      'Time series signal representing vfm ipraverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmVLPAverageOilRate: Wf05StringReservoirOutputsSchema.shape.vfmVLPAverageOilRate?.describe(
      'Time series signal representing vfm vlpaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmChokeAverageOilRate: Wf05StringReservoirOutputsSchema.shape.vfmChokeAverageOilRate?.describe(
      'Time series signal representing vfm choke average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmESPAverageOilRate: Wf05StringReservoirOutputsSchema.shape.vfmESPAverageOilRate?.describe(
      'Time series signal representing vfm espaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmDataDrivenAverageOilRate: Wf05StringReservoirOutputsSchema.shape.vfmDataDrivenAverageOilRate?.describe(
      'Time series signal representing vfm data driven average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmSystemAnalysisAverageAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.vfmSystemAnalysisAverageAssociatedGasRate?.describe(
        'Time series signal representing vfm system analysis average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmIPRAverageAssociatedGasRate: Wf05StringReservoirOutputsSchema.shape.vfmIPRAverageAssociatedGasRate?.describe(
      'Time series signal representing vfm ipraverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmVLPAverageAssociatedGasRate: Wf05StringReservoirOutputsSchema.shape.vfmVLPAverageAssociatedGasRate?.describe(
      'Time series signal representing vfm vlpaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmChokeAverageAssociatedGasRate: Wf05StringReservoirOutputsSchema.shape.vfmChokeAverageAssociatedGasRate?.describe(
      'Time series signal representing vfm choke average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmESPAverageAssociatedGasRate: Wf05StringReservoirOutputsSchema.shape.vfmESPAverageAssociatedGasRate?.describe(
      'Time series signal representing vfm espaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmDataDrivenAverageAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.vfmDataDrivenAverageAssociatedGasRate?.describe(
        'Time series signal representing vfm data driven average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate?.describe(
        'Time series signal representing vfm system analysis average associated non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmIPRAverageNonAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.vfmIPRAverageNonAssociatedGasRate?.describe(
        'Time series signal representing vfm ipraverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmVLPAverageNonAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.vfmVLPAverageNonAssociatedGasRate?.describe(
        'Time series signal representing vfm vlpaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmChokeAverageNonAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.vfmChokeAverageNonAssociatedGasRate?.describe(
        'Time series signal representing vfm choke average non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmESPAverageNonAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.vfmESPAverageNonAssociatedGasRate?.describe(
        'Time series signal representing vfm espaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmDataDrivenAverageNonAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.vfmDataDrivenAverageNonAssociatedGasRate?.describe(
        'Time series signal representing vfm data driven average non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmSystemAnalysisAverageWaterRate:
      Wf05StringReservoirOutputsSchema.shape.vfmSystemAnalysisAverageWaterRate?.describe(
        'Time series signal representing vfm system analysis average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    vfmIPRAverageWaterRate: Wf05StringReservoirOutputsSchema.shape.vfmIPRAverageWaterRate?.describe(
      'Time series signal representing vfm ipraverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmVLPAverageWaterRate: Wf05StringReservoirOutputsSchema.shape.vfmVLPAverageWaterRate?.describe(
      'Time series signal representing vfm vlpaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmChokeAverageWaterRate: Wf05StringReservoirOutputsSchema.shape.vfmChokeAverageWaterRate?.describe(
      'Time series signal representing vfm choke average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmESPAverageWaterRate: Wf05StringReservoirOutputsSchema.shape.vfmESPAverageWaterRate?.describe(
      'Time series signal representing vfm espaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vfmDataDrivenAverageWaterRate: Wf05StringReservoirOutputsSchema.shape.vfmDataDrivenAverageWaterRate?.describe(
      'Time series signal representing vfm data driven average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorSystemAnalysis:
      Wf05StringReservoirOutputsSchema.shape.normalizedWeightFactorSystemAnalysis?.describe(
        'Time series signal representing normalized weight factor system analysis for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    normalizedWeightFactorIPR: Wf05StringReservoirOutputsSchema.shape.normalizedWeightFactorIPR?.describe(
      'Time series signal representing normalized weight factor ipr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorVLP: Wf05StringReservoirOutputsSchema.shape.normalizedWeightFactorVLP?.describe(
      'Time series signal representing normalized weight factor vlp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorChoke: Wf05StringReservoirOutputsSchema.shape.normalizedWeightFactorChoke?.describe(
      'Time series signal representing normalized weight factor choke for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorESP: Wf05StringReservoirOutputsSchema.shape.normalizedWeightFactorESP?.describe(
      'Time series signal representing normalized weight factor esp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    normalizedWeightFactorDataDriven: Wf05StringReservoirOutputsSchema.shape.normalizedWeightFactorDataDriven?.describe(
      'Time series signal representing normalized weight factor data driven for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMOilRate: Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMOilRate?.describe(
      'Time series signal representing weighted average vfmoil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMAssociatedGasRate?.describe(
        'Time series signal representing weighted average vfmassociated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMNonAssociatedGasRate:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMNonAssociatedGasRate?.describe(
        'Time series signal representing weighted average vfmnon associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMWaterRate: Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMWaterRate?.describe(
      'Time series signal representing weighted average vfmwater rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    weightedAverageVFMEstimatedWellOilVolume:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMEstimatedWellOilVolume?.describe(
        'Time series signal representing weighted average vfmestimated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMEstimatedWellAssociatedGasVolume:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMEstimatedWellAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmestimated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMEstimatedWellNonAssociatedGasVolume:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMEstimatedWellNonAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmestimated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMEstimatedWellWaterVolume:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMEstimatedWellWaterVolume?.describe(
        'Time series signal representing weighted average vfmestimated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageDataSourceFlag: Wf05StringReservoirOutputsSchema.shape.weightedAverageDataSourceFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    preferredVFMEstimatedWellWaterVolume:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMEstimatedWellWaterVolume?.describe(
        'Time series signal representing preferred vfmestimated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    linkString: Wf05StringReservoirOutputsSchema.shape.linkString?.describe(
      'Link String attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    preferredVFMAllocatedWellOilVolume:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMAllocatedWellOilVolume?.describe(
        'Time series signal representing preferred vfmallocated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMAllocatedWellAssociatedGasVolume:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMAllocatedWellAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmallocated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMAllocatedWellNonAssociatedGasVolume:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMAllocatedWellNonAssociatedGasVolume?.describe(
        'Time series signal representing preferred vfmallocated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    preferredVFMAllocatedWellWaterVolume:
      Wf05StringReservoirOutputsSchema.shape.preferredVFMAllocatedWellWaterVolume?.describe(
        'Time series signal representing preferred vfmallocated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMAllocatedWellOilVolume:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMAllocatedWellOilVolume?.describe(
        'Time series signal representing weighted average vfmallocated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMAllocatedWellAssociatedGasVolume:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMAllocatedWellAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmallocated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMAllocatedWellNonAssociatedGasVolume:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMAllocatedWellNonAssociatedGasVolume?.describe(
        'Time series signal representing weighted average vfmallocated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    weightedAverageVFMAllocatedWellWaterVolume:
      Wf05StringReservoirOutputsSchema.shape.weightedAverageVFMAllocatedWellWaterVolume?.describe(
        'Time series signal representing weighted average vfmallocated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
    allocatedWellInjectionGasVolume: Wf05StringReservoirOutputsSchema.shape.allocatedWellInjectionGasVolume?.describe(
      'Time series signal representing allocated well injection gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    allocatedWellInjectionWaterVolume:
      Wf05StringReservoirOutputsSchema.shape.allocatedWellInjectionWaterVolume?.describe(
        'Time series signal representing allocated well injection water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
      ),
  })?.describe(
    'String-reservoir level outputs from the WF05 workflow, providing virtual flow meter (VFM) based oil, gas and water rates, estimated well volumes, method-specific VFM rates and diagnostics used for allocation and well performance evaluation at the reservoir sector level.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const Wf3OutputsStringView = parseView({
  view: { externalId: 'Wf3Outputs_String' },
  model: Wf3OutputsStringSchema.extend({
    ...InstanceIdType.shape,
    entityName: Wf3OutputsStringSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    modelOriginalFileId: Wf3OutputsStringSchema.shape.modelOriginalFileId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelNewFileId: Wf3OutputsStringSchema.shape.modelNewFileId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelProductivityIndex: Wf3OutputsStringSchema.shape.modelProductivityIndex?.describe(
      'Time series signal representing model productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelInjectivityIndex: Wf3OutputsStringSchema.shape.modelInjectivityIndex?.describe(
      'Time series signal representing model injectivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelReservoirPressure: Wf3OutputsStringSchema.shape.modelReservoirPressure?.describe(
      'Time series signal representing model reservoir pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelStabilityFlag: Wf3OutputsStringSchema.shape.modelStabilityFlag?.describe(
      'Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive).',
    ),
    modelMinStableRate: Wf3OutputsStringSchema.shape.modelMinStableRate?.describe(
      'Time series signal representing model min stable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelReservoirModel: Wf3OutputsStringSchema.shape.modelReservoirModel?.describe(
      'Time series signal representing model reservoir model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelVlpModel: Wf3OutputsStringSchema.shape.modelVlpModel?.describe(
      'Attribute capturing model vlp model for this production string in the production optimization context.',
    ),
    modelUval: Wf3OutputsStringSchema.shape.modelUval?.describe(
      'Time series signal representing model uval for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelGlOrificeSize: Wf3OutputsStringSchema.shape.modelGlOrificeSize?.describe(
      'Time series signal representing model gl orifice size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEspWf: Wf3OutputsStringSchema.shape.modelEspWf?.describe(
      'Time series signal representing model esp wf for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestGlInjection: Wf3OutputsStringSchema.shape.modelWellTestGlInjection?.describe(
      'Time series signal representing model well test gl injection for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestChp: Wf3OutputsStringSchema.shape.modelWellTestChp?.describe(
      'Time series signal representing model well test chp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestEspFrequency: Wf3OutputsStringSchema.shape.modelWellTestEspFrequency?.describe(
      'Time series signal representing model well test esp frequency for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestTimestamp: Wf3OutputsStringSchema.shape.modelWellTestTimestamp?.describe(
      'Time series signal representing model well test timestamp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestLiquidRate: Wf3OutputsStringSchema.shape.modelWellTestLiquidRate?.describe(
      'Time series signal representing model well test liquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestGasRate: Wf3OutputsStringSchema.shape.modelWellTestGasRate?.describe(
      'Time series signal representing model well test gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEstimatedLiquidRate: Wf3OutputsStringSchema.shape.modelEstimatedLiquidRate?.describe(
      'Time series signal representing model estimated liquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEstimatedGasRate: Wf3OutputsStringSchema.shape.modelEstimatedGasRate?.describe(
      'Time series signal representing model estimated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestGor: Wf3OutputsStringSchema.shape.modelWellTestGor?.describe(
      'Time series signal representing model well test gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestWc: Wf3OutputsStringSchema.shape.modelWellTestWc?.describe(
      'Time series signal representing model well test wc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelWellTestPdgPress: Wf3OutputsStringSchema.shape.modelWellTestPdgPress?.describe(
      'Time series signal representing model well test pdg press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEstimatedFbhp: Wf3OutputsStringSchema.shape.modelEstimatedFbhp?.describe(
      'Time series signal representing model estimated fbhp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEstimatedPdgPress: Wf3OutputsStringSchema.shape.modelEstimatedPdgPress?.describe(
      'Time series signal representing model estimated pdg press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    originalFileId: Wf3OutputsStringSchema.shape.originalFileId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    newFileId: Wf3OutputsStringSchema.shape.newFileId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelWellTestWhp: Wf3OutputsStringSchema.shape.modelWellTestWhp?.describe(
      'Time series signal representing model well test whp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelVlpCorrelation: Wf3OutputsStringSchema.shape.modelVlpCorrelation?.describe(
      'Time series signal representing model vlp correlation for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEstimatedOilRate: Wf3OutputsStringSchema.shape.modelEstimatedOilRate?.describe(
      'Time series signal representing model estimated oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEstimatedPip: Wf3OutputsStringSchema.shape.modelEstimatedPip?.describe(
      'Time series signal representing model estimated pip for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEstimatedPdp: Wf3OutputsStringSchema.shape.modelEstimatedPdp?.describe(
      'Time series signal representing model estimated pdp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelMatchStatus: Wf3OutputsStringSchema.shape.modelMatchStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    modelVlpParameter1: Wf3OutputsStringSchema.shape.modelVlpParameter1?.describe(
      'Time series signal representing model vlp parameter1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelVlpParameter2: Wf3OutputsStringSchema.shape.modelVlpParameter2?.describe(
      'Time series signal representing model vlp parameter2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelProductivityIndexPercentChange: Wf3OutputsStringSchema.shape.modelProductivityIndexPercentChange?.describe(
      'Time series signal representing model productivity index percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelInjectivityIndexPercentChange: Wf3OutputsStringSchema.shape.modelInjectivityIndexPercentChange?.describe(
      'Time series signal representing model injectivity index percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelReservoirPressurePercentChange: Wf3OutputsStringSchema.shape.modelReservoirPressurePercentChange?.describe(
      'Time series signal representing model reservoir pressure percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelVlpParameter1PercentChange: Wf3OutputsStringSchema.shape.modelVlpParameter1PercentChange?.describe(
      'Time series signal representing model vlp parameter1 percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelVlpParameter2PercentChange: Wf3OutputsStringSchema.shape.modelVlpParameter2PercentChange?.describe(
      'Time series signal representing model vlp parameter2 percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelIprC: Wf3OutputsStringSchema.shape.modelIprC?.describe(
      'Time series signal representing model ipr c for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelIprN: Wf3OutputsStringSchema.shape.modelIprN?.describe(
      'Time series signal representing model ipr n for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelGlOrificeSizePercentChange: Wf3OutputsStringSchema.shape.modelGlOrificeSizePercentChange?.describe(
      'Time series signal representing model gl orifice size percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEspWfPercentChange: Wf3OutputsStringSchema.shape.modelEspWfPercentChange?.describe(
      'Time series signal representing model esp wf percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelRevisionNumber: Wf3OutputsStringSchema.shape.modelRevisionNumber?.describe(
      'Time series signal representing model revision number for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelRevisionExternalId: Wf3OutputsStringSchema.shape.modelRevisionExternalId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    modelStatus: Wf3OutputsStringSchema.shape.modelStatus?.describe(
      'Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic.',
    ),
    chokeBestGor: Wf3OutputsStringSchema.shape.chokeBestGor?.describe(
      'Time series signal representing choke best gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vlpBestGor: Wf3OutputsStringSchema.shape.vlpBestGor?.describe(
      'Time series signal representing vlp best gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeBestWc: Wf3OutputsStringSchema.shape.chokeBestWc?.describe(
      'Time series signal representing choke best wc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vlpBestWc: Wf3OutputsStringSchema.shape.vlpBestWc?.describe(
      'Time series signal representing vlp best wc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    chokeBestWgr: Wf3OutputsStringSchema.shape.chokeBestWgr?.describe(
      'Time series signal representing choke best wgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    vlpBestWgr: Wf3OutputsStringSchema.shape.vlpBestWgr?.describe(
      'Time series signal representing vlp best wgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
    modelEstimatedWaterRate: Wf3OutputsStringSchema.shape.modelEstimatedWaterRate?.describe(
      'Time series signal representing model estimated water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization.',
    ),
  })?.describe(
    'WF3 well string model outputs and configuration identifiers, including productivity and injectivity indices, modelled reservoir pressures, minimum stable rates and links to the underlying reservoir and VLP model versions used for simulation and calibration.',
  ),
  dataModel: DataModel.IpsoSolution,
});

export const WfAlarmsAgentView = parseView({
  view: { externalId: 'WfAlarms_Agent' },
  model: WfAlarmsAgentSchema.extend({
    ...InstanceIdType.shape,
    entityName: WfAlarmsAgentSchema.shape.entityName?.describe(
      'Display name of the entity (well, string) with the alarm.',
    ),
    entityExternalId: WfAlarmsAgentSchema.shape.entityExternalId?.describe(
      'External ID of the entity for joining to other views.',
    ),
    entityType: WfAlarmsAgentSchema.shape.entityType?.describe('Type of entity (string, well, field).'),
    wellString: WfAlarmsAgentSchema.shape.wellString?.describe(
      "Direct relation to String_asset (when entityType = 'string').\nNavigate to string properties like lift type, status, field hierarchy.",
    ),
    startDateTime: WfAlarmsAgentSchema.shape.startDateTime?.describe('When the alarm was triggered.'),
    endDateTime: WfAlarmsAgentSchema.shape.endDateTime?.describe('When the alarm was cleared'),
    alarmFlags: WfAlarmsAgentSchema.shape.alarmFlags?.describe('Alarm validity flag (Valid, Invalid, etc.).'),
    alarmCounter: WfAlarmsAgentSchema.shape.alarmCounter?.describe('Count of how many times this alarm has occurred.'),
    alarmCode: WfAlarmsAgentSchema.shape.alarmCode?.describe('Reference to AlarmDefinition node.'),
    alarmCodeExternalId: WfAlarmsAgentSchema.shape.alarmCodeExternalId?.describe(
      'External ID of the alarm code (e.g., WF12-001) for easy filtering.',
    ),
    alarmName: WfAlarmsAgentSchema.shape.alarmName?.describe('Human-readable alarm name from AlarmDefinition.'),
    alarmMessage: WfAlarmsAgentSchema.shape.alarmMessage?.describe(
      'Standard alarm message template from AlarmDefinition.',
    ),
    alarmCategory: WfAlarmsAgentSchema.shape.alarmCategory?.describe(
      'Alarm category from AlarmDefinition (e.g., ESP, Gas Lift, Production).',
    ),
    subCategory: WfAlarmsAgentSchema.shape.subCategory?.describe('Sub-category from AlarmDefinition.'),
    alarmPriority: WfAlarmsAgentSchema.shape.alarmPriority?.describe(
      'Alarm priority level from AlarmDefinition (e.g., HIGH, MEDIUM, LOW).',
    ),
    alarmCriticality: WfAlarmsAgentSchema.shape.alarmCriticality?.describe(
      'Alarm criticality level from AlarmDefinition.',
    ),
    workflowCode: WfAlarmsAgentSchema.shape.workflowCode?.describe('Workflow code from AlarmDefinition (e.g., WF12).'),
    workflowName: WfAlarmsAgentSchema.shape.workflowName?.describe('Workflow name from AlarmDefinition.'),
    subWorkflowName: WfAlarmsAgentSchema.shape.subWorkflowName?.describe('Sub-workflow name from AlarmDefinition.'),
    customWorkflowAlarmMessage: WfAlarmsAgentSchema.shape.customWorkflowAlarmMessage?.describe(
      'Detailed alarm message with specific conditions that triggered it.',
    ),
    ticketId: WfAlarmsAgentSchema.shape.ticketId?.describe('Associated troubleshooting ticket ID if one was created.'),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Denormalized alarms with alarm-definition properties inlined; retention is\nabout 48 hours by alarm start (see delete job).\n\nThe Workflow Alarms (Agent) view holds recent denormalized alarm data,\nincluding properties such as alarmPriority,\nalarmCriticality, and workflow details. This view facilitates analysis of\nalarm occurrences and their characteristics, to address questions related to\nalarm frequency, severity, and workflow impact. Sourced from real-time alarm\nsystems, ensuring that it reflects the most current operational status.\nExcludes pre-filtered alarms for WF12/WF14 (use ESPAlarms_Agent, GasLiftAlarms_Agent).\n\nUse for: Real-Time Surveillance (WF18), cross-workflow alarm rollup.\n\n@name Workflow Alarms (Agent)',
    ),
  dataModel: DataModel.IpsoFieldWellSurveillanceAgent,
});

export const WfAlarmsView = parseView({
  view: { externalId: 'WfAlarms' },
  model: WfAlarmsSchema.extend({
    ...InstanceIdType.shape,
    entityName: WfAlarmsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    entityExternalId: WfAlarmsSchema.shape.entityExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    entityType: WfAlarmsSchema.shape.entityType?.describe(
      'Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    startDateTime: WfAlarmsSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this entity in the production optimization context.',
    ),
    endDateTime: WfAlarmsSchema.shape.endDateTime?.describe(
      'Attribute capturing end date time for this entity in the production optimization context.',
    ),
    alarmFlags: WfAlarmsSchema.shape.alarmFlags?.describe(
      'Alarm Flags attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    operationType: WfAlarmsSchema.shape.operationType?.describe(
      'Operation Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    alarmCounter: WfAlarmsSchema.shape.alarmCounter?.describe(
      'Numeric value storing alarm counter for this entity, used in calculations, reporting, or model configuration.',
    ),
    ticketId: WfAlarmsSchema.shape.ticketId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    alarmCode: WfAlarmsSchema.shape.alarmCode?.describe(
      'Alarm Code attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    removeAlaramForUser: WfAlarmsSchema.shape.removeAlaramForUser?.describe(
      'Attribute capturing remove alaram for user for this entity in the production optimization context.',
    ),
    markAsRead: WfAlarmsSchema.shape.markAsRead?.describe(
      'Attribute capturing mark as read for this entity in the production optimization context.',
    ),
    customWorkflowAlarmMessage: WfAlarmsSchema.shape.customWorkflowAlarmMessage?.describe(
      'Custom Workflow Alarm Message attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    ssWorkflowAlarmMessage: WfAlarmsSchema.shape.ssWorkflowAlarmMessage?.describe(
      'Ss Workflow Alarm Message attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    relatedEntity: WfAlarmsSchema.shape.relatedEntity?.describe(
      'Related Entity attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    relatedEntityExternalId: WfAlarmsSchema.shape.relatedEntityExternalId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
    additionalInformation: WfAlarmsSchema.shape.additionalInformation?.describe(
      'Attribute capturing additional information for this entity in the production optimization context.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Wf Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
    ),
  dataModel: DataModel.IpsoSolution,
});

export const WfFieldAlarmsView = parseView({
  view: { externalId: 'WfFieldAlarms' },
  model: WfFieldAlarmsSchema.extend({
    ...InstanceIdType.shape,
    entityName: WfFieldAlarmsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    workflowName: WfFieldAlarmsSchema.shape.workflowName?.describe(
      'Name or label for this field, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    startDateTime: WfFieldAlarmsSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this field in the production optimization context.',
    ),
    endDateTime: WfFieldAlarmsSchema.shape.endDateTime?.describe(
      'Attribute capturing end date time for this field in the production optimization context.',
    ),
    alarmName: WfFieldAlarmsSchema.shape.alarmName?.describe(
      'Name or label for this field, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    alarmMessage: WfFieldAlarmsSchema.shape.alarmMessage?.describe(
      'Alarm Message attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    alarmLevel: WfFieldAlarmsSchema.shape.alarmLevel?.describe(
      'Alarm Level attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    alarmType: WfFieldAlarmsSchema.shape.alarmType?.describe(
      'Alarm Type attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    configuration: WfFieldAlarmsSchema.shape.configuration?.describe(
      'Configuration attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    alarmFlags: WfFieldAlarmsSchema.shape.alarmFlags?.describe(
      'Alarm Flags attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    operationType: WfFieldAlarmsSchema.shape.operationType?.describe(
      'Operation Type attribute describing this field in more detail, often derived from master data or configuration tables.',
    ),
    alarmCounter: WfFieldAlarmsSchema.shape.alarmCounter?.describe(
      'Numeric value storing alarm counter for this field, used in calculations, reporting, or model configuration.',
    ),
    ticketId: WfFieldAlarmsSchema.shape.ticketId?.describe(
      'Unique identifier for this field, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Wf Field Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
    ),
  dataModel: DataModel.IpsoSolution,
});

export const WfReservoirAlarmsView = parseView({
  view: { externalId: 'WfReservoirAlarms' },
  model: WfReservoirAlarmsSchema.extend({
    ...InstanceIdType.shape,
    entityName: WfReservoirAlarmsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    workflowName: WfReservoirAlarmsSchema.shape.workflowName?.describe(
      'Name or label for this reservoir, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    startDateTime: WfReservoirAlarmsSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this reservoir in the production optimization context.',
    ),
    endDateTime: WfReservoirAlarmsSchema.shape.endDateTime?.describe(
      'Attribute capturing end date time for this reservoir in the production optimization context.',
    ),
    alarmName: WfReservoirAlarmsSchema.shape.alarmName?.describe(
      'Name or label for this reservoir, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    alarmMessage: WfReservoirAlarmsSchema.shape.alarmMessage?.describe(
      'Alarm Message attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
    alarmLevel: WfReservoirAlarmsSchema.shape.alarmLevel?.describe(
      'Alarm Level attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
    alarmType: WfReservoirAlarmsSchema.shape.alarmType?.describe(
      'Alarm Type attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
    configuration: WfReservoirAlarmsSchema.shape.configuration?.describe(
      'Configuration attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
    alarmFlags: WfReservoirAlarmsSchema.shape.alarmFlags?.describe(
      'Alarm Flags attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
    operationType: WfReservoirAlarmsSchema.shape.operationType?.describe(
      'Operation Type attribute describing this reservoir in more detail, often derived from master data or configuration tables.',
    ),
    alarmCounter: WfReservoirAlarmsSchema.shape.alarmCounter?.describe(
      'Numeric value storing alarm counter for this reservoir, used in calculations, reporting, or model configuration.',
    ),
    ticketId: WfReservoirAlarmsSchema.shape.ticketId?.describe(
      'Unique identifier for this reservoir, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Wf Reservoir Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
    ),
  dataModel: DataModel.IpsoSolution,
});

export const WfSectorAlarmsView = parseView({
  view: { externalId: 'WfSectorAlarms' },
  model: WfSectorAlarmsSchema.extend({
    ...InstanceIdType.shape,
    entityName: WfSectorAlarmsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    workflowName: WfSectorAlarmsSchema.shape.workflowName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    startDateTime: WfSectorAlarmsSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this entity in the production optimization context.',
    ),
    endDateTime: WfSectorAlarmsSchema.shape.endDateTime?.describe(
      'Attribute capturing end date time for this entity in the production optimization context.',
    ),
    alarmName: WfSectorAlarmsSchema.shape.alarmName?.describe(
      'Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    alarmMessage: WfSectorAlarmsSchema.shape.alarmMessage?.describe(
      'Alarm Message attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    alarmLevel: WfSectorAlarmsSchema.shape.alarmLevel?.describe(
      'Alarm Level attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    alarmType: WfSectorAlarmsSchema.shape.alarmType?.describe(
      'Alarm Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    configuration: WfSectorAlarmsSchema.shape.configuration?.describe(
      'Configuration attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    alarmFlags: WfSectorAlarmsSchema.shape.alarmFlags?.describe(
      'Alarm Flags attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    operationType: WfSectorAlarmsSchema.shape.operationType?.describe(
      'Operation Type attribute describing this entity in more detail, often derived from master data or configuration tables.',
    ),
    alarmCounter: WfSectorAlarmsSchema.shape.alarmCounter?.describe(
      'Numeric value storing alarm counter for this entity, used in calculations, reporting, or model configuration.',
    ),
    ticketId: WfSectorAlarmsSchema.shape.ticketId?.describe(
      'Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Wf Sector Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
    ),
  dataModel: DataModel.IpsoSolution,
});

export const WfStringAlarmsView = parseView({
  view: { externalId: 'WfStringAlarms' },
  model: WfStringAlarmsSchema.extend({
    ...InstanceIdType.shape,
    entityName: WfStringAlarmsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    workflowName: WfStringAlarmsSchema.shape.workflowName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    startDateTime: WfStringAlarmsSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this production string in the production optimization context.',
    ),
    endDateTime: WfStringAlarmsSchema.shape.endDateTime?.describe(
      'Attribute capturing end date time for this production string in the production optimization context.',
    ),
    alarmName: WfStringAlarmsSchema.shape.alarmName?.describe(
      'Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    alarmMessage: WfStringAlarmsSchema.shape.alarmMessage?.describe(
      'Alarm Message attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    alarmLevel: WfStringAlarmsSchema.shape.alarmLevel?.describe(
      'Alarm Level attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    alarmType: WfStringAlarmsSchema.shape.alarmType?.describe(
      'Alarm Type attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    configuration: WfStringAlarmsSchema.shape.configuration?.describe(
      'Configuration attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    alarmFlags: WfStringAlarmsSchema.shape.alarmFlags?.describe(
      'Alarm Flags attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    operationType: WfStringAlarmsSchema.shape.operationType?.describe(
      'Operation Type attribute describing this production string in more detail, often derived from master data or configuration tables.',
    ),
    alarmCounter: WfStringAlarmsSchema.shape.alarmCounter?.describe(
      'Numeric value storing alarm counter for this production string, used in calculations, reporting, or model configuration.',
    ),
    ticketId: WfStringAlarmsSchema.shape.ticketId?.describe(
      'Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Wf String Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
    ),
  dataModel: DataModel.IpsoSolution,
});

export const WfWellAlarmsView = parseView({
  view: { externalId: 'WfWellAlarms' },
  model: WfWellAlarmsSchema.extend({
    ...InstanceIdType.shape,
    entityName: WfWellAlarmsSchema.shape.entityName?.describe(
      'Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports.',
    ),
    workflowName: WfWellAlarmsSchema.shape.workflowName?.describe(
      'Name or label for this well, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    startDateTime: WfWellAlarmsSchema.shape.startDateTime?.describe(
      'Attribute capturing start date time for this well in the production optimization context.',
    ),
    endDateTime: WfWellAlarmsSchema.shape.endDateTime?.describe(
      'Attribute capturing end date time for this well in the production optimization context.',
    ),
    alarmName: WfWellAlarmsSchema.shape.alarmName?.describe(
      'Name or label for this well, chosen to be meaningful for operators and engineers when browsing or searching in the solution.',
    ),
    alarmMessage: WfWellAlarmsSchema.shape.alarmMessage?.describe(
      'Alarm Message attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    alarmLevel: WfWellAlarmsSchema.shape.alarmLevel?.describe(
      'Alarm Level attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    alarmType: WfWellAlarmsSchema.shape.alarmType?.describe(
      'Alarm Type attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    configuration: WfWellAlarmsSchema.shape.configuration?.describe(
      'Configuration attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    alarmFlags: WfWellAlarmsSchema.shape.alarmFlags?.describe(
      'Alarm Flags attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    operationType: WfWellAlarmsSchema.shape.operationType?.describe(
      'Operation Type attribute describing this well in more detail, often derived from master data or configuration tables.',
    ),
    alarmCounter: WfWellAlarmsSchema.shape.alarmCounter?.describe(
      'Numeric value storing alarm counter for this well, used in calculations, reporting, or model configuration.',
    ),
    ticketId: WfWellAlarmsSchema.shape.ticketId?.describe(
      'Unique identifier for this well, used to consistently link data for the same physical object across allocation, network modeling, and external source systems.',
    ),
  })
    .omit({ startDateTime: true, endDateTime: true })
    ?.describe(
      'Wf Well Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows.',
    ),
  dataModel: DataModel.IpsoSolution,
});
